import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FieldSet from '../../../../../../components/Modules/FieldSet';
import Selector from '../../../../../../components/Modules/Selector';
import DateFilter from '../../../../../../components/Modules/DateFilter';
import courtsMapper from '../../../courtsMapper';
import './criminal.less';


class Criminal extends Component {
  regionOptions = courtsMapper('district', 'District Court')

  render() {
    const {
      region,
      caseType,
      citation,
      dateFrom,
      dateTo,
      caseFlag,
      countStatus,
      includeCVBCases,
      caseProperties,
      select,
      multiselect,
    } = this.props;

    return (
      <div className="reports-tab-form reports-tab-forms-criminal">
        <FieldSet title="Case Information">
          <div className="row no-padding">
            <Selector
              multi
              clearable={false}
              className="reports-tab-criminal-region-selector"
              options={this.regionOptions}
              title="Region"
              value={region}
              placeholder="Select Region"
              onChange={multiselect.bind(this, 'region')} />
            <Selector
              multi
              clearable={false}
              className="reports-tab-criminal-case-type-selector"
              options={caseTypeOptions}
              title="Case Type"
              value={caseType}
              placeholder="Any"
              onChange={multiselect.bind(this, 'caseType')} />
          </div>
          <div className="row">
            <Selector
              clearable={false}
              className="reports-tab-criminal-citation-selector"
              options={citationOptions}
              title="Citation"
              value={citation}
              placeholder=""
              onChange={select.bind(this, 'citation')} />
            <DateFilter
              from={dateFrom}
              to={dateTo}
              onChangeFrom={select.bind(this, 'dateFrom')}
              onChangeTo={select.bind(this, 'dateTo')}
              className="reports-tab-criminal-date-filter-selector" />
          </div>
        </FieldSet>
        <FieldSet title="Advanced Filters">
          <div className="row no-padding">
            <Selector
              multi
              clearable={false}
              className="reports-tab-criminal-case-flag-selector"
              options={caseFlagOptions}
              title="Case Flag"
              value={caseFlag}
              placeholder=""
              onChange={multiselect.bind(this, 'caseFlag')} />
            <Selector
              multi
              clearable={false}
              className="reports-tab-criminal-count-status-selector"
              options={countStatusOptions}
              title="Count Status"
              value={countStatus}
              placeholder=""
              onChange={multiselect.bind(this, 'countStatus')} />
          </div>
          <div className="row">
            <Selector
              clearable={false}
              className="reports-tab-criminal-include-cvb-cases-selector"
              options={includeCVBCasesOptions}
              title="Include CVB Cases"
              value={includeCVBCases}
              placeholder=""
              onChange={select.bind(this, 'includeCVBCases')} />
          </div>
          <div className="row">
            <Selector
              multi
              clearable={false}
              className="reports-tab-criminal-case-properties-selector"
              options={casePropertiesOptions}
              title="Case Properties"
              value={caseProperties}
              placeholder=""
              onChange={multiselect.bind(this, 'caseProperties')} />
          </div>
        </FieldSet>
      </div>
    );
  }
}

Criminal.propTypes = {
  region: PropTypes.any.isRequired,
  caseType: PropTypes.any.isRequired,
  citation: PropTypes.any.isRequired,
  dateFrom: PropTypes.any.isRequired,
  dateTo: PropTypes.any.isRequired,
  caseFlag: PropTypes.any.isRequired,
  countStatus: PropTypes.any.isRequired,
  includeCVBCases: PropTypes.any.isRequired,
  caseProperties: PropTypes.any.isRequired,
  setFormValue: PropTypes.func.isRequired,
  select: PropTypes.func.isRequired,
  multiselect: PropTypes.func.isRequired,
};


function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(Criminal);

const caseTypeOptions = {
  cr: 'Criminal',
  mj: 'Magistrate Judge',
  po: 'Petty Offense',
};
const citationOptions = {
  '10:2408.M': '10:2408.M            DEFENSE CONTRACT RELATED FELONIES, C...',
  '10:847.P': '10:847.P             REFUSAL TO APPEAR OR TESTIFY',
  '10:976.F': '10:976.F             MEMBERSHIP IN MILITARY UNIONS',
  '12:1457.M': '12:1457.M            PENALTIES - PROHIBITED ACTIVITIES',
  '12:161.P': '12:161.P             REPORT OF CONDITIONS',
  '12:161A.P': '12:161A.P            REPORT OF CONDITIONS',
  '12:161B.P': '12:161B.P            PAYMENT OF DIVIDENDS',
  '12:161C.P': '12:161C.P            REPORTS OF AFFILIATES',
  '12:164.P': '12:164.P             FAILURE TO REPORT BANK EXAMINATIONS',
  '12:17092.F': '12:17092.F           EQUITY SKIMMING',
  '12:1715.F': '12:1715.F            MORTGAGE/INSURANCE LOW-COST, INCOME ...',
  '12:1730.F': '12:1730.F            RETENTION OF RECORDS BY INSURED INST...',
  '12:1730.M': '12:1730.M            SUSPEND OR REMOVE DIRECTOR OR OFFICER',
  '12:1738.P': '12:1738.P            MORTGAGE DISCRIMINATION',
  '12:1782.M': '12:1782.M            FAILURE TO FILE CERTIFIED STATEMENT/PAY',
  '12:1786K.M': '12:1786K.M           JURISDICTION AND ENFORCEMENT, PENALTIES',
  '12:1786L.M': '12:1786L.M           REMOVED DIRECTOR, OFFICER OR MEMBER,...',
  '12:1818.F': '12:1818.F            TERMINATION OF STATUS AS INSURED BANK',
  '12:1829.F': '12:1829.F            RETENTION OF RECORDS BY INSURED BANKS',
  '12:1841.M': '12:1841.M            BANK HOLDING COMPANY, DEFINITIONS',
  '12:1842.M': '12:1842.M            ACQUISITION OF SHARES OR ASSETS',
  '12:1843.M': '12:1843.M            INTERESTS IN NON-BANKING ORGANIZATIONS',
  '12:1844.M': '12:1844.M            ADMINISTRATION OF HOLDING COMPANIES',
  '12:1846.M': '12:1846.M            RESERVATION OF STATES RIGHTS',
  '12:1847.M': '12:1847.M            PENALTIES - HOLDING COMPANIES',
  '12:1848.M': '12:1848.M            JUDICIAL REVIEW',
  '12:1849.M': '12:1849.M            SAVINGS PROVISIONS',
  '12:1850.M': '12:1850.M            ACQUISITION OF SUBSIDIARIES',
  '12:1901.M': '12:1901.M            DEFINITIONS',
  '12:1902.M': '12:1902.M            RULES AND REGULATIONS, BY BOARD OF G...',
  '12:1903.M': '12:1903.M            INTEREST',
  '12:1904.M': '12:1904.M            CREDIT CONTROLS',
  '12:1905.M': '12:1905.M            EXTENT OF CONTROL',
  '12:1906.M': '12:1906.M            REPORTS: PRODUCTION OF RECORDS',
  '12:1909.M': '12:1909.M            CREDIT CONTROL - PENALTIES',
  '12:1956.M': '12:1956.M            PENALTIES - FINANCIAL RECORDKEEPING',
  '12:1957.F': '12:1957.F            ADDITIONAL PENALTIES',
  '12:211.M': '12:211.M             BANK CONSERVATOR VIOLATIONS',
  '12:2607B.M': '12:2607B.M           SPLITTING CHARGES',
  '12:2607D.M': '12:2607D.M           PENALTIES',
  '12:2614.M': '12:2614.M            TOXIC SUBSTANCES CONTROL',
  '12:3105.F': '12:3105.F            FOREIGN BANK PARTICIPATION IN DOMEST...',
  '12:3111.F': '12:3111.F            FOREIGN BANK PARTICIPATION IN DOMEST...',
  '12:334.P': '12:334.P             MUTUAL SAVINGS BANKS',
  '12:378.F': '12:378.F             VIOLATIONS IN THE BANKING BUSINESS',
  '12:481.P': '12:481.P             PENALTIES - BANK EXAMINATIONS',
  '12:582.P': '12:582.P             RECEIVING U.S. BANK NOTES AS COLLATERAL',
  '12:630.F': '12:630.F             OFFENSES BY OFFICERS OF A CORPORATION',
  '12:631.F': '12:631.F             FALSE REPRESENTATION OF U.S. LIABILITY',
  '12:95.F': '12:95.F              PRESIDENTIAL REGULATIONS IN NATIONAL...',
  '12:95.M': '12:95.M              PRESIDENTIAL REGULATIONS IN NATIONAL...',
  '13:212.P': '13:212.P             REFUSAL OR NEGLECT OF EMPLOYEE\'S DUTIES',
  '13:213.F': '13:213.F             FALSE STATEMENTS, CERTIFICATES AND I...',
  '13:214.F': '13:214.F             WRONGFUL DISCLOSURES',
  '13:221.P': '13:221.P             REFUSE OR NEGLECT TO ANSWER QUESTIONS',
  '13:222.M': '13:222.M             GIVE INACCURATE INFORMATION INTENTIO...',
  '13:223.P': '13:223.P             OWNER/MANAGER REFUSES TO ASSIST CENS...',
  '13:224.M': '13:224.M             FAILURE TO ANSWER QUESTIONS',
  '13:224.P': '13:224.P             FALSE ANSWERS',
  '13:304.F': '13:304.F             COLLECTION AND PUBLICATION OF FOREIG...',
  '13:304.M': '13:304.M             COLLECTION AND PUBLICATION OF FOREIG...',
  '13:305.F': '13:305.F             UNLAWFUL EXPORT INFORMATION ACTIVITIES',
  '14:431.M': '14:431.M             IMPROPER PAYMENT FOR SERVICES',
  '14:639.M': '14:639.M             PENALTIES - UNAUTHORIZED USE',
  '14:83.P': '14:83.P              UNAUTHORIZED AIDS TO MARITIME NAVIGA...',
  '14:84.P': '14:84.P              INTERFERENCE WITH AIDS TO NAVIGATION',
  '14:85.P': '14:85.P              AIDS TO MARITIME NAVIGATION ON FIXED...',
  '14:88.F': '14:88.F              FALSE DISTRESS SIGNALS',
  '14:892.P': '14:892.P             PENALTIES - IMPROPER USE OF UNIFORMS...',
  '15:1.F': '15:1.F               ANTITRUST VIOLATIONS',
  '15:1002.P': '15:1002.P            GOLDEN GATE BRIDGE TOLL',
  '15:1003.P': '15:1003.P            GOLDEN GATE BRIDGE TOLLS, AUTHORIZED...',
  '15:1004.P': '15:1004.P            TOLL FRAUD',
  '15:1005.P': '15:1005.P            SAN FRANCISCO-OAKLAND BAY BRIDGE TOLLS',
  '15:1006.P': '15:1006.P            SF-OAKLAND BAY BRIDGE TOLLS: AUTHORI...',
  '15:1007.P': '15:1007.P            TOLL FRAUD',
  '15:1172.F': '15:1172.F            IMPORTING GAMBLING DEVICES',
  '15:1173.F': '15:1173.F            REGISTRATION OF MANUFACTURERS AND DE...',
  '15:1174.F': '15:1174.F            LABELING AND MARKING OF SHIPPING PAC...',
  '15:1175.F': '15:1175.F            MANUFACTURING, REPAIRING ILLEGAL DEV...',
  '15:1176.F': '15:1176.F            TRANSPORTING GAMBLING DEVICES',
  '15:1192.M': '15:1192.M            PROHIBITED TRANSACTIONS',
  '15:1196.M': '15:1196.M            FLAMMABLE FABRICS',
  '15:1197.M': '15:1197.M            GUARANTIES',
  '15:1211.M': '15:1211.M            PROHIBITION - TRANSPORT OF REFRIGERA...',
  '15:1212.M': '15:1212.M            REFRIGERATORS W/O SAFETY DEVICES',
  '15:1232A.P': '15:1232A.P           FAILURE TO AFFIX LABEL',
  '15:1232B.P': '15:1232B.P           FAILURE TO CLEARLY ENDORSE LABEL',
  '15:1232C.P': '15:1232C.P           WILLFUL REMOVAL, ALTERATION, OR MARK...',
  '15:1233A.P': '15:1233A.P           FAILURE TO AFFIX LABEL',
  '15:1233B.P': '15:1233B.P           FAILURE TO CLEARLY ENDORSE LABEL',
  '15:1233C.M': '15:1233C.M           EXCISE TAX LABELS ON AUTOMOBILE',
  '15:1233C.P': '15:1233C.P           WILLFUL REMOVAL, ALTERATION, OR MARK...',
  '15:1242.F': '15:1242.F            MANUFACTURE, TRANSPORT OR DISTRIBUTE...',
  '15:1243.F': '15:1243.F            MANUFACTURE, SALE OR POSSESSION WITH...',
  '15:1263.M': '15:1263.M            PROHIBITED TRANSACTIONS',
  '15:1263.P': '15:1263.P            PROHIBITED TRANSACTIONS',
  '15:1264.M': '15:1264.M            HAZARDOUS SUBSTANCES',
  '15:1264.P': '15:1264.P            HAZARDOUS SUBSTANCES',
  '15:1281.F': '15:1281.F            DESTRUCTION OF PROPERTY, INTERSTATE ...',
  '15:1335.M': '15:1335.M            UNLAWFUL ADVERTISEMENT ON ELECTRONIC...',
  '15:1338.M': '15:1338.M            CIGARETTE LABELING AND ADVERTISING',
  '15:13A.M': '15:13A.M             DISCRIMINATION IN REBATES',
  '15:13C.M': '15:13C.M             PAYMENT OR ACCEPTANCE OF COMMISSION',
  '15:13D.M': '15:13D.M             PAYMENT FOR SERVICES OR FACILITIES F...',
  '15:13E.M': '15:13E.M             NOT FURNISHING SERVICES OR FACILITIE...',
  '15:13F.M': '15:13F.M             KNOWINGLY INDUCE/RECEIVE DISCRIMINAT...',
  '15:158.F': '15:158.F             FALSE OR FRAUDULENT STATEMENTS - CHI...',
  '15:159.F': '15:159.F             UNAUTHORIZED USE OF LEGEND',
  '15:1604.M': '15:1604.M            RULES AND REGULATIONS',
  '15:1605.M': '15:1605.M            DETERMINATION OF FINANCE CHARGE',
  '15:1606.M': '15:1606.M            DETERMINATION OF ANNUAL PERCENTAGE RATE',
  '15:1611.M': '15:1611.M            FEDERAL STATUTE - CONSUMER CREDIT PR...',
  '15:1644.F': '15:1644.F            CREDIT CARD FRAUD',
  '15:1674.M': '15:1674.M            RESTORE ON DISCHARGE FROM EMPLOYMENT...',
  '15:1681Q.M': '15:1681Q.M           OBTAINING CREDIT INFORMATION UNDER F...',
  '15:1681R.M': '15:1681R.M           UNAUTHORIZED CREDIT DISCLOSURE BY OF...',
  '15:1693.F': '15:1693.F            GIVING FALSE/INACCURATE INFORMATION',
  '15:1693.M': '15:1693.M            GIVING FALSE/INACCURATE INFORMATION',
  '15:1703.F': '15:1703.F            PROHIBITIONS RELATING TO REAL ESTATE',
  '15:1704.F': '15:1704.F            REGISTRATION OF SUBDIVISION',
  '15:1705.F': '15:1705.F            INFORMATION REQUIRED IN STATEMENT OF...',
  '15:1707.F': '15:1707.F            INFORMATION REQUIRED IN PROPERTY REPORT',
  '15:1716.F': '15:1716.F            UNLAWFUL REPRESENTATIONS',
  '15:1717.F': '15:1717.F            PENALTIES FOR VIOLATIONS',
  '15:1718.F': '15:1718.F            RULES, REGULATIONS, AND ORDERS',
  '15:1823.F': '15:1823.F            UNLAWFUL ACTS',
  '15:1824.M': '15:1824.M            INSPECTION OF HORSES',
  '15:1825.F': '15:1825.F            INSPECTION VIOLATION PENALTIES',
  '15:1825.M': '15:1825.M            INSPECTION OF HORSES',
  '15:1828.F': '15:1828.F            RULES AND REGULATIONS',
  '15:1963.F': '15:1963.F            VIOLATIONS AFFECTING INTERSTATE COMM...',
  '15:1984.F': '15:1984.F            ALTERING ODOMETER SETTINGS',
  '15:1984.M': '15:1984.M            ILLEGAL PRACTICES - AUTOMOBILES',
  '15:1986.F': '15:1986.F            ODOMETER LAWS',
  '15:1986.M': '15:1986.M            ODOMETER LAWS',
  '15:1988.F': '15:1988.F            FALSE STATEMENTS TO TRANSFEREES PROH...',
  '15:1988.M': '15:1988.M            FALSE STATEMENTS TO TRANSFEREES PROH...',
  '15:1990.F': '15:1990.F            PENALTIES - ODOMETER LAWS',
  '15:1990.M': '15:1990.M            PENALTIES - ODOMETER LAWS',
  '15:2.F': '15:2.F               MONOPOLIZING TRADE',
  '15:20.M': '15:20.M              PURCHASES BY CC IN CASE OF INTERLOCU...',
  '15:2068.M': '15:2068.M            PROHIBITED ACTS',
  '15:2070.M': '15:2070.M            CONSUMER PRODUCT SAFETY - PENALTIES',
  '15:234.P': '15:234.P             STANDARD BARREL FOR FRUITS/OTHER DRY...',
  '15:235.P': '15:235.P             SALE OR SHIPMENT OF BARREL OF LESS C...',
  '15:236.P': '15:236.P             VARIATIONS FROM STANDARD PERMITTED: ...',
  '15:237.P': '15:237.P             STANDARD BARRELS FOR LIME',
  '15:238.P': '15:238.P             PENALTY FOR SELLING IN BARRELS NOT M...',
  '15:239.P': '15:239.P             SALE IN CONTAINERS OF LESS THAN BARREL',
  '15:24.M': '15:24.M              LIABILITY OF DIRECTOR AND AGENTS OF ...',
  '15:241.P': '15:241.P             SELL LIME IN UNMARKED BARRELS/CONTAI...',
  '15:242.P': '15:242.P             DUTY OF U.S. ATTORNEY TO ENFORCE LAW',
  '15:2614.M': '15:2614.M            CONTEMPT, CONGRESSIONAL, PROHIBITED ...',
  '15:2615.M': '15:2615.M            CONTEMPT, CONGRESSIONAL, PROHIBITED ...',
  '15:2646.M': '15:2646.M            TOXIC SUBSTANCE CONTROL - ASBESTOS H...',
  '15:291.M': '15:291.M             STAMPING W/WORDS: UNITED STATES ASSAY',
  '15:292.M': '15:292.M             FORFEITURE',
  '15:293.M': '15:293.M             FALSELY STAMPED GOODS  (T)',
  '15:294.P': '15:294.P             IMPORTATION/TRANSPORTATION OF FALSEL...',
  '15:295.P': '15:295.P             STANDARD OF FINENESS OF GOLD ARTICLES',
  '15:296.P': '15:296.P             STANDARD OF FINENESS OF SILVER ARTICLES',
  '15:297.P': '15:297.P             STAMPING PLATED ARTICLES',
  '15:298.P': '15:298.P             FALSELY STAMPED GOODS  (T)',
  '15:3.F': '15:3.F               TRUSTS IN TERRITORIES AND DISTRICT O...',
  '15:330A.M': '15:330A.M            REPORT REQUIREMENT: FORM, INFORMATION',
  '15:330D.M': '15:330D.M            WEATHER MODIFICATION ACTS OR ATTEMPTS',
  '15:376.P': '15:376.P             REPORTS TO STATE TOBACCO TAX ADMINIS...',
  '15:377.P': '15:377.P             JENKINS ACT - CIGARETTE TAXES',
  '15:48.M': '15:48.M              FTC - IMPORT/UNFAIR COMPETITION',
  '15:50.F': '15:50.F              FTC WITNESSES/EMPLOYEES - OFFENSES A...',
  '15:50.M': '15:50.M              FTC WITNESSES/EMPLOYEES - OFFENSES A...',
  '15:52.M': '15:52.M              DISSEMINATION OF FALSE ADVERTISEMENT...',
  '15:52.P': '15:52.P              DISSEMINATION OF FALSE ADVERTISEMENT...',
  '15:54.M': '15:54.M              DISSEMINATION OF FALSE ADVERTISEMENT...',
  '15:54.P': '15:54.P              DISSEMINATION OF FALSE ADVERTISEMENT...',
  '15:645A.F': '15:645A.F            FALSE STATEMENTS: OVERVALUATION OF S...',
  '15:645B.F': '15:645B.F            EMBEZZLEMENT, ETC.',
  '15:645C.F': '15:645C.F            SMALL BUSINESS CORPORATION - CONCEAL...',
  '15:645C.M': '15:645C.M            SMALL BUSINESS CORPORATION - CONCEAL...',
  '15:6823.F': '15:6823.F            FRAUDULENT ACCESS TO FINANCIAL INFOR...',
  '15:68A.M': '15:68A.M             MISBRANDING DECLARED UNLAWFUL',
  '15:68C.M': '15:68C.M             AFFIXING OF STAMP, TAG, LABEL, OR OT...',
  '15:68F.M': '15:68F.M             EXCLUSION OF MISBRANDED WOOL PRODUCTS',
  '15:68G.M': '15:68G.M             FALSE GUARANTY',
  '15:68H.M': '15:68H.M             MIS-LABELING OF WOOL PRODUCTS',
  '15:69A.M': '15:69A.M             MISBRANDING AND FALSE ADVERTISING/IN...',
  '15:69D.M': '15:69D.M             EXCLUSION OF MISBRANDED OR FALSELY I...',
  '15:69H.M': '15:69H.M             FALSE GUARANTY',
  '15:69I.M': '15:69I.M             MIS-LABELING OF FUR PRODUCTS',
  '15:70A.M': '15:70A.M             MISBRANDING AND FALSE ADVERTISING DE...',
  '15:70C.M': '15:70C.M             REMOVAL OF STAMP, TAG, LABEL, OR OTH...',
  '15:70D.M': '15:70D.M             MAINTAINING AND KEEPING PROPER RECORDS',
  '15:70G.M': '15:70G.M             EXCLUSION OF MISBRANDED TEXTILE FIBE...',
  '15:70H.M': '15:70H.M             FALSE GUARANTY',
  '15:70I.M': '15:70I.M             TEXTILES PRODUCTS - REGULATIONS AND ...',
  '15:714.F': '15:714.F             FALSE STATEMENTS: OVERVALUATION OF S...',
  '15:714.M': '15:714.M             LARCENY: CONVERSION OF PROPERTY',
  '15:715B.P': '15:715B.P            INTERSTATE TRANSPORTATION OF CONTRAB...',
  '15:715D.P': '15:715D.P            RULES AND REGULATIONS: CERTIFICATES ...',
  '15:715E.P': '15:715E.P            INTERSTATE TRANSPORTATION OF PETROLE...',
  '15:717B.F': '15:717B.F            EXPORTATION OR IMPORTATION OF NATURA...',
  '15:717B.P': '15:717B.P            EXPORTATION OR IMPORTATION OF NATURA...',
  '15:717C.F': '15:717C.F            RATES AND CHARGES: SCHEDULES, SUSPEN...',
  '15:717C.P': '15:717C.P            RATES AND CHARGES: SCHEDULES, SUSPEN...',
  '15:717E.F': '15:717E.F            ASCERTAINMENT OF COST OF PROPERTY',
  '15:717E.P': '15:717E.P            ASCERTAINMENT OF COST OF PROPERTY',
  '15:717F.F': '15:717F.F            CONSTRUCTION, EXTENSION, OR ABANDONM...',
  '15:717F.P': '15:717F.P            CONSTRUCTION, EXTENSION, OR ABANDONM...',
  '15:717G.F': '15:717G.F            ACCOUNTS: RECORDS: MEMORANDA',
  '15:717G.P': '15:717G.P            ACCOUNTS: RECORDS: MEMORANDA',
  '15:717H.F': '15:717H.F            RATES OF DEPRECIATION',
  '15:717H.P': '15:717H.P            RATES OF DEPRECIATION',
  '15:717I.F': '15:717I.F            PERIODIC AND SPECIAL REPORTS',
  '15:717I.P': '15:717I.P            PERIODIC AND SPECIAL REPORTS',
  '15:717J.F': '15:717J.F            STATE COMPACTS: REPORTS ON',
  '15:717J.P': '15:717J.P            STATE COMPACTS: REPORTS ON',
  '15:717K.F': '15:717K.F            OFFICIALS DEALING IN SECURITIES',
  '15:717K.P': '15:717K.P            OFFICIALS DEALING IN SECURITIES',
  '15:717M.M': '15:717M.M            REFUSAL TO TESTIFY BEFORE FPC',
  '15:717N.F': '15:717N.F            HEARINGS: RULES OF PROCEDURE',
  '15:717N.P': '15:717N.P            HEARINGS: RULES OF PROCEDURE',
  '15:717O.F': '15:717O.F            ADMINISTRATIVE POWERS OF COMMERCE: R...',
  '15:717O.P': '15:717O.P            ADMINISTRATIVE POWERS OF COMMERCE: R...',
  '15:717P.F': '15:717P.F            USE OF JOINT BOARDS: COOPERATION W/S...',
  '15:717P.P': '15:717P.P            USE OF JOINT BOARDS: COOPERATION W/S...',
  '15:717T.F': '15:717T.F            NATURAL GAS REGULATIONS',
  '15:717T.P': '15:717T.P            NATURAL GAS REGULATIONS',
  '15:72.M': '15:72.M              IMPORT OR SELL ARTICLES, EXCLUDES MO...',
  '15:754.M': '15:754.M             PRODUCTION OR REFINING OF CRUDE OIL',
  '15:77E.F': '15:77E.F             PROHIBITIONS - INTERSTATE COMMERCE A...',
  '15:77F.F': '15:77F.F             REGISTRATION AND SIGNING OF SECURITIES',
  '15:77Q.F': '15:77Q.F             FRAUDULENT INTERSTATE TRANSACTIONS',
  '15:77X.F': '15:77X.F             SECURITIES VIOLATIONS',
  '15:77Y.F': '15:77Y.F             SECURITIES VIOLATIONS',
  '15:78D.F': '15:78D.F             FOREIGN SECURITIES EXCHANGES',
  '15:78E.F': '15:78E.F             TRANSACTIONS ON UNREGISTERED EXCHANGES',
  '15:78F.F': '15:78F.F             REGISTRATION OF NATIONAL SECURITIES ...',
  '15:78F.M': '15:78F.M             SECURITIES EXCHANGE PENALTIES',
  '15:78G.F': '15:78G.F             MARGIN REQUIREMENTS',
  '15:78H.F': '15:78H.F             RESTRICTIONS ON BORROWING BY MEMBERS',
  '15:78I.F': '15:78I.F             MANIPULATION OF SECURITY PRICES',
  '15:78J.F': '15:78J.F             MANIPULATIVE AND DECEPTIVE DEVICES',
  '15:78K.F': '15:78K.F             SEGREGATE OR LIMIT OF FUNCTIONS OF M...',
  '15:78L.F': '15:78L.F             REGISTRATION REQUIREMENTS FOR SECURI...',
  '15:78M.F': '15:78M.F             PERIODICAL AND OTHER REPORTS',
  '15:78N.F': '15:78N.F             PROXIES',
  '15:78O.F': '15:78O.F             OVER-THE-COUNTER MARKETS: REGISTER B...',
  '15:78P.F': '15:78P.F             DIRECTORS, OFFICERS, AND PRINCIPAL S...',
  '15:78Q.F': '15:78Q.F             ACCOUNTS AND RECORDS, REPORTS, EXAMI...',
  '15:78R.F': '15:78R.F             LIABILITY FOR MISLEADING STATEMENTS',
  '15:78T.F': '15:78T.F             LIABILITIES OF CONTROLLING PERSONS',
  '15:78X.F': '15:78X.F             INFORMATION FILED WITH THE COMMISSION',
  '15:78Z.F': '15:78Z.F             UNLAWFUL REPRESENTATIONS',
  '15:79D.F': '15:79D.F             TRANSACTIONS BY UNREGISTERED HOLDING...',
  '15:79E.F': '15:79E.F             REGISTRATION OF HOLDING COMPANIES',
  '15:79F.F': '15:79F.F             UNLAWFUL TRANSACTION BY REGISTERED C...',
  '15:79I.F': '15:79I.F             ACQUISITION OF SECURITIES AND UTILITY',
  '15:79J.F': '15:79J.F             APPROVAL OF ACQUISITION OF SECURITIES',
  '15:79K.F': '15:79K.F             SIMPLIFICATION OF HOLDING COMPANY SY...',
  '15:79L.F': '15:79L.F             INTERCOMPANY AND OTHER TRANSACTIONS',
  '15:79M.F': '15:79M.F             SERVICE, SALES AND CONSTRUCTION CONT...',
  '15:79N.F': '15:79N.F             PERIODIC AND OTHER REPORTS',
  '15:79O.F': '15:79O.F             ACCOUNTS AND RECORDS',
  '15:79R.M': '15:79R.M             REFUSAL TO TESTIFY BEFORE SECRETARY',
  '15:79V.F': '15:79V.F             ACCESS OF PUBLIC TO INFORMATION FILE...',
  '15:79Z.F': '15:79Z.F             LIABILITY OF CONTROLLING PERSON',
  '15:8.M': '15:8.M               TRUSTS IN RESTRAINT OF IMPORT TRADE',
  '15:80A.F': '15:80A.F             AFFILIATIONS OR INTEREST OF DIRECTOR...',
  '15:80B.F': '15:80B.F             DISCLOSURE OF INFORMATION BY COMMISSION',
  '15:80B.M': '15:80B.M             REFUSAL TO TESTIFY BEFORE SECURITIES...',
  '16:114.M': '16:114.M             MESA VERDE NATIONAL PARK - REMOVE, D...',
  '16:1151.M': '16:1151.M            FUR SEAL MANAGEMENT',
  '16:1167.P': '16:1167.P            PENALTIES FOR VIOLATIONS - PRIBILOF ...',
  '16:117.M': '16:117.M             MESA VERDE NATIONAL PARK - HUNTING A...',
  '16:117.P': '16:117.P             MESA VERDE NATIONAL PARK - HUNTING A...',
  '16:1171.M': '16:1171.M            CONTRACTS, AGREEMENTS OR LEASES',
  '16:121.M': '16:121.M             CRATER LAKE NATIONAL PARK - ESTABLIS...',
  '16:122.M': '16:122.M             CRATER LAKE NATIONAL PARK - ESTABLIS...',
  '16:123.M': '16:123.M             CRATER LAKE NATIONAL PARK',
  '16:124.P': '16:124.P             JURISDICTION OF THE U.S. - FUGITIVES...',
  '16:1246.P': '16:1246.P            NATIONAL TRAILS SYSTEM',
  '16:127.P': '16:127.P             CRATER LAKE NATIONAL PARK - HUNTING ...',
  '16:128.P': '16:128.P             HUNTING AND FISHING: FORFEITURE/SEIZ...',
  '16:1338.M': '16:1338.M            PROTECT WILD, FREE-ROAMING HORSES/BU...',
  '16:1372.M': '16:1372.M            MARINE MAMMALS',
  '16:1373.M': '16:1373.M            REGULATIONS ON TAKING OF MARINE MAMMALS',
  '16:1374.M': '16:1374.M            PERMITS ON TAKING OF MARINE MAMMALS',
  '16:1375.M': '16:1375.M            PENALTIES',
  '16:1382.M': '16:1382.M            REGULATIONS AND ADMINISTRATION',
  '16:146.M': '16:146.M             WIND COVE NATIONAL PARK - OFFENSES',
  '16:152.P': '16:152.P             PLATT NATIONAL PARK - PENALTIES',
  '16:1533.M': '16:1533.M            DETERMINATION OF ENDANGERED SPECIES',
  '16:1538.M': '16:1538.M            PROHIBITED ACTS - ENDANGERED SPECIES',
  '16:1538.P': '16:1538.P            ENDANGERED SPECIES ACT',
  '16:1540.M': '16:1540.M            ENDANGERED SPECIES - PENALTIES',
  '16:163.P': '16:163.P             JURISDICTION BY THE U.S. - FUGITIVES...',
  '16:170.P': '16:170.P             GLACIER NATIONAL PARK - HUNTING AND ...',
  '16:171.P': '16:171.P             FORFEITURES AND SEIZURES OF GUNS, TRAPS',
  '16:1857B.M': '16:1857B.M           FISHING IN U.S. WATERS WITHOUT PERMIT',
  '16:1857E.F': '16:1857E.F           FORCIBLY ASSAULT, RESIST, IMPEDE OFF...',
  '16:1857E.M': '16:1857E.M           FORCIBLY ASSAULT, RESIST, IMPEDE OFF...',
  '16:1857I.P': '16:1857I.P           KNOW&amp;WILLFLLY SUBMIT FALSE INFO ON M...',
  '16:1859.F': '16:1859.F            AGGRAVATED OR FELONIOUS ASSAULT',
  '16:1859.M': '16:1859.M            AGGRAVATED OR FELONIOUS ASSAULT',
  '16:198.P': '16:198.P             ROCKY MOUNTAIN NATIONAL PARK - PENAL...',
  '16:204.P': '16:204.P             LASSEN VOLCANIC NATIONAL PARK - HUNT...',
  '16:256B.P': '16:256B.P            OLYMPIC NATIONAL PARK - HUNTING AND ...',
  '16:256C.P': '16:256C.P            FORFEITURE OF PROPERTY USED IN HUNTI...',
  '16:26.P': '16:26.P              REGULATIONS FOR HUNTING AND FISHING ...',
  '16:3.P': '16:3.P               NATIONAL PARK/RECREATION VIOLATIONS',
  '16:3372.F': '16:3372.F            PROHIBITED ACTS, OTHER THAN MARKING ...',
  '16:3372.M': '16:3372.M            GAME CONSERVATION ACTS',
  '16:3373.F': '16:3373.F            IMPORTS/EXPORTS FISH, WILDLIFE OR PL...',
  '16:3373.M': '16:3373.M            KNOWING FISH, WILDLIFE, PLANTS WERE ...',
  '16:3374.F': '16:3374.F            CONTROL OF ILLEGALLY TAKEN FISH AND ...',
  '16:3374.M': '16:3374.M            CONTROL OF ILLEGALLY TAKEN FISH AND ...',
  '16:354.P': '16:354.P             MT. MCKINLEY NATIONAL PARK',
  '16:395.P': '16:395.P             HALEAKALA NATIONAL PARK - HUNTING AN...',
  '16:403C.P': '16:403C.P            SHENANDOAH PARK - HUNTING AND FISHING',
  '16:403H.P': '16:403H.P            GREAT SMOKEY MOUNTAINS NATIONAL PARK...',
  '16:404.P': '16:404.P             MAMMOTH CAVE NATIONAL PARK - HUNTING...',
  '16:408.P': '16:408.P             ISLE ROYALE NATIONAL PARK - HUNTING ...',
  '16:413.M': '16:413.M             NATIONAL MILITARY PARKS - STRUCTURES...',
  '16:414.P': '16:414.P             NATIONAL MILITARY PARKS - HUNTING AN...',
  '16:430H.P': '16:430H.P            VICKSBURG NATIONAL MILITARY PARK',
  '16:430Q.P': '16:430Q.P            MONOCACY NATIONAL MILITARY PARK - OF...',
  '16:430V.P': '16:430V.P            KENNESAW MOUNTAIN NATIONAL BATTLEFIE...',
  '16:433.P': '16:433.P             AMERICAN ANTIQUITIES - INQUIRIES TO',
  '16:45A.P': '16:45A.P             SEQUOIA NATIONAL PARK: REVISION OF B...',
  '16:45B.P': '16:45B.P             RULES AND REGULATIONS: LEASES: FISH ...',
  '16:45C.P': '16:45C.P             PRIOR CLAIMS, LOCATIONS, AND ENTRIES',
  '16:45D.P': '16:45D.P             EXCLUSIVE PRIVILEGES PROHIBITED',
  '16:45E.P': '16:45E.P             SEQUOIA NATIONAL PARK',
  '16:460D.P': '16:460D.P            CONSTRUCTION AND OPERATION OF PUBLIC...',
  '16:460K.P': '16:460K.P            PUBLIC RECREATION USE OF FISH AND WI...',
  '16:460N.P': '16:460N.P            PURPOSES AND USES OF AREA',
  '16:470.F': '16:470.F             ARCHAEOLOGICAL RESOURCE PROTECTION ACT',
  '16:470.M': '16:470.M             ARCHAEOLOGICAL RESOURCE PROTECTION ACT',
  '16:4711.F': '16:4711.F            VIOLATION OF NON-INDIGENOUS AQUATIC ...',
  '16:477.P': '16:477.P             USE OF TIMBER AND STONE BY SETTLERS',
  '16:478.P': '16:478.P             EGRESS OR INGRESS OF ACTUAL SETTLERS',
  '16:479.P': '16:479.P             SITES FOR SCHOOLS AND CHURCHES',
  '16:481.P': '16:481.P             USE OF WATERS',
  '16:482.P': '16:482.P             MINERAL LANDS: RESTORATION TO PUBLIC...',
  '16:551.P': '16:551.P             PROTECTION OF NATIONAL FORESTS - RUL...',
  '16:604.P': '16:604.P             CUTTING TIMBER ON CERTAIN MINERAL LANDS',
  '16:605.P': '16:605.P             NOTICE OF UNLAWFUL CUTTING',
  '16:606.P': '16:606.P             CUTTING TIMBER ON CERTAIN MINERAL LANDS',
  '16:661.M': '16:661.M             DECLARATION OF PURPOSES: COOPERATION...',
  '16:662.M': '16:662.M             IMPOUNDING, DIVERTING, OR CONTROLLIN...',
  '16:663.M': '16:663.M             IMPOUNDING, DIVERTING, OR CONTROLLIN...',
  '16:664.M': '16:664.M             ADMINISTRATION: RULES AND REGULATIONS',
  '16:665.M': '16:665.M             INVESTIGATIONS AS TO EFFECT OF SEWAGE',
  '16:666.M': '16:666.M             WILDLIFE PROTECTION - OFFENSES',
  '16:668A.F': '16:668A.F            USE OF BALD AND GOLDEN EAGLE FOR SCI...',
  '16:668A.M': '16:668A.M            USE OF BALD AND GOLDEN EAGLE FOR SCI...',
  '16:668C.M': '16:668C.M            IMPORTATION OF ENDANGERED SPECIES',
  '16:668C.P': '16:668C.P            REGULATIONS',
  '16:668D.M': '16:668D.M            NATIONAL WILDLIFE REFUGE SYSTEM',
  '16:668D.P': '16:668D.P            NATIONAL WILDLIFE REFUGE SYSTEM',
  '16:671.F': '16:671.F             NATIONAL BISON RANGE',
  '16:690D.P': '16:690D.P            INJURIES TO PROPERTY: DISTURBANCE OF...',
  '16:690G.P': '16:690G.P            BEAR PARK MIGRATORY BIRD REFUGE',
  '16:693.P': '16:693.P             GAME SANCTUARY/REFUGE IN QUACHITA NA...',
  '16:701.P': '16:701.P             MIGRATORY BIRD LAWS',
  '16:703.F': '16:703.F             TAKING, KILLING, OR POSSESSING MIGRA...',
  '16:703.P': '16:703.P             TAKING, KILLING, OR POSSESSING MIGRA...',
  '16:704.F': '16:704.F             RULES AND REGULATIONS ON MIGRATORY B...',
  '16:704.M': '16:704.M             RULES AND REGULATIONS ON MIGRATORY B...',
  '16:704.P': '16:704.P             RULES AND REGULATIONS ON MIGRATORY B...',
  '16:705.F': '16:705.F             TRANSPORTING OR IMPORTING MIGRATORY ...',
  '16:705.P': '16:705.P             TRANSPORTING OR IMPORTING MIGRATORY ...',
  '16:706.F': '16:706.F             ARRESTS AND SEARCH WARRANTS',
  '16:706.P': '16:706.P             ARRESTS AND SEARCH WARRANTS',
  '16:707A.P': '16:707A.P            VIOLATIONS AND PENALTIES - FORFEITURES',
  '16:707B.F': '16:707B.F            VIOLATIONS AND PENALTIES - FORFEITURES',
  '16:707C.M': '16:707C.M            VIOLATIONS AND PENALTIES - FORFEITURES',
  '16:708.F': '16:708.F             STATE OR TERRITORY LAWS',
  '16:708.P': '16:708.P             STATE OR TERRITORY LAWS',
  '16:711.F': '16:711.F             BREEDING/SALE FOR FOOD',
  '16:711.P': '16:711.P             BREEDING/SALE FOR FOOD',
  '16:718A.F': '16:718A.F            HUNTING LICENSE/STAMP FOR MIGRATORY ...',
  '16:718A.P': '16:718A.P            HUNTING LICENSE/STAMP FOR MIGRATORY ...',
  '16:718E.F': '16:718E.F            OFFENSES DEFINED',
  '16:718E.P': '16:718E.P            OFFENSES DEFINED',
  '16:718G.F': '16:718G.F            PENALTIES',
  '16:718G.P': '16:718G.P            PENALTIES',
  '16:725.P': '16:725.P             REGULATIONS, ETC. BY SECRETARY OF TH...',
  '16:726.P': '16:726.P             ACTS PROHIBITED IN REFUGE: COMMERCIA...',
  '16:730.P': '16:730.P             PENALTIES',
  '16:742.M': '16:742.M             PROHIBITION ON AIRBORNE HUNTING',
  '16:781.P': '16:781.P             TAKING OR CATCHING SPONGES &lt; PRESCRI...',
  '16:783.P': '16:783.P             PENALTIES - LIABILITY OF VESSELS',
  '16:811.P': '16:811.P             OPERATION OF NAVIGATION FACILITIES: ...',
  '16:825.F': '16:825.F             ACCOUNTS AND RECORDS, MAINTAINING',
  '16:825.P': '16:825.P             ACCOUNTS AND RECORDS, MAINTAINING',
  '16:825C.F': '16:825C.F            PERIODIC AND SPECIAL REPORTS, MAINTA...',
  '16:825C.P': '16:825C.P            PERIODIC AND SPECIAL REPORTS, MAINTA...',
  '16:825D.F': '16:825D.F            OFFICIALS DEALING IN SECURITIES',
  '16:825D.P': '16:825D.P            OFFICIALS DEALING IN SECURITIES',
  '16:825F.M': '16:825F.M            INVESTIGATIONS BY COMMISSION: DEPOSI...',
  '16:825O.F': '16:825O.F            PENALTIES',
  '16:825O.P': '16:825O.P            PENALTIES',
  '16:9.P': '16:9.P               GOVERNMENT OF PARKS, ETC.',
  '16:916C.M': '16:916C.M            ILLEGAL WHALING',
  '16:916D.M': '16:916D.M            LICENSES',
  '16:916E.P': '16:916E.P            FAILURE TO KEEP RETURNS, RECORDS, RE...',
  '16:916F.M': '16:916F.M            VIOLATIONS, FINES AND PENALTIES',
  '16:957A.M': '16:957A.M            VIOLATION OF TUNA CONVENTIONS - 1ST ...',
  '16:957B.P': '16:957B.P            VIOLATION OF TUNA CONVENTIONS - 2ND ...',
  '16:957C.M': '16:957C.M            IMPORTING TUNA ILLEGALLY',
  '16:957D.M': '16:957D.M            VIOLATIONS, FINES AND FORFEITURES',
  '16:957E.P': '16:957E.P            VIOLATIONS, FINES AND FORFEITURES',
  '16:957F.M': '16:957F.M            VIOLATIONS, FINES AND FORFEITURES',
  '17:104A.M': '17:104A.M            COPYRIGHT - WILLFUL INFRINGEMENT FOR...',
  '17:104B.F': '17:104B.F            INFRINGEMENT OF COPYRIGHT - 2ND OFFENSE',
  '17:104B.M': '17:104B.M            INFRINGEMENT OF COPYRIGHT - 1ST OFFENSE',
  '17:105.P': '17:105.P             FRAUDULENT NOTICE OF COPYRIGHT',
  '17:1201.F': '17:1201.F            CIRCUMVENTION OF COPYRIGHT PROTECTION',
  '17:1204.F': '17:1204.F            COPYRIGHT PROTECTION AND MANAGEMENT ...',
  '17:14.P': '17:14.P              COPYRIGHT - FAILURE TO DEPOSIT',
  '17:18.P': '17:18.P              MAKING FALSE AFFIDAVIT TO OBTAIN COP...',
  '17:506A.F': '17:506A.F            CRIMINAL INFRINGEMENT OF A COPYRIGHT',
  '17:506C.P': '17:506C.P            FRAUDULENT COPYRIGHT NOTICE',
  '17:506D.P': '17:506D.P            FRAUDULENT REMOVAL OF COPYRIGHT NOTICE',
  '17:506E.P': '17:506E.P            FALSE REPRESENTATION',
  '17A:102.F': '17A:102.F            COPYRIGHT LAWS',
  '17A:102.M': '17A:102.M            COPYRIGHT LAWS',
  '17A:106.F': '17A:106.F            RIGHTS IN COPYRIGHTED WORKS',
  '17A:106.M': '17A:106.M            RIGHTS IN COPYRIGHTED WORKS',
  '17A:506A.F': '17A:506A.F           CRIMINAL INFRINGEMENT ON COPYRIGHTS',
  '17A:506A.M': '17A:506A.M           CRIMINAL INFRINGEMENT ON COPYRIGHTS',
  '17A:506C.P': '17A:506C.P           FRAUDULENT COPYRIGHT NOTICES',
  '17A:506D.P': '17A:506D.P           FRAUDULENT COPYRIGHT NOTICES',
  '17A:506E.P': '17A:506E.P           FALSE REPRESENTATION OF COPYRIGHTS',
  182: '182                  test by patty',
  '18:1001.F': '18:1001.F            STATEMENTS OR ENTRIES GENERALLY',
  '18:1002.F': '18:1002.F            POSSESS OF FALSE PAPERS TO DEFRAUD U.S.',
  '18:1003.F': '18:1003.F            DEMANDS AGAINST THE UNITED STATES  (T)',
  '18:1003.M': '18:1003.M            DEMANDS AGAINST THE UNITED STATES  (T)',
  '18:1004.F': '18:1004.F            CERTIFICATION OF CHECKS',
  '18:1005.F': '18:1005.F            BANK ENTRIES, REPORTS AND TRANSACTIONS',
  '18:1006.F': '18:1006.F            FEDERAL CREDIT INSTITUTION ENTRIES, ...',
  '18:1007.F': '18:1007.F            FDIC TRANSACTION',
  '18:1010.F': '18:1010.F            Dept. of HUD and FHA Transactions',
  '18:1011.M': '18:1011.M            FEDERAL LAND BANK MORTGAGE TRANSACTIONS',
  '18:1012.M': '18:1012.M            DEPARTMENT OF HUD TRANSACTIONS',
  '18:1013.M': '18:1013.M            FARM LOAN BONDS AND CREDIT BANK DEBE...',
  '18:1014.F': '18:1014.F            LOAN AND CREDIT APPLICATIONS GENERALLY',
  '18:1015.F': '18:1015.F            NATURALIZATION/CITIZENSHIP/ALIEN REG...',
  '18:1016.F': '18:1016.F            ACKNOWLEDGMENT OF APPEARANCE OR OATH',
  '18:1017.F': '18:1017.F            GOVERNMENT SEALS/INSTRUMENTS WRONGFU...',
  '18:1018.M': '18:1018.M            OFFICIAL CERTIFICATES OR WRITINGS',
  '18:1019.F': '18:1019.F            CERTIFICATES BY CONSULAR OFFICERS',
  '18:1020.F': '18:1020.F            HIGHWAY PROJECTS',
  '18:1021.F': '18:1021.F            TITLE RECORDS',
  '18:1022.F': '18:1022.F            DELIVERY OF CERTIFICATE, VOUCHER, RE...',
  '18:1023.F': '18:1023.F            INSUFFICIENT DELIVERY OF MONEY/PROPE...',
  '18:1024.F': '18:1024.F            PURCHASE OR RECEIPT OF MILITARY, NAV...',
  '18:1025.F': '18:1025.F            FALSE PRETENSES ON HIGH SEAS',
  '18:1025.M': '18:1025.M            FALSE PRETENSES ON HIGH SEAS',
  '18:1026.M': '18:1026.M            COMPROMISE, ADJUSTMENT, CANCEL/FARM ...',
  '18:1027.F': '18:1027.F            FALSE STATEMENTS/CONCEALMENT OF FACT...',
  '18:1028A.F': '18:1028A.F           FRAUD WITH IDENTIFICATION DOCUMENTS',
  '18:1028A.M': '18:1028A.M           FRAUD WITH IDENTIFICATION DOCUMENTS',
  '18:1028B.F': '18:1028B.F           FRAUD WITH IDENTIFICATION DOCUMENTS',
  '18:1028B.M': '18:1028B.M           FRAUD WITH IDENTIFICATION DOCUMENTS',
  '18:1029A.F': '18:1029A.F           PRODUCES/TRAFFICS IN COUNTERFEIT DEVICE',
  '18:1029B.F': '18:1029B.F           ATTEMPTS TO COMMIT AN OFFENSE',
  '18:1030A.F': '18:1030A.F           FRAUD ACTIVITY CONNECTED WITH COMPUTERS',
  '18:1030A.M': '18:1030A.M           FRAUD ACTIVITY CONNECTED WITH COMPUTERS',
  '18:1030B.F': '18:1030B.F           COMPUTER FRAUD',
  '18:1030B.M': '18:1030B.M           COMPUTER FRAUD',
  '18:1030B.P': '18:1030B.P           COMPUTER FRAUD',
  '18:1031.F': '18:1031.F            MAJOR FRAUD AGAINST U. S.',
  '18:1032.F': '18:1032.F            CONCEAL ASSETS FROM RECEIVER/CONSERV...',
  '18:1033B.F': '18:1033B.F           INSURANCE CRIMES AFFECTING INTERSTAT...',
  '18:1033B.M': '18:1033B.M           INSURANCE CRIMES AFFECTING INTERSTAT...',
  '18:1035.F': '18:1035.F            FALSE STATEMENTS RELATING TO HEALTH ...',
  '18:1036.F': '18:1036.F            ENTRY BY FALSE PRETENSES TO ANY REAL...',
  '18:1036.P': '18:1036.P            ENTRY BY FALSE PRETENSES TO ANY REAL...',
  '18:1037.F': '18:1037.F            FRAUD AND RELATED ACTIVITY IN CONNEC...',
  '18:1037.M': '18:1037.M            FRAUD AND RELATED ACTIVITY IN CONNEC...',
  '18:1038.F': '18:1038.F            FALSE INFORMATION AND HOAXES',
  '18:1039.F': '18:1039.F            FRAUD AND FALSE STATEMENTS - OBTAINI...',
  '18:1040.F': '18:1040.F            DISASTER ASSISTANCE FRAUD',
  '18:1071.F': '18:1071.F            CONCEALING PERSON FROM ARREST',
  '18:1071.M': '18:1071.M            CONCEALING PERSON FROM ARREST',
  '18:1072.F': '18:1072.F            CONCEALING ESCAPED PRISONER',
  '18:1073.F': '18:1073.F            FLIGHT TO AVOID PROSECUTION/GIVING T...',
  '18:1074.F': '18:1074.F            FLIGHT TO AVOID PROSECUTION/DAMAGE, ...',
  '18:1082A.F': '18:1082A.F           GAMBLING SHIPS',
  '18:1082B.F': '18:1082B.F           GAMBLING SHIPS',
  '18:1084.F': '18:1084.F            TRANSMISSION OF WAGERING INFORMATION...',
  '18:111.F': '18:111.F             ASSAULTING/RESISTING/IMPEDING OFFICE...',
  '18:1111.F': '18:1111.F            MURDER, FIRST DEGREE',
  '18:1112.F': '18:1112.F            MANSLAUGHTER, INVOLUNTARY',
  '18:1112A.F': '18:1112A.F           VOLUNTARY MANSLAUGHTER',
  '18:1113.F': '18:1113.F            ATTEMPTED MURDER',
  '18:1114.F': '18:1114.F            PROTECTION OF OFFICERS AND EMPLOYEES...',
  '18:1115.F': '18:1115.F            MISCONDUCT OR NEGLECT OF SHIP OFFICERS',
  '18:1116.F': '18:1116.F            MURDER/MANSLAUGHTER OF FOREIGN OFFIC...',
  '18:1117.F': '18:1117.F            CONSPIRACY TO MURDER',
  '18:111A.M': '18:111A.M            ASSAULT, RESIST OR IMPEDE OFFICIAL  (T)',
  '18:1121.F': '18:1121.F            KILLING PERSONS AIDING FEDERAL INVES...',
  '18:112A.F': '18:112A.F            PROTECTION OF FOREIGN OFFICIAL GUESTS',
  '18:112B.P': '18:112B.P            PROTECTION OF FOREIGN OFFICIAL GUESTS',
  '18:112C.P': '18:112C.P            PROTECTION OF FOREIGN OFFICIAL GUESTS',
  '18:113A.F': '18:113A.F            ASSAULT WITH INTENT TO MURDER  (T)',
  '18:113B.F': '18:113B.F            ASSAULT WITH INTENT TO COMMIT FE... (T)',
  '18:113C.F': '18:113C.F            ASSAULT WITHIN MARITIME AND/OR TERRI...',
  '18:113D.P': '18:113D.P            ASSAULT, OTHER',
  '18:113E.M': '18:113E.M            SIMPLE ASSAULT WITHIN MARITIME AND T...',
  '18:113E.P': '18:113E.P            ASSAULT WITHIN SPECIAL MARITIME OR T...',
  '18:113F.F': '18:113F.F            ASSAULT WITHIN SPECIAL MARITIME OR T...',
  '18:113G.F': '18:113G.F            ASSAULT RESULTING IN SUBSTANTIAL BOD...',
  '18:114.F': '18:114.F             MAIMING WITHIN SPECIAL MARITIME OR T...',
  '18:115.F': '18:115.F             ASSAULT/THREAT TO ASSAULT - FEDERAL ...',
  '18:115.M': '18:115.M             ASSAULT/THREAT TO ASSAULT - FEDERAL ...',
  '18:1152.M': '18:1152.M            CURFEW, RESTRICTED AREAS',
  '18:1153.F': '18:1153.F            BURGLARY/ROBBERY WITHIN INDIAN COUNTRY',
  '18:1153.M': '18:1153.M            BURGLARY/ROBBERY WITHIN INDIAN COUNTRY',
  '18:1154.F': '18:1154.F            INTOXICANTS DISPENSED IN INDIAN COUNTRY',
  '18:1154.M': '18:1154.M            INTOXICANTS DISPENSED IN INDIAN COUNTRY',
  '18:1155.F': '18:1155.F            INTOXICANTS DISPENSED ON SCHOOL SITE',
  '18:1156.F': '18:1156.F            INTOXICANTS POSSESSED UNLAWFULLY',
  '18:1156.M': '18:1156.M            INTOXICANTS POSSESSED UNLAWFULLY',
  '18:1158.P': '18:1158.P            COUNTERFEITING INDIAN ARTS AND CRAFT...',
  '18:1159.P': '18:1159.P            MISREPRESENTATION IN SALE OF PRODUCTS',
  '18:115A.F': '18:115A.F            MURDER - FAMILY OF FEDERAL OFFICIAL',
  '18:115B.F': '18:115B.F            KIDNAPPING - FAMILY OF FEDERAL OFFICIAL',
  '18:115C.F': '18:115C.F            ASSAULT - FAMILY OF FEDERAL OFFICIAL',
  '18:1163.F': '18:1163.F            EMBEZZLEMENT FROM INDIAN TRIBAL ORGA...',
  '18:1163.M': '18:1163.M            EMBEZZLEMENT FROM INDIAN TRIBAL ORGA...',
  '18:1164.P': '18:1164.P            DESTROYING BOUNDARY AND WARNING SIGNS',
  '18:1165.P': '18:1165.P            HUNTING, TRAPPING, FISHING ON INDIAN...',
  '18:1167A.M': '18:1167A.M           THEFT FROM GAMING ESTABLISHMENTS ON ...',
  '18:1167B.F': '18:1167B.F           THEFT FROM GAMING ESTABLISHMENTS ON ...',
  '18:1168A.F': '18:1168A.F           THEFT BY OFF/EMPLOYEE OF GAMING EST....',
  '18:1168B.F': '18:1168B.F           THEFT BY OFF/EMPLOYEE OF GAMING EST....',
  '18:117.F': '18:117.F             DOMESTIC ASSAULT - HABITUAL OFFENDER',
  '18:1170.F': '18:1170.F            ILLEGAL TRAFFICKING - NATIVE AMERICA...',
  '18:1170.M': '18:1170.M            ILLEGAL TRAFFICKING - NATIVE AMERICA...',
  '18:1201.F': '18:1201.F            KIDNAPPING',
  '18:1202.F': '18:1202.F            RANSOM MONEY',
  '18:1203.F': '18:1203.F            HOSTAGE TAKING',
  '18:1204.F': '18:1204.F            INTERNATIONAL PARENTAL KIDNAPPING',
  '18:1231.F': '18:1231.F            BYRNES ACT - TRANSPORTATION OF STRIK...',
  '18:1262.M': '18:1262.M            TRANSPORTATION INTO STATE PROHIBITIN...',
  '18:1263.M': '18:1263.M            MARKS AND LABELS ON PACKAGE',
  '18:1264.M': '18:1264.M            DELIVERY TO CONSIGNEE',
  '18:1265.M': '18:1265.M            C.O.D. SHIPMENTS PROHIBITED',
  '18:13-0100.F': '18:13-0100.F         MURDER, FIRST DEGREE',
  '18:13-0101.F': '18:13-0101.F         MURDER, GOVERNMENT OFFICIALS',
  '18:13-0200.F': '18:13-0200.F         MURDER, SECOND DEGREE',
  '18:13-0201.F': '18:13-0201.F         MURDER, 2ND DEGREE, GOVERNMENT OFFIC...',
  '18:13-0300.F': '18:13-0300.F         MANSLAUGHTER',
  '18:13-0301.F': '18:13-0301.F         MANSLAUGHTER',
  '18:13-0310.F': '18:13-0310.F         INVOLUNTARY MANSLAUGHTER',
  '18:13-0311.F': '18:13-0311.F         NEGLIGENT HOMICIDE',
  '18:13-1100.F': '18:13-1100.F         ROBBERY, BANK',
  '18:13-1200.F': '18:13-1200.F         ROBBERY, POSTAL',
  '18:13-1400.F': '18:13-1400.F         ROBBERY, OTHER',
  '18:13-1400.M': '18:13-1400.M         ROBBERY, OTHER',
  '18:13-1500.F': '18:13-1500.F         AGGRAVATED OR FELONIOUS ASSAULT',
  '18:13-1500.M': '18:13-1500.M         ASSAULT WHILE RESISTING ARREST',
  '18:13-1500.P': '18:13-1500.P         SIMPLE ASSAULT',
  '18:13-1501.F': '18:13-1501.F         FELONY, ON GOVERNMENT OFFICIAL',
  '18:13-1560.F': '18:13-1560.F         FAIR HOUSING LAW',
  '18:13-1560.M': '18:13-1560.M         FAIR HOUSING LAW',
  '18:13-1560.P': '18:13-1560.P         FAIR HOUSING LAW',
  '18:13-1600.M': '18:13-1600.M         ASSAULT, OTHER',
  '18:13-1600.P': '18:13-1600.P         ASSAULT, OTHER',
  '18:13-1601.M': '18:13-1601.M         ASSAULT ON GOVERNMENT OFFICIAL',
  '18:13-1601.P': '18:13-1601.P         ASSAULT ON GOVERNMENT OFFICIAL',
  '18:13-2100.F': '18:13-2100.F         BURGLARY, BANK',
  '18:13-2200.F': '18:13-2200.F         BURGLARY, POSTAL',
  '18:13-2300.F': '18:13-2300.F         INTERSTATE COMMERCE',
  '18:13-2400.F': '18:13-2400.F         BURGLARY, OTHER',
  '18:13-2400.M': '18:13-2400.M         BURGLARY, OTHER',
  '18:13-2400.P': '18:13-2400.P         BURGLARY, OTHER',
  '18:13-3100.F': '18:13-3100.F         LARCENY AND THEFT, BANK',
  '18:13-3100.M': '18:13-3100.M         LARCENY AND THEFT, BANK',
  '18:13-3100.P': '18:13-3100.P         LARCENY AND THEFT, BANK',
  '18:13-3200.F': '18:13-3200.F         LARCENY AND THEFT, POSTAL',
  '18:13-3200.M': '18:13-3200.M         LARCENY AND THEFT, POSTAL',
  '18:13-3300.F': '18:13-3300.F         INTERSTATE COMMERCE',
  '18:13-3300.M': '18:13-3300.M         INTERSTATE COMMERCE',
  '18:13-3400.F': '18:13-3400.F         THEFT OF U.S. PROPERTY',
  '18:13-3400.M': '18:13-3400.M         THEFT OF U.S. PROPERTY',
  '18:13-3600.F': '18:13-3600.F         TRANSPORTATION OF STOLEN PROPERTY',
  '18:13-3700.F': '18:13-3700.F         LARCENY AND THEFT, FELONY OTHER',
  '18:13-3800.M': '18:13-3800.M         LARCENY AND THEFT, MISDEMEANOR OTHER',
  '18:13-3800.P': '18:13-3800.P         LARCENY AND THEFT, MISDEMEANOR OTHER',
  '18:13-4100.F': '18:13-4100.F         BANK EMBEZZLEMENT',
  '18:13-4100.M': '18:13-4100.M         BANK EMBEZZLEMENT',
  '18:13-4200.F': '18:13-4200.F         POSTAL EMBEZZLEMENT',
  '18:13-4200.M': '18:13-4200.M         POSTAL EMBEZZLEMENT',
  '18:13-4310.F': '18:13-4310.F         EMBEZZLES PUBLIC MONEYS OR PROPERTY',
  '18:13-4310.M': '18:13-4310.M         EMBEZZLES PUBLIC MONEYS OR PROPERTY',
  '18:13-4310.P': '18:13-4310.P         EMBEZZLES PUBLIC MONEYS OR PROPERTY',
  '18:13-4320.F': '18:13-4320.F         LENDING, CREDIT, INSURANCE INSTITUTIONS',
  '18:13-4320.M': '18:13-4320.M         LENDING, CREDIT, INSURANCE INSTITUTIONS',
  '18:13-4330.F': '18:13-4330.F         EMBEZZLEMENT: BY OFFICERS OF A CARRIER',
  '18:13-4340.F': '18:13-4340.F         WORLD WAR VETERANS RELIEF',
  '18:13-4350.F': '18:13-4350.F         EMBEZZLEMENT: OFFICER OR EMPLOYEE OF...',
  '18:13-4350.M': '18:13-4350.M         EMBEZZLEMENT: OFFICER OR EMPLOYEE OF...',
  '18:13-4390.F': '18:13-4390.F         EMBEZZLEMENT, OTHER',
  '18:13-4390.M': '18:13-4390.M         EMBEZZLEMENT, OTHER',
  '18:13-4510.F': '18:13-4510.F         INCOME TAX, EVADE OR DEFEAT',
  '18:13-4520.F': '18:13-4520.F         INCOME TAX, OTHER FELONY',
  '18:13-4520.M': '18:13-4520.M         INCOME TAX, OTHER FELONY',
  '18:13-4520.P': '18:13-4520.P         INCOME TAX, OTHER FELONY',
  '18:13-4530.F': '18:13-4530.F         INCOME TAX, FAILURE TO FILE',
  '18:13-4530.M': '18:13-4530.M         INCOME TAX, FAILURE TO FILE',
  '18:13-4530.P': '18:13-4530.P         INCOME TAX, FAILURE TO FILE',
  '18:13-4540.M': '18:13-4540.M         INCOME TAX, OTHER MISDEMEANOR',
  '18:13-4540.P': '18:13-4540.P         INCOME TAX, OTHER MISDEMEANOR',
  '18:13-4600.F': '18:13-4600.F         LENDING, CREDIT INSTITUTIONS',
  '18:13-4600.M': '18:13-4600.M         LENDING, CREDIT INSTITUTIONS',
  '18:13-4601.F': '18:13-4601.F         BANK FRAUD',
  '18:13-4700.F': '18:13-4700.F         POSTAL, INTERSTATE WIRE, RADIO, ETC.',
  '18:13-4700.M': '18:13-4700.M         POSTAL, INTERSTATE WIRE, RADIO, ETC.',
  '18:13-4700.P': '18:13-4700.P         POSTAL, INTERSTATE WIRE, RADIO, ETC.',
  '18:13-4800.F': '18:13-4800.F         VETERANS AND ALLOTMENTS',
  '18:13-4800.M': '18:13-4800.M         VETERANS AND ALLOTMENTS',
  '18:13-4800.P': '18:13-4800.P         VETERANS AND ALLOTMENTS',
  '18:13-4900.F': '18:13-4900.F         BANKRUPTCY',
  '18:13-4900.M': '18:13-4900.M         BANKRUPTCY',
  '18:13-4900.P': '18:13-4900.P         BANKRUPTCY',
  '18:13-4910.F': '18:13-4910.F         MARKETING AGREEMENTS AND COMMODITY C...',
  '18:13-4910.M': '18:13-4910.M         MARKETING AGREEMENTS AND COMMODITY C...',
  '18:13-4910.P': '18:13-4910.P         MARKETING AGREEMENTS AND COMMODITY C...',
  '18:13-4920.F': '18:13-4920.F         SECURITIES AND EXCHANGE',
  '18:13-4920.M': '18:13-4920.M         SECURITIES AND EXCHANGE',
  '18:13-4931.F': '18:13-4931.F         FRAUD, EXCISE TAX, OTHER',
  '18:13-4931.M': '18:13-4931.M         FRAUD, EXCISE TAX, OTHER',
  '18:13-4932.F': '18:13-4932.F         FRAUD, WAGERING TAX, OTHER',
  '18:13-4933.F': '18:13-4933.F         FRAUD, OTHER TAX',
  '18:13-4933.M': '18:13-4933.M         FRAUD, OTHER TAX',
  '18:13-4933.P': '18:13-4933.P         FRAUD, OTHER TAX',
  '18:13-4940.M': '18:13-4940.M         RAILROAD RETIREMENT AND UNEMPLOYMENT',
  '18:13-4940.P': '18:13-4940.P         RAILROAD RETIREMENT AND UNEMPLOYMENT',
  '18:13-4941.F': '18:13-4941.F         FRAUD - FOOD STAMP PROGRAM',
  '18:13-4941.M': '18:13-4941.M         FRAUD - FOOD STAMP PROGRAM',
  '18:13-4950.M': '18:13-4950.M         SOCIAL SECURITY',
  '18:13-4950.P': '18:13-4950.P         SOCIAL SECURITY',
  '18:13-4960.F': '18:13-4960.F         FALSE IMPERSONATION',
  '18:13-4960.M': '18:13-4960.M         FALSE IMPERSONATION',
  '18:13-4960.P': '18:13-4960.P         FALSE IMPERSONATION',
  '18:13-4970.F': '18:13-4970.F         NATIONALITY LAWS',
  '18:13-4980.F': '18:13-4980.F         PASSPORT FRAUD',
  '18:13-4980.M': '18:13-4980.M         PASSPORT FRAUD',
  '18:13-4980.P': '18:13-4980.P         PASSPORT FRAUD',
  '18:13-4991.F': '18:13-4991.F         FALSE CLAIMS AND STATEMENTS',
  '18:13-4991.M': '18:13-4991.M         FALSE CLAIMS AND STATEMENTS',
  '18:13-4991.P': '18:13-4991.P         FALSE CLAIMS AND STATEMENTS',
  '18:13-4992.F': '18:13-4992.F         FRAUD, CONSPIRACY TO DEFRAUD, OTHER',
  '18:13-4993.F': '18:13-4993.F         FRAUD, CONSPIRACY (GENERAL), OTHER',
  '18:13-4993.M': '18:13-4993.M         FRAUD, CONSPIRACY (GENERAL), OTHER',
  '18:13-4994.F': '18:13-4994.F         FRAUD, FALSE ENTRIES, OTHER',
  '18:13-4994.P': '18:13-4994.P         FRAUD, FALSE ENTRIES, OTHER',
  '18:13-4995.F': '18:13-4995.F         CREDIT CARD FRAUD',
  '18:13-4996.F': '18:13-4996.F         CREDIT CARD FRAUD',
  '18:13-4996.M': '18:13-4996.M         COMPUTER FRAUD',
  '18:13-4999.F': '18:13-4999.F         FRAUD, OTHER',
  '18:13-4999.M': '18:13-4999.M         FRAUD, OTHER',
  '18:13-4999.P': '18:13-4999.P         FRAUD, OTHER',
  '18:13-5100.F': '18:13-5100.F         TRANSPORT, ETC. STOLEN VEHICLES, AIR...',
  '18:13-5200.F': '18:13-5200.F         AUTO THEFT, OTHER',
  '18:13-5200.M': '18:13-5200.M         AUTO THEFT, OTHER',
  '18:13-5500.F': '18:13-5500.F         TRANSPORT FORGED SECURITIES',
  '18:13-5600.F': '18:13-5600.F         FORGERY, POSTAL',
  '18:13-5710.F': '18:13-5710.F         FORGERY, OTHER U.S.',
  '18:13-5710.M': '18:13-5710.M         FORGERY, OTHER U.S.',
  '18:13-5710.P': '18:13-5710.P         FORGERY, OTHER U.S.',
  '18:13-5720.F': '18:13-5720.F         FORGERY, OTHER',
  '18:13-5720.M': '18:13-5720.M         FORGERY, OTHER',
  '18:13-5720.P': '18:13-5720.P         FORGERY, OTHER',
  '18:13-5800.F': '18:13-5800.F         COUNTERFEITING',
  '18:13-5800.M': '18:13-5800.M         COUNTERFEITING',
  '18:13-5800.P': '18:13-5800.P         COUNTERFEITING',
  '18:13-6100.F': '18:13-6100.F         SEXUAL ABUSE',
  '18:13-6100.M': '18:13-6100.M         SEXUAL ABUSE',
  '18:13-6100.P': '18:13-6100.P         SEXUAL ABUSE',
  '18:13-6200.F': '18:13-6200.F         WHITE SLAVE AND IMPORTING ALIENS',
  '18:13-6200.M': '18:13-6200.M         WHITE SLAVE AND IMPORTING ALIENS',
  '18:13-6300.F': '18:13-6300.F         SEX OFFENSES, OTHER',
  '18:13-6300.M': '18:13-6300.M         SEX OFFENSES, OTHER',
  '18:13-6501.F': '18:13-6501.F         MARIJUANA - SELL, DISTRIBUTE ,OR DIS...',
  '18:13-6501.P': '18:13-6501.P         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '18:13-6700.F': '18:13-6700.F         NARCOTICS, OTHER',
  '18:13-6701.F': '18:13-6701.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '18:13-6800.F': '18:13-6800.F         CONTINUING CRIMINAL ENTERPRISE',
  '18:13-6802.M': '18:13-6802.M         CONTROLLED SUBSTANCE - IMPORTATION/E...',
  '18:13-6804.F': '18:13-6804.F         CONTROLLED SUBSTANCE - POSSESSION',
  '18:13-6804.P': '18:13-6804.P         CONTOLLED SUBSTANCE - POSSESSION',
  '18:13-6805.F': '18:13-6805.F         CONTROLLED SUBSTANCE - RECORDS, RX\'S...',
  '18:13-6807.F': '18:13-6807.F         ILLICIT DRUG PROFITS',
  '18:13-6808.F': '18:13-6808.F         CONTROLLED SUBSTANCES ABOARD AIRCRAFT',
  '18:13-6809.F': '18:13-6809.F         POSSESSION OF DRUG PARAPHERNALIA',
  '18:13-6809.M': '18:13-6809.M         POSSESSION OF DRUG PARAPHERNALIA',
  '18:13-6810.F': '18:13-6810.F         UNDER INFLUENCE ALCOHOL/DRUGS',
  '18:13-6907.F': '18:13-6907.F         ILLICIT DRUG PROFITS',
  '18:13-6911.F': '18:13-6911.F         OTHER DAPCA OFFENSES',
  '18:13-7100.F': '18:13-7100.F         BRIBERY',
  '18:13-7100.M': '18:13-7100.M         BRIBERY',
  '18:13-7100.P': '18:13-7100.P         BRIBERY',
  '18:13-7210.F': '18:13-7210.F         TRAFFIC OFFENSES, DRUNKEN DRIVING',
  '18:13-7210.M': '18:13-7210.M         TRAFFIC OFFENSES, DRUNKEN DRIVING',
  '18:13-7210.P': '18:13-7210.P         TRAFFIC OFFENSES, DRUNKEN DRIVING',
  '18:13-7220.F': '18:13-7220.F         TRAFFIC OFFENSES, OTHER',
  '18:13-7220.M': '18:13-7220.M         TRAFFIC OFFENSES, OTHER',
  '18:13-7220.P': '18:13-7220.P         TRAFFIC OFFENSES, OTHER',
  '18:13-7310.F': '18:13-7310.F         ESCAPE',
  '18:13-7310.M': '18:13-7310.M         ESCAPE',
  '18:13-7310.P': '18:13-7310.P         ESCAPE',
  '18:13-7311.F': '18:13-7311.F         ESCAPE, JUMPING BAIL',
  '18:13-7311.M': '18:13-7311.M         ESCAPE, JUMPING BAIL',
  '18:13-7320.F': '18:13-7320.F         ESCAPE, AIDING OR HARBORING',
  '18:13-7320.M': '18:13-7320.M         ESCAPE, AIDING OR HARBORING',
  '18:13-7400.F': '18:13-7400.F         EXTORTION, RACKETEERING, AND THREATS',
  '18:13-7400.M': '18:13-7400.M         EXTORTION, RACKETEERING, AND THREATS',
  '18:13-7400.P': '18:13-7400.P         EXTORTION, RACKETEERING, AND THREATS',
  '18:13-7401.F': '18:13-7401.F         THREATS AGAINST THE PRESIDENT',
  '18:13-7410.F': '18:13-7410.F         RACKETEERING, ARSON',
  '18:13-7420.F': '18:13-7420.F         RACKETEERING, BRIBERY',
  '18:13-7420.P': '18:13-7420.P         RACKETEERING, BRIBERY',
  '18:13-7430.F': '18:13-7430.F         RACKETEERING, EXTORTION',
  '18:13-7440.F': '18:13-7440.F         RACKETEERING, GAMBLING',
  '18:13-7450.F': '18:13-7450.F         RACKETEERING, LIQUOR',
  '18:13-7460.F': '18:13-7460.F         RACKETEERING, NARCOTICS',
  '18:13-7470.F': '18:13-7470.F         RACKETEERING, PROSTITUTION',
  '18:13-7471.F': '18:13-7471.F         RACKETEERING, MURDER',
  '18:13-7472.F': '18:13-7472.F         RACKETEERING, KIDNAP',
  '18:13-7473.F': '18:13-7473.F         RACKETEERING, MAIM',
  '18:13-7474.F': '18:13-7474.F         RACKETEERING, CONSPIRACY, MURDER, KI...',
  '18:13-7475.F': '18:13-7475.F         RACKETEERING, ATTEMPT/CONSPIRE TO MA...',
  '18:13-7477.F': '18:13-7477.F         RACKETEERING, MONEY LAUNDERING',
  '18:13-7478.F': '18:13-7478.F         RACKETEERING, MURDER, FIRST DEGREE',
  '18:13-7480.F': '18:13-7480.F         RACKETEERING, OTHER',
  '18:13-7481.F': '18:13-7481.F         RACKETEERING, ROBBERY',
  '18:13-7482.F': '18:13-7482.F         RACKETEERING, THREATS',
  '18:13-7490.F': '18:13-7490.F         RACKETEERING, EXTORTION, CREDIT TRAN...',
  '18:13-7500.F': '18:13-7500.F         GAMBLING AND LOTTERY',
  '18:13-7500.M': '18:13-7500.M         GAMBLING AND LOTTERY',
  '18:13-7520.F': '18:13-7520.F         GAMBLING AND LOTTERY, TRAVEL/RACKETE...',
  '18:13-7530.F': '18:13-7530.F         GAMBLING AND LOTTERY, TRANSMIT WAGER...',
  '18:13-7530.M': '18:13-7530.M         GAMBLING AND LOTTERY, TRANSMIT WAGER...',
  '18:13-7600.F': '18:13-7600.F         KIDNAPPING, INTERSTATE AND FOREIGN L...',
  '18:13-7601.F': '18:13-7601.F         KIDNAPPING, GOVERNMENT OFFICIALS',
  '18:13-7610.F': '18:13-7610.F         KIDNAPPING, LAWS OF STATES',
  '18:13-7611.F': '18:13-7611.F         KIDNAP, HOSTAGE',
  '18:13-7700.F': '18:13-7700.F         PERJURY',
  '18:13-7800.F': '18:13-7800.F         FIREARMS AND WEAPONS',
  '18:13-7800.M': '18:13-7800.M         FIREARMS AND WEAPONS',
  '18:13-7800.P': '18:13-7800.P         FIREARMS AND WEAPONS',
  '18:13-7820.F': '18:13-7820.F         FIREARMS, UNLAWFUL POSSESSION',
  '18:13-7820.M': '18:13-7820.M         FIREARMS, UNLAWFUL POSSESSION',
  '18:13-7830.F': '18:13-7830.F         FIREARMS',
  '18:13-7830.M': '18:13-7830.M         FIREARMS',
  '18:13-7910.F': '18:13-7910.F         ARSON',
  '18:13-7910.M': '18:13-7910.M         ARSON',
  '18:13-7930.F': '18:13-7930.F         BIGAMY',
  '18:13-7940.F': '18:13-7940.F         MALICIOUS DESTRUCTION OF PROPERTY',
  '18:13-7940.M': '18:13-7940.M         MALICIOUS DESTRUCTION OF PROPERTY',
  '18:13-7940.P': '18:13-7940.P         MALICIOUS DESTRUCTION OF PROPERTY',
  '18:13-7950.F': '18:13-7950.F         DISORDERLY CONDUCT',
  '18:13-7950.P': '18:13-7950.P         DISORDERLY CONDUCT',
  '18:13-7961.F': '18:13-7961.F         TRAVEL TO INCITE TO RIOT',
  '18:13-7962.F': '18:13-7962.F         CIVIL DISORDER',
  '18:13-7962.P': '18:13-7962.P         CIVIL DISORDER',
  '18:13-7990.F': '18:13-7990.F         MISCELLANEOUS GENERAL OFFENSES, OTHER',
  '18:13-7990.M': '18:13-7990.M         MISCELLANEOUS GENERAL OFFENSES, OTHER',
  '18:13-7990.P': '18:13-7990.P         MISCELLANEOUS GENERAL OFFENSES, OTHER',
  '18:13-8710.P': '18:13-8710.P         IMMIGRATION LAWS, ILLEGAL ENTRY',
  '18:13-8720.F': '18:13-8720.F         IMMIGRATION LAWS, ILLEGAL REENTRY',
  '18:13-8730.F': '18:13-8730.F         IMMIGRATION LAWS, OTHER',
  '18:13-8730.M': '18:13-8730.M         IMMIGRATION LAWS, OTHER',
  '18:13-8730.P': '18:13-8730.P         IMMIGRATION LAWS, OTHER',
  '18:13-8740.F': '18:13-8740.F         IMMIGRATION LAWS, ILLEGAL ENTRY',
  '18:13-8750.F': '18:13-8750.F         IMMIGRATION LAWS, FRAUDULENT CITIZEN...',
  '18:13-8900.F': '18:13-8900.F         LIQUOR, INTERNAL REVENUE',
  '18:13-8900.M': '18:13-8900.M         LIQUOR, INTERNAL REVENUE',
  '18:13-9001.F': '18:13-9001.F         HAZARDOUS WASTE-TREATMENT/DISPOSAL/S...',
  '18:13-9110.F': '18:13-9110.F         AGRICULTURE ACTS',
  '18:13-9110.M': '18:13-9110.M         AGRICULTURE ACTS',
  '18:13-9110.P': '18:13-9110.P         AGRICULTURE ACTS',
  '18:13-9120.P': '18:13-9120.P         AGRICULTURE, FEDERAL SEED ACT',
  '18:13-9130.F': '18:13-9130.F         GAME CONSERVATION ACTS',
  '18:13-9130.M': '18:13-9130.M         GAME CONSERVATION ACTS',
  '18:13-9130.P': '18:13-9130.P         GAME CONSERVATION ACTS',
  '18:13-9140.F': '18:13-9140.F         AGRICULTURE, INSECTICIDE ACT',
  '18:13-9140.M': '18:13-9140.M         AGRICULTURE, INSECTICIDE ACT',
  '18:13-9140.P': '18:13-9140.P         AGRICULTURE, INSECTICIDE ACT',
  '18:13-9150.F': '18:13-9150.F         NATIONAL PARK/RECREATION VIOLATIONS',
  '18:13-9150.M': '18:13-9150.M         NATIONAL PARK/RECREATION VIOLATIONS',
  '18:13-9150.P': '18:13-9150.P         NATIONAL PARK/RECREATION VIOLATIONS',
  '18:13-9160.F': '18:13-9160.F         AGRICULTURE, PACKERS AND STOCKYARD ACT',
  '18:13-9160.M': '18:13-9160.M         AGRICULTURE, PACKERS AND STOCKYARD ACT',
  '18:13-9160.P': '18:13-9160.P         AGRICULTURE, PACKERS AND STOCKYARD ACT',
  '18:13-9170.M': '18:13-9170.M         AGRICULTURE, PLANT QUARANTINE',
  '18:13-9170.P': '18:13-9170.P         AGRICULTURE, PLANT QUARANTINE',
  '18:13-9200.F': '18:13-9200.F         ANTITRUST VIOLATIONS',
  '18:13-9200.M': '18:13-9200.M         ANTITRUST VIOLATIONS',
  '18:13-9300.F': '18:13-9300.F         FAIR LABOR STANDARDS ACT',
  '18:13-9300.M': '18:13-9300.M         FAIR LABOR STANDARDS ACT',
  '18:13-9400.F': '18:13-9400.F         FOOD AND DRUG ACT',
  '18:13-9400.M': '18:13-9400.M         FOOD AND DRUG ACT',
  '18:13-9400.P': '18:13-9400.P         FOOD AND DRUG ACT',
  '18:13-9500.F': '18:13-9500.F         MIGRATORY BIRD LAWS',
  '18:13-9500.P': '18:13-9500.P         MIGRATORY BIRD LAWS',
  '18:13-9600.F': '18:13-9600.F         MOTOR CARRIER ACT',
  '18:13-9600.M': '18:13-9600.M         MOTOR CARRIER ACT',
  '18:13-9600.P': '18:13-9600.P         MOTOR CARRIER ACT',
  '18:13-9730.M': '18:13-9730.M         NATIONAL DEFENSE, DEFENSE PRODUCTION...',
  '18:13-9731.M': '18:13-9731.M         ECONOMIC STABILIZATION ACT OF 1970 -...',
  '18:13-9732.M': '18:13-9732.M         ECONOMIC STABILIZATION ACT OF 1970 -...',
  '18:13-9733.M': '18:13-9733.M         ECONOMIC STABILIZATION ACT OF 1970 -...',
  '18:13-9740.F': '18:13-9740.F         ALIEN REGISTRATION',
  '18:13-9740.P': '18:13-9740.P         ALIEN REGISTRATION',
  '18:13-9741.F': '18:13-9741.F         ENERGY FACILITY',
  '18:13-9751.F': '18:13-9751.F         TREASON',
  '18:13-9752.F': '18:13-9752.F         ESPIONAGE',
  '18:13-9752.M': '18:13-9752.M         ESPIONAGE',
  '18:13-9753.F': '18:13-9753.F         SABOTAGE',
  '18:13-9753.M': '18:13-9753.M         SABOTAGE',
  '18:13-9753.P': '18:13-9753.P         SABOTAGE',
  '18:13-9754.F': '18:13-9754.F         SEDITION',
  '18:13-9755.F': '18:13-9755.F         SMITH ACT',
  '18:13-9760.F': '18:13-9760.F         CURFEW, RESTRICTED AREAS',
  '18:13-9760.P': '18:13-9760.P         CURFEW, RESTRICTED AREAS',
  '18:13-9770.F': '18:13-9770.F         EXPORTATION OF WAR MATERIALS',
  '18:13-9770.M': '18:13-9770.M         EXPORTATION OF WAR MATERIALS',
  '18:13-9771.F': '18:13-9771.F         ANTI-APARTHEID PROGRAM',
  '18:13-9771.M': '18:13-9771.M         ANTI-APARTHEID PROGRAM',
  '18:13-9790.F': '18:13-9790.F         NATIONAL DEFENSE, OTHER',
  '18:13-9790.M': '18:13-9790.M         NATIONAL DEFENSE, OTHER',
  '18:13-9790.P': '18:13-9790.P         NATIONAL DEFENSE, OTHER',
  '18:13-9792.M': '18:13-9792.M         DEFENSE CONTRACTORS',
  '18:13-9810.F': '18:13-9810.F         OBSCENE MAIL',
  '18:13-9810.M': '18:13-9810.M         OBSCENE MAIL',
  '18:13-9810.P': '18:13-9810.P         OBSCENE MAIL',
  '18:13-9820.F': '18:13-9820.F         OBSCENE MATTER IN INTERSTATE COMMERCE',
  '18:13-9901.F': '18:13-9901.F         CIVIL RIGHTS',
  '18:13-9901.M': '18:13-9901.M         CIVIL RIGHTS',
  '18:13-9901.P': '18:13-9901.P         CIVIL RIGHTS',
  '18:13-9902.F': '18:13-9902.F         ELECTION LAW VIOLATORS',
  '18:13-9902.M': '18:13-9902.M         ELECTION LAW VIOLATORS',
  '18:13-9907.M': '18:13-9907.M         NOT REPORTING TRANSPORTATION OF CURR...',
  '18:13-9910.F': '18:13-9910.F         COMMUNICATION ACTS  (T)',
  '18:13-9910.M': '18:13-9910.M         COMMUNICATION ACTS  (T)',
  '18:13-9910.P': '18:13-9910.P         COMMUNICATION ACTS  (T)',
  '18:13-9911.F': '18:13-9911.F         WIRE INTERCEPTION',
  '18:13-9921.M': '18:13-9921.M         CONTEMPT',
  '18:13-9923.F': '18:13-9923.F         FORFEITURE, CRIMINAL OR DRUG RELATED',
  '18:13-9931.F': '18:13-9931.F         CUSTOMS LAWS  (T)',
  '18:13-9931.M': '18:13-9931.M         CUSTOMS LAWS  (T)',
  '18:13-9931.P': '18:13-9931.P         CUSTOMS LAWS  (T)',
  '18:13-9952.F': '18:13-9952.F         TAFT-HARTLEY ACT',
  '18:13-9952.M': '18:13-9952.M         TAFT-HARTLEY ACT',
  '18:13-9954.F': '18:13-9954.F         PEONAGE',
  '18:13-9971.F': '18:13-9971.F         MARITIME AND SHIPPING LAWS',
  '18:13-9971.M': '18:13-9971.M         MARITIME AND SHIPPING LAWS',
  '18:13-9971.P': '18:13-9971.P         MARITIME AND SHIPPING LAWS',
  '18:13-9972.M': '18:13-9972.M         STOWAWAYS',
  '18:13-9972.P': '18:13-9972.P         STOWAWAYS',
  '18:13-9973.M': '18:13-9973.M         FEDERAL BOAT SAFETY ACT OF 1971',
  '18:13-9981.F': '18:13-9981.F         POSTAL, NON-MAILABLE MATERIAL',
  '18:13-9981.M': '18:13-9981.M         POSTAL, NON-MAILABLE MATERIAL',
  '18:13-9981.P': '18:13-9981.P         POSTAL, NON-MAILABLE MATERIAL',
  '18:13-9982.F': '18:13-9982.F         POSTAL, INJURY TO PROPERTY',
  '18:13-9983.P': '18:13-9983.P         POSTAL, OBSTRUCTING THE MAIL',
  '18:13-9984.F': '18:13-9984.F         POSTAL, VIOLATIONS BY POSTAL EMPLOYEES',
  '18:13-9984.M': '18:13-9984.M         POSTAL, VIOLATIONS BY POSTAL EMPLOYEES',
  '18:13-9984.P': '18:13-9984.P         POSTAL, VIOLATIONS BY POSTAL EMPLOYEES',
  '18:13-9989.F': '18:13-9989.F         POSTAL, OTHER',
  '18:13-9989.M': '18:13-9989.M         POSTAL, OTHER',
  '18:13-9989.P': '18:13-9989.P         POSTAL, OTHER',
  '18:13-9991.F': '18:13-9991.F         DESTROYING FEDERAL PROPERTY',
  '18:13-9991.M': '18:13-9991.M         DESTROYING FEDERAL PROPERTY',
  '18:13-9991.P': '18:13-9991.P         DESTROYING FEDERAL PROPERTY',
  '18:13-9992.F': '18:13-9992.F         INTIMIDATION OF WITNESSES, JURORS, ETC.',
  '18:13-9992.M': '18:13-9992.M         INTIMIDATION OF WITNESSES, JURORS, ETC.',
  '18:13-9992.P': '18:13-9992.P         INTIMIDATION OF WITNESSES, JURORS, ETC.',
  '18:13-9993.F': '18:13-9993.F         AIRCRAFT REGULATIONS',
  '18:13-9993.M': '18:13-9993.M         AIRCRAFT REGULATIONS',
  '18:13-9993.P': '18:13-9993.P         AIRCRAFT REGULATIONS',
  '18:13-9994.F': '18:13-9994.F         EXPLOSIVES  (T)',
  '18:13-9994.M': '18:13-9994.M         EXPLOSIVES  (T)',
  '18:13-9994.P': '18:13-9994.P         EXPLOSIVES  (T)',
  '18:13-9995.F': '18:13-9995.F         GOLD ACTS',
  '18:13-9996.F': '18:13-9996.F         TRAIN WRECKING',
  '18:13-9999.F': '18:13-9999.F         FEDERAL STATUTES, OTHER',
  '18:13-9999.M': '18:13-9999.M         FEDERAL STATUTES, OTHER',
  '18:13-9999.P': '18:13-9999.P         FEDERAL STATUTES, OTHER',
  '18:1301.F': '18:1301.F            IMPORTING OR TRANSPORTING LOTTERY TI...',
  '18:1302.F': '18:1302.F            MAILING LOTTERY TICKETS/RELATED MATTER',
  '18:1303.M': '18:1303.M            POSTMASTER OR EMPLOYEE AS LOTTERY AGENT',
  '18:1304.M': '18:1304.M            BROADCASTING LOTTERY INFORMATION',
  '18:1306.M': '18:1306.M            LOTTERY - PARTICIPATION BY FINANCIAL...',
  '18:1341.F': '18:1341.F            FRAUDS AND SWINDLES',
  '18:1342.F': '18:1342.F            FICTITIOUS NAME OR ADDRESS',
  '18:1343.F': '18:1343.F            FRAUD BY WIRE, RADIO, OR TELEVISION',
  '18:1344A.F': '18:1344A.F           BANK FRAUD',
  '18:1347.F': '18:1347.F            HEALTH CARE FRAUD',
  '18:1348.F': '18:1348.F            SECURITIES FRAUD',
  '18:1349.F': '18:1349.F            ATTEMPT AND CONSPIRACY TO COMMIT MAI...',
  '18:1350.F': '18:1350.F            FAILURE OF CORPORATE OFFICERS TO CER...',
  '18:1351.F': '18:1351.F            FRAUD IN FOREIGN LABOR CONTRACTING',
  '18:1361.F': '18:1361.F            GOVERNMENT PROPERTY OR CONTRACTS &gt; $100',
  '18:1361.M': '18:1361.M            GOVERNMENT PROPERTY OR CONTRACTS &lt;= ...',
  '18:1362.F': '18:1362.F            COMMUNICATION LINES, STATIONS OR SYS...',
  '18:1363.F': '18:1363.F            BUILDINGS, PROPERTY, WITHIN SPECIAL ...',
  '18:1364.F': '18:1364.F            INTERFERE WITH FOREIGN COMMERCE BY V...',
  '18:1365A.F': '18:1365A.F           ATTEMPT TO TAMPER WITH CONSUMER PRODUCT',
  '18:1365B.F': '18:1365B.F           TAINT CONSUMER PRODUCT/CAUSE COMMERC...',
  '18:1365C.F': '18:1365C.F           COMMUNICATES FALSE CONSUMER PRODUCT ...',
  '18:1365D.F': '18:1365D.F           THREATEN TO TAMPER WITH CONSUMER PRO...',
  '18:1365E.F': '18:1365E.F           CONSPIRACY/ATTEMPT TO TAMPER WITH CO...',
  '18:1366A.F': '18:1366A.F           DESTRUCTION OF AN ENERGY FACILITY &gt; ...',
  '18:1366B.F': '18:1366B.F           DESTRUCTION OF AN ENERGY FACILITY &lt; ...',
  '18:1367.F': '18:1367.F            INTERFERENCE WITH OPERATION OF SATEL...',
  '18:1369.F': '18:1369.F            MALICIOUS MISCHIEF - DESTRUCTION OF ...',
  '18:1381.F': '18:1381.F            ENTICING DESERTION AND HARBORING DES...',
  '18:1382.P': '18:1382.P            ENTERING MILITARY/NAVAL/COAST GUARD ...',
  '18:1384.M': '18:1384.M            PROSTITUTION NEAR MILITARY AND NAVAL...',
  '18:1385.F': '18:1385.F            USE ARMY AND AIR FORCE AS POSSE COMI...',
  '18:1421.F': '18:1421.F            ACCOUNTS OF COURT OFFICERS',
  '18:1422.F': '18:1422.F            FEES IN NATURALIZATION PROCEEDINGS',
  '18:1423.F': '18:1423.F            MISUSE OF EVIDENCE OF CITIZENSHIP/NA...',
  '18:1424.F': '18:1424.F            IMPERSONATION/MISUSE OF PAPERS IN NA...',
  '18:1425.F': '18:1425.F            PROCUREMENT OF CITIZENSHIP OR NATURA...',
  '18:1426.F': '18:1426.F            REPRODUCTION OF NATURALIZATION OR CI...',
  '18:1427.F': '18:1427.F            SALE OF NATURALIZATION OR CITIZENSHI...',
  '18:1428.F': '18:1428.F            SURRENDER OF CANCELED NATURALIZATION...',
  '18:1429.F': '18:1429.F            PENALTIES FOR NEGLECT/REFUSAL ANSWER...',
  '18:1460.F': '18:1460.F            POSSESS W/INTENT TO SELL OBSCENE MAT...',
  '18:1461.F': '18:1461.F            MAILING OBSCENE OR CRIME-INCITING MA...',
  '18:1462.F': '18:1462.F            IMPORT OR TRANSPORT OBSCENE MATTER',
  '18:1463.F': '18:1463.F            MAILING INDECENT MATTER ON WRAPPERS/...',
  '18:1464.F': '18:1464.F            BROADCASTING OBSCENE LANGUAGE',
  '18:1465.F': '18:1465.F            TRANSPORTATION OF OBSCENE MATTER FOR...',
  '18:1466.F': '18:1466.F            SELLING/TRANSFERRING OBSCENE MATTER',
  '18:1467.F': '18:1467.F            CRIMINAL FORFEITURE',
  '18:1470.F': '18:1470.F            TRANSFER OF OBSCENE MATERIALS TO MINORS',
  '18:1470.P': '18:1470.P            TRANSFER OF OBSCENE MATERIALS TO MINORS',
  '18:1501.M': '18:1501.M            ASSAULT ON PROCESS SERVER',
  '18:1502.M': '18:1502.M            RESISTANCE TO EXTRADITION AGENT',
  '18:1503.F': '18:1503.F            INFLUENCE/INJURING OFFICER/JUROR/WIT...',
  '18:1504.P': '18:1504.P            INFLUENCING JUROR BY WRITING',
  '18:1505.F': '18:1505.F            OBSTRUCTION OF PROCEEDING BEFORE DEP...',
  '18:1506.F': '18:1506.F            THEFT OR ALTERATION OF RECORD OR PRO...',
  '18:1507.M': '18:1507.M            PICKETING OR PARADING',
  '18:1508.M': '18:1508.M            RECORD/LISTEN TO/OBSERVE GRAND JURY ...',
  '18:1509.M': '18:1509.M            OBSTRUCTION OF COURT ORDERS',
  '18:1510.F': '18:1510.F            OBSTRUCTION OF CRIMINAL INVESTIGATIONS',
  '18:1510.M': '18:1510.M            OBSTRUCTION OF CRIMINAL INVESTIGATIONS',
  '18:1511.F': '18:1511.F            INTIMIDATION OF WITNESSES, JURORS, ETC.',
  '18:1512A.F': '18:1512A.F           TAMPER W/WITNESS, VICTIM, INFORM... (T)',
  '18:1512A1.F': '18:1512A1.F          TAMPER W/WITNESS, VICTIM, INFORM... (T)',
  '18:1512B.F': '18:1512B.F           INTIMIDATION OR FORCE AGAINST WITNESS',
  '18:1512C.F': '18:1512C.F           TAMPERING WITH A WITNESS, VICTIM OR ...',
  '18:1512C.M': '18:1512C.M           HARASSMENT OF A WITNESS',
  '18:1512K.F': '18:1512K.F           TAMPERING WITH A WITNESS, VICTIM OR ...',
  '18:1513.F': '18:1513.F            RETALIATING AGAINST WITNESS, VICTIM',
  '18:1516.F': '18:1516.F            INFLUENCE/OBSTRUCT/IMPEDE/FEDERAL AU...',
  '18:1517.F': '18:1517.F            OBSTRUCTION OF JUSTICE - INTERFERENCE',
  '18:1518.F': '18:1518.F            OBSTRUCT CRIMINAL INVESTIGATIONS OF ...',
  '18:1519.F': '18:1519.F            DESTRUCTION,ALTERNATION,FALSIFICATIO...',
  '18:152.F': '18:152.F             CONCEAL ASSETS, FALSE OATH AND CLAIM...',
  '18:1521.F': '18:1521.F            RETALIATION AGAINST A FEDERAL JUDGE ...',
  '18:153.F': '18:153.F             EMBEZZLEMENT BY TRUSTEE, RECEIVERS O...',
  '18:154.P': '18:154.P             ADVERSE INTEREST AND CONDUCT OF TRUS...',
  '18:1541.M': '18:1541.M            ISSUANCE WITHOUT AUTHORITY',
  '18:1542.F': '18:1542.F            FALSE STATEMENT IN APPLICATION/USE O...',
  '18:1543.F': '18:1543.F            FORGERY OR FALSE USE OF PASSPORT',
  '18:1544.F': '18:1544.F            MISUSE OF PASSPORT',
  '18:1545.F': '18:1545.F            SAFE CONDUCT VIOLATION',
  '18:1546.F': '18:1546.F            FRAUD AND MISUSE OF VISAS/PERMITS',
  '18:155.M': '18:155.M             FEE AGREEMENTS IN BANKRUPTCY PROCEED...',
  '18:157.F': '18:157.F             BANKRUPTCY FRAUD',
  '18:1581.F': '18:1581.F            PEONAGE: OBSTRUCTING ENFORCEMENT',
  '18:1582.F': '18:1582.F            VESSELS FOR SLAVE TRADE',
  '18:1583.F': '18:1583.F            ENTICEMENT INTO SLAVERY',
  '18:1584.F': '18:1584.F            SALE INTO INVOLUNTARY SERVITUDE',
  '18:1585.F': '18:1585.F            SEIZURE, DETENTION, TRANSPORTATION O...',
  '18:1586.F': '18:1586.F            SERVICE ON VESSELS IN SLAVE TRADE',
  '18:1587.F': '18:1587.F            POSSESSION OF SLAVES ABOARD VESSEL',
  '18:1588.F': '18:1588.F            TRANSPORTATION OF SLAVES FROM U.S.',
  '18:1589.F': '18:1589.F            FORCED LABOR',
  '18:1590.F': '18:1590.F            TRAFFICKING WITH RESPECT TO PEONAGE,...',
  '18:1591.F': '18:1591.F            SEX TRAFFICKING OF CHILDREN OR BY FO...',
  '18:1592.F': '18:1592.F            UNLAWFUL CONDUCT W/RESPECT TO DOCS F...',
  '18:1594.F': '18:1594.F            FORFEITURE',
  '18:1621.F': '18:1621.F            PERJURY GENERALLY',
  '18:1622.F': '18:1622.F            SUBORNATION OF PERJURY',
  '18:1623.F': '18:1623.F            FALSE DECLARATIONS BEFORE GRAND JURY...',
  '18:1651.F': '18:1651.F            PIRACY UNDER LAW OF NATIONS',
  '18:1652.F': '18:1652.F            CITIZENS AS PIRATES',
  '18:1653.F': '18:1653.F            ALIENS AS PIRATES',
  '18:1654.F': '18:1654.F            ARMING OR SERVING ON PRIVATEERS',
  '18:1655.F': '18:1655.F            ASSAULT ON COMMANDER AS PIRACY',
  '18:1656.F': '18:1656.F            CONVERSION OR SURRENDER OF VESSEL',
  '18:1657.F': '18:1657.F            CORRUPTION OF SEAMEN - CONFEDERATING...',
  '18:1658.F': '18:1658.F            PLUNDER OF DISTRESSED VESSEL',
  '18:1659.F': '18:1659.F            ATTACK TO PLUNDER VESSEL',
  '18:1660.F': '18:1660.F            RECEIPT OF PIRATE PROPERTY',
  '18:1661.F': '18:1661.F            ROBBERY ASHORE',
  '18:1693.P': '18:1693.P            CARRIAGE OF MAIL GENERALLY',
  '18:1694.P': '18:1694.P            CARRIAGE OF MATTER OUT-MAIL OVER POS...',
  '18:1695.P': '18:1695.P            CARRIAGE OF MATTER OUT-MAIL ON VESSEL',
  '18:1696A.P': '18:1696A.P           PRIVATE EXPRESS FOR LETTERS AND PACKETS',
  '18:1696B.P': '18:1696B.P           PRIVATE EXPRESS FOR LETTERS AND PACKETS',
  '18:1697.P': '18:1697.P            TRANSPORTATION OF PERSONS ACTING AS ...',
  '18:1698.P': '18:1698.P            PROMPT DELIVERY OF MAIL FROM VESSEL',
  '18:1699.P': '18:1699.P            CERTIFICATION OF DELIVERY FROM VESSEL',
  '18:1700.M': '18:1700.M            DESERTION OF MAILS',
  '18:1701.P': '18:1701.P            OBSTRUCTION OF MAILS GENERALLY',
  '18:1702.F': '18:1702.F            OBSTRUCTION OF CORRESPONDENCE',
  '18:1703A.F': '18:1703A.F           DELAY OR DESTRUCTION OF MAIL OR NEWS...',
  '18:1703B.M': '18:1703B.M           DELAY OR DESTRUCTION OF MAIL OR NEWS...',
  '18:1704.F': '18:1704.F            KEYS OR LOCKS STOLEN OR REPRODUCED',
  '18:1705.F': '18:1705.F            DESTRUCTION OF LETTER BOXES OR MAIL',
  '18:1706.F': '18:1706.F            INJURY TO MAIL BAGS',
  '18:1707.F': '18:1707.F            THEFT OF PROPERTY USED BY POSTAL SER...',
  '18:1707.M': '18:1707.M            THEFT OF PROPERTY USED BY POSTAL SER...',
  '18:1708.F': '18:1708.F            THEFT OR RECEIPT OF STOLEN MAIL MATTER',
  '18:1709.F': '18:1709.F            THEFT OF MAIL MATTER BY OFFICER OR E...',
  '18:1710.M': '18:1710.M            THEFT OF NEWSPAPERS',
  '18:1711.F': '18:1711.F            MISAPPROPRIATION OF POSTAL FUNDS &gt; $100',
  '18:1711.M': '18:1711.M            MISAPPROPRIATION OF POSTAL FUNDS &lt; $100',
  '18:1712.F': '18:1712.F            FALSIFICATION OF POSTAL RETURNS TO I...',
  '18:1713.P': '18:1713.P            ISSUANCE OF MONEY ORDERS WITHOUT PAY...',
  '18:1715.F': '18:1715.F            FIREARMS AS NON-MAILABLE: REGULATIONS',
  '18:1716.F': '18:1716.F            INJURIOUS ARTICLE AS NON-MAILABLE  (T)',
  '18:1716.M': '18:1716.M            NON-MAILABLE MOTOR VEHICLE MASTER KEYS',
  '18:1717.F': '18:1717.F            LETTERS AND WRITINGS - NON-MAILABLE:...',
  '18:1719.P': '18:1719.P            FRANKING PRIVILEGE',
  '18:1720.F': '18:1720.F            VIOLATIONS BY POSTAL EMPLOYEES',
  '18:1720.M': '18:1720.M            CANCELED STAMPS AND ENVELOPES',
  '18:1721.M': '18:1721.M            SALE OR PLEDGE OF STAMPS',
  '18:1722.P': '18:1722.P            FALSE EVIDENCE TO SECURE 2ND-CLASS RATE',
  '18:1723.P': '18:1723.P            AVOIDANCE OF POSTAGE - USING LOWER C...',
  '18:1725.P': '18:1725.P            POSTAGE UNPAID ON DEPOSITED MAIL MATTER',
  '18:1726.P': '18:1726.P            POSTAGE COLLECTED UNLAWFULLY',
  '18:1728.F': '18:1728.F            WEIGHT OF MAIL INCREASED FRAUDULENTLY',
  '18:1729.P': '18:1729.P            POST OFFICE CONDUCTED WITHOUT AUTHORITY',
  '18:1730.P': '18:1730.P            UNIFORMS OF CARRIERS',
  '18:1731.P': '18:1731.P            VEHICLES FALSELY LABELED AS CARRIERS',
  '18:1732.M': '18:1732.M            APPROVAL OF BOND OR SURETIES BY POST...',
  '18:1733.M': '18:1733.M            MAIL PERIODICAL PUBLICATIONS WITHOUT...',
  '18:1734.P': '18:1734.P            EDITORIALS AND OTHER MATTER AS ADVER...',
  '18:1735.F': '18:1735.F            SEXUALLY ORIENTED ADVERTISEMENTS',
  '18:1737.F': '18:1737.F            MANUFACTURE SEXUALLY RELATED MAIL MA...',
  '18:1738.M': '18:1738.M            MAILING ID DOCUMENTS WITHOUT A DISCL...',
  '18:175.F': '18:175.F             PROHIBITIONS WITH RESPECT TO BIOLOGI...',
  '18:1751A.F': '18:1751A.F           PRESIDENTIAL ASSASSINATION',
  '18:1751B.F': '18:1751B.F           PRESIDENTIAL KIDNAPPING',
  '18:1751C.F': '18:1751C.F           ATTEMPT TO KILL OR KIDNAP GOVERNMENT...',
  '18:1751E.F': '18:1751E.F           ASSAULT ON PRESIDENT',
  '18:1752.P': '18:1752.P            TEMPORARY RESIDENCE OF THE PRESIDENT',
  '18:1761.M': '18:1761.M            PRISON-MADE-GOODS - TRANSPORTATION O...',
  '18:1762.P': '18:1762.P            MARKING PACKAGES - CONVICT GOODS',
  '18:1791A.F': '18:1791A.F           TRAFFIC IN CONTRABAND ARTICLES - FIR...',
  '18:1791A.M': '18:1791A.M           CONTRABAND IN PRISON - CURRENCY',
  '18:1791A.P': '18:1791A.P           CONTRABAND IN PRISON - OTHER ITEMS',
  '18:1791B.F': '18:1791B.F           CONTRABAND IN PRISON - MARIJUANA',
  '18:1791C.F': '18:1791C.F           TRAFFIC IN CONTRABAND ARTICLES',
  '18:1791C.M': '18:1791C.M           CONTRABAND IN PRISON - CONTROLLED SU...',
  '18:1791C.P': '18:1791C.P           CONTRABAND IN PRISON - ANY OTHER OBJECT',
  '18:1791D.F': '18:1791D.F           CONTRABAND IN PRISON - NARCOTIC DRUG',
  '18:1792.F': '18:1792.F            MUTINY/RIOT IN PRISON',
  '18:1793.P': '18:1793.P            TRESPASS ON PRISON LANDS/RESERVATIONS',
  '18:1801.M': '18:1801.M            VIDEO VOYEURISM',
  '18:1821.M': '18:1821.M            TRANSPORTATION OF DENTURES',
  '18:1831.F': '18:1831.F            ECONOMIC ESPIONAGE',
  '18:1832.F': '18:1832.F            THEFT OF TRADE SECRETS',
  '18:1841.F': '18:1841.F            PROTECTION OF UNBORN CHILDREN',
  '18:1851.M': '18:1851.M            COAL DEPREDATIONS - PUBLIC LANDS',
  '18:1852.M': '18:1852.M            TIMBER REMOVED OR TRANSPORTED',
  '18:1853.M': '18:1853.M            TREES CUT OR INJURED',
  '18:1854.M': '18:1854.M            TREES BOXED FOR PITCH OR TURPENTINE',
  '18:1855.F': '18:1855.F            TIMBER SET AFIRE',
  '18:1856.P': '18:1856.P            FIRES LEFT UNATTENDED AND UN-EXTINGU...',
  '18:1857.M': '18:1857.M            FENCES DESTROYED: LIVESTOCK ENTERING',
  '18:1858.P': '18:1858.P            SURVEY MARKS DESTROYED OR REMOVED',
  '18:1859.F': '18:1859.F            SURVEYS INTERRUPTED',
  '18:1860.M': '18:1860.M            BIDS AT LAND SALES',
  '18:1861.M': '18:1861.M            DECEPTION OF PROSPECTIVE PURCHASERS',
  '18:1863.P': '18:1863.P            TRESPASS ON NATIONAL FOREST LANDS',
  '18:1864.M': '18:1864.M            HAZARDOUS OR INJURIOUS DEVICES ON FE...',
  '18:1864B.F': '18:1864B.F           HAZARDOUS/INJURIOUS DEVICE - DEATH R...',
  '18:1864C.F': '18:1864C.F           HAZARDOUS/INJURIOUS DEVICE - DEA... (T)',
  '18:1901.M': '18:1901.M            COLLECTOR/DISBURSING OFFICER TRADING...',
  '18:1902.F': '18:1902.F            DISCLOSURE OF CROP INFORMATION AND S...',
  '18:1903.F': '18:1903.F            SPECULATION IN STOCKS OR COMMODITIES...',
  '18:1904.F': '18:1904.F            DISCLOSE INFORMATION/SPECULATE IN SE...',
  '18:1905.M': '18:1905.M            DISCLOSURE OF CONFIDENTIAL INFORMATI...',
  '18:1906.M': '18:1906.M            DISCLOSURE OF INFORMATION BY BANK EX...',
  '18:1907.M': '18:1907.M            DISCLOSURE OF INFORMATION BY FARM CR...',
  '18:1908.M': '18:1908.M            DISCLOSURE OF INFORMATION BY NACC EX...',
  '18:1909.M': '18:1909.M            EXAMINER PERFORMING OTHER SERVICES',
  '18:1910.F': '18:1910.F            NEPOTISM IN APPOINTMENT OF RECEIVER/...',
  '18:1911.M': '18:1911.M            RECEIVER MISMANAGING PROPERTY',
  '18:1912.P': '18:1912.P            UNAUTHORIZED FEES FOR INSPECTION OF ...',
  '18:1913.M': '18:1913.M            LOBBYING WITH APPROPRIATED MONEYS',
  '18:1915.F': '18:1915.F            COMPROMISE OF CUSTOMS LIABILITIES',
  '18:1916.M': '18:1916.M            UNAUTHORIZED EMPLOYMENT/DISPOSITION ...',
  '18:1917.M': '18:1917.M            INTERFERENCE WITH CIVIL SERVICE EXAMS',
  '18:1918.F': '18:1918.F            DISLOYALTY AND STRIKING AGAINST THE ...',
  '18:1919.M': '18:1919.M            FALSE STATEMENT TO OBTAIN UNEMPLOYME...',
  '18:1919.F': '18:1919.M            FALSE STATEMENTS TO OBTAIN FEDERAL E...',
  '18:1920.F': '18:1920.F            FRAUD TO GAIN FEDERAL EMPLOYEE COMPE...',
  '18:1920.M': '18:1920.M            FALSE STATEMENT TO OBTAIN FEDERAL EM...',
  '18:1921.M': '18:1921.M            RECEIVING FEDERAL EMPLOYEE COMPENSAT...',
  '18:1922.M': '18:1922.M            FALSE OR WITHHELD REPORT - FEDERAL E...',
  '18:1923.M': '18:1923.M            FRAUDULENT RECEIPT OF PAYMENTS OF MI...',
  '18:1924.M': '18:1924.M            UNAUTHORIZED REMOVAL/RETENTION OF CL...',
  '18:1951.F': '18:1951.F            INTERFERENCE WITH COMMERCE BY THREAT...',
  '18:1952-7400.F': '18:1952-7400.F       RACKETEERING - TRANSPORTING IN AID OF',
  '18:1952-7410.F': '18:1952-7410.F       RACKETEERING - ARSON',
  '18:1952-7420.F': '18:1952-7420.F       RACKETEERING - BRIBERY',
  '18:1952-7430.F': '18:1952-7430.F       RACKETEERING - EXTORTION',
  '18:1952-7440.F': '18:1952-7440.F       RACKETEERING - GAMBLING',
  '18:1952-7450.F': '18:1952-7450.F       RACKETEERING - LIQUOR',
  '18:1952-7460.F': '18:1952-7460.F       RACKETEERING - NARCOTICS',
  '18:1952-7470.F': '18:1952-7470.F       RACKETEERING - PROSTITUTION',
  '18:1952-7471.F': '18:1952-7471.F       RACKETEERING - MURDER',
  '18:1952-7472.F': '18:1952-7472.F       RACKETEERING - KIDNAP',
  '18:1952-7473.F': '18:1952-7473.F       RACKETEERING - MAIM',
  '18:1952-7474.F': '18:1952-7474.F       RACKETEERING - CONSPIRACY, MURDER, K...',
  '18:1952-7475.F': '18:1952-7475.F       RACKETEERING - ATTEMPT/CONSPIRE TO M...',
  '18:1952-7480.F': '18:1952-7480.F       RACKETEERING - OTHER',
  '18:1952-7482.F': '18:1952-7482.F       RACKETEERING - THREATS',
  '18:1952-7490.F': '18:1952-7490.F       RACKETEERING - EXTORTION CREDIT TRAN...',
  '18:1953.F': '18:1953.F            INTERSTATE TRANSPORT OF WAGERING PAR...',
  '18:1954.F': '18:1954.F            EMPLOYEE BENEFITS - FRAUD',
  '18:1955.F': '18:1955.F            ILLEGAL GAMBLING',
  '18:1956-0100.F': '18:1956-0100.F       MONEY LAUNDERING - MURDER',
  '18:1956-0200.F': '18:1956-0200.F       MONEY LAUNDERING - MURDER, SECOND DE...',
  '18:1956-1100.F': '18:1956-1100.F       MONEY LAUNDERING - ROBBERY, BANK',
  '18:1956-1200.F': '18:1956-1200.F       MONEY LAUNDERING - ROBBERY, POSTAL',
  '18:1956-3100.F': '18:1956-3100.F       MONEY LAUNDERING - LARCENY AND THEFT...',
  '18:1956-3200.F': '18:1956-3200.F       MONEY LAUNDERING - LARCENY AND THEFT...',
  '18:1956-3300.F': '18:1956-3300.F       MONEY LAUNDERING - INTERSTATE COMMERCE',
  '18:1956-3600.F': '18:1956-3600.F       MONEY LAUNDERING - TRANSPORTATION OF...',
  '18:1956-4100.F': '18:1956-4100.F       MONEY LAUNDERING - BANK EMBEZZLEMENT',
  '18:1956-4310.F': '18:1956-4310.F       MONEY LAUNDERING - EMBEZZLES PUBLIC ...',
  '18:1956-4390.F': '18:1956-4390.F       MONEY LAUNDERING - EMBEZZLEMENT, OTHER',
  '18:1956-4601.F': '18:1956-4601.F       MONEY LAUNDERING - BANK FRAUD',
  '18:1956-4700.F': '18:1956-4700.F       MONEY LAUNDERING - POSTAL, INTERSTAT...',
  '18:1956-4900.F': '18:1956-4900.F       MONEY LAUNDERING - BANKRUPTCY',
  '18:1956-4999.F': '18:1956-4999.F       MONEY LAUNDERING - FRAUD, OTHER',
  '18:1956-5100.F': '18:1956-5100.F       MONEY LAUNDERING - TRANSPORT, ETC. S...',
  '18:1956-5800.F': '18:1956-5800.F       MONEY LAUNDERING - COUNTERFEITING',
  '18:1956-6200.F': '18:1956-6200.F       MONEY LAUNDERING - WHITE SLAVE AND I...',
  '18:1956-6501.F': '18:1956-6501.F       MARIJUANA - SELL, DISTRIBUTE OR DISP...',
  '18:1956-6502.F': '18:1956-6502.F       MARIJUANA - IMPORTATION/EXPORTATION',
  '18:1956-6503.F': '18:1956-6503.F       MARIJUANA - MANUFACTURE',
  '18:1956-6701.F': '18:1956-6701.F       NARCOTICS - SELL, DISTRIBUTE OR DISP...',
  '18:1956-6702.F': '18:1956-6702.F       NARCOTICS - IMPORTATION/EXPORTATION',
  '18:1956-6703.F': '18:1956-6703.F       NARCOTICS - MANUFACTURE',
  '18:1956-6800.F': '18:1956-6800.F       MONEY LAUNDERING - CONTINUING CRIMIN...',
  '18:1956-6801.F': '18:1956-6801.F       MONEY LAUNDERING - CONTROLLED SUBSTA...',
  '18:1956-6802.F': '18:1956-6802.F       MONEY LAUNDERING - CONTROLLED SUBSTA...',
  '18:1956-6803.F': '18:1956-6803.F       MONEY LAUNDERING - CONTROLLED SUBSTA...',
  '18:1956-7100.F': '18:1956-7100.F       MONEY LAUNDERING - BRIBERY',
  '18:1956-7400.F': '18:1956-7400.F       MONEY LAUNDERING - EXTORTION, RACKET...',
  '18:1956-7477.F': '18:1956-7477.F       LAUNDERING OF MONETARY INSTRUMENTS',
  '18:1956-7480.F': '18:1956-7480.F       MONEY LAUNDERING - RACKETEERING',
  '18:1956-7481.F': '18:1956-7481.F       MONEY LAUNDERING - RACKETEERING - RO...',
  '18:1956-7482.F': '18:1956-7482.F       MONEY LAUNDERING - RACKETEERING - TH...',
  '18:1956-7490.F': '18:1956-7490.F       MONEY LAUNDERING - RACKETEERING -  E...',
  '18:1956-7530.F': '18:1956-7530.F       MONEY LAUNDERING - GAMBLING/LOTTERY:...',
  '18:1956-7600.F': '18:1956-7600.F       MONEY LAUNDERING - KIDNAPPING, FEDER...',
  '18:1956-7611.F': '18:1956-7611.F       MONEY LAUNDERING - KIDNAP, HOSTAGE',
  '18:1956-9752.F': '18:1956-9752.F       MONEY LAUNDERING - ESPIONAGE',
  '18:1956-9780.F': '18:1956-9780.F       MONEY LAUNDERING - ENEMIES OF THE U.S.',
  '18:1956-9790.F': '18:1956-9790.F       MONEY LAUNDERING - NATIONAL DEFENSE,...',
  '18:1956-9810.F': '18:1956-9810.F       MONEY LAUNDERING - OBSCENE MAIL',
  '18:1956-9820.F': '18:1956-9820.F       MONEY LAUNDERING - OBSCENE MATTER IN...',
  '18:1956-9931.F': '18:1956-9931.F       MONEY LAUNDERING - CUSTOMS LAWS  (T)',
  '18:1956-9992.F': '18:1956-9992.F       MONEY LAUNDERING - INTIMIDATION OF W...',
  '18:1956-9999.F': '18:1956-9999.F       MONEY LAUNDERING - FEDERAL STATUTES,...',
  '18:1957-0100.F': '18:1957-0100.F       MURDER, FIRST DEGREE',
  '18:1957-0200.F': '18:1957-0200.F       MURDER, SECOND DEGREE',
  '18:1957-1100.F': '18:1957-1100.F       ROBBERY, BANK',
  '18:1957-1200.F': '18:1957-1200.F       ROBBERY, POSTAL',
  '18:1957-3100.F': '18:1957-3100.F       LARCENY AND THEFT, BANK',
  '18:1957-3200.F': '18:1957-3200.F       LARCENY AND THEFT, POSTAL',
  '18:1957-3300.F': '18:1957-3300.F       INTERSTATE COMMERCE',
  '18:1957-3600.F': '18:1957-3600.F       TRANSPORTATION OF STOLEN PROPERTY',
  '18:1957-4100.F': '18:1957-4100.F       BANK EMBEZZLEMENT',
  '18:1957-4310.F': '18:1957-4310.F       EMBEZZLES PUBLIC MONEYS OR PROPERTY',
  '18:1957-4390.F': '18:1957-4390.F       EMBEZZLEMENT, OTHER',
  '18:1957-4601.F': '18:1957-4601.F       BANK FRAUD',
  '18:1957-4700.F': '18:1957-4700.F       POSTAL, INTERSTATE WIRE, RADIO, ETC.',
  '18:1957-4900.F': '18:1957-4900.F       BANKRUPTCY',
  '18:1957-4999.F': '18:1957-4999.F       FRAUD, OTHER',
  '18:1957-5100.F': '18:1957-5100.F       TRANSPORT, ETC. STOLEN VEHICLES, AIR...',
  '18:1957-5800.F': '18:1957-5800.F       ENGAGING IN MONETARY TRANSACTIONS',
  '18:1957-6200.F': '18:1957-6200.F       WHITE SLAVE AND IMPORTING ALIENS',
  '18:1957-6701.F': '18:1957-6701.F       NARCOTIC-SELL, DISTRIBUTE OR DISPENSE',
  '18:1957-6800.F': '18:1957-6800.F       CONTINUING CRIMINAL ENTERPRISE',
  '18:1957-6801.F': '18:1957-6801.F       CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '18:1957-6802.F': '18:1957-6802.F       CONTROLLED SUBSTANCE - IMPORTATION/E...',
  '18:1957-6803.F': '18:1957-6803.F       CONTROLLED SUBSTANCE - MANUFACTURE',
  '18:1957-7100.F': '18:1957-7100.F       BRIBERY',
  '18:1957-7400.F': '18:1957-7400.F       EXTORTION, RACKETEERING, AND THREATS',
  '18:1957-7420.F': '18:1957-7420.F       RACKETEERING - BRIBERY',
  '18:1957-7430.F': '18:1957-7430.F       ENGAGING IN MONETARY TRANSACTIONS',
  '18:1957-7440.F': '18:1957-7440.F       RACKETEERING - GAMBLING',
  '18:1957-7450.F': '18:1957-7450.F       RACKETEERING - LIQUOR',
  '18:1957-7460.F': '18:1957-7460.F       RACKETEERING - NARCOTICS',
  '18:1957-7470.F': '18:1957-7470.F       RACKETEERING - PROSTITUTION',
  '18:1957-7480.F': '18:1957-7480.F       RACKETEERING',
  '18:1957-7481.F': '18:1957-7481.F       RACKETEERING - ROBBERY',
  '18:1957-7482.F': '18:1957-7482.F       ENGAGING IN MONETARY TRANSACTIONS',
  '18:1957-7490.F': '18:1957-7490.F       RACKETEERING - EXTORTION, CREDIT TRA...',
  '18:1957-7530.F': '18:1957-7530.F       GAMBLING AND LOTTERY, TRANSMIT WAGER...',
  '18:1957-7600.F': '18:1957-7600.F       ENGAGING IN MONETARY TRANSACTIONS',
  '18:1957-7611.F': '18:1957-7611.F       ENGAGING IN MONETARY TRANSACTIONS',
  '18:1957-9752.F': '18:1957-9752.F       ENGAGING IN MONETARY INSTRUMENTS',
  '18:1957-9780.F': '18:1957-9780.F       ENGAGING IN MONETARY TRANSACTIONS',
  '18:1957-9790.F': '18:1957-9790.F       NATIONAL DEFENSE, OTHER',
  '18:1957-9810.F': '18:1957-9810.F       ENGAGING IN MONETARY TRANSACTIONS',
  '18:1957-9820.F': '18:1957-9820.F       ENGAGING IN MONETARY TRANSACTIONS',
  '18:1957-9931.F': '18:1957-9931.F       CUSTOMS LAWS  (T)',
  '18:1957-9992.F': '18:1957-9992.F       ENGAGING IN MONETARY TRANSACTIONS',
  '18:1957-9999.F': '18:1957-9999.F       FEDERAL STATUTES, OTHER',
  '18:1958-7471.F': '18:1958-7471.F       RACKETEERING - MURDER',
  '18:1959-0100.F': '18:1959-0100.F       MURDER, FIRST DEGREE',
  '18:1959-1500.F': '18:1959-1500.F       AGGRAVATED OR FELONIOUS ASSAULT',
  '18:1959-1600.F': '18:1959-1600.F       ASSAULT, OTHER',
  '18:1959-7400.F': '18:1959-7400.F       THREATENING TO COMMIT CRIME OF VIOLENCE',
  '18:1959-7471.F': '18:1959-7471.F       RACKETEERING ACTIVITY, MURDER/KIDNAP...',
  '18:1959-7473.F': '18:1959-7473.F       RACKETEERING ACTIVITY, MAIMING',
  '18:1959-7474.F': '18:1959-7474.F       CONSPIRACY, MURDER, KIDNAP',
  '18:1959-7475.F': '18:1959-7475.F       ATTEMPT/CONSPIRE TO MAIM/ASSAULT',
  '18:1959-7482.F': '18:1959-7482.F       RACKETEERING - THREATS',
  '18:1960.F': '18:1960.F            MONETARY LAUNDERING',
  '18:1962-0100.F': '18:1962-0100.F       MURDER, FIRST DEGREE',
  '18:1962-0200.F': '18:1962-0200.F       MURDER, SECOND DEGREE',
  '18:1962-3300.F': '18:1962-3300.F       INTERSTATE COMMERCE',
  '18:1962-3600.F': '18:1962-3600.F       TRANSPORTATION OF STOLEN PROPERTY',
  '18:1962-4390.F': '18:1962-4390.F       EMBEZZLEMENT, OTHER',
  '18:1962-4700.F': '18:1962-4700.F       POSTAL, INTERSTATE WIRE, RADIO, ETC.',
  '18:1962-4900.F': '18:1962-4900.F       BANKRUPTCY',
  '18:1962-4995.F': '18:1962-4995.F       CREDIT CARD FRAUD',
  '18:1962-4999.F': '18:1962-4999.F       FRAUD, OTHER',
  '18:1962-5100.F': '18:1962-5100.F       TRANSPORT, ETC., STOLEN VEHICLES, AI...',
  '18:1962-5800.F': '18:1962-5800.F       RECEIVED INCOME DERIVED FROM RICO',
  '18:1962-6100.F': '18:1962-6100.F       CHILD PORNOGRAPHY/OBSCENITY',
  '18:1962-6200.F': '18:1962-6200.F       WHITE SLAVE AND IMPORTING ALIENS',
  '18:1962-6800.F': '18:1962-6800.F       CONTINUING CRIMINAL ENTERPRISE',
  '18:1962-7100.F': '18:1962-7100.F       BRIBERY',
  '18:1962-7400.F': '18:1962-7400.F       EXTORTION, RACKETEERING, AND THREATS',
  '18:1962-7420.F': '18:1962-7420.F       RACKETEERING - BRIBERY',
  '18:1962-7430.F': '18:1962-7430.F       RACKETEERING - EXTORTION',
  '18:1962-7440.F': '18:1962-7440.F       RACKETEERING - GAMBLING',
  '18:1962-7450.F': '18:1962-7450.F       RACKETEERING - LIQUOR',
  '18:1962-7460.F': '18:1962-7460.F       RACKETEERING - NARCOTICS',
  '18:1962-7470.F': '18:1962-7470.F       RACKETEERING - PROSTITUTION',
  '18:1962-7471.F': '18:1962-7471.F       RACKETEERING - MURDER',
  '18:1962-7480.F': '18:1962-7480.F       RACKETEERING',
  '18:1962-7481.F': '18:1962-7481.F       RACKETEERING - ROBBERY',
  '18:1962-7482.F': '18:1962-7482.F       RACKETEERING - THREATS',
  '18:1962-7490.F': '18:1962-7490.F       RACKETEERING - EXTORTION, CREDIT TRA...',
  '18:1962-7530.F': '18:1962-7530.F       GAMBLING AND LOTTERY, TRANSMIT WAGER...',
  '18:1962-7600.F': '18:1962-7600.F       KIDNAPPING  (T)',
  '18:1962-9810.F': '18:1962-9810.F       RICO - OBSCENE MAIL',
  '18:1962-9820.F': '18:1962-9820.F       OBSCENE MATTER IN INTERSTATE COMMERCE',
  '18:1962-9992.F': '18:1962-9992.F       INTIMIDATION OF WITNESSES, JURORS, ETC.',
  '18:1962-9999.F': '18:1962-9999.F       FEDERAL STATUTES, OTHER',
  '18:1963.F': '18:1963.F            PENALTIES - CORRUPT ORGANIZATIONS',
  '18:1991.F': '18:1991.F            ROBBERY, TRAIN, MURDER',
  '18:1991.M': '18:1991.M            ROBBERY, TRAIN, ASSAULT',
  '18:1992.F': '18:1992.F            TRAIN WRECKING',
  '18:1993A.F': '18:1993A.F           TERRORISTS ATTACKS &amp; OTHER ACTS OF V...',
  '18:1993A.M': '18:1993A.M           TERRORISTS ATTACKS AND OTHER ACTS OF...',
  '18:1993B.F': '18:1993B.F           TERRORISTS ATTACKS &amp; OTHER ACTS OF V...',
  '18:1993B.M': '18:1993B.M           TERRORISTS ATTACKS AND OTHER ACTS OF...',
  '18:201A.F': '18:201A.F            BRIBERY OF PUBLIC OFFICIALS AND WITN...',
  '18:201B.F': '18:201B.F            GRAFT AND CONFLICT OF INTEREST',
  '18:201C.F': '18:201C.F            BRIBERY OF PUBLIC OFFICIALS AND WITN...',
  '18:203A.F': '18:203A.F            COMPENSATE MEMBERS OF CONGRESS/GOVER...',
  '18:203A.M': '18:203A.M            COMPENSATE MEMBERS OF CONGRESS/GOVER...',
  '18:203B.F': '18:203B.F            COMPENSATE MEMBERS OF CONGRESS/GOVER...',
  '18:203B.M': '18:203B.M            COMPENSATE MEMBERS OF CONGRESS/GOVER...',
  '18:204.F': '18:204.F             GRAFT AND CONFLICT OF INTEREST - BRI...',
  '18:205.F': '18:205.F             BRIBERY/GRAFT - CLAIMS AGAINST THE G...',
  '18:2071A.F': '18:2071A.F           CONCEALMENT, REMOVAL, OR MUTILATION ...',
  '18:2071B.F': '18:2071B.F           CONCEALMENT, REMOVAL, OR MUTILATION ...',
  '18:2072.F': '18:2072.F            FALSE CROP REPORTS',
  '18:2073.F': '18:2073.F            FALSE ENTRIES AND REPORTS',
  '18:2074.P': '18:2074.P            FALSE WEATHER REPORTS',
  '18:2075.P': '18:2075.P            OFFICER FAILING TO MAKE RETURNS OR R...',
  '18:2076.M': '18:2076.M            FAILURE OF CLERK OF COURT TO REPORT',
  '18:207A.M': '18:207A.M            DISQUALIFY FORMER OFFICER/EMPLOYEE',
  '18:207B.F': '18:207B.F            DISQUALIFY IN MATTER RELATING TO FOR...',
  '18:207C.F': '18:207C.F            GRAFT AND CONFLICT OF INTEREST - BRI...',
  '18:208.F': '18:208.F             ACTS AFFECTING PERSONAL FINANCIAL IN...',
  '18:208.M': '18:208.M             ACTS AFFECTING A PERSONAL FINANCIAL ...',
  '18:209.F': '18:209.F             SALARY OF GOVERNMENT EMPLOYEE PYABLE...',
  '18:209.M': '18:209.M             SALARY OF GOVERNMENT EMPLOYEE PAYABL...',
  '18:210.M': '18:210.M             OFFER TO PROCURE APPOINTIVE PUBLIC O...',
  '18:2101.F': '18:2101.F            TRAVEL TO INCITE RIOTS',
  '18:211.M': '18:211.M             ACCEPT OR SOLICIT TO OBTAIN APPOINTI...',
  '18:2111.F': '18:2111.F            MARITIME - ROBBERY',
  '18:2112.F': '18:2112.F            MARITIME - BURGLARY',
  '18:2113A.F': '18:2113A.F           BANK ROBBERY BY FORCE OR VIOLENCE',
  '18:2113B.F': '18:2113B.F           ROBBERY OF PROPERTY OR MONEY &gt; $100',
  '18:2113B.M': '18:2113B.M           ROBBERY OF PROPERTY OR MONEY &lt;= $100',
  '18:2113C.F': '18:2113C.F           RECEIVING STOLEN MONEY OR PROPERTY',
  '18:2113C.M': '18:2113C.M           RECEIVING STOLEN MONEY OR PROPERTY',
  '18:2113D.F': '18:2113D.F           BANK ROBBERY, ASSAULT WITH A DEADLY ...',
  '18:2113E.F': '18:2113E.F           DEATH AS A RESULT OF BANK ROBBERY',
  '18:2114.F': '18:2114.F            MAIL, MONEY OR OTHER PROPERTY OF U.S.',
  '18:2115.F': '18:2115.F            BURGLARY, POST OFFICE',
  '18:2116.F': '18:2116.F            RAILWAY OR STEAMBOAT POST OFFICE/ROB...',
  '18:2117.F': '18:2117.F            BREAKING/ENTERING A CARRIER FACILITY',
  '18:2118A.F': '18:2118A.F           ROBBERY OF CONTROLLED SUBSTANCE',
  '18:2118B.F': '18:2118B.F           BURGLARY OF CONTROLLED SUBSTANCE',
  '18:2118C.F': '18:2118C.F           AGGRAVATED OR FELONIOUS ASSAULT ON P...',
  '18:2118D.F': '18:2118D.F           CONSPIRE TO ROBBERY',
  '18:2119.F': '18:2119.F            MOTOR VEHICLE THEFT - CARJACKING',
  '18:212.M': '18:212.M             OFFER OF LOAN OR GRATUITY TO BANK EX...',
  '18:213.M': '18:213.M             ACCEPTANCE OF LOAN OR GRATUITY BY BA...',
  '18:214.M': '18:214.M             OFFER TO PROCURE FEDERAL RESERVE BAN...',
  '18:215.F': '18:215.F             RECEIPT OF COMMISSION FOR PROCURING ...',
  '18:215.M': '18:215.M             RECEIPT OF COMMISSION FOR PROCURING ...',
  '18:2152.F': '18:2152.F            FORTIFICATIONS/HARBOR DEFENSES/DEFEN...',
  '18:2153A.F': '18:2153A.F           DESTRUCTION WAR MATERIALS/PREMISES/U...',
  '18:2153B.F': '18:2153B.F           CONSPIRACY: WAR MATERIALS/PREMISES/U...',
  '18:2154A.F': '18:2154A.F           PRODUCTION OF DEFECTIVE WAR MATERIAL...',
  '18:2154B.F': '18:2154B.F           PRODUCTION OF DEFECTIVE WAR MATERIAL...',
  '18:2155A.F': '18:2155A.F           DESTRUCTION OF NATIONAL DEFENSE MATE...',
  '18:2155B.F': '18:2155B.F           CONSPIRACY - DESTRUCTION OF NATIONAL...',
  '18:2156A.F': '18:2156A.F           PRODUCE DEFECTIVE NATIONAL DEFENSE M...',
  '18:2156B.F': '18:2156B.F           PRODUCE DEFECTIVE NATIONAL DEFENSE M...',
  '18:216.F': '18:216.F             ACTS AFFECTING A PERSONAL FINANCIAL ...',
  '18:216.M': '18:216.M             PENALTIES - GRAFT/BRIBERY',
  '18:217.M': '18:217.M             GRAFT IN CONJUNCTION WITH FARM LOANS',
  '18:219.F': '18:219.F             PUBLIC OFFICIALS ACTING AS AGENTS FO...',
  '18:2191.F': '18:2191.F            CRUELTY TO SEAMEN',
  '18:2192.F': '18:2192.F            INCITE SEAMEN TO REVOLT OR MUTINY',
  '18:2193.F': '18:2193.F            REVOLT OR MUTINY OF SEAMEN',
  '18:2194.M': '18:2194.M            SHANGHAIING SAILORS',
  '18:2195.P': '18:2195.P            ABANDONMENT OF SAILORS',
  '18:2196.M': '18:2196.M            DRUNKENNESS OR NEGLECT OF DUTY BY SE...',
  '18:2197.F': '18:2197.F            MISUSE OF FEDERAL CERTIFICATE, LICEN...',
  '18:2199.F': '18:2199.F            STOWAWAYS ON VESSELS OR AIRCRAFT',
  '18:2199.M': '18:2199.M            STOWAWAYS ON VESSELS OR AIRCRAFT',
  '18:2231A.F': '18:2231A.F           ASSAULT OR RESISTANCE OF PERSONS WIT...',
  '18:2231B.F': '18:2231B.F           ASSAULT OR RESISTANCE - USE OF DEADL...',
  '18:2232A.F': '18:2232A.F           DESTRUCTION OR REMOVAL OF PROPERTY T...',
  '18:2232A.M': '18:2232A.M           DESTRUCTION OR REMOVAL OF PROPERTY T...',
  '18:2232B.F': '18:2232B.F           WARNING THE SUBJECT OF A SEARCH',
  '18:2233.F': '18:2233.F            RESCUE OF SEIZED PROPERTY',
  '18:2234.M': '18:2234.M            AUTHORITY EXCEEDED IN EXECUTING WARRANT',
  '18:2235.M': '18:2235.M            SEARCH WARRANT PROCURED MALICIOUSLY',
  '18:2236.M': '18:2236.M            SEARCHES WITHOUT WARRANT - 2ND OFFENSE',
  '18:2237.F': '18:2237.F            OBSTRUCTION OF BOARDING',
  '18:224.F': '18:224.F             BRIBERY IN SPORTING CONTESTS',
  '18:2241A.F': '18:2241A.F           AGGRAVATED SEXUAL ABUSE',
  '18:2241B.F': '18:2241B.F           FORCED, DRUG-INDUCED SEX',
  '18:2241C.F': '18:2241C.F           SEX WITH PERSON LESS THAN 12 YEARS OLD',
  '18:2242A.F': '18:2242A.F           FORCED SEX THREATS/FEAR OF HARM',
  '18:2242B.F': '18:2242B.F           SEX WITH PERSON MENTALLY/PHYSICALLY ...',
  '18:2243A.F': '18:2243A.F           SEX ABUSE OF MINOR/WARD 4 YEARS OR M...',
  '18:2243B.F': '18:2243B.F           SEX ABUSE OF ADULT WARD IN CUSTODY',
  '18:2243B.M': '18:2243B.M           SEX ACT WITH PERSON UNDER PERIPHERAL...',
  '18:2244A.F': '18:2244A.F           ABUSIVE SEXUAL CONTACT WITHOUT PERMI...',
  '18:2244A.M': '18:2244A.M           ABUSIVE SEX CONTACT: VIOLATION SEC. ...',
  '18:2244A.P': '18:2244A.P           ABUSIVE SEX CONTACT: VIOLATION SEC. ...',
  '18:2244B.P': '18:2244B.P           ABUSIVE SEXUAL CONTACT',
  '18:2244C.F': '18:2244C.F           ABUSIVE SEXUAL CONTACT INVOLVING YOU...',
  '18:2244C.M': '18:2244C.M           ABUSIVE SEXUAL CONTACT INVOLVING YOU...',
  '18:2245.F': '18:2245.F            SEXUAL ABUSE RESULTING IN DEATH',
  '18:225.F': '18:225.F             CONTINUING CRIMINAL ENTERPRISE',
  '18:2250.F': '18:2250.F            FAILURE TO REGISTER AS A SEX OFFENDER',
  '18:2251.F': '18:2251.F            SEXUAL EXPLOITATION OF CHILDREN',
  '18:2251.M': '18:2251.M            VIOLATION BY AN ORGANIZATION',
  '18:2251A.F': '18:2251A.F           SELLING OR BUYING OF CHILDREN',
  '18:2252.F': '18:2252.F            SEXUAL EXPLOITATION OF MINORS',
  '18:2252.M': '18:2252.M            VIOLATION BY AN ORGANIZATION',
  '18:2252A.F': '18:2252A.F           ACTIVITIES RELATING TO MATERIAL CONT...',
  '18:2253.F': '18:2253.F            CRIMINAL FORFEITURE IN VIOLATION OF ...',
  '18:2256.F': '18:2256.F            SEXUAL EXPLOITATION AND OTHER ABUSE ...',
  '18:2257.M': '18:2257.M            SEX OFFENSES, OTHER',
  '18:2260.F': '18:2260.F            PRODUCE SEX EXPLICIT DEPICTIONS OF M...',
  '18:2261.F': '18:2261.F            INTERSTATE DOMESTIC VIOLENCE',
  '18:2262.F': '18:2262.F            INTERSTATE VIOLATION OF PROTECTION O...',
  '18:2271.F': '18:2271.F            CONSPIRACY TO DESTROY VESSELS',
  '18:2272.F': '18:2272.F            DESTRUCTION OF VESSEL BY OWNER',
  '18:2273.F': '18:2273.F            DESTRUCTION OF VESSEL BY NONOWNER',
  '18:2274.F': '18:2274.F            DESTRUCTION OR MISUSE OF VESSEL BY P...',
  '18:2275.F': '18:2275.F            FIRING OR TAMPERING WITH VESSELS',
  '18:2276.F': '18:2276.F            BREAKING AND ENTERING VESSEL',
  '18:2277.M': '18:2277.M            EXPLOSIVE OR DANGEROUS WEAPONS ABOAR...',
  '18:2278.M': '18:2278.M            EXPLOSIVE ON VESSELS CARRYING STEERA...',
  '18:2279.P': '18:2279.P            BOARDING VESSELS BEFORE ARRIVAL',
  '18:228.F': '18:228.F             FAILURE TO PAY CHILD SUPPORT  (T)',
  '18:228.P': '18:228.P             FAILURE TO PAY CHILD SUPPORT  (T)',
  '18:2280.F': '18:2280.F            VIOLENCE AGAINST MARITIME NAVIGATION',
  '18:2285.F': '18:2285.F            OPERATION OF SUBMERSIBLE VESSEL OR S...',
  '18:231.F': '18:231.F             CIVIL DISORDER',
  '18:2312.F': '18:2312.F            TRANSPORTATION OF STOLEN VEHICLES',
  '18:2313.F': '18:2313.F            SALE OR RECEIPT OF STOLEN VEHICLES',
  '18:2314.F': '18:2314.F            TRANSPORTATION OF STOLEN PROPERTY',
  '18:2315.F': '18:2315.F            SALE OR RECEIPT OF STOLEN GOODS, SEC...',
  '18:2316.F': '18:2316.F            TRANSPORTATION OF CATTLE',
  '18:2317.F': '18:2317.F            SALE OR RECEIPT OF CATTLE',
  '18:2318.F': '18:2318.F            COUNTERFEIT LABELS FOR PHONOGRAPH RE...',
  '18:2318.M': '18:2318.M            COUNTERFEIT LABELS FOR PHONOGRAPH RE...',
  '18:2319.F': '18:2319.F            COPYRIGHT INFRINGEMENT AND REMEDIES',
  '18:2319.M': '18:2319.M            CRIMINAL INFRINGEMENT OF A COPYRIGHT',
  '18:2320.F': '18:2320.F            TRAFFICKING IN COUNTERFEIT GOODS... (T)',
  '18:2320.M': '18:2320.M            TRAFFICKING IN COUNTERFEIT GOODS/SER...',
  '18:2321.F': '18:2321.F            TRAFFICKING IN MOTOR VEHICLES/MOTOR ...',
  '18:2322.F': '18:2322.F            OWNS, MAINTAINS, OPERATES A CHOP SHOP',
  '18:2326.F': '18:2326.F            ENHANCED PENALTIES FOR UNLAWFUL TELE...',
  '18:2332.F': '18:2332.F            CRIMINAL PENALTIES FOR TERRORISM',
  '18:2332A.F': '18:2332A.F           KILLING A CITIZEN OUTSIDE THE U.S.',
  '18:2332AA.F': '18:2332AA.F          USE OF CERTAIN WEAPONS OF MASS DESTR...',
  '18:2332B.F': '18:2332B.F           CONSPIRACY TO KILL A U.S. CITIZEN',
  '18:2332BB.F': '18:2332BB.F          ACTS OF TERRORISM TRANSCENDING NATIO...',
  '18:2332D.F': '18:2332D.F           FINANCIAL TRANSACTIONS RELATED TO TE...',
  '18:2332F.F': '18:2332F.F           BOMBINGS OF PLACES OF PUBLIC USE',
  '18:2339.F': '18:2339.F            HARBORING OR CONCEALING TERRORISTS',
  '18:2339A.F': '18:2339A.F           PROVIDING MATERIAL SUPPORT TO TERROR...',
  '18:2342.F': '18:2342.F            TRAFFICKING IN CONTRABAND CIGARETTES',
  '18:2343.F': '18:2343.F            TRAFFICKING IN CONTRABAND CIGARETTES...',
  '18:2344.F': '18:2344.F            PENALTIES - TRAFFICKING IN CONTRABAN...',
  '18:2381.F': '18:2381.F            TREASON',
  '18:2382.F': '18:2382.F            CONCEALING KNOWLEDGE OF TREASON',
  '18:2383.F': '18:2383.F            REBELLION OR INSURRECTION',
  '18:2384.F': '18:2384.F            SEDITIOUS CONSPIRACY',
  '18:2385.F': '18:2385.F            ADVOCATING OVERTHROW OF GOVERNMENT',
  '18:2386.F': '18:2386.F            REGISTRATION OF CERTAIN ORGANIZATIONS',
  '18:2387.F': '18:2387.F            ACTIVITIES AFFECTING ARMED FORCES',
  '18:2388A.F': '18:2388A.F           ACTIVITIES AFFECTING ARMED FORCES - WAR',
  '18:2388B.F': '18:2388B.F           ACTIVITIES AFFECTING ARMED FORCES - WAR',
  '18:2388C.F': '18:2388C.F           ACTIVITIES AFFECTING ARMED FORCES - WAR',
  '18:2389.F': '18:2389.F            RECRUITING FOR SERVICE AGAINST U.S.',
  '18:2390.F': '18:2390.F            ENLISTMENT TO SERVE AGAINST U.S.',
  '18:241.F': '18:241.F             CONSPIRACY AGAINST RIGHTS',
  '18:242.F': '18:242.F             DEPRIVE CIVIL RIGHTS',
  '18:242.M': '18:242.M             DEPRIVE CIVIL RIGHTS',
  '18:2421.F': '18:2421.F            TRANSPORTING FOR PROSTITUTION',
  '18:2422.F': '18:2422.F            COERCION OR ENTICEMENT',
  '18:2423.F': '18:2423.F            TRANSPORTATION OF MINORS',
  '18:2424.F': '18:2424.F            FAIL TO FILE FACTUAL STATEMENT ABOUT...',
  '18:2425.F': '18:2425.F            USE INTERSTATE FACILITIES TO TRANSMI...',
  '18:2426.F': '18:2426.F            REPEAT OFFENDER-PRIOR SEX OFFENSE CO...',
  '18:2428.F': '18:2428.F            FORFEITURES',
  '18:243.P': '18:243.P             EXCLUDE JURORS BASED ON RACE OR COLOR',
  '18:244.P': '18:244.P             DISCRIMINATE AGAINST PERSON IN MILIT...',
  '18:245.F': '18:245.F             FEDERALLY PROTECTED ACTIVITIES',
  '18:245.M': '18:245.M             FEDERALLY PROTECTED ACTIVITIES',
  '18:247.F': '18:247.F             DAMAGE TO RELIGIOUS PROPERTY/OBSTRUC...',
  '18:247.M': '18:247.M             DAMAGE TO RELIGIOUS PROPERTY/OBSTRUC...',
  '18:248.M': '18:248.M             ACCESS TO CLINIC ENTRANCE  (T)',
  '18:248A.F': '18:248A.F            ACCESS TO CLINIC ENTRANCE  (T)',
  '18:248B.F': '18:248B.F            ACCESS TO CLINIC  (T)',
  '18:248B1.P': '18:248B1.P           ACCESS TO CLINIC ENTRANCE  (T)',
  '18:25.F': '18:25.F              USE OF MINORS IN CRIMES OF VIOLENCE',
  '18:2511.F': '18:2511.F            INTERCEPTION AND DISCLOSURE OF WIRE ...',
  '18:2511.M': '18:2511.M            INTERCEPTION AND DISCLOSURE OF WIRE ...',
  '18:2512.F': '18:2512.F            MANUFACTURE/DISTR/POSSESS/ADVERTISE ...',
  '18:2513.M': '18:2513.M            CONFISCATION OF WIRE, ORAL, OR ELECT...',
  '18:2701.F': '18:2701.F            UNLAWFUL ACCESS  (T)',
  '18:2701.M': '18:2701.M            UNLAWFUL ACCESS  (T)',
  '18:2701.P': '18:2701.P            UNLAWFUL ACCESS  (T)',
  '18:2723.P': '18:2723.P            PROHIBITION ON RELEASE AND USE OF CE...',
  '18:285.F': '18:285.F             TAKE/USE PAPERS RELATING TO CLAIMS',
  '18:286.F': '18:286.F             CONSPIRE TO DEFRAUD GOVERNMENT RESPE...',
  '18:287.F': '18:287.F             FALSE OR FRAUDULENT CLAIMS',
  '18:288.M': '18:288.M             FALSE CLAIMS FOR POSTAL LOSSES',
  '18:288.P': '18:288.P             FALSE CLAIMS FOR POSTAL LOSSES',
  '18:289.F': '18:289.F             FALSE CLAIMS FOR PENSIONS',
  '18:290.P': '18:290.P             DISCHARGE PAPERS WITHHELD BY CLAIM A...',
  '18:291.P': '18:291.P             PURCHASE CLAIMS FOR FEES BY COURT OF...',
  '18:292.M': '18:292.M             SOLICITATION OF EMPLOYMENT',
  '18:3.F': '18:3.F               ACCESSORY AFTER THE FACT',
  '18:3.M': '18:3.M               ACCESSORY AFTER THE FACT',
  '18:3.P': '18:3.P               ACCESSORY AFTER THE FACT',
  '18:3056B.M': '18:3056B.M           OBSTRUCTION AND INTERFERENCE W/SECRE...',
  '18:3056D.M': '18:3056D.M           OBSTRUCTION AND INTERFERENCE W/SECRE...',
  '18:3118.P': '18:3118.P            FAILURE TO SUBMIT TO DRUG/ALCOHOL TEST',
  '18:3142.F': '18:3142.F            RELEASE AND DETENTION PENDING JUDICI...',
  '18:3144.P': '18:3144.P            RELEASE OR DETENTION OF MATERIAL WIT...',
  '18:3145.M': '18:3145.M            REVIEW AND APPEAL OF A RELEASE OR DE...',
  '18:3146.F': '18:3146.F            FAILURE TO APPEAR',
  '18:3146.M': '18:3146.M            FAILURE TO APPEAR',
  '18:3146A.F': '18:3146A.F           PENALTY FOR FAILURE TO APPEAR',
  '18:3146B.F': '18:3146B.F           PENALTY FOR FAILURE TO APPEAR',
  '18:3146B.M': '18:3146B.M           FAILURE TO APPEAR AS MATERIAL WITNESS',
  '18:3146C.F': '18:3146C.F           PENALTY FOR FAILURE TO APPEAR',
  '18:3146D.M': '18:3146D.M           PENALTY FOR FAILURE TO APPEAR',
  '18:3147.F': '18:3147.F            OFFENSE COMMITTED WHILE ON RELEASE',
  '18:3147.M': '18:3147.M            OFFENSE COMMITTED WHILE ON RELEASE',
  '18:3148.F': '18:3148.F            SANCTIONS FOR VIOLATION OF A RELEASE...',
  '18:3184.F': '18:3184.F            FUGITIVES FROM FOREIGN COUNTRY TO UN...',
  '18:32A.F': '18:32A.F             DESTRUCTION OF AIRCRAFT OR FACILITY',
  '18:32B.F': '18:32B.F             DESTRUCTION OF AIRCRAFT OR FACILITY',
  '18:32C.F': '18:32C.F             ATTEMPTS TO COMMIT AN OFFENSE',
  '18:33.F': '18:33.F              DESTROY MOTOR VEHICLE OR MOTOR VEHIC...',
  '18:331.F': '18:331.F             MUTILATION AND FALSIFICATION OF COINS',
  '18:332.F': '18:332.F             EMBEZZLEMENT',
  '18:333.P': '18:333.P             MUTILATION OF CURRENCY',
  '18:334.F': '18:334.F             ISSUE FEDERAL RESERVE OR NATIONAL BA...',
  '18:335.F': '18:335.F             CIRCULATE OBLIGATIONS OF EXPIRED COR...',
  '18:336.P': '18:336.P             ISSUE CIRCULATING OBLIGATIONS OF LES...',
  '18:337.M': '18:337.M             COINS AS SECURITY FOR LOANS',
  '18:34.F': '18:34.F              DESTRUCTION OF AIRCRAFT  (T)',
  '18:342.F': '18:342.F             OPERATING COMMON CARRIER UNDER INFLU...',
  '18:35.F': '18:35.F              MOTOR VEHICLE OR OTHER THAN AIRCRAFT',
  '18:351A.F': '18:351A.F            CONGRESSIONAL - ASSASSINATION/VOLUNT...',
  '18:351B.F': '18:351B.F            CONGRESSIONAL - KIDNAPPING   (T)',
  '18:351C.F': '18:351C.F            CONGRESSIONAL - ATTEMPT TO KILL',
  '18:351D.F': '18:351D.F            CONGRESSIONAL - CONSPIRACY TO KILL  (T)',
  '18:351E.F': '18:351E.F            CONGRESSIONAL - ASSAULT',
  '18:351E.M': '18:351E.M            CONGRESSIONAL - ASSAULT ON GOVERNMEN...',
  '18:3521.F': '18:3521.F            WITNESS RELOCATION AND PROTECTION',
  '18:3553.F': '18:3553.F            SENTENCE AGGRAVATING FACTORS UNDER B...',
  '18:3559C.F': '18:3559C.F           IMPRISONMENT OF CERTAIN VIOLENT FELONS',
  '18:3583.F': '18:3583.F            INCLUSION OF A TERM OF SUPERVISED RE...',
  '18:3591.F': '18:3591.F            DEATH PENALTY',
  '18:3592.F': '18:3592.F            DEATH PENALTY',
  '18:36.F': '18:36.F              DRIVE-BY SHOOTINGS',
  '18:3606.F': '18:3606.F            ARREST AND RETURN OF A PROBATIONER',
  '18:3615.M': '18:3615.M            FAILURE TO PAY A FINE',
  '18:37.F': '18:37.F              VIOLENCE AT INTERNATIONAL AIRPORTS',
  '18:371.F': '18:371.F             CONSPIRACY TO DEFRAUD THE UNITED STATES',
  '18:371.M': '18:371.M             CONSPIRACY TO DEFRAUD THE UNITED STATES',
  '18:371.P': '18:371.P             CONSPIRACY TO DEFRAUD THE UNITED STATES',
  '18:372.F': '18:372.F             CONSPIRE TO IMPEDE OR INJURE OFFICER',
  '18:373-0100.F': '18:373-0100.F        SOLICIT/COMMIT CRIME OF VIOLENCE - M...',
  '18:373-0101.F': '18:373-0101.F        SOLICIT/COMMIT CRIME OF VIOLENCE',
  '18:373-0200.F': '18:373-0200.F        MURDER, SECOND DEGREE',
  '18:373-0200.P': '18:373-0200.P        SOLICIT/COMMIT CRIME OF VIOLENCE',
  '18:373-0201.F': '18:373-0201.F        MURDER, 2ND DEGREE - GOVERNMENT OFFI...',
  '18:373-0300.F': '18:373-0300.F        MANSLAUGHTER',
  '18:373-0300.P': '18:373-0300.P        MANSLAUGHTER',
  '18:373-0301.F': '18:373-0301.F        MANSLAUGHTER',
  '18:373-0310.F': '18:373-0310.F        NEGLIGENT HOMICIDE',
  '18:373-0311.F': '18:373-0311.F        SOLICIT/COMMIT CRIME OF VIOLENCE',
  '18:373-1100.F': '18:373-1100.F        ROBBERY, BANK',
  '18:373-1200.F': '18:373-1200.F        ROBBERY, POSTAL',
  '18:373-1400.F': '18:373-1400.F        ROBBERY, OTHER',
  '18:373-1400.P': '18:373-1400.P        SOLICIT/COMMIT CRIME OF VIOLENCE',
  '18:373-1500.F': '18:373-1500.F        AGGRAVATED OR FELONIOUS',
  '18:373-1500.M': '18:373-1500.M        SOLICIT/COMMIT CRIME OF VIOLENCE',
  '18:373-1500.P': '18:373-1500.P        SOLICIT/COMMIT CRIME OF VIOLENCE',
  '18:373-1501.F': '18:373-1501.F        FELONY, ON GOVERNMENT OFFICIAL',
  '18:373-1600.P': '18:373-1600.P        ASSAULT, OTHER',
  '18:373-1601.M': '18:373-1601.M        ASSAULT ON GOVERNMENT OFFICIAL',
  '18:373-1601.P': '18:373-1601.P        MISDEMEANOR, ON GOVERNMENT OFFICIAL',
  '18:373-6100.F': '18:373-6100.F        SEXUAL ASSAULT',
  '18:373-6100.P': '18:373-6100.P        SEXUAL ASSAULT',
  '18:373-6200.F': '18:373-6200.F        WHITE SLAVERY AND IMPORTING ALIENS',
  '18:373-6200.M': '18:373-6200.M        WHITE SLAVERY AND IMPORTING ALIENS',
  '18:373-6300.F': '18:373-6300.F        SEX OFFENSES, OTHER',
  '18:373-6300.M': '18:373-6300.M        SEX OFFENSES, OTHER',
  '18:373-6300.P': '18:373-6300.P        SEX OFFENSES, OTHER',
  '18:373-7410.F': '18:373-7410.F        RACKETEERING, ARSON',
  '18:373-7471.F': '18:373-7471.F        RACKETEERING, MURDER',
  '18:373-7472.F': '18:373-7472.F        RACKETEERING, KIDNAP',
  '18:373-7473.F': '18:373-7473.F        RACKETEERING, MAIM',
  '18:373-7600.F': '18:373-7600.F        RACKETEERING, KIDNAPPING',
  '18:373-7611.F': '18:373-7611.F        RACKETEERING, KIDNAP, HOSTAGE',
  '18:373-7800.F': '18:373-7800.F        RACKETEERING, FIREARMS AND WEAPONS',
  '18:373-7910.F': '18:373-7910.F        RACKETEERING, ARSON',
  '18:373-7910.P': '18:373-7910.P        RACKETEERING, SOLICIT/COMMIT CRIME O...',
  '18:373-7940.F': '18:373-7940.F        RACKETEERING, MALICIOUS DESTRUCTION ...',
  '18:373-9994.F': '18:373-9994.F        RACKETEERING, EXPLOSIVES  (T)',
  '18:38.F': '18:38.F              FRAUD INVOLVING AIRCRAFT OR SPACE VE...',
  '18:4.F': '18:4.F               WITHHOLDING INFORMATION ON A CRIME',
  '18:401.F': '18:401.F             CRIMINAL CONTEMPT',
  '18:401.M': '18:401.M             CRIMINAL CONTEMPT',
  '18:401.P': '18:401.P             CONTEMPT, CONSTITUTING CRIME',
  '18:402.F': '18:402.F             CRIMINAL CONTEMPT',
  '18:402.M': '18:402.M             CRIMINAL CONTEMPT',
  '18:402.P': '18:402.P             CRIMINAL CONTEMPT',
  '18:4082.F': '18:4082.F            ESCAPE FROM CUSTODY',
  '18:41.P': '18:41.P              DISTURBANCE OR INJURY TO WILDLIFE RE...',
  '18:4246.F': '18:4246.F            HOSPITALIZATION OF PERSON DUE FOR RE...',
  '18:4248.F': '18:4248.F            OFFENDERS WITH MENTAL DISEASE OR DEFECT',
  '18:42A.P': '18:42A.P             IMPORT SHIPMENT OF INJURIOUS MAMMALS',
  '18:42B.P': '18:42B.P             IMPORT OR SHIP INJURIOUS MAMMALS, ETC.',
  '18:431.P': '18:431.P             CONTRACTS BY MEMBER OF CONGRESS',
  '18:432.P': '18:432.P             OFFICER OR EMPLOYEE CONTRACTING WITH...',
  '18:435.M': '18:435.M             CONTRACTS IN EXCESS OF SPECIFIC APPR...',
  '18:436.F': '18:436.F             CONVICT LABOR CONTRACTS',
  '18:437.P': '18:437.P             INDIAN CONTRACTS FOR GOODS AND SUPPLIES',
  '18:438.P': '18:438.P             INDIAN CONTRACTS FOR SERVICES GENERALLY',
  '18:439.P': '18:439.P             INDIAN ENROLLMENT CONTRACTS',
  '18:43A.F': '18:43A.F             FORCE, VIOLENCE AND THREATS INVOLVIN...',
  '18:43A.M': '18:43A.M             TRANSPORTATION OF WILDLIFE TAKEN IN ...',
  '18:43B.M': '18:43B.M             TRANSPORTATION OF WILDLIFE TAKEN IN ...',
  '18:43C.M': '18:43C.M             TRANSPORTATION OF WILDLIFE TAKEN IN ...',
  '18:440.M': '18:440.M             MAIL CONTRACTS',
  '18:441.M': '18:441.M             POSTAL SUPPLY CONTRACTS',
  '18:442.M': '18:442.M             PRINTING CONTRACTS',
  '18:443.F': '18:443.F             WAR CONTRACTS',
  '18:46.P': '18:46.P              TRANSPORTATION OF WATER HYACINTHS',
  '18:470.F': '18:470.F             COUNTERFEIT ACTS COMMITTED OUTSIDE T...',
  '18:471.F': '18:471.F             UTTERS COUNTERFEIT OBLIGATIONS',
  '18:472.F': '18:472.F             PASSES COUNTERFEIT OBLIGATIONS OR SE...',
  '18:473.F': '18:473.F             DEAL IN COUNTERFEIT OBLIGATIONS AND ...',
  '18:474.F': '18:474.F             PLATES OR STONES FOR COUNTERFEIT OBL...',
  '18:475.P': '18:475.P             IMITATING OBLIGATIONS OR SECURITIES',
  '18:476.F': '18:476.F             TAKE IMPRESSION OF TOOLS USED FOR OB...',
  '18:477.F': '18:477.F             POSSESS/SELL IMPRESSION OF TOOLS FOR...',
  '18:478.F': '18:478.F             FOREIGN OBLIGATIONS OR SECURITIES',
  '18:479.F': '18:479.F             UTTER COUNTERFEIT OBLIGATIONS OR SEC...',
  '18:47A.P': '18:47A.P             USE OF AIRCRAFT OR MOTOR VEHICLE TO ...',
  '18:47B.P': '18:47B.P             POLLUTION OF WATERING HOLES',
  '18:48.F': '18:48.F              DEPICTION OF ANIMAL CRUELTY',
  '18:480.F': '18:480.F             POSSESS COUNTERFEIT FOREIGN OBLIGATI...',
  '18:480.M': '18:480.M             POSSESS COUNTERFEIT FOREIGN OBLIGATI...',
  '18:481.F': '18:481.F             PLATES/STONES - COUNTERFEIT FOREIGN ...',
  '18:482.F': '18:482.F             FOREIGN BANK NOTES',
  '18:483.M': '18:483.M             UTTER COUNTERFEIT BANK NOTES',
  '18:484.F': '18:484.F             CONNECTING PARTS OF DIFFERENT NOTES',
  '18:485.F': '18:485.F             COINS OR BARS',
  '18:486.F': '18:486.F             UTTER COINS OF GOLD, SILVER OR OTHER...',
  '18:487.F': '18:487.F             MAKE OR POSSESS COUNTERFEIT DIES FOR...',
  '18:488.F': '18:488.F             MAKE OR POSSESS COUNTERFEIT DIES FOR...',
  '18:489.P': '18:489.P             MAKE OR POSSESS LIKENESS OF COINS',
  '18:49.F': '18:49.F              ENFORCEMENT OF ANIMAL FIGHTING PROHI...',
  '18:490.F': '18:490.F             MINOR COINS',
  '18:491.M': '18:491.M             TOKENS OR PAPER USED AS MONEY',
  '18:492.F': '18:492.F             FORFEIT COUNTERFEIT PARAPHERNALIA',
  '18:492.M': '18:492.M             FORFEIT COUNTERFEIT PARAPHERNALIA',
  '18:493.F': '18:493.F             BONDS AND OBLIGATIONS OF CERTAIN LEN...',
  '18:494.F': '18:494.F             CONTRACTOR\'S BONDS, BIDS, AND PUBLIC...',
  '18:495.F': '18:495.F             CONTRACTS, DEALS AND POWERS OF ATTORNEY',
  '18:496.F': '18:496.F             CUSTOMS MATTERS',
  '18:497.F': '18:497.F             LETTER PATENT',
  '18:498.M': '18:498.M             MILITARY OR NAVAL DISCHARGE CERTIFIC...',
  '18:499.F': '18:499.F             MILITARY, NAVAL, OFFICIAL PASSES',
  '18:500.F': '18:500.F             MONEY ORDERS',
  '18:501.F': '18:501.F             POSTAGE STAMPS, POSTAGE METER STAMPS...',
  '18:502.F': '18:502.F             POSTAGE AND REVENUE, STAMPS OF FOREI...',
  '18:503.F': '18:503.F             POSTAGE AND REVENUE, STAMPS OF FOREI...',
  '18:5032.F': '18:5032.F            JUVENILE DELINQUENCY',
  '18:5032.M': '18:5032.M            JUVENILE DELINQUENCY',
  '18:5032.P': '18:5032.P            JUVENILE DELINQUENCY',
  '18:505.F': '18:505.F             FORGERY, SEALS OF DEPARTMENTS OR AGE...',
  '18:506.F': '18:506.F             SEALS OF DEPARTMENTS OR AGENCIES',
  '18:507.F': '18:507.F             SHIP\'S PAPERS',
  '18:508.F': '18:508.F             TRANSPORTATION REQUESTS OF GOVERNMENT',
  '18:509.F': '18:509.F             POSSESS/MAKE PLATES FOR GOVERNMENT T...',
  '18:510A.F': '18:510A.F            FALSELY MAKES/FORGES ENDORSEMENT/SIG...',
  '18:510A.M': '18:510A.M            FORGES ENDORSEMENT ON TREASURY CHECK...',
  '18:510B.F': '18:510B.F            DELIVERS, RETAINS TREASURY CHECK OR ...',
  '18:510B.M': '18:510B.M            FORGES ENDORSEMENT ON TREASURY CHECK...',
  '18:510C.M': '18:510C.M            IF TREASURY CHECK/BOND DOES NOT EXCE...',
  '18:511.F': '18:511.F             ALTERING OR REMOVING MOTOR VEHICLE I.D.',
  '18:512.F': '18:512.F             FORFEITURE OF MOTOR VEHICLES AND PARTS',
  '18:513A.F': '18:513A.F            UTTER FORGED AND COUNTERFEIT SECURITY',
  '18:513B.F': '18:513B.F            POSSESSION OF COUNTERFEITING INSTRUM...',
  '18:514.F': '18:514.F             FICTITIOUS OBLIGATIONS INTENDED TO D...',
  '18:541.F': '18:541.F             ENTRY OF GOODS FALSELY CLASSIFIED, E...',
  '18:541.M': '18:541.M             ENTRY OF GOODS FALSELY CLASSIFIED, E...',
  '18:542.F': '18:542.F             ENTRY OF GOODS BY MEANS OF FALSE STA...',
  '18:543.F': '18:543.F             ENTRY OF GOODS FOR LESS THAN LEGAL DUTY',
  '18:545.F': '18:545.F             SMUGGLING GOODS INTO THE U.S.  (T)',
  '18:546.F': '18:546.F             SMUGGLING GOODS INTO FOREIGN COUNTRIES',
  '18:547.F': '18:547.F             DEPOSITING GOODS IN BUILDINGS ON BOU...',
  '18:548.F': '18:548.F             REMOVE OR REPACK GOODS IN WAREHOUSES',
  '18:549.F': '18:549.F             REMOVE GOODS FROM CUSTOMS CUSTODY',
  '18:550.F': '18:550.F             FALSE CLAIM FOR REFUND OF DUTIES',
  '18:551.F': '18:551.F             CONCEAL OR DESTROY INVOICES OR OTHER...',
  '18:552.F': '18:552.F             OFFICERS AIDING IMPORT OF OBSCENE/TR...',
  '18:553.F': '18:553.F             IMPORT OR EXPORT OF STOLEN MOTOR VEH...',
  '18:554.F': '18:554.F             SMUGGLING GOODS FROM THE UNITED STATES',
  '18:592.F': '18:592.F             TROOPS AT POLLS',
  '18:593.F': '18:593.F             INTERFERENCE BY ARMED FORCES',
  '18:594.M': '18:594.M             INTIMIDATION OF VOTERS',
  '18:595.M': '18:595.M             INTERFERENCE BY ADMIN. EMPLOYEE OF F...',
  '18:596.M': '18:596.M             POLLING ARMED FORCES',
  '18:597.F': '18:597.F             EXPENDITURES TO INFLUENCE VOTING',
  '18:597.M': '18:597.M             EXPENDITURES TO INFLUENCE VOTING',
  '18:598.M': '18:598.M             COERCION BY MEANS OF RELIEF APPROPRI...',
  '18:599.F': '18:599.F             PROMISE OF APPOINTMENT BY CANDIDATE',
  '18:599.M': '18:599.M             PROMISE OF APPOINTMENT BY CANDIDATE',
  '18:600.M': '18:600.M             PROMISE OF EMPLOYMENT OR OTHER BENEF...',
  '18:601.M': '18:601.M             DEPRIVE EMPLOYMENT OR OTHER BENEFIT ...',
  '18:602.F': '18:602.F             SOLICIT POLITICAL CONTRIBUTIONS',
  '18:603.F': '18:603.F             PLACE OF SOLICITATION',
  '18:604.M': '18:604.M             SOLICIT FROM PERSON ON RELIEF',
  '18:605.M': '18:605.M             DISCLOSE NAMES OF PERSONS ON RELIEF',
  '18:606.F': '18:606.F             INTIMIDATE TO SECURE POLITICAL CONTR...',
  '18:607.F': '18:607.F             MAKING POLITICAL CONTRIBUTIONS',
  '18:611.M': '18:611.M             VOTING BY ALIENS',
  '18:641.F': '18:641.F             PUBLIC MONEY, PROPERTY OR RECORDS',
  '18:641.M': '18:641.M             THEFT/EMBEZZLEMENT OF U. S. PROPERTY',
  '18:642.F': '18:642.F             TOOLS AND MATERIALS FOR COUNTERFEITING',
  '18:643.F': '18:643.F             ACCOUNTING GENERALLY FOR PUBLIC MONEY',
  '18:643.M': '18:643.M             ACCOUNTING GENERALLY FOR PUBLIC MONEY',
  '18:644.F': '18:644.F             BANKER RECEIVING UNAUTHORIZED DEPOSI...',
  '18:644.M': '18:644.M             EMBEZZLES PUBLIC MONEYS OR PROPERTY',
  '18:645.F': '18:645.F             EMBEZZLEMENT: COURT OFFICERS',
  '18:645.M': '18:645.M             EMBEZZLEMENT: COURT OFFICERS',
  '18:646.F': '18:646.F             COURT OFFICERS DEPOSITING REGISTRY M...',
  '18:646.M': '18:646.M             COURT OFFICERS DEPOSITING REGISTRY M...',
  '18:647.F': '18:647.F             RECEIVING LOAN FROM COURT OFFICER',
  '18:647.M': '18:647.M             RECEIVING LOAN FROM COURT OFFICER',
  '18:648.F': '18:648.F             CUSTODIANS, GENERALLY, MISUSING PUBL...',
  '18:648.M': '18:648.M             CUSTODIANS, GENERALLY, MISUSING PUBL...',
  '18:649.F': '18:649.F             CUSTODIANS: FAILING TO DEPOSIT MONEYS',
  '18:649.M': '18:649.M             CUSTODIANS: FAILING TO DEPOSIT MONEYS',
  '18:650.F': '18:650.F             DEPOSITARIES FAILING TO SAFEGUARD DE...',
  '18:650.M': '18:650.M             DEPOSITARIES FAILING TO SAFEGUARD DE...',
  '18:651.F': '18:651.F             DISBURSING OFFICER FALSELY CERTIFYIN...',
  '18:651.M': '18:651.M             DISBURSING OFFICER FALSELY CERTIFYIN...',
  '18:652.F': '18:652.F             DISBURSING OFFICER PAYING LESSER LAW...',
  '18:652.M': '18:652.M             DISBURSING OFFICER PAYING LESSER LAW...',
  '18:653.F': '18:653.F             DISBURSING OFFICER MISUSING PUBLIC FUND',
  '18:653.M': '18:653.M             DISBURSING OFFICER MISUSING PUBLIC FUND',
  '18:654.F': '18:654.F             OFFICER OR EMPLOYEE OF U.S. CONVERTI...',
  '18:654.M': '18:654.M             OFFICER OR EMPLOYEE OF U.S. CONVERTI...',
  '18:655.F': '18:655.F             THEFT BY BANK EXAMINER  (T)',
  '18:655.M': '18:655.M             THEFT BY BANK EXAMINER  (T)',
  '18:656.F': '18:656.F             THEFT/EMBEZZLEMENT/MISAPPLICATION BY...',
  '18:656.M': '18:656.M             THEFT/EMBEZZLEMENT/MISAPPLICATION BY...',
  '18:657.F': '18:657.F             LENDING, CREDIT AND INSURANCE INSTIT...',
  '18:657.M': '18:657.M             LENDING, CREDIT AND INSURANCE INSTIT...',
  '18:658.F': '18:658.F             PROP MORTGAGED OR PLEDGED TO FARM CR...',
  '18:658.M': '18:658.M             PROP MORTGAGED OR PLEDGED TO FARM CR...',
  '18:659.F': '18:659.F             INTERSTATE OR FOREIGN SHIPMENT BY CA...',
  '18:659.M': '18:659.M             INTERSTATE OR FOREIGN SHIPMENT BY CA...',
  '18:660.F': '18:660.F             CARRIER\'S FUNDS DERIVED FROM COMMERCE',
  '18:661.F': '18:661.F             LARCENY W/IN SPECIAL MARITIME JURISD...',
  '18:661.M': '18:661.M             LARCENY W/IN SPECIAL MARITIME JURISD...',
  '18:662.F': '18:662.F             RECEIVING STOLEN PROP W/IN SPECIAL M...',
  '18:662.M': '18:662.M             RECEIVING STOLEN PROP W/IN SPECIAL M...',
  '18:663.F': '18:663.F             SOLICITATION OR USE OF GIFTS',
  '18:664.F': '18:664.F             THEFT OR EMBEZZLEMENT FROM EMPLOYEE ...',
  '18:665A.F': '18:665A.F            THEFT OR EMBEZZLEMENT FROM MANPOWER ...',
  '18:665A.M': '18:665A.M            THEFT OR EMBEZZLEMENT FROM MANPOWER ...',
  '18:665B.M': '18:665B.M            THEFT OR EMBEZZLEMENT FROM MANPOWER ...',
  '18:666A.F': '18:666A.F            CONVERTS TO OWN USE PROPERTY OF ANOTHER',
  '18:666B.F': '18:666B.F            UNLAWFULLY ACCEPT PROPERTY OF ANOTHER',
  '18:666C.F': '18:666C.F            BRIBERY INVOLVING FEDERAL PROGRAMS',
  '18:667.F': '18:667.F             THEFT OF LIVESTOCK',
  '18:668.F': '18:668.F             THEFT OR RECEIPT OF STOLEN ARTWORK',
  '18:669.F': '18:669.F             THEFT OR EMBEZZLEMENT IN CONNECTION ...',
  '18:669.M': '18:669.M             THEFT OR EMBEZZLEMENT IN CONNECTION ...',
  '18:7.F': '18:7.F               SPECIAL MARITIME AND TERRITORIAL JUR...',
  '18:700.M': '18:700.M             DESECRATION OF THE FLAG OF THE U.S.',
  '18:701.P': '18:701.P             MILITARY-BADGES ID CARDS, OTHER INSI...',
  '18:702.P': '18:702.P             UNIFORM OF ARMED FORCES AND PUB HEAL...',
  '18:703.P': '18:703.P             UNIFORM OF FRIENDLY NATION',
  '18:704.F': '18:704.F             MILITARY MEDALS OR DECORATIONS',
  '18:704.M': '18:704.M             MILITARY MEDALS OR DECORATIONS',
  '18:704.P': '18:704.P             MILITARY MEDALS OR DECORATIONS',
  '18:705.P': '18:705.P             BADGE OR MEDAL OF VETERANS\' ORGANIZA...',
  '18:706.P': '18:706.P             IMPERSONATE RED CROSS PERSONNEL',
  '18:707.P': '18:707.P             4-H CLUB EMBLEM FRAUDULENTLY USED',
  '18:708.P': '18:708.P             SWISS CONFEDERATION COAT OF ARMS',
  '18:709.M': '18:709.M             FALSE ADVERTISING OR MISUSE OF NAMES',
  '18:710.P': '18:710.P             CREMATION URNS FOR MILITARY USE',
  '18:711.P': '18:711.P             SMOKEY BEAR CHARACTER OR NAME',
  '18:712.M': '18:712.M             MISUSE OF NAMES, WORDS, EMBLEMS, OR ...',
  '18:713.P': '18:713.P             USE OF LIKENESS OF THE GREAT SEAL/U.S.',
  '18:715.P': '18:715.P             THE GOLDEN EAGLE INSIGNIA',
  '18:716.P': '18:716.P             TRNSFR/TRNSPT/RCPT OF CNTRFIT POLC B...',
  '18:751A.F': '18:751A.F            PRISONER IN CUSTODY OF INSTITUTION O...',
  '18:751A.M': '18:751A.M            ESCAPE/ATTEMPTED ESCAPE FROM A/G CUS...',
  '18:751B.M': '18:751B.M            PRISONERS IN CUSTODY OF INSTITUTION/...',
  '18:752A.F': '18:752A.F            INSTIGATING OR ASSISTING ESCAPE',
  '18:752A.M': '18:752A.M            INSTIGATING OR ASSISTING ESCAPE',
  '18:752B.M': '18:752B.M            INSTIGATING OR ASSISTING ESCAPE',
  '18:753.F': '18:753.F             RESCUE TO PREVENT EXECUTION',
  '18:754.M': '18:754.M             RESCUE OF BODY OF EXECUTED OFFENDER',
  '18:755.F': '18:755.F             OFFICER PERMITTING ESCAPE',
  '18:755.M': '18:755.M             OFFICER PERMITTING ESCAPE',
  '18:756.M': '18:756.M             INTERNEE OF BELLIGERENT NATION',
  '18:757.F': '18:757.F             PRISONERS OF WAR OR ENEMY ALIENS',
  '18:758.F': '18:758.F             HIGH SPEED FLIGHT FROM IMMIGRATION C...',
  '18:792.F': '18:792.F             HARBORING OR CONCEALING PERSONS',
  '18:793.F': '18:793.F             GATHERING, TRANSMITTING, OR LOSING D...',
  '18:794.F': '18:794.F             GATHERING, DELIVERING DEFENSE INFO',
  '18:795.M': '18:795.M             PHOTOGRAPHING AND SKETCHING DEFENSE INS',
  '18:797.M': '18:797.M             PUBLISH AND SELL PHOTOGRAPHS OF DEFE...',
  '18:798.F': '18:798.F             DISCLOSURE OF CLASSIFIED INFORMATION',
  '18:799.M': '18:799.M             VIOL OF REGULATIONS OF NASA',
  '18:81.F': '18:81.F              ARSON WITHIN SPECIAL MARITIME OR TER...',
  '18:831.F': '18:831.F             RECEIVE/ALTER/DISPERSE/NUCLEAR MATERIAL',
  '18:836.M': '18:836.M             TRANSPORTATION OF FIREWORKS INTO STA...',
  '18:842A.F': '18:842A.F            IMPORTING EXPLOSIVE MATERIAL',
  '18:842B.F': '18:842B.F            DISTRIBUTE EXPLOSIVE MATERIAL',
  '18:842C.F': '18:842C.F            DISTRIBUTE EXPLOSIVE MATERIAL TO PRO...',
  '18:842D.F': '18:842D.F            DISTRIBUTE EXPLOSIVE MATERIAL TO UNA...',
  '18:842E.F': '18:842E.F            DISTRIBUTE EXPLOSIVE MATERIAL IN VIO...',
  '18:842F.F': '18:842F.F            MANUFACTURE OF IMPORT EXPLOSIVE MATE...',
  '18:842G.F': '18:842G.F            FALSE ENTRIES, EXPLOSIVE MATERIALS',
  '18:842H.F': '18:842H.F            DISTRIBUTE STOLEN EXPLOSIVES',
  '18:842H.M': '18:842H.M            DISTRIBUTE STOLEN EXPLOSIVES',
  '18:842I.F': '18:842I.F            SHIP OR TRANSPORT EXPLOSIVE MATERIAL...',
  '18:842I.M': '18:842I.M            SHIP OR TRANSPORT EXPLOSIVE MATERIAL...',
  '18:842J.M': '18:842J.M            NOT CONFORMING TO STORAGE OF EXPLOSI...',
  '18:842K.M': '18:842K.M            FAILURE TO REPORT THEFT OR LOSS OF E...',
  '18:842P.F': '18:842P.F            TEACHING OR DEMONSTRATING MAKING OF ...',
  '18:844A.F': '18:844A.F            PENALTIES FOR 18:842A-I',
  '18:844B.M': '18:844B.M            PENALTIES FOR 18:842J-K',
  '18:844D.F': '18:844D.F            PENALTIES - IF DEATH OR INJURY RESULTS',
  '18:844E.F': '18:844E.F            PENALTIES',
  '18:844F.F': '18:844F.F            PENALTIES - IF DEATH RESULTS',
  '18:844G.F': '18:844G.F            POSSESS EXPLOSIVES ON FEDERAL PROPERTY',
  '18:844G.M': '18:844G.M            POSSESS EXPLOSIVES ON FEDERAL PROPERTY',
  '18:844H.F': '18:844H.F            EXPLOSIVES USED IN COMMISSION OF FELONY',
  '18:844I.F': '18:844I.F            PENALTIES - IF DEATH RESULTS',
  '18:844J.F': '18:844J.F            UNLAWFUL STORAGE OF EXPLOSIVES',
  '18:844N.F': '18:844N.F            CONSPIRACY',
  '18:871.F': '18:871.F             THREATS AGAINST PRESIDENT AND SUCCES...',
  '18:872.F': '18:872.F             EXTORTION BY OFFICERS OR EMPLOYEES O...',
  '18:872.M': '18:872.M             EXTORTION BY OFFICERS OR EMPLOYEES O...',
  '18:873.M': '18:873.M             BLACKMAIL',
  '18:874.F': '18:874.F             KICKBACKS FROM PUBLIC WORKS EMPLOYEES',
  '18:875A.F': '18:875A.F            INTERSTATE COMMUNICATIONS - RANSOMS',
  '18:875B.F': '18:875B.F            INTERSTATE COMMUNICATIONS - THREAT T...',
  '18:875C.F': '18:875C.F            INTERSTATE COMMUNICATIONS - THREATS',
  '18:875D.F': '18:875D.F            INTERSTATE COMMUNICATIONS - THREATS ...',
  '18:876.F': '18:876.F             MAILING THREATENING COMMUNICATIONS',
  '18:877.F': '18:877.F             MAILING THREATENING COMMUNICATIONS/F...',
  '18:878A.F': '18:878A.F            THREATENED ASSAULT',
  '18:878B.F': '18:878B.F            EXTORTIONATE DEMANDS',
  '18:879.F': '18:879.F             THREATS AGAINST FORMER PRESIDENT/FAM...',
  '18:880.F': '18:880.F             RECEIVING PROCEEDS OF EXTORTION',
  '18:892.F': '18:892.F             EXTENSIONS OF CREDIT BY EXTORTION',
  '18:893.F': '18:893.F             EXTENSIONS OF CREDIT BY FINANCIAL EX...',
  '18:894.F': '18:894.F             COLLECTION OF CREDIT BY EXTORTION',
  '18:911.F': '18:911.F             IMPERSONATING CITIZEN OF THE U.S.',
  '18:912.F': '18:912.F             IMPERSONATING OFFICER OR EMPLOYEE OF...',
  '18:913.F': '18:913.F             IMPERSONATOR MAKING ARREST OR SEARCH',
  '18:914.F': '18:914.F             IMPERSONATING A CREDITOR OF U.S.',
  '18:915.F': '18:915.F             IMPERSONATING FOREIGN DIPLOMATS, CON...',
  '18:916.P': '18:916.P             IMPERSONATING 4-H CLUB MEMBERS OR AG...',
  '18:917.F': '18:917.F             IMPERSONATING A RED CROSS MEMBER',
  '18:917.M': '18:917.M             IMPERSONATING RED CROSS MEMBERS OR A...',
  '18:922A.F': '18:922A.F            IMPORTING/MANUFACTURING FIREARMS',
  '18:922B.F': '18:922B.F            SELL FIREARMS TO UNAUTHORIZED PERSONS',
  '18:922C.F': '18:922C.F            ILLEGAL TRANSFER OF FIREARMS',
  '18:922D.F': '18:922D.F            SELL FIREARMS TO ADDICTS, FELONS, FU...',
  '18:922E.F': '18:922E.F            INTERSTATE SHIPMENTS',
  '18:922F.F': '18:922F.F            KNOWINGLY SHIP ILLEGAL WEAPONS',
  '18:922G.F': '18:922G.F            UNLAWFUL TRANSPORT OF FIREARMS, ETC.',
  '18:922H.F': '18:922H.F            RECEIVE OR TRANSPORT BY EMPLOYEE',
  '18:922I.F': '18:922I.F            TRANSPORT STOLEN FIREARMS',
  '18:922J.F': '18:922J.F            RECEIVE STOLEN FIREARMS',
  '18:922K.F': '18:922K.F            SELL DEFACED FIREARMS',
  '18:922L.F': '18:922L.F            ILLEGAL IMPORTATION OF FIREARMS',
  '18:922M.F': '18:922M.F            FAILURE TO MAINTAIN RECORDS',
  '18:922M.M': '18:922M.M            FAILURE TO MAINTAIN RECORDS',
  '18:922N.F': '18:922N.F            TRANSPORT FIREARMS INTERSTATE BY FELON',
  '18:922O.F': '18:922O.F            VIOLENT CRIME/DRUGS/MACHINE GUN',
  '18:922Q.F': '18:922Q.F            CARRYING/USING FIREARM IN/NEAR SCHOO...',
  '18:922Q.M': '18:922Q.M            CARRYING/USING FIREARM IN/NEAR SCHOO...',
  '18:922S.M': '18:922S.M            UNLAWFUL TRANSFER OF HANDGUN TO AN U...',
  '18:922T.M': '18:922T.M            ILLEGAL TRANSFER OF FIREARMS TO AN U...',
  '18:922U.F': '18:922U.F            STEALING A FIREARM FROM A LICENSED D...',
  '18:922W.F': '18:922W.F            TRANSFER OR POSSESS A LARGE CAP AMMU...',
  '18:922X.M': '18:922X.M            TRANSFER OF WEAPONS TO A JUVENILE',
  '18:923.F': '18:923.F             FIREARMS LICENSING',
  '18:924A.F': '18:924A.F            PENALTIES FOR FIREARMS',
  '18:924A.M': '18:924A.M            LICENSE VIOLATION (FRAUD) 18.922M',
  '18:924B.F': '18:924B.F            PENALTIES FOR FIREARMS',
  '18:924C.F': '18:924C.F            VIOLENT CRIME/DRUGS/MACHINE GUN',
  '18:924D.F': '18:924D.F            SEIZURE, FORFEITURE AND DISPOSITION ...',
  '18:924E.F': '18:924E.F            ARMED CAREER CRIMINAL',
  '18:924F.F': '18:924F.F            INTERDICT/SUPPLY FIREARM/DRUG TRAFFI...',
  '18:924G.F': '18:924G.F            KNOWING TRANSFER ARMS USED IN VIOLEN...',
  '18:924H.F': '18:924H.F            TRANSFER OF FIREARM-USE IN VIOLENT C...',
  '18:924I.F': '18:924I.F            STEAL IMPORTED OR INTERSTATE SHIPPED...',
  '18:924J.F': '18:924J.F            VIOLENT CRIME/DRUGS/MACHINE GUN WHER...',
  '18:924K.F': '18:924K.F            STEAL IMPORTED/INTERSTATE SHIPPED WE...',
  '18:924L.F': '18:924L.F            STEAL IMPORTED/INTERSTATE SHIPPED WE...',
  '18:924N.F': '18:924N.F            TO TRAVEL TO ANOTHER STATE TO ENGAGE...',
  '18:924O.F': '18:924O.F            CONSPIRACY TO COMMIT A VIOLENT CRIME...',
  '18:929.F': '18:929.F             USE OF RESTRICTED AMMUNITION',
  '18:930.F': '18:930.F             POSSESS W/INTENT/USE IN CRIME  (T)',
  '18:930.M': '18:930.M             ATTEMPT/POSSESS/CAUSE/WEAPON IN FEDE...',
  '18:931.F': '18:931.F             PROHIBT PURCHASE,OWN,POSSES OF BODY ...',
  '18:951.F': '18:951.F             IMPERSONATING AGENTS OF FOREIGN GOVE...',
  '18:952.F': '18:952.F             DIPLOMATIC  CODES AND CORRESPONDENCE',
  '18:953.F': '18:953.F             PRIVATE CORRESPONDENCE W/FOREIGN GOV...',
  '18:954.F': '18:954.F             FALSE STATEMENTS INFLUENCING FOREIGN...',
  '18:955.F': '18:955.F             FINANCIAL TRANSACTIONS W/FOREIGN GOV...',
  '18:956.F': '18:956.F             CONSPIRACY TO INJURE PROPERTY OF FOR...',
  '18:957.F': '18:957.F             POSSESSING PROP IN AID OF FOREIGN GO...',
  '18:958.F': '18:958.F             COMMISSION TO SERVE AGAINST FRIENDLY...',
  '18:959.F': '18:959.F             ENLISTMENT IN FOREIGN SERVICE',
  '18:960.F': '18:960.F             EXPEDITION AGAINST FRIENDLY NATION',
  '18:961.M': '18:961.M             STRENGTHENING ARMED VESSEL OF FOREIG...',
  '18:962.F': '18:962.F             ARMING VESSEL AGAINST FRIENDLY NATION',
  '18:963.F': '18:963.F             DETENTION OF ARMED VESSEL',
  '18:964.F': '18:964.F             DELIVER ARMED VESSEL TO HOSTILE NATION',
  '18:965.F': '18:965.F             VERIFYING STATEMENTS BEFORE VESSEL D...',
  '18:966.F': '18:966.F             DEPARTURE OF VESSEL FORBIDDEN/FALSE ...',
  '18:967.F': '18:967.F             DEPARTURE OF VESSEL FORBIDDEN/AID NE...',
  '18:970.F': '18:970.F             PROTECT PROPERTY OCCUPIED BY FOREIGN...',
  '18:970.P': '18:970.P             PROTECT PROPERTY OCCUPIED BY FOREIGN...',
  '18:981.F': '18:981.F             CIVIL FORFEITURE',
  '18:982.F': '18:982.F             CRIMINAL FORFEITURE',
  '19:1304.M': '19:1304.M            MARKING OF IMPORTED ARTICLES AND CON...',
  '19:1305.M': '19:1305.M            IMPORTATION OF IMMORAL ARTICLES',
  '19:1341.M': '19:1341.M            INTERFERENCE WITH FUNCTIONS OF COMMI...',
  '19:1433.F': '19:1433.F            REPORT OF ARRIVAL OF VESSELS, VEHICL...',
  '19:1433.M': '19:1433.M            REPORT OF ARRIVAL OF VESSELS, VEHICL...',
  '19:1436.F': '19:1436.F            FORGED, ALTERED DOCUMENT ON ENTRY',
  '19:1436.M': '19:1436.M            FAILURE TO REPORT OR ENTER VESSEL: A...',
  '19:1445.P': '19:1445.P            FAILURE TO HAVE PERMIT/CERTIFIED MAN...',
  '19:1459.M': '19:1459.M            REPORTING REQUIREMENTS - CUSTOM DUTIES',
  '19:1459.P': '19:1459.P            CONTIGUOUS COUNTRIES, REPORT AND MAN...',
  '19:1460.P': '19:1460.P            PENALTIES FOR FAILURE TO FILE MANIFEST',
  '19:1461.F': '19:1461.F            FAILURE TO DECLARE NARCOTICS',
  '19:1464.F': '19:1464.F            PENALTIES IN CONNECTION WITH SEALED ...',
  '19:1465.F': '19:1465.F            SUPPLIES - CUSTOM LAWS',
  '19:1465.P': '19:1465.P            SUPPLIES - CUSTOM LAWS',
  '19:1497.P': '19:1497.P            FAILURE TO DECLARE  (T)',
  '19:1581.P': '19:1581.P            FAILURE TO STOP FOR CUSTOMS OFFICER',
  '19:1585.M': '19:1585.M            DEPARTURE BEFORE REPORT ON ENTRY',
  '19:1586.F': '19:1586.F            UNLAWFUL UNLOADING OF MERCHANDISE',
  '19:1590=CI.F': '19:1590=CI.F         MARITIME DRUG LAWS - CONTROLLED SUBS...',
  '19:1590=MI.F': '19:1590=MI.F         MARITIME DRUG LAWS - MARIJUANA',
  '19:1590=NI.F': '19:1590=NI.F         MARITIME DRUG LAWS - NARCOTICS',
  '19:1603.M': '19:1603.M            SEIZURE: CUSTOMS OFFICER\'S REPORTS',
  '19:1919.F': '19:1919.F            FALSE STATEMENT DESIGNED TO INFLUENC...',
  '19:1975.M': '19:1975.M            FALSE STATEMENTS MADE IN CONNECTION ...',
  '19:2349.F': '19:2349.F            MAKE FALSE CLAIMS FOR UNEMPLOYMENT B...',
  '19:283.F': '19:283.F             DUTY ON SALOON STORES',
  '19:286.P': '19:286.P             DEPARTURE FOR PLACE WHERE THERE IS N...',
  '19:287.P': '19:287.P             REPORT AND UNLADING CARGOES',
  '19:290.P': '19:290.P             DEPARTURE FROM WHERE THERE IS NO CUS...',
  '19:291.P': '19:291.P             FORMS',
  '19:460.P': '19:460.P             PENALTY FOR FAILURE TO REPORT OR TO ...',
  '19:468.P': '19:468.P             STAMPS AND BRANDS EFFACED ON EMPTYIN...',
  '19:469.M': '19:469.M             DEAL IN/USE EMPTY STAMPED IMPORT LIQ...',
  '19:469.P': '19:469.P             DEALING IN OR USING EMPTY STAMPED IM...',
  '19:507.M': '19:507.M             REFUSAL TO ASSIST CUSTOMS OFFICER',
  '19:507.P': '19:507.P             REFUSAL TO ASSIST CUSTOMS OFFICER',
  '19:60.P': '19:60.P              EXTORTION',
  '19:70.P': '19:70.P              OBSTRUCTION OF REVENUE OFFICERS BY M...',
  '19:81.P': '19:81.P              OFFENSES',
  '20:1087.F': '20:1087.F            EMBEZZLES ANY FUNDS BY FRAUD OR FORGERY',
  '20:1087.M': '20:1087.M            EMBEZZLES ANY FUNDS BY FRAUD OR FORGERY',
  '20:10874.F': '20:10874.F           EMBEZZLES ANY FUNDS BY FRAUD OR FORGERY',
  '20:10874.M': '20:10874.M           EMBEZZLES ANY FUNDS BY FRAUD OR FORGERY',
  '20:1097A.F': '20:1097A.F           EMBEZZLEMENT, STEALING, FRAUD, FALSE...',
  '20:1097A.M': '20:1097A.M           EMBEZZLEMENT, STEALING, FRAUD, FALSE...',
  '20:1097B.M': '20:1097B.M           FALSE STATEMENTS, FALSE INFORMATION',
  '20:1097C.M': '20:1097C.M           UNLAWFUL PAYMENTS TO ELIGIBLE LENDERS',
  '20:1097D.F': '20:1097D.F           DESTRUCTION OR CONCEALMENT OF RECORDS',
  '21:1037.M': '21:1037.M            ADULTERATED OR MISBRANDED EGGS USED ...',
  '21:104.F': '21:104.F             IMPORTATION OF DISEASED ANIMALS PROH...',
  '21:1041A.F': '21:1041A.F           PENALTIES: SCOPE OF LIABILITY',
  '21:1041A.M': '21:1041A.M           PENALTIES: SCOPE OF LIABILITY',
  '21:1041C.F': '21:1041C.F           PENALTIES',
  '21:111.M': '21:111.M             REGULATIONS TO PREVENT CONTAGIOUS DI...',
  '21:115.M': '21:115.M             TRANSPORTATION OF DISEASED LIVESTOCK...',
  '21:117.M': '21:117.M             NOTICE OF EXISTENCE OF CONTAGION TO ...',
  '21:1175.P': '21:1175.P            CONFIDENTIALITY OF PATIENT RECORDS',
  '21:120.M': '21:120.M             REGULATIONS OF EXPORT/TRANSPORTATION...',
  '21:122.M': '21:122.M             OFFENSES: PENALTY',
  '21:124.M': '21:124.M             TRANSPORTATION OR DELIVERY OF QUARAN...',
  '21:126.M': '21:126.M             MOVING QUARANTINED ANIMALS AND LIVE ...',
  '21:134A.M': '21:134A.M            SEIZURE, QUARANTINE,AND DISPOSAL OF ...',
  '21:134B.M': '21:134B.M            REGULATIONS FOR CLEAN AND SANITARY M...',
  '21:134C.M': '21:134C.M            REGULATIONS FOR MOVEMENT OF ANIMALS ...',
  '21:134D.M': '21:134D.M            INSPECTIONS AND SEIZURES: ISSUANCE O...',
  '21:134E.M': '21:134E.M            PENALTIES: ENFORCEMENT PROVISIONS',
  '21:135.F': '21:135.F             SMUGGLING PENALTIES',
  '21:141.M': '21:141.M             PROHIBITION OF IMPORTATION WITHOUT P...',
  '21:142.M': '21:142.M             MILK OR CREAM WHEN UNFIT FOR IMPORTA...',
  '21:143.M': '21:143.M             INSPECTION: CERTIFIED STATEMENT IN L...',
  '21:144.M': '21:144.M             UNLAWFUL RECEIVING OF IMPORTED MILK/...',
  '21:145.M': '21:145.M             PENALTIES',
  '21:151.M': '21:151.M             PREPARE AND SELL HARMFUL PRODUCTS FO...',
  '21:152.M': '21:152.M             IMPORTATION REGULATED AND PROHIBITED',
  '21:153.M': '21:153.M             INSPECTION OF IMPORTS: DENIAL OF ENTRY',
  '21:154.M': '21:154.M             REGULATIONS FOR PREPARATION AND SALE...',
  '21:155.M': '21:155.M             PERMITS FOR IMPORTATION',
  '21:157.M': '21:157.M             INSPECTION - DAYTIME OR NIGHTTIME',
  '21:158.M': '21:158.M             OFFENSES: PUNISHMENT',
  '21:16.P': '21:16.P              INTRODUCTION OR SALE OF DAIRY - FOOD...',
  '21:17.P': '21:17.P              INTRODUCE FALSELY LABELED/BRAND FOOD...',
  '21:1904.F': '21:1904.F            INTERNATIONAL NARCOTICS TRAFFICKING',
  '21:1906.F': '21:1906.F            INTERNATIONAL NARCOTICS TRAFFICKING',
  '21:20.P': '21:20.P              APPLES IN INTERSTATE COMMERCE: STAND...',
  '21:201.P': '21:201.P             PRACTICING PHARMACY WITHOUT A LICENSE',
  '21:203.P': '21:203.P             APPLICATION FOR PHARMACY LICENSE: QU...',
  '21:205.P': '21:205.P             DISPLAY OF LICENSE IN PHARMACY',
  '21:207.P': '21:207.P             RESTRICTIONS ON SALES: WRITTEN ORDER',
  '21:209.P': '21:209.P             RESTRICTIONS ON SALES: POISONS, LABE...',
  '21:21.P': '21:21.P              MISBRANDED BARRELS',
  '21:210.P': '21:210.P             PHARMACIST: UNAUTHORIZED USE OF TITLE',
  '21:211.P': '21:211.P             PRESERVATION OF ORIGINALS OF PRESCRI...',
  '21:212.P': '21:212.P             OFFENSES: PUNISHMENT: DUTY TO ENFORC...',
  '21:213.P': '21:213.P             FRAUD. REPRESENTATION TO EVADE/DEFEA...',
  '21:22.P': '21:22.P              APPLES IN INTERSTATE COMMERCE: BARRE...',
  '21:23.P': '21:23.P              PENALTIES',
  '21:331A.F': '21:331A.F            ADULTERATION OR MISBRANDING OF ANY F...',
  '21:331A.M': '21:331A.M            ADULTERATION OR MISBRANDING OF ANY F...',
  '21:331B.F': '21:331B.F            ADULTERATION OR MISBRANDING OF ANY F...',
  '21:331B.M': '21:331B.M            ADULTERATION OR MISBRANDING OF ANY F...',
  '21:331C.F': '21:331C.F            RECEIPT IN INTERSTATE COMMERCE OF AN...',
  '21:331C.M': '21:331C.M            RECEIPT IN INTERSTATE COMMERCE OF AN...',
  '21:331D.F': '21:331D.F            VIOLATIONS OF 21-344 OR 21-355',
  '21:331D.M': '21:331D.M            VIOLATIONS OF 21-344 OR 21-355',
  '21:331E.F': '21:331E.F            REFUSAL TO PERMIT ACCESS TO OR COPYI...',
  '21:331E.M': '21:331E.M            REFUSAL TO PERMIT ACCESS TO OR COPYI...',
  '21:331F.F': '21:331F.F            REFUSAL TO PERMIT ENTRY OR INSPECTION',
  '21:331F.M': '21:331F.M            REFUSAL TO PERMIT ENTRY OR INSPECTION',
  '21:331G.F': '21:331G.F            MANUFACTURE OF ADULTERATED OR MISBRA...',
  '21:331G.M': '21:331G.M            MANUFACTURE OF ADULTERATED OR MISBRA...',
  '21:331H.F': '21:331H.F            FALSE GUARANTY  (T)',
  '21:331H.M': '21:331H.M            FALSE GUARANTY  (T)',
  '21:331I.F': '21:331I.F            FALSIFICATION OF ID REQUIRED BY REGU...',
  '21:331I.M': '21:331I.M            FALSIFICATION OF ID REQUIRED BY REGU...',
  '21:331J.F': '21:331J.F            USING OR REVEALING OF TRADE SECRETS',
  '21:331J.M': '21:331J.M            USING OR REVEALING OF TRADE SECRETS',
  '21:331K.F': '21:331K.F            AFFECTING THE LABEL TO CAUSE MISBRAN...',
  '21:331K.M': '21:331K.M            AFFECTING THE LABEL TO CAUSE MISBRAN...',
  '21:331L.F': '21:331L.F            MISREPRESENTING COMPLIANCE',
  '21:331L.M': '21:331L.M            MISREPRESENTING COMPLIANCE',
  '21:331M.F': '21:331M.F            SALE OF COLORED OLEOMARGARINE IN VIO...',
  '21:331M.M': '21:331M.M            SALE OF COLORED OLEOMARGARINE IN VIO...',
  '21:331N.F': '21:331N.F            PROMOTING PRODUCTS BY USING ANY REPORT',
  '21:331N.M': '21:331N.M            PROMOTING PRODUCTS BY USING ANY REPORT',
  '21:331O.F': '21:331O.F            FAILURE TO TRANSMIT INFORMATION ABOU...',
  '21:331O.M': '21:331O.M            FAILURE TO TRANSMIT INFORMATION ABOU...',
  '21:331P.F': '21:331P.F            FAILURE TO REGISTER AS REQUIRED',
  '21:331P.M': '21:331P.M            FAILURE TO REGISTER AS REQUIRED',
  '21:331Q.F': '21:331Q.F            FAILURE OR REFUSAL TO COMPLY',
  '21:331Q.M': '21:331Q.M            FAILURE OR REFUSAL TO COMPLY',
  '21:331T.F': '21:331T.F            PROHIBITED ACTS - IMPORTING DRUGS',
  '21:331T.M': '21:331T.M            PROHIBITED ACTS - IMPORTING DRUGS',
  '21:332.F': '21:332.F             ADULTERATION OR MISBRANDING OF ANY F...',
  '21:333A.M': '21:333A.M            VIOLATION OF SEC. 331 OF THIS TITLE',
  '21:333B.F': '21:333B.F            PRESCRIPTION DRUG MARKETING',
  '21:333E.F': '21:333E.F            TRAFFIC IN STEROIDS, DISTRIBUTE/POSS...',
  '21:334.F': '21:334.F             ADULTERATION OR MISBRANDING OF ANY F...',
  '21:353.M': '21:353.M             FOOD, DRUG AND COSMETIC ACT OF 1972',
  '21:458A.F': '21:458A.F            SLAUGHTER POULTRY IN COMPLIANCE WITH...',
  '21:458A.M': '21:458A.M            SLAUGHTER POULTRY IN COMPLIANCE WITH...',
  '21:458B.F': '21:458B.F            SIMULATION OF OFFICIAL CERTIFICATE P...',
  '21:458B.M': '21:458B.M            SIMULATION OF OFFICIAL CERTIFICATE P...',
  '21:458C.F': '21:458C.F            FORGERY OF OFFICIAL DEVICE, MARK OR ...',
  '21:458C.M': '21:458C.M            FORGERY OF OFFICIAL DEVICE, MARK OR ...',
  '21:459.F': '21:459.F             COMPLIANCE BY ALL ESTABLISHMENTS',
  '21:459.M': '21:459.M             COMPLIANCE BY ALL ESTABLISHMENTS',
  '21:460A.F': '21:460A.F            PROHIBITION OF INSPECTION OF ARTICLES',
  '21:460A.M': '21:460A.M            PROHIBITION OF INSPECTION OF ARTICLES',
  '21:460B.F': '21:460B.F            RECORDKEEPING REQUIREMENTS',
  '21:460B.M': '21:460B.M            RECORDKEEPING REQUIREMENTS',
  '21:460C.F': '21:460C.F            REGISTRATION OF BUSINESS, NAME OF PE...',
  '21:460C.M': '21:460C.M            REGISTRATION OF BUSINESS, NAME OF PE...',
  '21:460D.F': '21:460D.F            REGULATION OF TRANSACTIONS, TRANSPOR...',
  '21:460D.M': '21:460D.M            REGULATION OF TRANSACTIONS, TRANSPOR...',
  '21:461A.F': '21:461A.F            VIOLATIONS: LIABILITY OF AGENTS - EM...',
  '21:461A.M': '21:461A.M            VIOLATIONS: LIABILITY OF AGENTS - EM...',
  '21:461C.F': '21:461C.F            AGGRAVATED OR FELONIOUS ASSAULT',
  '21:463.F': '21:463.F             RULES AND REGULATIONS',
  '21:463.M': '21:463.M             RULES AND REGULATIONS',
  '21:466.F': '21:466.F             COMPLIANCE WITH STANDARDS AND REGULA...',
  '21:466.M': '21:466.M             COMPLIANCE WITH STANDARDS AND REGULA...',
  '21:610A.F': '21:610A.F            SLAUGHTER AND PREPARE ANIMALS FOR HU...',
  '21:610A.M': '21:610A.M            SLAUGHTER AND PREPARE ANIMALS FOR HU...',
  '21:610B.F': '21:610B.F            SELL OR TRANSPORT ADULTERATED OR MIS...',
  '21:610B.M': '21:610B.M            SELL OR TRANSPORT ADULTERATED OR MIS...',
  '21:610C.F': '21:610C.F            CAUSE ADULTERATION/MISBRANDING IN TR...',
  '21:610C.M': '21:610C.M            CAUSE ADULTERATION/MISBRANDING IN TR...',
  '21:611A.F': '21:611A.F            SIMULATION OF DEVICES, MARKS, LABELS...',
  '21:611A.M': '21:611A.M            SIMULATION OF DEVICES, MARKS, LABELS...',
  '21:611B.F': '21:611B.F            FORGERY OF OFFICIAL DEVICE, MARK OR ...',
  '21:611B.M': '21:611B.M            FORGERY OF OFFICIAL DEVICE, MARK OR ...',
  '21:62.M': '21:62.M              MANUFACTURE/SHIP/DELIVER SHIPMENT IN...',
  '21:620.F': '21:620.F             KNOWING OF IMPORTATION OF PROHIBITED...',
  '21:620.M': '21:620.M             KNOWING OF IMPORTATION OF PROHIBITED...',
  '21:622.F': '21:622.F             BRIBERY OF INSPECTORS OR OTHER OFFICERS',
  '21:622.M': '21:622.M             BRIBERY OF INSPECTORS OR OTHER OFFICERS',
  '21:63.M': '21:63.M              PENALTIES - VIOLATION OF LAW: ACTS, ...',
  '21:642.F': '21:642.F             RECORDKEEPING REQUIREMENTS',
  '21:642.M': '21:642.M             RECORDKEEPING REQUIREMENTS',
  '21:675A.F': '21:675A.F            ASSAULT, RESISTING, IMPEDING, MURDER...',
  '21:675B.F': '21:675B.F            ASSAULT, RESISTING, IMPEDING, MURDER...',
  '21:675C.F': '21:675C.F            MURDER',
  '21:676.F': '21:676.F             INTENT TO DEFRAUD AND DISTRIBUTE ADU...',
  '21:676.M': '21:676.M             INTENT TO DEFRAUD AND DISTRIBUTE ADU...',
  '21:825A=CD.F': '21:825A=CD.F         LABELING OF CONTROLLED SUBSTANCES',
  '21:825A=CD.M': '21:825A=CD.M         LABELING OF CONTROLLED SUBSTANCES',
  '21:825B=CD.F': '21:825B=CD.F         LABELING OF CONTROLLED SUBSTANCES',
  '21:825B=CD.M': '21:825B=CD.M         LABELING OF CONTROLLED SUBSTANCES',
  '21:825C=CD.F': '21:825C=CD.F         LABELING OF CONTROLLED SUBSTANCES',
  '21:825C=CD.M': '21:825C=CD.M         LABELING OF CONTROLLED SUBSTANCES',
  '21:825D=CD.F': '21:825D=CD.F         LABELING OF CONTROLLED SUBSTANCES',
  '21:825D=CD.M': '21:825D=CD.M         LABELING OF CONTROLLED SUBSTANCES',
  '21:829A=CR.F': '21:829A=CR.F         PRESCRIPTION DRUGS - RECORDS',
  '21:829A=CR.M': '21:829A=CR.M         PRESCRIPTION DRUGS - RECORDS',
  '21:829B=CR.F': '21:829B=CR.F         PRESCRIPTION DRUGS - RECORDS',
  '21:829B=CR.M': '21:829B=CR.M         PRESCRIPTION DRUGS - RECORDS',
  '21:829C=CR.F': '21:829C=CR.F         PRESCRIPTION DRUGS - RECORDS',
  '21:829C=CR.M': '21:829C=CR.M         PRESCRIPTION DRUGS - RECORDS',
  '21:830A=CD.F': '21:830A=CD.F         PIPERIDINE REPORTING',
  '21:841A=CD.F': '21:841A=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:841A=CD.M': '21:841A=CD.M         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:841A=CM.F': '21:841A=CM.F         CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:841A=CM.M': '21:841A=CM.M         CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:841A=MD.F': '21:841A=MD.F         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '21:841A=MD.M': '21:841A=MD.M         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '21:841A=MM.F': '21:841A=MM.F         MARIJUANA - MANUFACTURE',
  '21:841A=ND.F': '21:841A=ND.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '21:841A=ND.M': '21:841A=ND.M         NARCOTICS - SELL, DISTRIBUTE OR DISP...',
  '21:841A=NM.F': '21:841A=NM.F         NARCOTICS - MANUFACTURE',
  '21:841A=NP.F': '21:841A=NP.F         NARCOTICS - POSSESSION',
  '21:841A=NP.M': '21:841A=NP.M         NARCOTICS - POSSESSION',
  '21:841B=CC.M': '21:841B=CC.M         DRUG CULTIVATION',
  '21:841B=CD.F': '21:841B=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:841B=CD.M': '21:841B=CD.M         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:841B=CM.F': '21:841B=CM.F         CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:841B=CM.M': '21:841B=CM.M         CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:841B=CP.F': '21:841B=CP.F         CONTROLLED SUBSTANCE - POSSESSION',
  '21:841B=MD.F': '21:841B=MD.F         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '21:841B=MD.M': '21:841B=MD.M         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '21:841B=MM.F': '21:841B=MM.F         MARIJUANA - MANUFACTURE',
  '21:841B=MM.M': '21:841B=MM.M         MARIJUANA - MANUFACTURE',
  '21:841B=MP.F': '21:841B=MP.F         MARIJUANA - POSSESSION',
  '21:841B=MP.M': '21:841B=MP.M         MARIJUANA - POSSESSION',
  '21:841B=ND.F': '21:841B=ND.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '21:841B=ND.M': '21:841B=ND.M         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '21:841B=NM.F': '21:841B=NM.F         NARCOTICS - MANUFACTURE',
  '21:841B=NM.M': '21:841B=NM.M         NARCOTICS - MANUFACTURE',
  '21:841B=NP.F': '21:841B=NP.F         NARCOTICS - POSSESSION',
  '21:841C=CD.F': '21:841C=CD.F         CONTROLLED SUBSTANCE-SELL, DISTRIBUT...',
  '21:841C=CM.F': '21:841C=CM.F         CONTROLLED SUBSTANCE-SELL, DISTRIBUT...',
  '21:841D=CD.F': '21:841D=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:841D=CM.F': '21:841D=CM.F         CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:841D=NM.F': '21:841D=NM.F         NARCOTICS - MANUFACTURE',
  '21:841D=NR.F': '21:841D=NR.F         NARCOTICS - RECORDS, RX\'S, FRAUDULEN...',
  '21:841E=CD.F': '21:841E=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:841E=CM.F': '21:841E=CM.F         CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:841E=MD.F': '21:841E=MD.F         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '21:841E=MM.F': '21:841E=MM.F         MARIJUANA - MANUFACTURE',
  '21:841E=ND.F': '21:841E=ND.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '21:841E=NM.F': '21:841E=NM.F         NARCOTICS - MANUFACTURE',
  '21:841F.F': '21:841F.F            WRONGFUL DISTRIBUTION OR POSSESSION ...',
  '21:841F.M': '21:841F.M            WRONGFUL DISTRIBUTION OR POSSESSION ...',
  '21:841G=CD.F': '21:841G=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:841G=CI.F': '21:841G=CI.F         CONTROLLED SUBSTANCE - IMPORTATION/E...',
  '21:841G=CI.M': '21:841G=CI.M         CONTROLLED SUBSTANCE - IMPORTATION/E...',
  '21:841G=CP.F': '21:841G=CP.F         CONTROLLED SUBSTANCE - POSSESSION',
  '21:841G=MD.F': '21:841G=MD.F         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '21:841G=MI.F': '21:841G=MI.F         MARIJUANA - IMPORTATION/EXPORTATION',
  '21:841G=MI.M': '21:841G=MI.M         MARIJUANA - IMPORTATION/EXPORTATION',
  '21:841G=MP.M': '21:841G=MP.M         MARIJUANA - POSSESSION',
  '21:841G=ND.F': '21:841G=ND.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '21:841G=NI.F': '21:841G=NI.F         NARCOTICS - IMPORTATION/EXPORTATION',
  '21:841G=NI.M': '21:841G=NI.M         NARCOTICS - IMPORTATION/EXPORTATION',
  '21:841G=NP.M': '21:841G=NP.M         NARCOTICS - POSSESSION',
  '21:842A=CD.F': '21:842A=CD.F         DISTRIBUTE/DISPENSE A CONTROLLED SUB...',
  '21:842A=CD.M': '21:842A=CD.M         DISTRIBUTE/DISPENSE A CONTROLLED SUB...',
  '21:842A=CM.F': '21:842A=CM.F         MANUFACTURE A CONTROLLED SUBSTANCE',
  '21:842A=CM.M': '21:842A=CM.M         MANUFACTURE A CONTROLLED SUBSTANCE',
  '21:842A=CR.F': '21:842A=CR.F         CONTROLLED SUBSTANCES - RECORDS AND ...',
  '21:842A=CR.M': '21:842A=CR.M         CONTROLLED SUBSTANCES - RECORDS AND ...',
  '21:842A=ND.F': '21:842A=ND.F         DISTRIBUTE/DISPENSE A NARCOTIC',
  '21:842A=ND.M': '21:842A=ND.M         DISTRIBUTE/DISPENSE A NARCOTIC',
  '21:842A=NM.F': '21:842A=NM.F         MANUFACTURE A NARCOTIC',
  '21:842A=NM.M': '21:842A=NM.M         MANUFACTURE A NARCOTIC',
  '21:842A=NR.F': '21:842A=NR.F         NARCOTICS - RECORDS AND RX\'S',
  '21:842A=NR.M': '21:842A=NR.M         NARCOTICS - RECORDS AND RX\'S',
  '21:842C=CD.F': '21:842C=CD.F         PENALTIES FOR VIOLATIONS OF SUBSECTI...',
  '21:842C=CR.F': '21:842C=CR.F         PENALTIES FOR VIOLATIONS OF SUBSECTI...',
  '21:843A=CD.F': '21:843A=CD.F         UNLAWFUL ACTS - CONTROLLED SUBSTANCE...',
  '21:843A=CM.F': '21:843A=CM.F         UNLAWFUL ACTS - CONTROLLED SUBSTANCE...',
  '21:843A=CP.F': '21:843A=CP.F         UNLAWFUL ACTS - CONTROLLED SUBSTANCE...',
  '21:843A=CR.F': '21:843A=CR.F         UNLAWFUL ACTS - CONTROLLED SUBSTANCE...',
  '21:843B=CD.F': '21:843B=CD.F         USE COMMUNICATIONS FACILITY - CONTRO...',
  '21:843B=MD.F': '21:843B=MD.F         USE COMMUNICATIONS FACILITY - MARIJU...',
  '21:843B=MI.F': '21:843B=MI.F         USE COMMUNICATIONS FACILITY - MARIJU...',
  '21:843B=ND.F': '21:843B=ND.F         USE COMMUNICATIONS FACILITY - NARCOT...',
  '21:843B=NI.F': '21:843B=NI.F         USE COMMUNICATIONS FACILITY - NARCOT...',
  '21:844A=CP.F': '21:844A=CP.F         CONTROLLED SUBSTANCE - POSSESSION',
  '21:844A=CP.M': '21:844A=CP.M         CONTROLLED SUBSTANCE - POSSESSION',
  '21:844A=MP.F': '21:844A=MP.F         MARIJUANA - POSSESSION',
  '21:844A=MP.M': '21:844A=MP.M         MARIJUANA - POSSESSION',
  '21:844A=NP.F': '21:844A=NP.F         NARCOTICS - POSSESSION',
  '21:844A=NP.M': '21:844A=NP.M         NARCOTICS - POSSESSION',
  '21:845=CD.F': '21:845=CD.F          CONTENTS OF THIS SUBSECTION TRANSFER...',
  '21:846=CD.F': '21:846=CD.F          CONSPIRACY TO DISTRIBUTE CONTROLLED ...',
  '21:846=CD.M': '21:846=CD.M          CONSPIRACY TO DISTRIBUTE CONTROLLED ...',
  '21:846=CI.F': '21:846=CI.F          CONSPIRACY TO IMPORT A CONTROL SUBST...',
  '21:846=CM.F': '21:846=CM.F          CONSPIRACY TO MANUFACTURE CONTROLLED...',
  '21:846=CM.M': '21:846=CM.M          CONSPIRACY TO MANUFACTURE CONTROLLED...',
  '21:846=CP.F': '21:846=CP.F          CONSPIRACY TO POSSESS CONTROLLED SUB...',
  '21:846=CP.M': '21:846=CP.M          CONSPIRACY TO POSSESS CONTROLLED SUB...',
  '21:846=CR.F': '21:846=CR.F          CONSPIRACY TO MAKE FALSE RX\'S - CONT...',
  '21:846=CR.M': '21:846=CR.M          CONSPIRACY TO MAKE FALSE RX\'S - CONT...',
  '21:846=MD.F': '21:846=MD.F          CONSPIRACY TO DISTRIBUTE MARIJUANA',
  '21:846=MD.M': '21:846=MD.M          CONSPIRACY TO DISTRIBUTE MARIJUANA',
  '21:846=MM.F': '21:846=MM.F          CONSPIRACY TO MANUFACTURE MARIJUANA',
  '21:846=MM.M': '21:846=MM.M          CONSPIRACY TO MANUFACTURE MARIJUANA',
  '21:846=MP.F': '21:846=MP.F          CONSPIRACY TO POSSESS MARIJUANA',
  '21:846=MP.M': '21:846=MP.M          CONSPIRACY TO POSSESS MARIJUANA',
  '21:846=ND.F': '21:846=ND.F          CONSPIRACY TO DISTRIBUTE NARCOTICS',
  '21:846=ND.M': '21:846=ND.M          CONSPIRACY TO DISTRIBUTE NARCOTICS',
  '21:846=NI.F': '21:846=NI.F          CONSPIRACY TO IMPORT NARCOTICS',
  '21:846=NM.F': '21:846=NM.F          CONSPIRACY TO MANUFACTURE NARCOTICS',
  '21:846=NM.M': '21:846=NM.M          CONSPIRACY TO MANUFACTURE NARCOTICS',
  '21:846=NP.F': '21:846=NP.F          CONSPIRACY TO POSSESS NARCOTICS',
  '21:846=NP.M': '21:846=NP.M          CONSPIRACY TO POSSESS NARCOTICS',
  '21:846=NR.F': '21:846=NR.F          CONSPIRACY TO MAKE FALSE RX\'S - NARC...',
  '21:846=NR.M': '21:846=NR.M          CONSPIRACY TO MAKE FALSE RX\'S - NARC...',
  '21:848.F': '21:848.F             CONTINUING CRIMINAL ENTERPRISE',
  '21:848E.F': '21:848E.F            CONTINUING CRIMINAL ENTERPRISE',
  '21:849B=CD.F': '21:849B=CD.F         DISTR OF CONTROLLED SUBST W/IN 1000F...',
  '21:849C=CD.F': '21:849C=CD.F         DISTR OF CNTRLLD SUBST W/IN 1000FT T...',
  '21:851.F': '21:851.F             PROCEEDINGS TO ESTABLISH PRIOR CONVI...',
  '21:853.F': '21:853.F             CRIMINAL FORFEITURES',
  '21:854.F': '21:854.F             INVEST ILLICIT DRUG PROFITS',
  '21:856=CD.F': '21:856=CD.F          Controlled Substance Sell/Distribute...',
  '21:856=CM.F': '21:856=CM.F          CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:856=MD.F': '21:856=MD.F          Marijuana - Sell, Distribute, Dispense',
  '21:856=MM.F': '21:856=MM.F          MARIJUANA - MANUFACTURE',
  '21:856=ND.F': '21:856=ND.F          Narcotics - Sell, Distribute, Dispense',
  '21:856=NM.F': '21:856=NM.F          NARCOTICS - MANUFACTURE',
  '21:858.F': '21:858.F             ENDANGERING LIFE MANUFACTURING CONTR...',
  '21:859A=CD.F': '21:859A=CD.F         DISTRIBUTE TO PERSONS UNDER 21/CONTR...',
  '21:859A=MD.F': '21:859A=MD.F         DISTRIBUTE TO PERSONS UNDER 21/MARIJ...',
  '21:859A=MD.M': '21:859A=MD.M         DISTRIBUTE TO PERSONS UNDER 21/MARIJ...',
  '21:859A=ND.F': '21:859A=ND.F         DISTRIBUTE TO PERSONS UNDER 21/NARCOTIC',
  '21:859B=CD.F': '21:859B=CD.F         DISTRIBUTE TO PERSONS UNDER 21/CONTR...',
  '21:859B=MD.F': '21:859B=MD.F         DISTRIBUTE TO PERSONS UNDER 21/MARIJ...',
  '21:859B=ND.F': '21:859B=ND.F         DISTRIBUTE TO PERSONS UNDER 21/NARCO...',
  '21:860A=CD.F': '21:860A=CD.F         DISTRIBUTE IN OR NEAR SCHOOLS/CONTRO...',
  '21:860A=CM.F': '21:860A=CM.F         MANUFACTURE/DISTRIBUTE IN OR NEAR SC...',
  '21:860A=MD.F': '21:860A=MD.F         DISTRIBUTE IN OR NEAR SCHOOLS/MARIJUANA',
  '21:860A=MM.F': '21:860A=MM.F         MANUFACTURE/DISTRIBUTE IN OR NEAR SC...',
  '21:860A=ND.F': '21:860A=ND.F         DISTRIBUTE IN OR NEAR SCHOOLS/NARCOTICS',
  '21:860A=NM.F': '21:860A=NM.F         MANUFACTURE/DISTRIBUTE IN OR NEAR SC...',
  '21:861A.F': '21:861A.F            EMPLOY PERSONS UNDER 18',
  '21:861C.F': '21:861C.F            EMPLOY PERSONS UNDER 18',
  '21:861D.F': '21:861D.F            EMPLOY PERSONS UNDER 18',
  '21:861F.F': '21:861F.F            EMPLOY PERSONS UNDER 18',
  '21:863A.F': '21:863A.F            MAIL ORDER DRUG PARAPHERNALIA',
  '21:952=CI.F': '21:952=CI.F          CONTROLLED SUBSTANCE - IMPORT',
  '21:952=MI.F': '21:952=MI.F          MARIJUANA - IMPORT',
  '21:952=NI.F': '21:952=NI.F          NARCOTICS - IMPORT',
  '21:952A=CI.F': '21:952A=CI.F         CONTROLLED SUBSTANCES - IMPORT',
  '21:952A=MI.F': '21:952A=MI.F         MARIJUANA - IMPORT',
  '21:952A=NI.F': '21:952A=NI.F         NARCOTICS - IMPORT',
  '21:952B=CI.F': '21:952B=CI.F         CONTROLLED SUBSTANCES - IMPORT',
  '21:952B=MI.F': '21:952B=MI.F         MARIJUANA - IMPORT',
  '21:953=CI.F': '21:953=CI.F          CONTROLLED SUBSTANCE - EXPORT',
  '21:953=MI.F': '21:953=MI.F          MARIJUANA -  EXPORT',
  '21:953=NI.F': '21:953=NI.F          NARCOTICS - EXPORT',
  '21:953A=CI.F': '21:953A=CI.F         CONTROLLED SUBSTANCES - EXPORT',
  '21:953A=NI.F': '21:953A=NI.F         NARCOTICS - EXPORT',
  '21:953C=CI.F': '21:953C=CI.F         CONTROLLED SUBSTANCES - EXPORT',
  '21:953E=CI.F': '21:953E=CI.F         CONTROLLED SUBSTANCES - EXPORT',
  '21:954=CI.M': '21:954=CI.M          TRANS-SHIPMENT OF CONTROLLED SUBSTANCES',
  '21:955=CP.F': '21:955=CP.F          TRANSFERRED TO 46:APPX 1901 1904',
  '21:957=CI.F': '21:957=CI.F          REGISTER TO IMPORT CONTROLLED SUBSTA...',
  '21:957=MI.F': '21:957=MI.F          REGISTER TO IMPORT MARIJUANA',
  '21:957=NI.F': '21:957=NI.F          REGISTER TO IMPORT NARCOTICS',
  '21:959=CD.F': '21:959=CD.F          MANUF./DISTR. FOR ILLEGAL IMPORTATIO...',
  '21:959=CD.M': '21:959=CD.M          MANUF./DISTR. FOR ILLEGAL IMPORTATIO...',
  '21:959=CM.F': '21:959=CM.F          MANUF./DISTR. FOR ILLEGAL IMPORTATIO...',
  '21:959=CM.M': '21:959=CM.M          MANUF./DISTR. FOR ILLEGAL IMPORTATIO...',
  '21:959=MD.F': '21:959=MD.F          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
  '21:959=MD.M': '21:959=MD.M          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
  '21:959=MM.F': '21:959=MM.F          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
  '21:959=MM.M': '21:959=MM.M          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
  '21:959=ND.F': '21:959=ND.F          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
  '21:959=ND.M': '21:959=ND.M          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
  '21:959=NM.F': '21:959=NM.F          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
  '21:959=NM.M': '21:959=NM.M          MANUFACTURE/DISTRIBUTE FOR ILLEGAL I...',
  '21:960A=CI.F': '21:960A=CI.F         CONTROLLED SUBSTANCE - IMPORTATION/E...',
  '21:960A=MI.F': '21:960A=MI.F         MARIJUANA-IMPORTATION/EXPORTATION',
  '21:960A=NI.F': '21:960A=NI.F         NARCOTICS - IMPORTATION/EXPORTATION',
  '21:960B=CD.F': '21:960B=CD.F         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:960B=CD.M': '21:960B=CD.M         CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:960B=CI.F': '21:960B=CI.F         CONTROLLED SUBSTANCE - IMPORTATION/E...',
  '21:960B=CM.F': '21:960B=CM.F         CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:960B=CM.M': '21:960B=CM.M         CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:960B=CP.F': '21:960B=CP.F         CONTROLLED SUBSTANCE - POSSESSION',
  '21:960B=MD.F': '21:960B=MD.F         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '21:960B=MD.M': '21:960B=MD.M         MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '21:960B=MI.F': '21:960B=MI.F         MARIJUANA - IMPORTATION/EXPORTATION',
  '21:960B=MM.F': '21:960B=MM.F         MARIJUANA - MANUFACTURE',
  '21:960B=MM.M': '21:960B=MM.M         MARIJUANA - MANUFACTURE',
  '21:960B=MP.F': '21:960B=MP.F         MARIJUANA - POSSESSION',
  '21:960B=ND.F': '21:960B=ND.F         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '21:960B=ND.M': '21:960B=ND.M         NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '21:960B=NI.F': '21:960B=NI.F         NARCOTICS - IMPORTATION/EXPORTATION',
  '21:960B=NM.F': '21:960B=NM.F         NARCOTICS - MANUFACTURE',
  '21:960B=NM.M': '21:960B=NM.M         NARCOTICS - MANUFACTURE',
  '21:960B=NP.F': '21:960B=NP.F         NARCOTICS - POSSESSION',
  '21:960D=CI.F': '21:960D=CI.F         CONTROLLED SUBSTANCE - IMPORTATION/E...',
  '21:960D=NI.F': '21:960D=NI.F         NARCOTICS - IMPORTATION/EXPORTATION',
  '21:961=CI.M': '21:961=CI.M          CONTROLLED SUBSTANCE - IMPORTATION/E...',
  '21:962=CD.F': '21:962=CD.F          CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:962=CD.M': '21:962=CD.M          CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '21:962=CI.F': '21:962=CI.F          CONTROLLED SUBSTANCE - IMPORTATION/E...',
  '21:962=CM.F': '21:962=CM.F          CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:962=CM.M': '21:962=CM.M          CONTROLLED SUBSTANCE - MANUFACTURE',
  '21:962=CP.F': '21:962=CP.F          CONTROLLED SUBSTANCE - POSSESSION',
  '21:962=MD.F': '21:962=MD.F          MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '21:962=MD.M': '21:962=MD.M          MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '21:962=MI.F': '21:962=MI.F          MARIJUANA - IMPORTATION/EXPORTATION',
  '21:962=MM.F': '21:962=MM.F          MARIJUANA - MANUFACTURE',
  '21:962=MM.M': '21:962=MM.M          MARIJUANA - MANUFACTURE',
  '21:962=MP.F': '21:962=MP.F          MARIJUANA - POSSESSION',
  '21:962=ND.F': '21:962=ND.F          NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '21:962=ND.M': '21:962=ND.M          NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '21:962=NI.F': '21:962=NI.F          NARCOTICS - IMPORTATION/EXPORTATION',
  '21:962=NM.F': '21:962=NM.F          NARCOTICS - MANUFACTURE',
  '21:962=NM.M': '21:962=NM.M          NARCOTICS - MANUFACTURE',
  '21:962=NP.F': '21:962=NP.F          NARCOTICS - POSSESSION',
  '21:963=CD.F': '21:963=CD.F          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
  '21:963=CD.M': '21:963=CD.M          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
  '21:963=CI.F': '21:963=CI.F          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
  '21:963=CI.M': '21:963=CI.M          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
  '21:963=CM.F': '21:963=CM.F          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
  '21:963=CM.M': '21:963=CM.M          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
  '21:963=CP.F': '21:963=CP.F          ATTEMPT/CONSPIRACY - CONTROLLED SUBS...',
  '21:963=MD.F': '21:963=MD.F          ATTEMPT/CONSPIRACY - MARIJUANA - SEL...',
  '21:963=MD.M': '21:963=MD.M          ATTEMPT/CONSPIRACY - MARIJUANA - SEL...',
  '21:963=MI.F': '21:963=MI.F          ATTEMPT/CONSPIRACY - MARIJUANA - IMP...',
  '21:963=MM.F': '21:963=MM.F          ATTEMPT/CONSPIRACY - MARIJUANA - MAN...',
  '21:963=MM.M': '21:963=MM.M          ATTEMPT/CONSPIRACY - MARIJUANA - MAN...',
  '21:963=MP.F': '21:963=MP.F          ATTEMPT/CONSPIRACY - MARIJUANA - POS...',
  '21:963=ND.F': '21:963=ND.F          ATTEMPT/CONSPIRACY - NARCOTICS - SEL...',
  '21:963=ND.M': '21:963=ND.M          ATTEMPT/CONSPIRACY - NARCOTICS - SEL...',
  '21:963=NI.F': '21:963=NI.F          ATTEMPT/CONSPIRACY - NARCOTICS - IMP...',
  '21:963=NM.F': '21:963=NM.F          ATTEMPT/CONSPIRACY - NARCOTICS - MAN...',
  '21:963=NM.M': '21:963=NM.M          ATTEMPT/CONSPIRACY - NARCOTICS - MAN...',
  '21:963=NP.F': '21:963=NP.F          ATTEMPT/CONSPIRACY - NARCOTICS - POS...',
  '21:971.F': '21:971.F             IMPORTATION AND EXPORTATION OF LISTE...',
  '22:1178.F': '22:1178.F            FAILURE TO GIVE BOND AS ADMINISTRATOR',
  '22:1179.F': '22:1179.F            EMBEZZLEMENT',
  '22:1182.M': '22:1182.M            PENALTY: EXCESSIVE FEES FOR VERIFICA...',
  '22:1198.F': '22:1198.F            EMBEZZLEMENT OF FEES OR EFFECTS OF A...',
  '22:1199.F': '22:1199.F            ACTION ON BOND: NEGLECT OF DUTY OR M...',
  '22:1199.M': '22:1199.M            ACTION ON BOND: NEGLECT OF DUTY OR M...',
  '22:1200.F': '22:1200.F            FALSE CERTIFICATE AS TO OWNERSHIP OF...',
  '22:1203.F': '22:1203.F            DEPOSITIONS AND NOTARIAL ACTS: PERJURY',
  '22:1631.F': '22:1631.F            PENALTIES',
  '22:1642.M': '22:1642.M            VALIDITY AND AMOUNT OF CLAIMS',
  '22:1643.M': '22:1643.M            VALIDITY AND AMOUNT OF CLAIMS',
  '22:1978.M': '22:1978.M            IMPORTATION OF FISH PRODUCTS FROM OF...',
  '22:1978C.M': '22:1978C.M           IMPORTATION OF FISH PRODUCTS FROM OF...',
  '22:1978D.M': '22:1978D.M           RESTRICTION ON IMPORTATION OF FISHER...',
  '22:1980.M': '22:1980.M            PENALTY FOR FALSE OR MISLEADING STAT...',
  '22:252.F': '22:252.F             SUITS AGAINST MINISTERS AND THEIR DO...',
  '22:253.F': '22:253.F             PENALTY FOR WRONGFUL SUIT',
  '22:277.M': '22:277.M             ATTORNEY\'S FEE: PENALTIES',
  '22:2778.F': '22:2778.F            ATTEMPTED EXPORTATION OF ARMS AND MU...',
  '22:2778B.F': '22:2778B.F           REGISTRATION AND LICENSING REQUIREMENTS',
  '22:2778C.F': '22:2778C.F           CRIMINAL VIOLATIONS',
  '22:2797.F': '22:2797.F            ARMS EXPORT CONTROL - LICENSING',
  '22:286.F': '22:286.F             DISCLOSURE OF INFORMATION, UNLAWFUL',
  '22:287.F': '22:287.F             ENFORCEMENT OF ECONOMIC AND COMMERCI...',
  '22:4198.F': '22:4198.F            FAILURE TO GIVE BOND AS ADMINISTRATOR',
  '22:4199.F': '22:4199.F            EMBEZZLEMENT - PENALTIES',
  '22:4202.M': '22:4202.M            PENALTY: EXCESSIVE FEES FOR VERIFICA...',
  '22:4217.F': '22:4217.F            EMBEZZLEMENT OF FEES OR EFFECTS OF A...',
  '22:4218.F': '22:4218.F            FALSE CERTIFICATE AS TO OWNERSHIP OF...',
  '22:4221.F': '22:4221.F            DEPOSITIONS AND NOTARIAL ACTS: PERJURY',
  '22:447.F': '22:447.F             FINANCIAL TRANSACTIONS WITH NATIONS ...',
  '22:447A.F': '22:447A.F            FINANCIAL TRANSACTIONS WITH NATIONS ...',
  '22:447C.F': '22:447C.F            FINANCIAL TRANSACTIONS WITH NATIONS ...',
  '22:448.F': '22:448.F             SOLICITATION AND COLLECTION OF FUNDS',
  '22:450.F': '22:450.F             RESTRICTIONS ON USE OF AMERICAN PORTS',
  '22:451.F': '22:451.F             SUBMARINES AND ARMED MERCHANT VESSELS',
  '22:455.F': '22:455.F             GENERAL PENALTY PROVISION',
  '22:5113A.F': '22:5113A.F           ANTI-APARTHEID PROGRAM',
  '22:5113C.F': '22:5113C.F           GOLD COIN IMPORT  (T)',
  '22:5113D.F': '22:5113D.F           UNTRUE STATEMENTS/OMISSION OF MATERI...',
  '22:612.F': '22:612.F             REGISTRATION STATEMENT: FILING OF OR...',
  '22:614A.F': '22:614A.F            FILING AND LABELING OF POLITICAL PRO...',
  '22:614B.P': '22:614B.P            FILING AND LABELING OF POLITICAL PRO...',
  '22:614E.P': '22:614E.P            FILING AND LABELING OF POLITICAL PRO...',
  '22:614F.P': '22:614F.P            FILING AND LABELING OF POLITICAL PRO...',
  '22:615.F': '22:615.F             BOOKS AND RECORDS, UNLAWFUL TO FALSIFY',
  '22:617.F': '22:617.F             LIABILITY OF OFFICERS',
  '22:618A.F': '22:618A.F            VIOLATIONS: FALSE STATEMENTS AND WIL...',
  '22:618G.P': '22:618G.P            DEFICIENT REGISTRATION STATEMENT',
  '22:618H.P': '22:618H.P            CONTINGENT FEE ARRANGEMENT',
  '22D:103-0100.M': '22D:103-0100.M       ATTEMPTED MURDER',
  '22D:103-0200.M': '22D:103-0200.M       ATTEMPTED MURDER 2ND DEGREE',
  '22D:103-0300.M': '22D:103-0300.M       ATTEMPTED MANSLAUGHTER',
  '22D:103-1400.M': '22D:103-1400.M       ATTEMPTED ROBBERY',
  '22D:103-1500.M': '22D:103-1500.M       ATTEMPTED ASSAULT',
  '22D:103-1600.M': '22D:103-1600.M       ATTEMPTED ASSAULT, OTHER',
  '22D:103-1601.M': '22D:103-1601.M       MISDEMEANOR, ON GOVERNMENT OFFICIAL',
  '22D:103-2400.M': '22D:103-2400.M       ATTEMPTED BURGLARY',
  '22D:103-3700.M': '22D:103-3700.M       ATTEMPTED THEFT',
  '22D:103-3800.M': '22D:103-3800.M       ATTEMPTED THEFT',
  '22D:103-4390.M': '22D:103-4390.M       ATTEMPTED EMBEZZLEMENT',
  '22D:103-4999.M': '22D:103-4999.M       ATTEMPTS TO COMMIT CRIME',
  '22D:103-5200.M': '22D:103-5200.M       ATTEMPTS TO COMMIT CRIME',
  '22D:103-5720.M': '22D:103-5720.M       FORGERY, OTHER',
  '22D:103-6100.M': '22D:103-6100.M       ATTEMPT TO RAPE',
  '22D:103-6300.M': '22D:103-6300.M       ATTEMPTS TO COMMIT CRIME',
  '22D:103-7100.M': '22D:103-7100.M       ATTEMPTS TO COMMIT CRIME',
  '22D:103-7310.M': '22D:103-7310.M       ATTEMPTS TO COMMIT CRIME',
  '22D:103-7400.M': '22D:103-7400.M       ATTEMPTS TO COMMIT CRIME',
  '22D:103-7500.M': '22D:103-7500.M       ATTEMPTS TO COMMIT CRIME',
  '22D:103-7610.M': '22D:103-7610.M       ATTEMPTS TO COMMIT CRIME',
  '22D:103-7800.M': '22D:103-7800.M       FIREARMS AND WEAPONS',
  '22D:103-7820.M': '22D:103-7820.M       FIREARMS, UNLAWFUL POSSESSION',
  '22D:103-7990.M': '22D:103-7990.M       MISCELLANEOUS GENERAL OFFENSES, OTHER',
  '22D:105.F': '22D:105.F            FRAUD, CONSPIRACY (GENERAL), OTHER',
  '22D:106.F': '22D:106.F            ACCESSORIES AFTER THE FACT',
  '22D:1306.F': '22D:1306.F           IMPERSONATING A POLICE OFFICIAL',
  '22D:1306.M': '22D:1306.M           IMPERSONATING A POLICE OFFICER',
  '22D:1402.M': '22D:1402.M           FORGERY LABELS',
  '22D:1410.M': '22D:1410.M           FORGERY, CHECKS OR DRAFTS',
  '22D:1411.P': '22D:1411.P           FALSE ADVERTISEMENT',
  '22D:1501.F': '22D:1501.F           OPERATING A LOTTERY',
  '22D:1502.M': '22D:1502.M           POSSESSION OF LOTTERY OR POLICE TICKETS',
  '22D:1505.F': '22D:1505.F           ILLEGAL GAMBLING',
  '22D:1505.M': '22D:1505.M           ILLEGAL GAMBLING',
  '22D:1506.F': '22D:1506.F           GAMBLING AND LOTTERY',
  '22D:1508.M': '22D:1508.M           GAMBLING - ATHLETIC CONTEST',
  '22D:1801A.F': '22D:1801A.F          BURGLARY, OTHER',
  '22D:1801B.F': '22D:1801B.F          BREAKING AND ENTERING',
  '22D:2101.F': '22D:2101.F           CONSPIRACY',
  '22D:2307.F': '22D:2307.F           EXTORTION, RACKETEERING, AND THREATS',
  '22D:2401.F': '22D:2401.F           MURDER, FIRST DEGREE',
  '22D:2402.F': '22D:2402.F           MURDER, FIRST DEGREE',
  '22D:2403.F': '22D:2403.F           MURDER, SECOND DEGREE',
  '22D:2404.F': '22D:2404.F           MURDER, SECOND DEGREE',
  '22D:2405.F': '22D:2405.F           MANSLAUGHTER',
  '22D:2601.F': '22D:2601.F           ESCAPE',
  '22D:2603.F': '22D:2603.F           MISCELLANEOUS GENERAL OFFENSES, OTHER',
  '22D:2701.P': '22D:2701.P           INVITE FOR PROSTITUTION',
  '22D:2705.F': '22D:2705.F           PANDERING',
  '22D:2801.F': '22D:2801.F           UNLAWFUL CARNAL KNOWLEDGE',
  '22D:2901.F': '22D:2901.F           ROBBERY, OTHER',
  '22D:2902.F': '22D:2902.F           ATTEMPTED ROBBERY',
  '22D:3102.P': '22D:3102.P           UNLAWFUL ENTRY',
  '22D:3202A.F': '22D:3202A.F          ARMED ROBBERY',
  '22D:3203.M': '22D:3203.M           FIREARMS AND WEAPONS - PISTOL',
  '22D:3204.F': '22D:3204.F           FIREARMS AND WEAPONS - CONCEALED WEAPON',
  '22D:3204.M': '22D:3204.M           FIREARMS AND WEAPONS - CONCEALED WEAPON',
  '22D:3212.F': '22D:3212.F           FIREARMS AND WEAPONS - DEFACE A WEAPON',
  '22D:3212.M': '22D:3212.M           FIREARMS AND WEAPONS - DEFACE A WEAPON',
  '22D:3214.F': '22D:3214.F           FIREARMS, UNLAWFUL POSSESSION',
  '22D:3214.M': '22D:3214.M           FIREARMS, UNLAWFUL POSSESSION',
  '22D:3215A.F': '22D:3215A.F          TRANSPORTING HOMEMADE BOMBS',
  '22D:3215A.M': '22D:3215A.M          TRANSPORTING HOMEMADE BOMBS',
  '22D:3427.F': '22D:3427.F           BREAKING AND ENTERING A VENDING MACHINE',
  '22D:3501A.F': '22D:3501A.F          INDECENT ACTS WITH CHILDREN',
  '22D:3501B.F': '22D:3501B.F          INDECENT ACTS WITH CHILDREN',
  '22D:3502.F': '22D:3502.F           SODOMY',
  '22D:3601.F': '22D:3601.F           POSSESSION OF CRIME IMPLEMENTS',
  '22D:3601.M': '22D:3601.M           POSSESSION OF CRIME IMPLEMENTS',
  '22D:3811.F': '22D:3811.F           LARCENY AND THEFT, FELONY OTHER',
  '22D:3811.M': '22D:3811.M           LARCENY AND THEFT, MISDEMEANOR OTHER',
  '22D:3813.P': '22D:3813.P           SHOPLIFTING',
  '22D:3814.M': '22D:3814.M           COMMERCIAL PIRACY',
  '22D:3815B.F': '22D:3815B.F          AUTO THEFT, OTHER',
  '22D:3815C.F': '22D:3815C.F          AUTO THEFT, OTHER',
  '22D:3816.P': '22D:3816.P           LARCENY AND THEFT, MISDEMEANOR OTHER',
  '22D:3821A.F': '22D:3821A.F          FRAUD',
  '22D:3821A.M': '22D:3821A.M          FRAUD',
  '22D:3821B.F': '22D:3821B.F          FRAUD',
  '22D:3821B.M': '22D:3821B.M          FRAUD',
  '22D:3823.F': '22D:3823.F           CREDIT CARD FRAUD',
  '22D:3823.M': '22D:3823.M           CREDIT CARD FRAUD',
  '22D:3824.P': '22D:3824.P           FRAUDULENT REGISTRATION',
  '22D:3831.F': '22D:3831.F           TRAFFICKING IN STOLEN PROPERTY',
  '22D:3832.F': '22D:3832.F           RECEIVING STOLEN PROPERTY',
  '22D:3832.M': '22D:3832.M           RECEIVING STOLEN PROPERTY',
  '22D:3841.F': '22D:3841.F           FORGERY, OTHER U. S.',
  '22D:3842A.F': '22D:3842A.F          PENALTIES - GOVERNMENT BONDS, FORGERY',
  '22D:3842B.F': '22D:3842B.F          PENALTIES - CORPORATIONS AND ORGANIZ...',
  '22D:3842C.F': '22D:3842C.F          PENALTIES - CORPORATIONS AND ORGANIZ...',
  '22D:3851.F': '22D:3851.F           EXTORTION',
  '22D:3852.F': '22D:3852.F           BLACKMAIL',
  '22D:401.F': '22D:401.F            ARSON',
  '22D:403.M': '22D:403.M            ARSON',
  '22D:501.F': '22D:501.F            AGGRAVATED OR FELONIOUS ASSAULT',
  '22D:502.F': '22D:502.F            ASSAULT WITH A DEADLY WEAPON',
  '22D:503.F': '22D:503.F            ASSAULT WITH INTENT TO COMMIT CARNAL...',
  '22D:504.M': '22D:504.M            ASSAULT, OTHER',
  '22D:505A.F': '22D:505A.F           ASSAULT OR IMPEDE A POLICE OFFICER',
  '22D:505B.F': '22D:505B.F           ASSAULT OR IMPEDE AN OFFICER WITH WE...',
  '22D:506.F': '22D:506.F            MAYHEM AND MALICIOUS DISFIGUREMENT',
  '22D:507.F': '22D:507.F            ASSAULTS WITHIN MARITIME AND TERRITO...',
  '22D:507.M': '22D:507.M            ASSAULTS WITHIN MARITIME AND TERRITO...',
  '22D:507.P': '22D:507.P            ASSAULT, OTHER',
  '22D:508.F': '22D:508.F            ASSAULTING, BEATING, FIGHTING',
  '22D:713.F': '22D:713.F            BRIBERY, PENALTIES',
  '22DC:1406.P': '22DC:1406.P          FALSE PERSONATION OF POLICE OFFICER',
  '22DC:1502.P': '22DC:1502.P          FORGING OR IMITATING BRANDS OR PACKA...',
  '22DC:1510.F': '22DC:1510.F          MAKING, DRAWING. OR ALTERING CHECK, ...',
  '22DC:1510.P': '22DC:1510.P          MAKING, DRAWING, OR ALTERING CHECK, ...',
  '22DC:1511.P': '22DC:1511.P          FRAUDULENT ADVERTISING.',
  '22DC:1701.F': '22DC:1701.F          LOTTERIES; PROMOTIONS; SALE OR POSSE...',
  '22DC:1702.P': '22DC:1702.P          POSSESSION OF LOTTERY OR POLICY TICK...',
  '22DC:1705.F': '22DC:1705.F          GAMBLING PREMISES; SUBSEQUENT OFFENSES',
  '22DC:1705.P': '22DC:1705.P          GAMBLING PREMISES; PROHIBITION AGAIN...',
  '22DC:1706.P': '22DC:1706.P          THREE-CARD MONTE AND CONFIDENCE GAMES',
  '22DC:1708.P': '22DC:1708.P          GAMBLING POOLS AND BOOKMAKING',
  '22DC:1805.F': '22DC:1805.F          PERSONS ADVISING, INCITING, OR CONNI...',
  '22DC:1805A.F': '22DC:1805A.F         CONSPIRACY TO COMMIT CRIME',
  '22DC:1806.F': '22DC:1806.F          ACCESSORIES AFTER THE FACT',
  '22DC:1810.F': '22DC:1810.F          THREATENING TO KIDNAP OR INJURE A PE...',
  '22DC:2001.F': '22DC:2001.F          CONSPIRACY TO KIDNAPPING',
  '22DC:2101.F': '22DC:2101.F          MURDER IN THE FIRST DEGREE-PURPOSEFU...',
  '22DC:2102.F': '22DC:2102.F          MURDER IN THE FIRST DEGREE- PLACING ...',
  '22DC:2103.F': '22DC:2103.F          MURDER SECOND DEGREE- MANSLAUGHTER',
  '22DC:2104.F': '22DC:2104.F          MURDER IN THE FIRST AND SECOND DEGREE',
  '22DC:2105.F': '22DC:2105.F          PENALTY FOR MANSLAUGHTER',
  '22DC:2501.F': '22DC:2501.F          POSSESSIONS OF IMPLEMENTS OF CRIME A...',
  '22DC:2501.M': '22DC:2501.M          POSSESSIONS OF IMPLEMENTS OF CRIME A...',
  '22DC:2501.P': '22DC:2501.P          POSSESSION OF IMPLEMENTS OF CRIME',
  '22DC:2601.F': '22DC:2601.F          ESCAPE FROM INSTITUTION OR OFFICER',
  '22DC:2603.F': '22DC:2603.F          INTRODUCING CONTRABAND INTO PENAL IN...',
  '22DC:2701.P': '22DC:2701.P          INVITING FOR PURPOSES OF PROSTITUTIO...',
  '22DC:2705.F': '22DC:2705.F          PANDERING; INDUCING OR COMPELLING AN...',
  '22DC:2801.F': '22DC:2801.F          ROBBERY',
  '22DC:2802.F': '22DC:2802.F          ATTEMPT TO COMMIT ROBBERY',
  '22DC:301.F': '22DC:301.F           ARSON',
  '22DC:303.F': '22DC:303.F           MALICIOUS BURNING, DESTRUCTION, OR I...',
  '22DC:303.P': '22DC:303.P           MALICIOUS BURNING, DESTRUCTION, OR I...',
  '22DC:3211.F': '22DC:3211.F          THEFT',
  '22DC:3213.M': '22DC:3213.M          THEFT',
  '22DC:3213.P': '22DC:3213.P          SHOPLIFTING',
  '22DC:3214-01.F': '22DC:3214-01.F       THEFT, RELATED OFFENSES - DECEPTIVE ...',
  '22DC:3214-01.M': '22DC:3214-01.M       THEFT, RELATED OFFENSES - DECEPTIVE ...',
  '22DC:3214.P': '22DC:3214.P          THEFT, RELATED OFFENSES - COMMERCIAL...',
  '22DC:3215.F': '22DC:3215.F          UNAUTHORIZED USE OF MOTOR VEHICLE',
  '22DC:3216.P': '22DC:3216.P          TAKING PROPERTY WITHOUT RIGHT',
  '22DC:3221.F': '22DC:3221.F          FRAUD',
  '22DC:3223.F': '22DC:3223.F          CREDIT CARD FRAUD',
  '22DC:3223.P': '22DC:3223.P          CREDIT CARD FRAUD',
  '22DC:3224.P': '22DC:3224.P          FRAUDULENT REGISTRATION',
  '22DC:3231.F': '22DC:3231.F          TRAFFICKING IN STOLEN PROPERTY',
  '22DC:3232.F': '22DC:3232.F          RECEIVING STOLEN PROPERTY',
  '22DC:3232.P': '22DC:3232.P          RECEIVING STOLEN PROPERTY',
  '22DC:3241.F': '22DC:3241.F          FORGERY',
  '22DC:3242.F': '22DC:3242.F          PENALTIES FOR FORGERY',
  '22DC:3251.F': '22DC:3251.F          EXTORTION',
  '22DC:3252.F': '22DC:3252.F          BLACKMAIL',
  '22DC:3302.P': '22DC:3302.P          UNLAWFUL ENTRY ON PROPERTY',
  '22DC:401.F': '22DC:401.F           ASSAULT WITH INTENT TO KILL, ROB, PO...',
  '22DC:402.F': '22DC:402.F           ASSAULT WITH INTENT TO COMMIT MAYHEM...',
  '22DC:403.F': '22DC:403.F           ASSAULT WITH INTENT TO COMMIT ANY OT...',
  '22DC:404-01.F': '22DC:404-01.F        AGGRAVATED ASSAULT',
  '22DC:404.F': '22DC:404.F           ASSAULT OR THREATENED ASSAULT IN MEN...',
  '22DC:404.M': '22DC:404.M           ASSAULT OR THREATENED ASSAULT IN A M...',
  '22DC:404.P': '22DC:404.P           ASSAULT OR THREATENED ASSAULT IN A M...',
  '22DC:405.F': '22DC:405.F           ASSAULT ON MEMBER OF POLICE FORCE',
  '22DC:406C.F': '22DC:406C.F          MAYHEM OR MALICIOUSLY DISFIGURING',
  '22DC:407.M': '22DC:407.M           THREATS TO DO BODILY HARM',
  '22DC:407.P': '22DC:407.P           THREATS TO DO BODILY HARM',
  '22DC:601.F': '22DC:601.F           BREAKING AND ENTERING VENDING MACHIN...',
  '22DC:713.F': '22DC:713.F           BRIBERY OF WITNESS',
  '22DC:801A.F': '22DC:801A.F          BURGLARY IN THE FIRST DEGREE',
  '22DC:801B.F': '22DC:801B.F          BURGLARY IN THE 2ND DEGREE',
  '23D:1327.F': '23D:1327.F           FAILURE TO APPEAR',
  '23D:1327.M': '23D:1327.M           FAILURE TO APPEAR',
  '25:202.M': '25:202.M             INDUCING CONVEYANCE OF TRUST',
  '25:450D.F': '25:450D.F            FRAUDULENT USE OF MONIES FROM GRANTS...',
  '25:450D.M': '25:450D.M            FRAUDULENT USE OF MONIES FROM GRANTS...',
  '26:3402.M': '26:3402.M            OTHER MISDEMEANOR',
  '26:4411.P': '26:4411.P            FRAUD, WAGERING TAX, OTHER',
  '26:4412.P': '26:4412.P            REGISTRATION',
  '26:5061.F': '26:5061.F            DISCRETION METHOD OF COLLECTION',
  '26:5113.M': '26:5113.M            SALES BY PROPERTY OF DISTRIBUTING SP...',
  '26:5115.M': '26:5115.M            SIGN REQUIRED ON PREMISES',
  '26:5171.F': '26:5171.F            FILING A FALSE OR FRAUDULENT APPLICA...',
  '26:5171A.F': '26:5171A.F           DISTILLER REGISTRATION',
  '26:5171C.F': '26:5171C.F           DISTILLER REGISTRATION',
  '26:5173.F': '26:5173.F            QUALIFICATION BONDS',
  '26:5179.F': '26:5179.F            REGISTRATION OF STILLS',
  '26:5180.M': '26:5180.M            SIGN REQUIREMENTS',
  '26:5214.F': '26:5214.F            WITHDRAWAL OF DISTILLED SPIRITS',
  '26:5221.F': '26:5221.F            COMMENCE, SUSPEND, RESUME OPERATIONS',
  '26:5222.F': '26:5222.F            PRODUCTION, RECEIPT  AND USE OF DIST...',
  '26:5273.F': '26:5273.F            INTERNAL MEDICINAL PREPARATIONS AND ...',
  '26:5291.F': '26:5291.F            REQUIREMENTS WHEN DISPOSING OF DENAT...',
  '26:5301A.M': '26:5301A.M           REQUIREMENTS FOR CONTAINERS OF DISTI...',
  '26:5301B.M': '26:5301B.M           DISPOSITION OF CONTAINERS FOR DISTIL...',
  '26:5301C.M': '26:5301C.M           REFILLING OF LIQUOR BOTTLES',
  '26:5601.F': '26:5601.F            UNLAWFUL PRODUCTION OF DISTILLED SPI...',
  '26:5602.F': '26:5602.F            PENALTY FOR TAX FRAUD BY DISTILLER',
  '26:5603A.F': '26:5603A.F           FRAUDULENT NONCOMPLIANCE',
  '26:5603B.M': '26:5603B.M           FAILURE TO COMPLY',
  '26:5604.F': '26:5604.F            POSSESS ANY UN-DESTROYED OR UN-DEFAC...',
  '26:5605.F': '26:5605.F            PENALTIES: RETURN OF MATERIAL USED I...',
  '26:5606.M': '26:5606.M            PENALTY: CONTAINERS OF DISTILLED SPI...',
  '26:5607.F': '26:5607.F            PENALTY: FORFEIT FOR UNLAWFUL USE, C...',
  '26:5608A.F': '26:5608A.F           PENALTY: FRAUDULENT CLAIM FOR DRAWBACK',
  '26:5608B.F': '26:5608B.F           PENALTY: UNLAWFUL RELANDING',
  '26:5661A.F': '26:5661A.F           FRAUDULENT OFFENSES',
  '26:5661B.M': '26:5661B.M           FRAUDULENT OFFENSES',
  '26:5662.M': '26:5662.M            PENALTY FOR ALTERATION OF WINE LABELS',
  '26:5671.F': '26:5671.F            PENALTY: FORFEIT FOR BEER TAX EVASION',
  '26:5672.M': '26:5672.M            PENALTY: FAILURE OF BREWER TO COMPLY',
  '26:5674.M': '26:5674.M            PENALTY: UNLAWFUL REMOVAL OF BEER',
  '26:5681A.M': '26:5681A.M           PENALTY RELATING TO SIGNS',
  '26:5681B.M': '26:5681B.M           PENALTY RELATING TO SIGNS',
  '26:5681C.M': '26:5681C.M           PENALTY RELATING TO SIGNS',
  '26:5682.F': '26:5682.F            PENALTY FOR BREAKING LOCKS OR GAININ...',
  '26:5683.M': '26:5683.M            PENALTY: FORFEIT FOR REMOVAL OF LIQUORS',
  '26:5685A.F': '26:5685A.F           POSSESSION OF DEVICES FOR EMITTING G...',
  '26:5685B.F': '26:5685B.F           POSSESSION OF MACHINE GUN, ETC.',
  '26:5686.M': '26:5686.M            PENALTY: POSSESSING/USING LIQUOR OR ...',
  '26:5687.M': '26:5687.M            PENALTY: OFFENSES NOT SPECIFICALLY C...',
  '26:5691.F': '26:5691.F            PENALTY: NONPAYMENT OF SPECIAL TAX -...',
  '26:5751.F': '26:5751.F            SALE, ETC., OF TOBACCO PRODUCTS AND ...',
  '26:5752.F': '26:5752.F            RESTRICTIONS RELATED TO MARKS, LABEL...',
  '26:5762A.F': '26:5762A.F           ENGAGING IN BUSINESS UNLAWFULLY',
  '26:5762B.M': '26:5762B.M           OTHER OFFENSES',
  '26:5801.F': '26:5801.F            SPECIAL TAX FOR IMPORTERS, MANUFACTU...',
  '26:5802.F': '26:5802.F            REGISTRATION OF IMPORTERS, MANUFACTU...',
  '26:5811.F': '26:5811.F            TAX ON FIREARMS TRANSFERRED',
  '26:5812.F': '26:5812.F            TRANSFER OF FIREARMS',
  '26:5821.F': '26:5821.F            TAX ON MAKING OF A FIREARM',
  '26:5822.F': '26:5822.F            MAKING OF A FIREARM',
  '26:5841.F': '26:5841.F            REGISTRATION OF FIREARMS',
  '26:5842.F': '26:5842.F            IDENTIFICATION OF FIREARMS',
  '26:5843.F': '26:5843.F            RECORDS AND RETURNS FOR IMPORTERS, M...',
  '26:5844.F': '26:5844.F            IMPORTATION OF FIREARMS UNLAWFUL - E...',
  '26:5845.F': '26:5845.F            POSSESSION OF A DESTRUCTIVE DEVICE',
  '26:5851.F': '26:5851.F            SPECIAL TAX EXEMPTION',
  '26:5861A.F': '26:5861A.F           UNLAWFUL TO IMPORT OR MANUFACTURE FI...',
  '26:5861B.F': '26:5861B.F           UNLAWFUL TO RECEIVE A FIREARM TRANSF...',
  '26:5861C.F': '26:5861C.F           UNLAWFUL TO RECEIVE OR POSSESS FIREA...',
  '26:5861D.F': '26:5861D.F           UNLAWFUL TO RECEIVE A FIREARM NOT RE...',
  '26:5861E.F': '26:5861E.F           UNLAWFUL TO TRANSFER A FIREARM IN VI...',
  '26:5861F.F': '26:5861F.F           UNLAWFUL TO MAKE A FIREARM IN VIOLATION',
  '26:5861G.F': '26:5861G.F           UNLAWFUL TO ALTER OR CHANGE SERIAL N...',
  '26:5861H.F': '26:5861H.F           UNLAWFUL TO RECEIVE A FIREARM WITH A...',
  '26:5861I.F': '26:5861I.F           RECEIVE A FIREARM WITHOUT A SERIAL N...',
  '26:5861J.F': '26:5861J.F           TRANSP./DELIVER/RECEIVE IN INTERSTAT...',
  '26:5861K.F': '26:5861K.F           RECEIVE A FIREARM IMPORTED IN VIOLATION',
  '26:5861L.F': '26:5861L.F           KNOWINGLY MAKE A FALSE ENTRY ON APPL...',
  '26:5871.F': '26:5871.F            PENALTIES - FIREARMS AND WEAPONS',
  '26:5872A.F': '26:5872A.F           FORFEITURE OF MACHINE GUNS, DESTRUCT...',
  '26:6047A.M': '26:6047A.M           TRUSTEES AND INSURANCE COMPANIES - R...',
  '26:6047B.M': '26:6047B.M           OWNER/EMPLOYEES MUST FURNISH PRESCRI...',
  '26:6047C.M': '26:6047C.M           INFORMATION REQUIRED OF EMPLOYEES - ...',
  '26:6050I.F': '26:6050I.F           RETURNS RELATING TO CASH REC\'D IN TR...',
  '26:6050I.M': '26:6050I.M           RETURNS RELATING TO CASH REC\'D IN TR...',
  '26:6051.M': '26:6051.M            RECEIPTS FOR EMPLOYEES',
  '26:6331.F': '26:6331.F            LEVY AND DISTRAINT',
  '26:6420.M': '26:6420.M            EXAMINATION OF BOOKS AND WITNESSES',
  '26:6420E.M': '26:6420E.M           EXAMINATION OF BOOKS AND WITNESSES',
  '26:6427.M': '26:6427.M            EXAMINATION OF BOOKS AND WITNESSES',
  '26:6674.P': '26:6674.P            FRAUDULENT STATEMENT OR FAIL TO FURNISH',
  '26:7001.M': '26:7001.M            LICENSE FOR COLLECTION OF FOREIGN ITEMS',
  '26:7121.F': '26:7121.F            CLOSING AGREEMENTS',
  '26:7122.F': '26:7122.F            COMPROMISES',
  '26:7201.F': '26:7201.F            ATTEMPT TO EVADE OR DEFEAT TAX',
  '26:7202.F': '26:7202.F            WILLFUL FAILURE TO COLLECT/PAY OVER TAX',
  '26:7203C.M': '26:7203C.M           WILLFUL FAILURE TO FILE RETURN, SUPP...',
  '26:7203D.F': '26:7203D.F           WILLFUL FAILURE TO FILE RETURN/INFOR...',
  '26:7203D.M': '26:7203D.M           WILLFUL FAILURE TO FILE RETURN, SUPP...',
  '26:7204.M': '26:7204.M            FRAUDULENT STATEMENT/FAILURE TO MAKE...',
  '26:7205.M': '26:7205.M            FRAUDULENT WITHHOLDING EXEMPTION CER...',
  '26:7206A.F': '26:7206A.F           FRAUD AND FALSE STATEMENTS',
  '26:7206B.F': '26:7206B.F           FRAUD AND FALSE STATEMENTS',
  '26:7206C.F': '26:7206C.F           DECLARE UNDER PENALTY OF PERJURY',
  '26:7207.M': '26:7207.M            FRAUDULENT RETURNS, STATEMENTS/OTHER...',
  '26:7208A.F': '26:7208A.F           OFFENSES RELATING TO STAMPS',
  '26:7208B.F': '26:7208B.F           OFFENSES RELATING TO STAMPS',
  '26:7208C.F': '26:7208C.F           OFFENSES RELATING TO STAMPS',
  '26:7209.P': '26:7209.P            UNAUTHORIZED USE OR SALE OF STAMPS',
  '26:7210.M': '26:7210.M            FAILURE TO OBEY SUMMONS',
  '26:7211.M': '26:7211.M            FALSE STATEMENTS TO PURCHASERS/LESSE...',
  '26:7212A.F': '26:7212A.F           CORRUPT OR FORCIBLE INTERFERENCE',
  '26:7212A.M': '26:7212A.M           CORRUPT OR FORCIBLE INTERFERENCE',
  '26:7212B.F': '26:7212B.F           FORCIBLE RESCUE OF SEIZED PROPERTY',
  '26:7213A.F': '26:7213A.F           UNAUTHORIZED DISCLOSE OF INCOME TAX ...',
  '26:7213AA.M': '26:7213AA.M          Unauthorized inspection of returns o...',
  '26:7213B.F': '26:7213B.F           UNAUTHORIZED DISCLOSURE OF OPERATION...',
  '26:7213C.M': '26:7213C.M           OFFENSE RELATING TO REPRODUCTION OF ...',
  '26:7213D.M': '26:7213D.M           DISCLOSURES BY CERTAIN DELEGATES',
  '26:7214A.F': '26:7214A.F           UNLAWFUL ACTS OF REVENUE OFFICERS/AG...',
  '26:7214B.P': '26:7214B.P           INTEREST OF INTERNAL REVENUE OFFICER...',
  '26:7215.M': '26:7215.M            OFFENSES WITH RESPECT TO COLLECTED T...',
  '26:7216.M': '26:7216.M            DISCLOSURE OR USE OF INFORMATION BY ...',
  '26:7231.M': '26:7231.M            FAILURE TO OBTAIN LICENSE FOR COLLEC...',
  '26:7232.F': '26:7232.F            FAIL TO REGISTER/FALSE STATEMENT BY ...',
  '26:7261.P': '26:7261.P            RETAILERS\' EXCISE TAX FRAUD',
  '26:7262.P': '26:7262.P            VIOLATION OF OCCUPATIONAL TAX LAWS -...',
  '26:7272A.P': '26:7272A.P           FAILURE TO REGISTER',
  '26:7275A.P': '26:7275A.P           TAXABLE AIRLINE TICKETS',
  '26:7275B.P': '26:7275B.P           PRICE ADVERTISING TO INCLUDE COST AN...',
  '26:7275C.P': '26:7275C.P           PENALTY',
  '26:7512.M': '26:7512.M            REQUIREMENTS FOR SEPARATE ACCOUNTING',
  '26:7513.M': '26:7513.M            REGULATIONS FOR REPRODUCTION OF RETURNS',
  '26:7513B.M': '26:7513B.M           REGULATIONS FOR REPRODUCTION OF RETURNS',
  '26:7602.M': '26:7602.M            EXAMINATION OF BOOKS AND RECORDS',
  '26:7603.M': '26:7603.M            SERVICE OF SUMMONS',
  '26:7604B.M': '26:7604B.M           ENFORCEMENT OF SUMMONS',
  '26:9012A.M': '26:9012A.M           EXCESS CAMPAIGN EXPENSES',
  '26:9012B.M': '26:9012B.M           CONTRIBUTIONS',
  '26:9012C.F': '26:9012C.F           UNLAWFUL USE OF PAYMENTS',
  '26:9012D.F': '26:9012D.F           FALSE STATEMENTS, ETC.',
  '26:9012E.F': '26:9012E.F           KICKBACKS AND ILLEGAL PAYMENTS',
  '26:9012F.M': '26:9012F.M           UNAUTHORIZED EXPENDITURES AND CONTRI...',
  '26:9012G.M': '26:9012G.M           UNAUTHORIZED DISCLOSURE OF INFORMATION',
  '26:9035.F': '26:9035.F            QUALIFIED CAMPAIGN EXPENSE LIMITATIONS',
  '26:9037.F': '26:9037.F            PAYMENTS TO ELIGIBLE CANDIDATES',
  '26:9042A.F': '26:9042A.F           EXCESS CAMPAIGN EXPENSES',
  '26:9042B.F': '26:9042B.F           UNLAWFUL USE OF PAYMENTS',
  '26:9042C.F': '26:9042C.F           FALSE STATEMENTS, ETC.',
  '26:9042D.F': '26:9042D.F           KICKBACKS AND ILLEGAL PAYMENTS',
  '27:203.P': '27:203.P             PERMIT REQUIRED TO CONDUCT DISTILLED...',
  '27:205A.P': '27:205A.P            LIQUORS MUST BE LABELED AS REQUIRED',
  '27:205B.P': '27:205B.P            UNFAIR COMPETITION - TIED HOUSE',
  '27:205C.P': '27:205C.P            UNFAIR COMPETITION - COMMERCIAL BRIBERY',
  '27:205D.P': '27:205D.P            UNFAIR COMPETITION - CONSIGNMENT SALES',
  '27:205E.P': '27:205E.P            LIQUORS MUST BE LABELED AS REQUIRED',
  '27:205F.P': '27:205F.P            ADVERTISING ACCORDING TO REGULATIONS',
  '27:206A.M': '27:206A.M            BULK SALES AND BOTTLING',
  '27:206B.M': '27:206B.M            PENALTIES',
  '27:207.P': '27:207.P             PENALTIES',
  '27:208A.P': '27:208A.P            INTERLOCKING DIRECTORATES',
  '27:208D.P': '27:208D.P            PENALTIES',
  '28:1442.F': '28:1442.F            REMOVAL FROM STATE COURT - FEDERAL O...',
  '28:1442.M': '28:1442.M            REMOVAL FROM STATE COURT - FEDERAL O...',
  '28:1443.F': '28:1443.F            REMOVAL FROM STATE COURT - CIVIL RIGHTS',
  '28:1826C.F': '28:1826C.F           ESCAPE FROM FACILITY WHERE CONFINED',
  '28:1864B.P': '28:1864B.P           FAILURE TO APPEAR AS JUROR',
  '28:1866G.P': '28:1866G.P           SELECTION AND SUMMONING OF JURY PANELS',
  '28:2255.F': '28:2255.F            HABEAS CORPUS',
  '28:2461C.F': '28:2461C.F           CRIMINAL FORFEITURE',
  '29:1021A.M': '29:1021A.M           BENEFIT PLAN TO BE FURNISHED TO PART...',
  '29:1021B.M': '29:1021B.M           PLAN DESCRIPTION, CHANGES AND REPORTS',
  '29:1021C.M': '29:1021C.M           TERMINAL AND SUPPLEMENTARY REPORTS',
  '29:1022.M': '29:1022.M            PLAN DESCRIPTION TO BE FURNISHED TO ...',
  '29:1023A.M': '29:1023A.M           PUBLICATION AND FILING OF ANNUAL REP...',
  '29:1023B.M': '29:1023B.M           FINANCIAL STATEMENT REQUIRED',
  '29:1023C.M': '29:1023C.M           INFORMATION REQUIRED TO BE FURNISHED...',
  '29:1023D.M': '29:1023D.M           REPORT TO INCLUDE COMPLETE ACTUARIAL...',
  '29:1023E.M': '29:1023E.M           STATEMENT FROM COMPANY WHICH SELLS O...',
  '29:1024A.M': '29:1024A.M           FILING OF ANNUAL REPORT, PLAN DESCRI...',
  '29:1024B.M': '29:1024B.M           PUBLICATION OF SUMMARY PLAN DESCRIPT...',
  '29:1024C.M': '29:1024C.M           STATEMENT OF RIGHTS',
  '29:1025.M': '29:1025.M            REPORTING OF PARTICIPANTS\' BENEFIT R...',
  '29:1027.M': '29:1027.M            RETENTION OF RECORDS',
  '29:1111A.F': '29:1111A.F           PERSONS PROHIBITED FROM HOLDING CERT...',
  '29:1111A.M': '29:1111A.M           PERSONS PROHIBITED FROM HOLDING CERT...',
  '29:1111B.F': '29:1111B.F           PENALTIES',
  '29:1111B.M': '29:1111B.M           PENALTIES',
  '29:1112B.M': '29:1112B.M           UNLAWFUL TO CONTROL FUNDS WITHOUT BE...',
  '29:1112C.M': '29:1112C.M           CONFLICT OF INTEREST PROHIBITED IN P...',
  '29:1131.F': '29:1131.F            CRIMINAL PENALTIES FOR VIOLATIONS OF...',
  '29:1131.M': '29:1131.M            PENALTIES, RETIREMENT INCOME SECURIT...',
  '29:1141.M': '29:1141.M            COERCIVE INTERFERENCE',
  '29:162.M': '29:162.M             INTERFERENCE WITH MEMBERS OF THE BOA...',
  '29:1811.F': '29:1811.F            PERSONS ENGAGED IN FARM LABOR CONTRACTS',
  '29:1811.M': '29:1811.M            PERSONS ENGAGED IN FARM LABOR CONTRACTS',
  '29:1816.F': '29:1816.F            EMPLOYING ILLEGAL ALIENS',
  '29:1816.M': '29:1816.M            EMPLOYING ILLEGAL ALIENS',
  '29:1821.F': '29:1821.F            WRITTEN DISCLOSURE REQUIREMENTS',
  '29:1821.M': '29:1821.M            WRITTEN DISCLOSURE REQUIREMENTS',
  '29:1823.F': '29:1823.F            SAFETY AND HEALTH OF HOUSING',
  '29:1823.M': '29:1823.M            SAFETY AND HEALTH OF HOUSING',
  '29:1851.F': '29:1851.F            CRIMINAL SANCTIONS',
  '29:1851.M': '29:1851.M            CRIMINAL SANCTIONS',
  '29:186A.F': '29:186A.F            PENALTIES, RETIREMENT INCOME SECURIT...',
  '29:186A.M': '29:186A.M            PENALTIES, RETIREMENT INCOME SECURIT...',
  '29:186B.F': '29:186B.F            REQUEST DEMAND FOR MONEY, THING OF V...',
  '29:186B.M': '29:186B.M            REQUEST DEMAND FOR MONEY, THING OF V...',
  '29:186D.F': '29:186D.F            PENALTIES FOR VIOLATIONS',
  '29:186D.M': '29:186D.M            PENALTIES FOR VIOLATIONS',
  '29:206.M': '29:206.M             MINIMUM WAGE TO BE PAID BY EMPLOYERS',
  '29:207.M': '29:207.M             MAXIMUM HOURS EMPLOYERS MAY WORK EMP...',
  '29:211C.M': '29:211C.M            EMPLOYER MUST KEEP RECORDS OF WAGES ...',
  '29:211D.M': '29:211D.M            REGULATIONS REGARDING INDUSTRIAL HOM...',
  '29:212.M': '29:212.M             CHILD LABOR PROVISIONS',
  '29:214.M': '29:214.M             REGULATIONS FOR EMPLOYEES REGARDING ...',
  '29:215.M': '29:215.M             PROHIBITED ACTS',
  '29:216.M': '29:216.M             CRIMINAL PENALTY',
  '29:304.P': '29:304.P             ADMINISTRATOR MUST PUB. DESCRIPTION ...',
  '29:305A.P': '29:305A.P            TIME FOR PUB. OF DESCRIPTION OF EMPL...',
  '29:305B.P': '29:305B.P            CONTENTS OF DESCRIPTION OF PENSION PLAN',
  '29:306.P': '29:306.P             ANNUAL REPORTS OF EMPLOYEE BENEFIT PLAN',
  '29:307A.P': '29:307A.P            PLAN MUST BE AVAILABLE FOR EXAMINATION',
  '29:307B.P': '29:307B.P            FILING OF COPIES OF PLAN AND REPORT',
  '29:308.P': '29:308.P             PENALTY FOR VIOLATIONS',
  '29:411.M': '29:411.M             FREEDOM OF SPEECH AND ASSEMBLY',
  '29:436.M': '29:436.M             RETENTION OF RECORDS',
  '29:439A.M': '29:439A.M            VIOLATION AND PENALTIES FAIR LABOR S...',
  '29:439B.M': '29:439B.M            VIOLATIONS AND PENALTIES',
  '29:439C.M': '29:439C.M            VIOLATIONS AND PENALTIES',
  '29:461A.M': '29:461A.M            FILING AND CONTENTS OF TRUSTEESHIP R...',
  '29:461C.M': '29:461C.M            PENALTY FOR VIOLATIONS',
  '29:463.M': '29:463.M             UNLAWFUL ACTS RELATING TO LABOR ORGA...',
  '29:463A.M': '29:463A.M            UNLAWFUL ACTS RELATING TO LABOR ORGA...',
  '29:463B.M': '29:463B.M            LABOR ORGANIZATION - TRUSTEESHIP/UNL...',
  '29:501C.F': '29:501C.F            EMBEZZLEMENT OF ASSETS: PENALTY',
  '29:502.M': '29:502.M             BONDING OF OFFICERS AND EMPLOYEES OF...',
  '29:502A.M': '29:502A.M            BONDING OF OFFICERS AND EMPLOYEES OF...',
  '29:502B.M': '29:502B.M            BONDING OF OFFICERS AND EMPLOYEES OF...',
  '29:503A.M': '29:503A.M            LOANS TO OFFICERS OR EMPLOYEES PROHI...',
  '29:503B.M': '29:503B.M            PAYMENT OF FINE FOR OFFICERS OR EMPL...',
  '29:503C.M': '29:503C.M            LOANS TO OFFICERS AND EMPLOYEES',
  '29:504.F': '29:504.F             PROHIBITION AGAINST CERTAIN PERSONS ...',
  '29:504.M': '29:504.M             PROHIBITION AGAINST CERTAIN PERSONS ...',
  '29:504A.F': '29:504A.F            PROHIBITION AGAINST CERTAIN PERSONS ...',
  '29:504A.M': '29:504A.M            PROHIBITION AGAINST CERTAIN PERSONS ...',
  '29:504B.F': '29:504B.F            PROHIBITION AGAINST CERTAIN PERSONS ...',
  '29:504B.M': '29:504B.M            PROHIBITION AGAINST CERTAIN PERSONS ...',
  '29:522A.F': '29:522A.F            EXTORTIONATE PICKETING',
  '29:522B.F': '29:522B.F            PENALTY FOR VIOLATION',
  '29:530.M': '29:530.M             DEPRIVATION OF RIGHTS BY VIOLENCE',
  '29:629.M': '29:629.M             FORCIBLE RESISTANCE OR INTERFERENCE',
  '29:655.M': '29:655.M             STANDARDS FOR OCCUPATIONAL HEALTH AN...',
  '29:666E.M': '29:666E.M            WILLFUL VIOLATION OF STANDARDS RULES...',
  '29:666E.P': '29:666E.P            WILLFUL VIOLATION OF STANDARDS RULES...',
  '29:666F.P': '29:666F.P            WILLFUL VIOLATION OF STANDARDS RULES...',
  '29:666G.M': '29:666G.M            FALSE STATEMENTS ON FILING',
  '2:167A.P': '2:167A.P             LIBRARY OF CONGRESS - PUBLIC USE',
  '2:167B.P': '2:167B.P             LIBRARY OF CONGRESS - SALE OF ARTICLES',
  '2:167C.P': '2:167C.P             LIBRARY OF CONGRESS - INJURY TO PROP...',
  '2:167D.P': '2:167D.P             LIBRARY OF CONGRESS - FIREARMS AND W...',
  '2:167E.P': '2:167E.P             LIBRARY OF CONGRESS - PARADES AND AS...',
  '2:167F.P': '2:167F.P             LIBRARY OF CONGRESS - ADDITIONAL REG...',
  '2:167G.F': '2:167G.F             LIBRARY OF CONGRESS - PROSECUTION AN...',
  '2:167G.P': '2:167G.P             LIBRARY OF CONGRESS - PROSECUTION AN...',
  '2:192.M': '2:192.M              CONGRESSIONAL CONTEMPT - REFUSE TO T...',
  '2:192.P': '2:192.P              CONGRESSIONAL CONTEMPT - REFUSE TO T...',
  '2:262.M': '2:262.M              ACCOUNT OF CONTRIBUTIONS, RETAINING ...',
  '2:263.M': '2:263.M              RECEIPTS FOR CONTRIBUTIONS',
  '2:264.M': '2:264.M              STATEMENTS OF ACCOUNTS',
  '2:265.M': '2:265.M              PRESERVATION OF STATEMENTS',
  '2:266.M': '2:266.M              DEFAMATION OF APPLICABLE PERSONS',
  '2:267.M': '2:267.M              REGISTRATION OF LOBBYISTS - SENATE',
  '2:268.M': '2:268.M              REPORTS AND STATEMENTS UNDER OATH',
  '2:269A.M': '2:269A.M             PENALTIES AND PROHIBITIONS',
  '2:269B.F': '2:269B.F             PENALTIES AND PROHIBITIONS',
  '2:388A.M': '2:388A.M             ISSUANCE OF SUBPOENAS',
  '2:388B.M': '2:388B.M             SUBPOENAS, TIME, METHOD AND PROOF OF...',
  '2:388C.M': '2:388C.M             SUBPOENAS, PLACE OF EXAMINATION',
  '2:388D.M': '2:388D.M             SUBPOENAS, FORMS',
  '2:388E.M': '2:388E.M             SUBPOENAS, PRODUCTION OF DOCUMENTS',
  '2:390.M': '2:390.M              PENALTY, FAILURE TO APPEAR/TESTIFY/P...',
  '2:390.P': '2:390.P              PENALTY, FAILURE TO APPEAR/TESTIFY/P...',
  '2:432A.M': '2:432A.M             POLITICAL COMMITTEES - FILLING TREAS...',
  '2:432B.M': '2:432B.M             POLITICAL COMMITTEES - CONTRIBUTIONS...',
  '2:432C.M': '2:432C.M             POLITICAL COMMITTEES - RECORDKEEPING',
  '2:432D.M': '2:432D.M             POLITICAL COMMITTEES - RECEIPTS',
  '2:432E.M': '2:432E.M             POLITICAL COMMITTEES - CAMPAIGN/UNAU...',
  '2:432F.M': '2:432F.M             POLITICAL COMMITTEES - PRINCIPAL CAM...',
  '2:433A.M': '2:433A.M             POLITICAL COMMITTEES - ORGANIZATION ...',
  '2:433B.M': '2:433B.M             POLITICAL COMMITTEES - STATEMENT CON...',
  '2:433C.M': '2:433C.M             POLITICAL COMMITTEES - REPORTING INF...',
  '2:433D.M': '2:433D.M             POLITICAL COMMITTEES - STATEMENT OF ...',
  '2:433E.M': '2:433E.M             POLITICAL COMMITTEES - STATEMENT OF ...',
  '2:434A.M': '2:434A.M             POLITICAL COMMITTEES - REPORTS, RECO...',
  '2:434B.M': '2:434B.M             POLITICAL COMMITTEES - REPORT CONTENTS',
  '2:434C.M': '2:434C.M             POLITICAL COMMITTEES - REPORTS, OTHE...',
  '2:437.M': '2:437.M              PENALTIES ILLEGAL CAMPAIGN CONTRIBUT...',
  '2:439A.M': '2:439A.M             USE OF CONTRIBUTIONS',
  '2:441.M': '2:441.M              ILLEGAL CAMPAIGN CONTRIBUTIONS',
  '2:441B.F': '2:441B.F             DISCLOSURE OF FEDERAL CAMPAIGN FUNDS',
  '30:1211F.M': '30:1211F.M           OFFICE OF SURFACE MINING, PENALTY',
  '30:1232D.M': '30:1232D.M           SURFACE MINING CONTROL AND RECLAMATION',
  '30:1267G.M': '30:1267G.M           INSPECTIONS AND MONITORING, PENALTY',
  '30:1268E.M': '30:1268E.M           PENALTIES - WILLFUL VIOLATIONS',
  '30:1268F.M': '30:1268F.M           PENALTIES - CORPORATE  VIOLATIONS',
  '30:1268G.M': '30:1268G.M           FALSE STATEMENTS, REPRESENTATIONS, P...',
  '30:1294.M': '30:1294.M            PENALTY SECTION',
  '30:195.F': '30:195.F             VIOLATION OF FEDERAL ON-SHORE OIL AN...',
  '30:689.F': '30:689.F             PROCURING A PAYMENT TO WHICH NOT ENT...',
  '30:727A.P': '30:727A.P            WITHDRAWAL AND DEBARMENT FROM DANGER...',
  '30:727B.P': '30:727B.P            PROPER OFFICIAL NOT TO BE BARRED FRO...',
  '30:733B.P': '30:733B.P            PENALTY FOR VIOLATIONS: CIVIL AND CR...',
  '30:814A.F': '30:814A.F            NOTICE OF IMMINENT DANGER - 2ND OFFENSE',
  '30:814A.M': '30:814A.M            NOTICE OF IMMINENT DANGER - 1ST OFFENSE',
  '30:814B.M': '30:814B.M            FAILURE TO COMPLY WITH NOTICE TO ABATE',
  '30:814C.M': '30:814C.M            NOTICE OF SUBSTANTIAL VIOLATIONS',
  '30:819B.F': '30:819B.F            PENALTIES (IF PRIOR) - 2ND OFFENSE',
  '30:819B.M': '30:819B.M            PENALTIES - 1ST OFFENSE',
  '30:819D.M': '30:819D.M            FALSE STATEMENTS OR REPRESENTATION',
  '30:819E.M': '30:819E.M            DISTRIBUTION OR SALE OF NON-COMPLYIN...',
  '30:820C.F': '30:820C.F            LIABILITY OF CORPORATE DIRECTORS AND...',
  '30:820C.M': '30:820C.M            LIABILITY OF CORPORATE DIRECTORS AND...',
  '30:820D.F': '30:820D.F            PENALTIES (IF PRIOR) - 2ND OFFENSE',
  '30:820D.M': '30:820D.M            PENALTIES - 1ST OFFENSE',
  '30:820E.P': '30:820E.P            UNAUTHORIZED ADVANCE NOTICE OF INSPE...',
  '30:820F.F': '30:820F.F            FALSE STATEMENTS AND REPRESENTATIONS',
  '30:820F.M': '30:820F.M            FALSE STATEMENTS OR REPRESENTATION',
  '30:820H.F': '30:820H.F            FALSELY REPRESENTED EQUIPMENT',
  '30:941.M': '30:941.M             FALSE CLAIMS AND STATEMENTS',
  '31:1003.P': '31:1003.P            RESTRICTIONS ON SECRETARY OF TREASURY',
  '31:1018.P': '31:1018.P            RESTRICTIONS ON CLERKS IN THE TREASU...',
  '31:1058.M': '31:1058.M            CRIMINAL PENALTY',
  '31:1059.F': '31:1059.F            ADDITIONAL CRIMINAL PENALTY IN CERTA...',
  '31:1081.F': '31:1081.F            REPORTS ON DOMESTIC CURRENCY TRANSAC...',
  '31:1081.M': '31:1081.M            REPORTS ON DOMESTIC CURRENCY TRANSAC...',
  '31:1101A.M': '31:1101A.M           PERSONS REQUIRED TO FILE',
  '31:1101B.M': '31:1101B.M           CONTENTS OF FILED REPORT',
  '31:1101C.M': '31:1101C.M           COMMON CARRIERS',
  '31:241A.P': '31:241A.P            PAYMENTS OF CLAIMS TO MEMBERS OF UNI...',
  '31:241B.P': '31:241B.P            CLAIMS BY CIVILIANS',
  '31:241C.P': '31:241C.P            TIME LIMITATION FOR PRESENTATION OF ...',
  '31:243.P': '31:243.P             LIMITATION ON AGENT OR ATTORNEY FEES',
  '31:329.P': '31:329.P             RESTRICTIONS ON SECRETARY OF TREASURY',
  '31:333.M': '31:333.M             FRAUDULENT USE OF DOT AND IRS LOGO',
  '31:3721.P': '31:3721.P            PAYMENTS OF CLAIMS TO MEMBERS OF UNI...',
  '31:5313.F': '31:5313.F            REPORTS ON DOMESTIC COINS AND CURREN...',
  '31:5313.M': '31:5313.M            REPORTS ON DOMESTIC COINS AND CURREN...',
  '31:5316.F': '31:5316.F            REPORTS ON EXPORT AND IMPORT OF MONE...',
  '31:5316.M': '31:5316.M            REPORTS ON EXPORT AND IMPORT OF MONE...',
  '31:5317.F': '31:5317.F            SEARCH AND FORFEITURE OF MONETARY IN...',
  '31:5318.F': '31:5318.F            RECORDS AND REPORTS ON MONETARY TRAN...',
  '31:5322A.F': '31:5322A.F           PENALTIES',
  '31:5322A.M': '31:5322A.M           PENALTIES',
  '31:5322B.F': '31:5322B.F           PENALTIES',
  '31:5324.F': '31:5324.F            STRUCTURING TRANSACTIONS TO EVADE RE...',
  '31:5324.M': '31:5324.M            STRUCTURING TRANSACTIONS TO EVADE RE...',
  '31:5331.F': '31:5331.F            RECORDS AND REPORTS ON MONETARY INST...',
  '31:5332.F': '31:5332.F            BULK CASH SMUGGLING INTO OR OUT OF T...',
  '31:699B.M': '31:699B.M            CITIZENSHIP REQUIREMENTS, FEDERAL EM...',
  '33:1.P': '33:1.P               REGULATIONS BY SECRETARY OF THE ARMY...',
  '33:1227.F': '33:1227.F            PORTS AND WATERWAYS - SAFETY PROGRAM',
  '33:1232B.F': '33:1232B.F           PORTS AND WATERWAYS SAFETY PROGRAM -...',
  '33:1236.P': '33:1236.P            TRANSPORTATION OF PASSENGERS AND MER...',
  '33:1311A.F': '33:1311A.F           POLLUTANT DISCHARGES ILLEGAL - 2ND O...',
  '33:1311A.M': '33:1311A.M           POLLUTANT DISCHARGES ILLEGAL',
  '33:1311F.F': '33:1311F.F           ILLEGALITY OF DISCHARGE OF RADIOLOGI...',
  '33:1311F.M': '33:1311F.M           ILLEGALITY OF DISCHARGE OF RADIOLOGI...',
  '33:1312.F': '33:1312.F            WATER QUALITY RELATED EFFLUENT LIMIT...',
  '33:1312.M': '33:1312.M            WATER QUALITY RELATED EFFLUENT LIMIT...',
  '33:1316.F': '33:1316.F            NATIONAL STANDARDS OF PERFORMANCE',
  '33:1316.M': '33:1316.M            NATIONAL STANDARDS OF PERFORMANCE',
  '33:1317.F': '33:1317.F            TOXIC AND PRE-TREATMENT EFFLUENT STA...',
  '33:1317.M': '33:1317.M            TOXIC AND PRE-TREATMENT EFFLUENT STA...',
  '33:1318.F': '33:1318.F            INSPECTIONS, MONITORING, AND ENTRY',
  '33:1318.M': '33:1318.M            INSPECTIONS, MONITORING, AND ENTRY',
  '33:1319.F': '33:1319.F            ENFORCEMENT - CRIMINAL PENALTIES',
  '33:1319.M': '33:1319.M            ENFORCEMENT - CRIMINAL PENALTIES',
  '33:1321B.F': '33:1321B.F           OIL AND HAZARDOUS SUBSTANCES LIABILITY',
  '33:1321B.M': '33:1321B.M           FAILURE TO NOTIFY OF OIL DISCHARGE',
  '33:1342.M': '33:1342.M            NATIONAL POLLUTANT DISCHARGE ELIMINA...',
  '33:1344.F': '33:1344.F            PERMITS FOR DREDGED OR FILL MATERIAL',
  '33:1344.M': '33:1344.M            PERMITS FOR DREDGED OR FILL MATERIAL',
  '33:1411.F': '33:1411.F            OCEAN DUMPING',
  '33:1415.M': '33:1415.M            OCEAN DUMPING - CRIMINAL PENALTIES',
  '33:1481.M': '33:1481.M            OIL POLLUTION CASUALTIES - VIOLATION...',
  '33:1514.M': '33:1514.M            DEEPWATER PORTS - CRIMINAL PENALTIES',
  '33:1517.M': '33:1517.M            DEEPWATER PORTS - OIL DISCHARGE: NOT...',
  '33:1908.F': '33:1908.F            ENFORCEMENT - CRIMINAL PENALTIES',
  '33:2.P': '33:2.P               REGULATIONS: NAVIGATION OF SET SW PA...',
  '33:3.P': '33:3.P               REGULATIONS: PREVENT INJURIES FROM T...',
  '33:368.F': '33:368.F             PENALTY FOR FAILURE TO GIVE AID, ETC.',
  '33:401.M': '33:401.M             CONSTRUCTION OF BRIDGES WITHOUT CONS...',
  '33:403.M': '33:403.M             OBSTRUCTION OF NAVIGABLE WATERS NOT ...',
  '33:404.M': '33:404.M             NO WORKS TO EXTEND BEYOND HARBOR LINES',
  '33:406.M': '33:406.M             PENALTY FOR WRONGFUL CONSTRUCTION OF...',
  '33:407.M': '33:407.M             DEPOSIT OF REFUSE IN NAVIGABLE RIVER',
  '33:408.M': '33:408.M             TAKING POSSESSION OF, USE OF, INJURY...',
  '33:409.M': '33:409.M             OBSTRUCTION OF NAVIGABLE WATERS BY V...',
  '33:410.M': '33:410.M             VIOLATION OF REGULATIONS: FLOATING L...',
  '33:411.M': '33:411.M             PENALTY FOR WRONGFUL DEPOSIT OF REFUSE',
  '33:412.M': '33:412.M             LIABILITY OF MASTERS, PILOTS, ETC., ...',
  '33:419.M': '33:419.M             REGULATIONS BY SEC GOVERNING TRANSPO...',
  '33:421.P': '33:421.P             DEPOSIT OF REFUSE, ETC., IN LAKE MIC...',
  '33:441.M': '33:441.M             DEPOSIT OF REFUSE PROHIBITED: PENALTY',
  '33:442.M': '33:442.M             LIABILITY OF OFFICERS OF TOWING VESSEL',
  '33:443.P': '33:443.P             PENALTY FOR TAKING OR TOWING WITHOUT...',
  '33:444.M': '33:444.M             DUMPING AT PLACE OTHER THAN DESIGNATED',
  '33:447.M': '33:447.M             BRIBERY OF INSPECTOR: PENALTY',
  '33:448.P': '33:448.P             RETURN OF PERMIT: PENALTY FOR FAILURE',
  '33:449.P': '33:449.P             DISPOSITION OF DREDGED MATTER: PENALTY',
  '33:452.P': '33:452.P             TAKING SHELLFISH/INTERFERING WITH NA...',
  '33:495.P': '33:495.P             FAILURE TO COMPLY WITH REGULATIONS: ...',
  '33:499.M': '33:499.M             REGULATIONS FOR DRAWBRIDGES: PENALTI...',
  '33:502.P': '33:502.P             CRIMINAL LIABILITY FOR FAILURE TO AL...',
  '33:506.M': '33:506.M             TOLLS: HEARINGS - REASONABLENESS ATT...',
  '33:507.M': '33:507.M             TOLLS: FAILURE TO OBEY ORDER PRESCRI...',
  '33:519.P': '33:519.P             NONCOMPLIANCE WITH ORDERS: REMOVAL O...',
  '33:533.M': '33:533.M             GENERAL BRIDGE AUTHORITY: PENALTIES',
  '33:554.P': '33:554.P             DUTY OF SHIPOWNERS AND OFFICERS TO F...',
  '33:555.P': '33:555.P             DUTY OF SHIPOWNERS AND OFFICERS TO F...',
  '33:601.P': '33:601.P             MISSISSIPPI RIVER: REGULATIONS OF RE...',
  '33:682.F': '33:682.F             MALICIOUS INJURY TO WORKS',
  '33:682.M': '33:682.M             MALICIOUS INJURY TO WORKS',
  '33:915.P': '33:915.P             INVALID AGREEMENTS',
  '33:928.M': '33:928.M             UNAPPROVED FEES: SOLICITATION: PENALTY',
  '33:931.F': '33:931.F             PENALTY FOR MISREPRESENTATION',
  '33:931.M': '33:931.M             PENALTY FOR MISREPRESENTATION',
  '33:937.M': '33:937.M             CERTIFICATE OF COMPLIANCE WITH CHAPTER',
  '33:938A.M': '33:938A.M            FAILURE TO SECURE PAYMENT OF COMPENS...',
  '33:938B.M': '33:938B.M            ATTEMPTING TO AVOID PAYMENT OF COMPE...',
  '33:941A.P': '33:941A.P            SAFE PLACE OF EMPLOYMENT: INSTALLATI...',
  '33:941C.P': '33:941C.P            HINDERING INSPECTION OF PLACES OF EM...',
  '33:941F.P': '33:941F.P            VIOLATIONS AND PENALTIES',
  '33:990B.F': '33:990B.F            FRAUDS AND FALSE ENTRIES, REPORTS OR...',
  '33:990C.F': '33:990C.F            RECEIPT OF COMPENSATION, OR CONSPIRA...',
  '33D:541A=CD.F': '33D:541A=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '33D:541A=CD.M': '33D:541A=CD.M        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '33D:541A=CM.F': '33D:541A=CM.F        CONTROLLED SUBSTANCE - MANUFACTURE',
  '33D:541A=CM.M': '33D:541A=CM.M        CONTROLLED SUBSTANCE - MANUFACTURE',
  '33D:541A=MD.F': '33D:541A=MD.F        MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '33D:541A=MM.F': '33D:541A=MM.F        MARIJUANA - MANUFACTURE',
  '33D:541A=ND.F': '33D:541A=ND.F        NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '33D:541A=NM.F': '33D:541A=NM.F        NARCOTICS - MANUFACTURE',
  '33D:541D=CP.F': '33D:541D=CP.F        CONTROLLED SUBSTANCE - POSSESSION',
  '33D:541D=CP.M': '33D:541D=CP.M        CONTROLLED SUBSTANCE - POSSESSION',
  '33D:541D=MP.F': '33D:541D=MP.F        MARIJUANA - POSSESSION',
  '33D:541D=MP.M': '33D:541D=MP.M        MARIJUANA - POSSESSION',
  '33D:541D=NP.F': '33D:541D=NP.F        NARCOTICS - POSSESSION',
  '33D:541D=NP.M': '33D:541D=NP.M        NARCOTICS - POSSESSION',
  '33D:542A=CD.F': '33D:542A=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '33D:542A=CD.M': '33D:542A=CD.M        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '33D:542A=CM.F': '33D:542A=CM.F        CONTROLLED SUBSTANCE - MANUFACTURE',
  '33D:542A=CM.M': '33D:542A=CM.M        CONTROLLED SUBSTANCE - MANUFACTURE',
  '33D:542A=CR.F': '33D:542A=CR.F        CONTROLLED SUBSTANCE - FRAUDULENT RE...',
  '33D:542A=CR.M': '33D:542A=CR.M        CONTROLLED SUBSTANCE - FRAUDULENT RE...',
  '33D:543A=CD.F': '33D:543A=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '33D:543A=CM.F': '33D:543A=CM.F        CONTROLLED SUBSTANCE - MANUFACTURE',
  '33D:543A=CP.F': '33D:543A=CP.F        CONTROLLED SUBSTANCE - POSSESSION',
  '33D:543A=CR.F': '33D:543A=CR.F        CONTROLLED SUBSTANCE - FRAUDULENT RE...',
  '33D:546A=MD.F': '33D:546A=MD.F        MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '33D:546A=ND.F': '33D:546A=ND.F        NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '33D:546B=CD.F': '33D:546B=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '33D:547A=CD.F': '33D:547A=CD.F        CONTROLLED SUBSTANCE - SELL/DISTRIBU...',
  '33D:547A=MD.F': '33D:547A=MD.F        MARIJUANA - SELL, DISTRIBUTE OR DISP...',
  '33D:547A=ND.F': '33D:547A=ND.F        NARCOTICS - SELL, DISTRIBUTE OR DISP...',
  '33D:549=CD.F': '33D:549=CD.F         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
  '33D:549=CD.M': '33D:549=CD.M         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
  '33D:549=CM.F': '33D:549=CM.F         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
  '33D:549=CM.M': '33D:549=CM.M         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
  '33D:549=CP.F': '33D:549=CP.F         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
  '33D:549=CP.M': '33D:549=CP.M         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
  '33D:549=CR.F': '33D:549=CR.F         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
  '33D:549=CR.M': '33D:549=CR.M         CONSPIRACY - CONTROLLED SUBSTANCE - ...',
  '33D:549=MD.F': '33D:549=MD.F         CONSPIRACY - MARIJUANA - SELL, DISTR...',
  '33D:549=MM.F': '33D:549=MM.F         CONSPIRACY - MARIJUANA - MANUFACTURE',
  '33D:549=MP.F': '33D:549=MP.F         CONSPIRACY - MARIJUANA - POSSESSION',
  '33D:549=MP.M': '33D:549=MP.M         CONSPIRACY - MARIJUANA - POSSESSION',
  '33D:549=ND.F': '33D:549=ND.F         CONSPIRACY - NARCOTICS - SELL, DISTR...',
  '33D:549=NM.F': '33D:549=NM.F         CONSPIRACY - NARCOTICS - MANUFACTURE',
  '33D:549=NP.F': '33D:549=NP.F         CONSPIRACY - NARCOTICS - POSSESSION',
  '33D:549=NP.M': '33D:549=NP.M         CONSPIRACY - NARCOTICS - POSSESSION',
  '33D:550=CP.M': '33D:550=CP.M         PARAPHERNALIA FOR CONTROLLED SUBSTANCES',
  '33D:550=MP.M': '33D:550=MP.M         PARAPHERNALIA FOR MARIJUANA',
  '33D:550=NP.M': '33D:550=NP.M         PARAPHERNALIA FOR NARCOTICS',
  '33D:603A=CP.P': '33D:603A=CP.P        CONTROLLED SUBSTANCE - MANUFACTURE',
  '33D:603A=MP.P': '33D:603A=MP.P        MARIJUANA - MANUFACTURE',
  '33D:603A=NP.P': '33D:603A=NP.P        NARCOTICS - MANUFACTURE',
  '33D:603B=CD.F': '33D:603B=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '33D:603B=CD.P': '33D:603B=CD.P        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '33D:603B=MD.F': '33D:603B=MD.F        MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '33D:603B=MD.P': '33D:603B=MD.P        MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '33D:603B=ND.F': '33D:603B=ND.F        NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '33D:603B=ND.P': '33D:603B=ND.P        NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '33D:603C=CD.F': '33D:603C=CD.F        CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '35:184.F': '35:184.F             FILING OF APPLICATION IN FOREIGN COU...',
  '35:186.F': '35:186.F             SECRECY OF CERTAIN INVENTIONS - PENALTY',
  '35:292.P': '35:292.P             FALSE MARKING',
  '35:33.P': '35:33.P              UNAUTHORIZED REPRESENTATION AS PRACT...',
  '36:379.M': '36:379.M             PRETENSE OF MEMBERSHIP - U.S. OLYMPI...',
  '36:728.P': '36:728.P             VIOLATIONS: DURATION OF REGISTRATION...',
  '38:218A.P': '38:218A.P            RULES AND REGULATIONS FOR VA PROPERTY',
  '38:218B.P': '38:218B.P            RULES AND REGULATIONS FOR VA PROPERT...',
  '38:3301.M': '38:3301.M            TRANSFERRED TO 38:5701',
  '38:3405.F': '38:3405.F            AGENTS AND ATTORNEYS: PENALTIES - CE...',
  '38:3501.F': '38:3501.F            TRANSFERRED TO 38:6101.F',
  '38:3502A.M': '38:3502A.M           FRAUDULENT ACCEPTANCE OF PAYMENTS',
  '38:3502B.M': '38:3502B.M           FRAUDULENT ACCEPTANCE OF PAYMENTS',
  '38:5701.M': '38:5701.M            IMPROPER USE OF NAMES AND ADDRESSES',
  '38:5905.M': '38:5905.M            TO WRONGFULLY SOLICIT, CHARGE, AND R...',
  '38:6101.F': '38:6101.F            MISAPPROPRIATION BY FIDUCIARIES',
  '38:6102.M': '38:6102.M            FRAUDULENT ACCEPTANCE OF PAYMENTS',
  '38:6103.F': '38:6103.F            FORFEITURE FOR FRAUD',
  '38:6103.M': '38:6103.M            FORFEITURE FOR FRAUD',
  '38:787A.M': '38:787A.M            INSURANCE - FALSE STATEMENTS IN APPL...',
  '38:787B.F': '38:787B.F            INSURANCE - FALSE STATEMENTS IN CLAIM',
  '38:901C.P': '38:901C.P            AUTHORITY TO PRESCRIBE RULES FOR CON...',
  '40:101.P': '40:101.P             LAWS OF DISTRIBUTION EXTENDED TO PUB...',
  '40:1315.P': '40:1315.P            VIOLATION OF REGULATIONS ON GOVERNME...',
  '40:193B.P': '40:193B.P            PUBLIC TRAVEL ON CAPITAL GROUNDS RES...',
  '40:193C.P': '40:193C.P            VIOLENT ENTRY AND DISORDERLY CONDUCT...',
  '40:193D.P': '40:193D.P            U.S. CAPITAL GROUNDS - SALE OF ARTIC...',
  '40:193E.P': '40:193E.P            U.S. CAPITAL GROUNDS - INJURIES TO P...',
  '40:193F.F': '40:193F.F            U.S. CAPITAL GROUNDS - FIREARMS, DAN...',
  '40:193F.P': '40:193F.P            VIOLENT ENTRY AND DISORDERLY CONDUCT...',
  '40:193G.P': '40:193G.P            U.S. CAPITAL GROUNDS - PARADES OR AS...',
  '40:193H.F': '40:193H.F            U.S. CAPITAL GROUNDS - VIOLATION OF ...',
  '40:193H.P': '40:193H.P            U.S. CAPITAL GROUNDS - VIOLATION OF ...',
  '40:193O.F': '40:193O.F            SMITHSONIAN INSTITUTION: PUBLIC USE',
  '40:193O.P': '40:193O.P            SMITHSONIAN INSTITUTION: PUBLIC USE',
  '40:193P.F': '40:193P.F            SMITHSONIAN INSTITUTION: SALE OF ART...',
  '40:193P.P': '40:193P.P            SMITHSONIAN INSTITUTION: SALE OF ART...',
  '40:193Q.F': '40:193Q.F            SMITHSONIAN INSTITUTION: INJURY TO P...',
  '40:193Q.P': '40:193Q.P            SMITHSONIAN INSTITUTION: INJURY TO P...',
  '40:193R.F': '40:193R.F            SMITHSONIAN INSTITUTION: ADDITIONAL ...',
  '40:193R.P': '40:193R.P            SMITHSONIAN INSTITUTION: ADDITIONAL ...',
  '40:193S.F': '40:193S.F            SMITHSONIAN INSTITUTION: DAMAGE OVER...',
  '40:193S.P': '40:193S.P            SMITHSONIAN INSTITUTION: DAMAGE UNDE...',
  '40:212.P': '40:212.P             REGULATION OF TRAFFIC BY CAPITAL POL...',
  '40:318A.P': '40:318A.P            GENERAL SERVICES ADMINISTRATION RULE...',
  '40:318C.P': '40:318C.P            PROTECTION OF FED. PROPERTY UNDER GE...',
  '40:332.P': '40:332.P             HOURS OF LABOR AND SAFETY - PENALTIES',
  '40:53.P': '40:53.P              DESTROYING FEDERAL PROPERTY',
  '40:883B.F': '40:883B.F            FALSE STATEMENTS OR ENTRY - INTENT T...',
  '40:883C.F': '40:883C.F            COMPLICITY OR CONSPIRACY WITH INTENT...',
  '41:423.F': '41:423.F             FEDERAL STATUTES - PUBLIC OFFICERS/E...',
  '41:51.F': '41:51.F              FEES OR KICK-BACKS BY SUBCONTRACTORS',
  '41:53.F': '41:53.F              PROVIDE, OFFER, SOLICIT, ACCEPT ANY ...',
  '41:54.F': '41:54.F              CONTRACTOR FRAUD',
  '42:1306.F': '42:1306.F            IMPROPER DISCLOSURE OF INFO IN POSSE...',
  '42:1306.M': '42:1306.M            DISCLOSURE OF INFORMATION IN POSSESS...',
  '42:1307A.M': '42:1307A.M           PENALTY FOR SOCIAL SECURITY FRAUD',
  '42:1307B.M': '42:1307B.M           PENALTY FOR SOCIAL SECURITY FRAUD',
  '42:1320A.F': '42:1320A.F           PAYMENT TO NON-LICENSED PHYSICIAN',
  '42:1320A.M': '42:1320A.M           PAYMENT TO NON-LICENSED PHYSICIAN',
  '42:1320C.P': '42:1320C.P           DISCLOSURE OF INFORMATION PROHIBITED',
  '42:1320D-6.F': '42:1320D-6.F         WRONGFUL DISCLOSURE OF INDIVIDUALLY ...',
  '42:1383.F': '42:1383.F            FRAUDULENT ACTS; PENALTIES; RESTITUTION',
  '42:1383A.M': '42:1383A.M           FALSE STATEMENTS IN APPLICATION FOR ...',
  '42:1383D.M': '42:1383D.M           PROCEDURES APPLICATION, PENALTIES FO...',
  '42:1395.F': '42:1395.F            FALSE STATEMENTS OR REPRESENTATIONS',
  '42:1395.M': '42:1395.M            FALSE STATEMENTS OR REPRESENT ON APP...',
  '42:1395.P': '42:1395.P            VIOLATION OF ASSIGNMENT TERMS',
  '42:1396.F': '42:1396.F            MAKE/CAUSE FALSE STATEMENT/REPRESENT...',
  '42:1396.M': '42:1396.M            MAKE/CAUSE FALSE STATEMENT/REPRESENT...',
  '42:14072.F': '42:14072.F           FAILURE TO REGISTER-CRIMES AGAINST C...',
  '42:1713.M': '42:1713.M            FRAUD: PENALTIES',
  '42:1714.M': '42:1714.M            LEGAL SERVICES',
  '42:1760.F': '42:1760.F            MISAPPROPRIATION OF FUNDS, PENALTIES...',
  '42:1760.M': '42:1760.M            MISAPPROPRIATION OF FUNDS, PENALTIES...',
  '42:1761O.F': '42:1761O.F           SUMMER FOOD SERVICE PROGRAM, PENALTIES',
  '42:1857C.F': '42:1857C.F           OPERATION IN VIOLATION OF STANDARD O...',
  '42:1857C.M': '42:1857C.M           AIR POLLUTANTS IN VIOLATION OF STAND...',
  '42:1874D.F': '42:1874D.F           SCHOLARSHIP, PENALTIES',
  '42:1973A.F': '42:1973A.F           PROCEEDING TO ENFORCE THE RIGHT TO VOTE',
  '42:1973B.F': '42:1973B.F           SUSPENSION OF THE USE OF TESTS OR DE...',
  '42:1973C.F': '42:1973C.F           ALTERATION OF VOTING QUALIFICATION A...',
  '42:1973D.F': '42:1973D.F           FALSIFICATION OR CONCEALMENT OF MATE...',
  '42:1973E.F': '42:1973E.F           EXAMINATION OF APPLICANTS FOR REGIST...',
  '42:1973H.F': '42:1973H.F           POLL TAXES',
  '42:1973I.F': '42:1973I.F           FAILURE OR REFUSAL TO PERMIT CASTING...',
  '42:1973J.F': '42:1973J.F           DENIAL OF RIGHT TO VOTE ON ACCOUNT O...',
  '42:1974.M': '42:1974.M            THEFT, DESTRUCTION, CONCEALMENT, MUT...',
  '42:1995.P': '42:1995.P            CRIMINAL CONTEMPT PROCEEDINGS: PENAL...',
  '42:2000E.M': '42:2000E.M           PROHIBITED DISCLOSURES, PENALTIES',
  '42:2000E.P': '42:2000E.P           POSTING OF NOTICES, PENALTIES',
  '42:2000G.M': '42:2000G.M           COOPERATION WITH OTHER AGENCIES, PEN...',
  '42:2000H.P': '42:2000H.P           CRIMINAL CONTEMPT PROCEEDINGS',
  '42:2077.F': '42:2077.F            UNAUTHORIZED DEALINGS IN SPECIAL NUC...',
  '42:2095.F': '42:2095.F            REPORTS OF SOURCE MATERIALS REQUIRED',
  '42:2122.F': '42:2122.F            PROHIBITIONS GOVERNING ATOMIC WEAPONS',
  '42:2131.F': '42:2131.F            ATOMIC ENERGY LICENSE REQUIRED',
  '42:2138.F': '42:2138.F            SUSPENSION OF LICENSES DURING WAR OR...',
  '42:2201B.F': '42:2201B.F           STANDARDS GOVERNING USE/POSSESSION O...',
  '42:2201I.F': '42:2201I.F           REGULATIONS GOVERNING RESTRICTED DATA',
  '42:2201O.F': '42:2201O.F           REPORTS REQUIRED TO ATOMIC ENERGY CO...',
  '42:2272.F': '42:2272.F            VIOLATION OF SPECIFIC SANCTIONS',
  '42:2273A.F': '42:2273A.F           VIOLATION OF SECTION GENERALLY - TRE...',
  '42:2273B.F': '42:2273B.F           VIOLATION OF SECTION GENERALLY - SIMPLE',
  '42:2274A.F': '42:2274A.F           COMMUNICATION OF RESTRICTED DATA - S...',
  '42:2274B.F': '42:2274B.F           COMMUNICATION OF RESTRICTED DATA - S...',
  '42:2275.F': '42:2275.F            RECEIPT OF RESTRICTED DATA - SABOTAGE',
  '42:2276.F': '42:2276.F            TAMPERING WITH RESTRICTED DATA - SAB...',
  '42:2277.P': '42:2277.P            DISCLOSURE OF RESTRICTED DATA',
  '42:2278B.M': '42:2278B.M           PHOTOGRAPHING, ETC., OF COMMUNICATIO...',
  '42:2284A.F': '42:2284A.F           PHYSICAL DAMAGE TO NUCLEAR FACILITIES',
  '42:2284B.F': '42:2284B.F           TAMPERING WITH NUCLEAR FACILITIES',
  '42:2378A.M': '42:2378A.M           DEVELOPMENT AND CONTROL OF ATOMIC EN...',
  '42:2462B.P': '42:2462B.P           FORMER NASA EMPLOYEE REQUIRED TO FIL...',
  '42:2462E.P': '42:2462E.P           FILING REPORTS ON TERMINATION OF EMP...',
  '42:2462G.P': '42:2462G.P           PENALTIES',
  '42:261A.F': '42:261A.F            INTRODUCING PROHIBITED ARTICLES AND ...',
  '42:261B.F': '42:261B.F            ESCAPE OR ATTEMPTED ESCAPE FROM HOSP...',
  '42:261C.F': '42:261C.F            PROCURING ESCAPE: CONCEALING ESCAPE',
  '42:262A.M': '42:262A.M            INTRASTATE AND INTERSTATE TRAFFIC IN...',
  '42:262B.M': '42:262B.M            FALSELY LABELING OR MARKING PACKAGE ...',
  '42:262C.M': '42:262C.M            INSPECT ESTABLISHMENT FOR PROPAGATIO...',
  '42:262D.M': '42:262D.M            REGULATIONS GOVERNING LICENSES',
  '42:262E.M': '42:262E.M            INTERFERENCE WITH PUBLIC HEALTH OFFICER',
  '42:262F.M': '42:262F.M            PENALTIES FOR OFFENSES',
  '42:263.M': '42:263.M             PROHIBITION OF UNLICENSED LABORATORY...',
  '42:264.M': '42:264.M             REGULATIONS TO CONTROL COMMUNICABLE ...',
  '42:265.M': '42:265.M             SUSPENSION OF ENTRIES AND IMPORTS FR...',
  '42:266.M': '42:266.M             SPECIAL QUARANTINE POWERS IN TIME OF...',
  '42:269.M': '42:269.M             BILLS OF HEALTH FOR CLEARING OR DEPA...',
  '42:271.M': '42:271.M             PENALTIES FOR VIOLATION OF QUARANTIN...',
  '42:274.F': '42:274.F             ORGAN PROCUREMENT AND TRANSPORTATION',
  '42:2971.F': '42:2971.F            CRIMINAL PROVISIONS - AMOUNT OVER $100',
  '42:2971.M': '42:2971.M            CRIMINAL PROVISIONS - AMOUNT UNDER $100',
  '42:300E.F': '42:300E.F            FINANCIAL DISCLOSURE, PENALTIES',
  '42:300G.P': '42:300G.P            REGULATIONS FOR FORM AND MANNER OF N...',
  '42:300H.F': '42:300H.F            WILLFUL VIOLATION OF UNDERGROUND INJ...',
  '42:3188A.F': '42:3188A.F           PROHIBITED FINANCIAL INTERESTS OF CO...',
  '42:3188C.M': '42:3188C.M           SUPPLEMENTARY SALARY PROHIBITED: PEN...',
  '42:3220A.F': '42:3220A.F           FALSE STATEMENTS: SECURITY OVERVALUA...',
  '42:3220B.F': '42:3220B.F           EMBEZZLEMENT: SCHEMES TO DEFRAUD',
  '42:3425.F': '42:3425.F            ESCAPE OR RESCUE FROM CUSTODY - PENA...',
  '42:3425.M': '42:3425.M            ESCAPE OR RESCUE FROM CUSTODY - PENA...',
  '42:3426.F': '42:3426.F            FALSE STATEMENTS',
  '42:3610.M': '42:3610.M            PERSON AGGRIEVED: COMPLAINT: COPY: I...',
  '42:3611.M': '42:3611.M            VIOLATIONS: PENALTIES',
  '42:3631.F': '42:3631.F            INTIMIDATE OR INTERFERE: BODILY INJU...',
  '42:3631.M': '42:3631.M            INTIMIDATE OR INTERFERE: BODILY INJU...',
  '42:3771.M': '42:3771.M            REVELATION OF INFORMATION FOR STATED...',
  '42:3791.F': '42:3791.F            EMBEZZLEMENT',
  '42:3792.F': '42:3792.F            FRAUDULENT AND FALSE STATEMENTS OR E...',
  '42:3793.F': '42:3793.F            CONSPIRACIES',
  '42:3795.F': '42:3795.F            MISUSE OF FEDERAL ASSISTANCE',
  '42:406.M': '42:406.M             REPRESENTATION OF CLAIMANTS BEFORE S...',
  '42:408.F': '42:408.F             MISUSE OF SOCIAL SECURITY NUMBER',
  '42:408.M': '42:408.M             FALSE STATEMENTS/REPRESENTATION - PE...',
  '42:4367.M': '42:4367.M            REPORTING REQUIREMENTS, PENALTIES',
  '42:4582.P': '42:4582.P            CONFIDENTIALITY OF PATIENT RECORDS -...',
  '42:4909.F': '42:4909.F            DISTRIBUTION OF PRODUCT NOT CONFORMI...',
  '42:4909.M': '42:4909.M            DISTRIBUTION OF PRODUCT NOT CONFORMI...',
  '42:4910.F': '42:4910.F            CRIMINAL PENALTIES - IF PRIOR OFFENSE',
  '42:4910.M': '42:4910.M            FALSE CLAIMS AND STATEMENTS',
  '42:4912.M': '42:4912.M            FALSE STATEMENTS IN DOCUMENTS REQUIR...',
  '42:5157.M': '42:5157.M            FRAUDULENT OR WILLFUL MISREPRESENTATION',
  '42:5409.M': '42:5409.M            MANUFACTURE OR SELL MOBILE HOME IN N...',
  '42:5410.M': '42:5410.M            CIVIL AND CRIMINAL PENALTIES',
  '42:5411.M': '42:5411.M            INJUNCTIVE RELIEF',
  '42:5420.M': '42:5420.M            FAILURE TO REPORT VIOLATIONS: PENALTIES',
  '42:5816.M': '42:5816.M            FINANCIAL STATEMENTS OF ADMINISTRATI...',
  '42:6392.M': '42:6392.M            CONFLICTS OF INTEREST, PENALTY',
  '42:6395B.M': '42:6395B.M           PENALTY FOR WILLFUL VIOLATION',
  '42:6395C.M': '42:6395C.M           PENALTY FOR VIOLATION AFTER PRIOR VI...',
  '42:6906.M': '42:6906.M            FINANCIAL DISCLOSURE, PENALTY',
  '42:6928.F': '42:6928.F            STORES/TREATS/TRANSPORTS ETC. - RE-U...',
  '42:6928.M': '42:6928.M            FEDERAL ENFORCEMENT, PENALTY',
  '42:7218.M': '42:7218.M            SANCTIONS AND PENALTY',
  '42:7412.F': '42:7412.F            AIR POLLUTION PREVENTION/CONTROL-HAZ...',
  '42:7412.M': '42:7412.M            AIR POLLUTION PREVENTION/CONTROL-HAZ...',
  '42:7413.F': '42:7413.F            FEDERAL ENFORCEMENT PROCEDURES, PENALTY',
  '42:7413.M': '42:7413.M            FEDERAL ENFORCEMENT PROCEDURES, PENALTY',
  '42:7618.M': '42:7618.M            FINANCIAL DISCLOSURE, PENALTY',
  '42:7671.F': '42:7671.F            DEFINITION OF STRATOSPHERIC OZONE PR...',
  '42:8432.M': '42:8432.M            POWER PLANT AND INDUSTRIAL FUEL USE',
  '42:9603B.F': '42:9603B.F           FAILURE TO NOTIFY/FALSE INFORMATION',
  '42:9603B.M': '42:9603B.M           NOTIFICATION REQUIREMENTS/RELEASED S...',
  '43:104.P': '43:104.P             DISOBEDIENCE TO SUBPOENA',
  '43:1064.M': '43:1064.M            UNLAWFUL ENCLOSURES OR OCCUPANCY - V...',
  '43:1333.P': '43:1333.P            COAST GUARD REGULATIONS: MARKING OF ...',
  '43:1334.P': '43:1334.P            ADMINISTRATION OF LEASING',
  '43:1350.F': '43:1350.F            SUBMERGED LANDS, REMEDIES AND PENALTIES',
  '43:1605.M': '43:1605.M            PROHIBITION OF EXPENDITURE FOR PROPA...',
  '43:1619.M': '43:1619.M            ATTORNEY/CONSULTANT FEES: RESTRICTIONS',
  '43:1701.M': '43:1701.M            FEDERAL LAND POLICY AND MANAGEMENT',
  '43:1733.M': '43:1733.M            ENFORCEMENT AUTHORITY, CRIMINAL PENA...',
  '43:18223.M': '43:18223.M           RESOURCE MANAGEMENT, PENALTY',
  '43:315.P': '43:315.P             GRAZING LANDS, REGULATIONS AND IMPRO...',
  '43:316.P': '43:316.P             UNLAWFUL TO GRAZE LIVESTOCK',
  '43:362.F': '43:362.F             INJURY TO SIGNPOSTS AND FOULING WATE...',
  '45:152.M': '45:152.M             RAILWAY LABOR: GENERAL DUTIES - VIOL...',
  '45:181.M': '45:181.M             APPLICATION OF SECS. TO CARRIERS BY AIR',
  '45:182.M': '45:182.M             APPLICATION OF SECS. TO CARRIERS BY AIR',
  '45:231.M': '45:231.M             RETIREMENT OF RAILROAD EMPLOYEES: PE...',
  '45:231L.F': '45:231L.F            FAILURE TO REPORT INFORMATION TO RAI...',
  '45:231L.M': '45:231L.M            FAILURE TO REPORT INFORMATION TO RAI...',
  '45:355.M': '45:355.M             RAILROAD UNEMPLOYMENT INSURANCE: FEE...',
  '45:359A.M': '45:359A.M            FALSE OR FRAUDULENT STATEMENT OR CLAIM',
  '45:359B.M': '45:359B.M            AGREEMENT BY EMPLOYEE TO BEAR EMPLOY...',
  '45:359C.M': '45:359C.M            PUNISHMENTS NOT SPECIFICALLY PROVIDED',
  '45:38.P': '45:38.P              MONTHLY REPORTS OF RAILROAD ACCIDENTS',
  '45:39.P': '45:39.P              FAILURE TO MAKE REPORTS',
  '45:60.M': '45:60.M              SUPPRESSION OF VOLUNTARY INFORMATION...',
  '45:65.M': '45:65.M              EIGHT-HOUR DAY ESTABLISHED',
  '45:66.M': '45:66.M              PENALTIES FOR VIOLATION OF SEC. 65 -...',
  '45:81.F': '45:81.F              GOVERNMENT AIDED RAILROAD, DIVIDENDS...',
  '45:83.P': '45:83.P              ROADS/TELEGRAPHS - EQUAL FACILITY TO...',
  '46:101.P': '46:101.P             STATEMENTS OF CONSULAR SERVICES PERF...',
  '46:1119.M': '46:1119.M            APPROPRIATION: EXCEPT BY PERSONS ADV...',
  '46:1132.P': '46:1132.P            CITIZENSHIP OF OFFICERS AND CREW: PE...',
  '46:1171.F': '46:1171.F            FALSE STATEMENT OF FINANCIAL INTERES...',
  '46:1222.M': '46:1222.M            OPERATING COMPETING FOREIGN-FLAG VESSEL',
  '46:1223A.M': '46:1223A.M           FOREIGN TRADE SUBSIDY CONTRACTOR ENG...',
  '46:1223D.M': '46:1223D.M           EMPLOYING OTHER PERSONS AS MANAGING ...',
  '46:1223E.M': '46:1223E.M           EMPLOYING MEMBER OF CONGRESS',
  '46:1223F.M': '46:1223F.M           PENALTY FOR WILLFUL VIOLATION OF ANY...',
  '46:1224.F': '46:1224.F            COLLUSION WITH RESPECT TO BIDDING',
  '46:1225.F': '46:1225.F            EMPLOYMENT OF PERSONS TO APPEAR BEFO...',
  '46:1226.F': '46:1226.F            DISCRIMINATION IN RESPECT TO CARGO',
  '46:1227.M': '46:1227.M            AGREEMENTS WITH OTHER CARRIERS FORBI...',
  '46:1228.M': '46:1228.M            KNOWING AND WILLFUL VIOLATION: ORDER...',
  '46:1276.M': '46:1276.M            FALSE STATEMENTS TO OBTAIN A LOAN',
  '46:1333A.M': '46:1333A.M           INSPECTION LAWS RELATING TO PASSENGE...',
  '46:1333B.M': '46:1333B.M           MINIMUM STANDARDS FOR QUARTERS',
  '46:1333C.M': '46:1333C.M           CERTIFICATE OF INSPECTION',
  '46:1333D.M': '46:1333D.M           UNLAWFUL TO OPERATE VESSEL WITHOUT C...',
  '46:1333E.M': '46:1333E.M           CIVILIAN NAUTICAL SCHOOL: FINES AND ...',
  '46:142.F': '46:142.F             RETALIATORY SUSPENSION - COMMERCIAL ...',
  '46:143.F': '46:143.F             DENIAL OF RIGHTS TO U.S. VESSELS - B...',
  '46:1461C.M': '46:1461C.M           USE OF VESSEL IN VIOLATION OF REGULA...',
  '46:1461D.M': '46:1461D.M           NEGLIGENT USE OF VESSEL',
  '46:1483.M': '46:1483.M            USE OF VESSEL IN VIOLATION OF CHAPTE...',
  '46:151.P': '46:151.P             ACCOMMODATIONS FOR STEERAGE PASSENGE...',
  '46:152.P': '46:152.P             BERTHS FOR PASSENGERS',
  '46:154.P': '46:154.P             FOOD FOR STEERAGE PASSENGERS',
  '46:156.M': '46:156.M             TRANSPORT OF ANIMALS BY VESSEL CARRY...',
  '46:157.P': '46:157.P             VISITING PARTS OF VESSEL OCCUPIED BY...',
  '46:158.P': '46:158.P             BOARDING VESSEL ON ARRIVAL: PASSENGE...',
  '46:161.M': '46:161.M             WITHHOLDING CLEARANCE PAPERS',
  '46:163.P': '46:163.P             REGULATIONS: BOARDING ARRIVING VESSE...',
  '46:170.F': '46:170.F             TENDERING EXPLOSIVES OR OTHER DANGER...',
  '46:190.P': '46:190.P             STIPULATIONS RELIEVING FROM LIABILIT...',
  '46:191.P': '46:191.P             STIPULATIONS RELIEVING FROM EXERCISE...',
  '46:192.P': '46:192.P             LIMITATION OF LIABILITY FOR ERRORS O...',
  '46:193.P': '46:193.P             BILLS OF LADING TO BE ISSUED: CONTENTS',
  '46:194.P': '46:194.P             PENALTY FOR VIOLATION OF 190-3',
  '46:229E.F': '46:229E.F            LICENSING OF RADIOTELEGRAPH OPERATOR...',
  '46:229F.P': '46:229F.P            LICENSES OF RADIOTELEGRAPH OPERATORS...',
  '46:2302.M': '46:2302.M            NEGLIGENT OPERATION OF VESSEL',
  '46:2302.P': '46:2302.P            NEGLIGENT OPERATION OF VESSEL',
  '46:231.F': '46:231.F             OATH OF LICENSE: PERJURY: ALTERATION...',
  '46:232.P': '46:232.P             EXHIBITION OF LICENSES',
  '46:239.M': '46:239.M             MARINE CASUALTIES: COERCION - BRIBER...',
  '46:246.P': '46:246.P             UNLAWFUL TO CHANGE CERTIFICATE OF RE...',
  '46:249.P': '46:249.P             REGULATIONS: MANUFACTURE/SELL/POSSES...',
  '46:277.M': '46:277.M             INSPECTION OF DOCUMENTS',
  '46:369.F': '46:369.F             DEFACING OR DESTRUCTION OF PLANS: PE...',
  '46:391.F': '46:391.F             PENALTIES - WILLFUL VIOLATION',
  '46:403.P': '46:403.P             PUNISHMENT FOR CERTIFYING FALSELY',
  '46:407.P': '46:407.P             PUNISHMENT FOR IMPROPER CONSTRUCTION',
  '46:408.F': '46:408.F             BOILER PLATES',
  '46:410.F': '46:410.F             COUNTERFEITING STAMPS',
  '46:413.F': '46:413.F             OBSTRUCTING SAFETY VALVES',
  '46:45.P': '46:45.P              NUMBERS FOR VESSELS',
  '46:452.P': '46:452.P             PENALTY FOR CARRYING TOO MANY PASSEN...',
  '46:457.P': '46:457.P             TRANSPORTATION OF PASSENGERS AND MER...',
  '46:471.P': '46:471.P             PENALTY FOR FAILURE TO KEEP WATCHMEN',
  '46:479.P': '46:479.P             PENALTY: NOT PROVIDING PROPER ACCOMM...',
  '46:481.F': '46:481.F             MANUFACTURE/SALE OF DEFECTIVE EQUIPMENT',
  '46:498.P': '46:498.P             PENALTY IN CASES NOT PROVIDED FOR',
  '46:563.P': '46:563.P             SHIPMENT OF CREWS: SHIPPING AGREEMENTS',
  '46:58.P': '46:58.P              MISCONDUCT BY OFFICERS - PENALTIES',
  '46:59.P': '46:59.P              PENALTY FOR NEGLECT BY OFFICERS',
  '46:599.P': '46:599.P             ADVANCES AND ALLOTMENTS',
  '46:643A.P': '46:643A.P            ISSUANCE, FORM AND CONTENTS',
  '46:643G.M': '46:643G.M            DISCHARGE BOOK AND CERTIFICATE OF ID...',
  '46:643K.P': '46:643K.P            PERFORMANCE OF DUTIES BY COLLECTOR, ...',
  '46:658.F': '46:658.F             DISCHARGE OF CREW ON ACCOUNT OF UNSE...',
  '46:660.P': '46:660.P             REFUSAL TO PAY WAGES AND CHARGES',
  '46:672.M': '46:672.M             REQUIREMENTS, QUALIFICATIONS, AND RE...',
  '46:676.P': '46:676.P             RULES AS TO LIST OF CREW',
  '46:684.P': '46:684.P             WAGES ON DISCHARGE IN CASE OF SALE',
  '46:701.F': '46:701.F             ASSAULTING OFFICER',
  '46:701.M': '46:701.M             WILLFULLY DAMAGING VESSEL',
  '46:701.P': '46:701.P             WILLFUL DISOBEDIENCE TO ANY LAWFUL C...',
  '46:70502.F': '46:70502.F           DEFINITIONS - MARITIME DRUG LAW ENFO...',
  '46:70504.F': '46:70504.F           JURISDICTION AND VENUE - MARITIME DR...',
  '46:709.P': '46:709.P             SOLICITING SEAMAN AS LODGERS',
  '46:728.F': '46:728.F             DUTY OF MASTER TO ASSIST PERSONS IN ...',
  '46:738B.P': '46:738B.P            OPERATOR OF VESSEL TO GIVE NOTICE OF...',
  '46:738C.P': '46:738C.P            SPEED OF VESSEL IN ICE REGION: PENALTY',
  '46:808.F': '46:808.F             REGISTRATION, ENROLLMENT, LICENSE OF...',
  '46:812.M': '46:812.M             REBATES AND DISCRIMINATION BY CARRIE...',
  '46:815.P': '46:815.P             DISCRIMINATORY ACTS PROHIBITED',
  '46:817.M': '46:817.M             FREE TRANSPORT OF GOVT. PERSON IN AM...',
  '46:820.M': '46:820.M             REPORTS BY CARRIERS REQUIRED',
  '46:831.P': '46:831.P             PENALTY FOR VIOLATION OF CHAPTER 6',
  '46:835.F': '46:835.F             RESTRICTION ON TRANSFER OF SHIPPING ...',
  '46:838.F': '46:838.F             RECORD OF SALE OR OTHER DISPOSAL OF ...',
  '46:85F.M': '46:85F.M             DETENTION OF VESSELS LOADED IN VIOLA...',
  '46:85G.M': '46:85G.M             PERMITTING A VESSEL TO DEPART IN VIO...',
  '46:86H.M': '46:86H.M             DETENTION OF VESSELS - LIABILITY FOR...',
  '46:88F.P': '46:88F.P             DETENTION OF VESSELS LOADED IN VIOLA...',
  '46:88G.M': '46:88G.M             REMOVAL OF MARKS PLACED ON VESSEL',
  '46:88G.P': '46:88G.P             DEPARTURE IN VIOLATION OF 88F DETENT...',
  '46:924.F': '46:924.F             PRIOR AND SUBSEQUENT MARITIME LIENS ...',
  '46:941.F': '46:941.F             SHIP MORTGAGES: UNLAWFUL ACTS BY MOR...',
  '46A:1903G=CD.F': '46A:1903G=CD.F       CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '46A:1903G=CD.M': '46A:1903G=CD.M       CONTROLLED SUBSTANCE - MANUFACTURE',
  '46A:1903G=CM.F': '46A:1903G=CM.F       CONTROLLED SUBSTANCE - MANUFACTURE',
  '46A:1903G=MD.F': '46A:1903G=MD.F       MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '46A:1903G=MM.F': '46A:1903G=MM.F       MARIJUANA - MANUFACTURE',
  '46A:1903G=ND.F': '46A:1903G=ND.F       NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '46A:1903G=ND.M': '46A:1903G=ND.M       NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '46A:1903G=NM.F': '46A:1903G=NM.F       NARCOTICS - MANUFACTURE',
  '46A:1903G=NM.M': '46A:1903G=NM.M       NARCOTICS - MANUFACTURE',
  '46A:1903J=CD.m': '46A:1903J=CD.F       CONSP TO DISTRIB/POSS WITH INTENT TO...',
  '46A:1903J=CD.F': '46A:1903J=CD.F       CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '46A:1903J=CD.M': '46A:1903J=CD.M       CONTROLLED SUBSTANCE - SELL, DISTRIB...',
  '46A:1903J=CM.F': '46A:1903J=CM.F       CONSPIRACY TO MANU/POSS W/INTENT TO ...',
  '46A:1903J=CM.M': '46A:1903J=CM.F       CONTROLLED SUBSTANCE - MANUFACTURE',
  '46A:1903J=MD.F': '46A:1903J=MD.F       MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '46A:1903J=MD.M': '46A:1903J=MD.M       MARIJUANA - SELL, DISTRIBUTE, OR DIS...',
  '46A:1903J=MM.F': '46A:1903J=MM.F       MARIJUANA - MANUFACTURE',
  '46A:1903J=ND.F': '46A:1903J=ND.F       NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '46A:1903J=ND.M': '46A:1903J=ND.M       NARCOTICS - SELL, DISTRIBUTE, OR DIS...',
  '46A:1903J=NM.F': '46A:1903J=NM.F       NARCOTICS - MANUFACTURE',
  '46A:1903J=NM.M': '46A:1903J=NM.M       NARCOTICS - MANUFACTURE',
  '47:13.P': '47:13.P              TELEGRAPHS - ACTION FOR DAMAGES - VI...',
  '47:21.F': '47:21.F              WILLFUL INJURY TO SUBMARINE CABLES',
  '47:22.P': '47:22.P              SUBMARINE CABLES: NEGLIGENT INJURY TO',
  '47:220.F': '47:220.F             ACCOUNTS, RECORDS, MEMOS: WILLFUL FA...',
  '47:223A.F': '47:223A.F            OBSCENE OR HARASSING TELEPHONE CALLS',
  '47:223A.M': '47:223A.M            OBSCENE OR HARASSING TELEPHONE CALLS',
  '47:223A.P': '47:223A.P            OBSCENE OR HARASSING TELEPHONE CALLS',
  '47:223B.M': '47:223B.M            OBSCENE OR HARASSING TELEPHONE CALLS',
  '47:223B.P': '47:223B.P            OBSCENE OR HARASSING TELEPHONE CALLS',
  '47:24.P': '47:24.P              VESSELS LAYING CABLES: SIGNALS: AVOI...',
  '47:25.P': '47:25.P              FISHING VESSELS: DUTY TO KEEP NETS F...',
  '47:27.F': '47:27.F              OFFENDING VESSELS TO SHOW NATIONALITY',
  '47:301.F': '47:301.F             LICENSE FOR RADIO COMMUNICATION  (T)',
  '47:301.M': '47:301.M             LICENSE FOR RADIO COMMUNICATION',
  '47:302.F': '47:302.F             DEVICES WHICH INTERFERE WITH RADIO R...',
  '47:325.F': '47:325.F             FALSE DISTRESS SIGNALS',
  '47:325.M': '47:325.M             FALSE DISTRESS SIGNALS',
  '47:37.M': '47:37.M              LICENSES FOR LANDING OR OPERATING CA...',
  '47:409.M': '47:409.M             REFUSAL TO OBEY A SUBPOENA',
  '47:501.F': '47:501.F             COMMUNICATION ACTS  (T)',
  '47:501.M': '47:501.M             GENERAL PENALTY - 1ST OFFENSE',
  '47:502.P': '47:502.P             VIOLATION OF RULES, REGULATIONS, ETC.',
  '47:506.M': '47:506.M             COERCIVE PRACTICE AFFECTING BROADCAS...',
  '47:506.P': '47:506.P             UNAUTHORIZED COMMUNICATION  (T)',
  '47:508A.M': '47:508A.M            PAYMENTS TO STATION EMPLOYEES',
  '47:508B.M': '47:508B.M            PRODUCTION OR PREPARATION OF PROGRAMS',
  '47:508C.M': '47:508C.M            SUPPLYING OF PROGRAM OR PROGRAM MATTER',
  '47:508G.M': '47:508G.M            DISCLOSURE OF PAYMENTS TO INDIV. CON...',
  '47:509A.M': '47:509A.M            INFLUENCING, PREARRANGING OR PREDETE...',
  '47:509C.M': '47:509C.M            PROHIBITED PRACTICE IN CONTESTS OF K...',
  '47:553.F': '47:553.F             FINANCIAL GAIN FROM CABLE SERVICE',
  '47:553.M': '47:553.M             FINANCIAL GAIN FROM CABLE SERVICE',
  '47:605A.F': '47:605A.F            UNAUTHORIZED COMMUNICATION  (T)',
  '47:605A.M': '47:605A.M            UNAUTHORIZED COMMUNICATION  (T)',
  '47:606.F': '47:606.F             WILLFUL ACT WITH INTENT TO INJURE U.S.',
  '47:606.M': '47:606.M             WILLFUL ACT IN VIOLATION OF PRESIDEN...',
  '49:101.F': '49:101.F             UNLAWFUL DISCRIMINATION IN RATES: VI...',
  '49:102.F': '49:102.F             FALSE BILLING OR CLASSIFICATION BY C...',
  '49:1021A.P': '49:1021A.P           VIOLATION OF CHAPTER - 2ND OFFENSE',
  '49:1021B.P': '49:1021B.P           SERVICE AT LESS THAN SPECIFIED RATES...',
  '49:1021C.P': '49:1021C.P           SERVICE AT LESS THAN LAWFUL RATES - ...',
  '49:1021D.P': '49:1021D.P           FAILURE OR REFUSAL TO MAKE REPORT, F...',
  '49:1021E.P': '49:1021E.P           DISCLOSURE OF INFORMATION BY AGENT O...',
  '49:1021F.P': '49:1021F.P           DISCLOSURE OF INFORMATION BY FREIGHT...',
  '49:103.F': '49:103.F             OBTAINING LOWER RATES BY FALSE BILLI...',
  '49:104.F': '49:104.F             INDUCING UNJUST DISCRIMINATION: PENALTY',
  '49:11322.F': '49:11322.F           RESTRICTIONS ON ACTIONS OF OFFICERS/...',
  '49:11703.P': '49:11703.P           DISCLOSURE OF INFORMATION BY FREIGHT...',
  '49:11709.F': '49:11709.F           SECURITIES ISSUED CONTRARY TO LAW VOID',
  '49:117A.P': '49:117A.P            BRIBERY',
  '49:117B.F': '49:117B.F            BRIBERY',
  '49:11903A.F': '49:11903A.F          LIABILITY OF CORPORATE COMMON CARRIE...',
  '49:11903B.F': '49:11903B.F          NOT PUBLISHING OR FILING RATES OR TA...',
  '49:11904.P': '49:11904.P           SERVICE AT LESS THAN SPECIFIED RATES...',
  '49:11904A.F': '49:11904A.F          FALSE BILLING OR CLASSIFICATION BY C...',
  '49:11904B.F': '49:11904B.F          INDUCING UNJUST DISCRIMINATION: PENALTY',
  '49:11905.P': '49:11905.P           FREE TRANSPORT FOR PASSENGERS PROHIB...',
  '49:11907.F': '49:11907.F           BRIBERY',
  '49:11907.P': '49:11907.P           BRIBERY',
  '49:11909A.F': '49:11909A.F          RECORDKEEPING AND REPORTING VIOLATIONS',
  '49:11909B.P': '49:11909B.P          FAILURE OR REFUSAL TO MAKE REPORT, F...',
  '49:11909C.P': '49:11909C.P          RECORDKEEPING AND REPORTING VIOLATIONS',
  '49:11909D.P': '49:11909D.P          RECORDKEEPING AND REPORTING VIOLATIONS',
  '49:11910.P': '49:11910.P           DISCLOSURE OF INFORMATION BY AGENT O...',
  '49:11910C.P': '49:11910C.P          ACCOUNTS, RECORDS, REPORTS: DIVULGIN...',
  '49:11913.M': '49:11913.M           NEGLECT OR REFUSAL TO ATTEND AND TES...',
  '49:11914.F': '49:11914.F           UNLAWFUL DISCRIMINATION IN RATES: VI...',
  '49:11914.P': '49:11914.P           MOTOR CARRIER SAFETY REGULATIONS',
  '49:11915.F': '49:11915.F           PUNISHMENT OF CORPORATION FOR VIOLAT...',
  '49:1679.F': '49:1679.F            FEDERAL SAFETY STANDARDS',
  '49:17.P': '49:17.P              FREE TRANSPORTATION PROHIBITED - PEN...',
  '49:1725.F': '49:1725.F            AVIATION FACILITY: FALSE STATEMENTS,...',
  '49:20.F': '49:20.F              SECURITIES ISSUED CONTRARY TO LAW',
  '49:207B.F': '49:207B.F            KNOWING AND WILLFUL FALSE ENTRY',
  '49:207F.P': '49:207F.P            ACCOUNTS, RECORDS, REPORTS: DIVULGIN...',
  '49:301.F': '49:301.F             SHORT TITLE',
  '49:302.F': '49:302.F             APPLICATION OF PROVISIONS',
  '49:303.F': '49:303.F             DEFINITIONS AND EXCEPTIONS',
  '49:304.F': '49:304.F             POWERS AND DUTIES OF COMMISSION',
  '49:322A.P': '49:322A.P            VIOLATION WHERE NONE OTHER PROVIDED:...',
  '49:322C.P': '49:322C.P            PARTICIPATION IN UNJUST DISCRIMINATI...',
  '49:322D.P': '49:322D.P            DISCLOSURE OF INFORMATION BY AGENT, ...',
  '49:322G.P': '49:322G.P            ALTERING OR MAKING FALSE REPORT OR R...',
  '49:32701.F': '49:32701.F           ALTERING ODOMETER SETTINGS FORMERLY ...',
  '49:32703.F': '49:32703.F           TAMPERING WITH MOTOR VEHICLE ODOMETERS',
  '49:32704.F': '49:32704.F           ODOMETERS-SERVICE, REPAIR, REPLACEMENT',
  '49:32705F': '49:32705F            DISCLOSURE REQUIREMENTS ON TRANSFER ...',
  '49:32709.F': '49:32709.F           FALSE STATEMENTS ON TRANSFER DOCUMENTS',
  '49:411.F': '49:411.F             LIABILITY OF CORPORATE COMMON CARRIE...',
  '49:46.M': '49:46.M              NEGLECT OR REFUSAL TO ATTEND AND TES...',
  '49:46306.F': '49:46306.F           REGISTRATION VIOLATIONS NON-AIR TRAN...',
  '49:46308.F': '49:46308.F           INTERFERENCE WITH AIR NAVIGATION',
  '49:46310.F': '49:46310.F           REPORTING AND RECORD KEEPING VIOLATIONS',
  '49:46312.F': '49:46312.F           TRANSPORTING HAZARDOUS MATERIAL',
  '49:46313.M': '49:46313.M           REFUSING TO APPEAR OR PRODUCE RECORDS',
  '49:46314.F': '49:46314.F           Interference with flight crew member...',
  '49:46314.M': '49:46314.M           Interference with flight crew member...',
  '49:46316.P': '49:46316.P           IN VIOLATION OF REGULATIONS PRESCRIB...',
  '49:46317.F': '49:46317.F           PILOTS OPERATING IN AIR TRANSPORTATI...',
  '49:46318.M': '49:46318.M           INTERFERENCE WITH CABIN OR FLIGHT CREW',
  '49:46502.F': '49:46502.F           AIRCRAFT PIRACY',
  '49:46503.F': '49:46503.F           INTERFERENCE WITH SECURITY SCREENING...',
  '49:46504.F': '49:46504.F           INTERFERENCE WITH FLIGHT CREW MEMBER...',
  '49:46505.F': '49:46505.F           ATTEMPT OR CARRY A WEAPON OR EXPLOSI...',
  '49:46505.M': '49:46505.M           ATTEMPT OR CARRY WEAPON OR EXPLOSIVE...',
  '49:46506.F': '49:46506.F           APPLICATION OF CERTAIN CRIMINAL LAWS...',
  '49:46506.M': '49:46506.M           APPLICATION OF CERTAIN LAWS ON AIRCRAFT',
  '49:46507.F': '49:46507.F           FALSE INFORMATION OR THREATS CONCERN...',
  '49:5124.F': '49:5124.F            TRANSPORTATION OF HAZARDOUS MATERIAL',
  '49:521B.M': '49:521B.M            VIOLATIONS PERTAINING TO CDLS',
  '49:522A.F': '49:522A.F            REPORTING AND RECORDKEEPING VIOLATIONS',
  '49:522B.P': '49:522B.P            REPORTING AND RECORDKEEPING VIOLATIONS',
  '49:525.M': '49:525.M             DISOBEDIENCE TO A SUBPOENA',
  '49:526.P': '49:526.P             PENALTY FOR VIOLATION WHERE NONE OTH...',
  '49:60123.F': '49:60123.F           VIOLATION OF SAFETY STANDARDS AND WA...',
  '49:60123.M': '49:60123.M           VIOLATION OF SAFETY STANDARDS AND WA...',
  '49:80116.F': '49:80116.F           FRAUD-BILLS OF LADING-CRIMINAL PENALTY',
  '49:917A.P': '49:917A.P            UNLAWFUL ACTS AND PENALTIES',
  '49:917B.P': '49:917B.P            UNLAWFUL ACTS AND PENALTIES: GIVING ...',
  '49:917C.P': '49:917C.P            ACCEPTING REBATES, FALSE BILLING, ETC.',
  '49:917D.P': '49:917D.P            WILLFUL FAILURE OR REFUSAL TO MAKE R...',
  '49:917E.P': '49:917E.P            DIVULGING INFORMATION BY AGENT OF CO...',
  '49:917F.P': '49:917F.P            DISCLOSURE OF INFORMATION BY COMMON ...',
  '49A:1159.P': '49A:1159.P           WILLFUL VIOLATION OF RULES OR REGULA...',
  '49A:120.F': '49A:120.F            ISSUANCE OF CERTIFICATE - UNLAWFUL E...',
  '49A:121.F': '49A:121.F            FALSIFYING BILLS OF LADING',
  '49A:1472A.F': '49A:1472A.F          FORGE, COUNTERFEIT OR POSSESS FALSE ...',
  '49A:1472A.P': '49A:1472A.P          FORGE, COUNTERFEIT OR POSSESS FALSE ...',
  '49A:1472B.F': '49A:1472B.F          FORGERY OF CERTIFICATE, FALSE MARKIN...',
  '49A:1472B=CA.F': '49A:1472B=CA.F       CONTROLLED SUBSTANCES ABOARD AIRCRAFT',
  '49A:1472C.F': '49A:1472C.F          INTERFERENCE WITH AIR NAVIGATION',
  '49A:1472D.P': '49A:1472D.P          OFFER, GRANT OR GIVE ANY REBATE OR C...',
  '49A:1472E.P': '49A:1472E.P          FAILURE TO FILE REPORTS',
  '49A:1472F.F': '49A:1472F.F          DIVULGING INFORMATION',
  '49A:1472G.M': '49A:1472G.M          REFUSAL TO TESTIFY',
  '49A:1472H.F': '49A:1472H.F          SHIPPING HAZARDOUS MATERIAL',
  '49A:1472I.F': '49A:1472I.F          RAPE ON BOARD VESSEL',
  '49A:1472J.F': '49A:1472J.F          INTERFERENCE WITH FLIGHT CREW MEMBER',
  '49A:1472K.F': '49A:1472K.F          ASSAULT WITH INTENT TO MURDER',
  '49A:1472K.M': '49A:1472K.M          STEAL PERSONAL PROPERTY ON BOARD VESSEL',
  '49A:1472K.P': '49A:1472K.P          ASSAULT BY STRIKING, BEATING OR WOUN...',
  '49A:1472L.F': '49A:1472L.F          ASSAULT WITH INTENT TO COMMIT MURDER',
  '49A:1472M.M': '49A:1472M.M          FALSE INFORMATION AND THREATS',
  '49A:1472M.P': '49A:1472M.P          SOLICITING REFUND OF ANY RATE, FARE ...',
  '49A:1472O.M': '49A:1472O.M          INTERFERENCE WITH AIRCRAFT ACCIDENT ...',
  '49A:1472P.M': '49A:1472P.M          INTERFERENCE WITH AIRCRAFT ACCIDENT ...',
  '49A:1472Q.F': '49A:1472Q.F          TRANSPORTATION OF DRUGS BY AIRCRAFT',
  '49A:1523.M': '49A:1523.M           SECURITY PROVISION - PENALTIES',
  '49A:1804.F': '49A:1804.F           REGULATIONS GOVERNING TRANSPORT OF H...',
  '49A:1805.F': '49A:1805.F           HANDLING OF HAZARDOUS MATERIALS',
  '49A:1809.F': '49A:1809.F           VIOLATING PROVISIONS OR REGULATIONS ...',
  '4:3.P': '4:3.P                MUTILATION OF FLAG',
  '50:1436B.P': '50:1436B.P           REPORTING REQUIREMENTS',
  '50:1436E.P': '50:1436E.P           TERMINATION OF EMPLOYMENT: FILING RE...',
  '50:1436G.P': '50:1436G.P           PENALTIES FOR FAILURE TO COMPLY WITH...',
  '50:167.F': '50:167.F             HELIUM GAS',
  '50:1702.F': '50:1702.F            PRESIDENTIAL AUTHORITIES',
  '50:1705.F': '50:1705.F            PENALTIES, VIOLATES ANY LICENSE OR O...',
  '50:1809A.F': '50:1809A.F           ENGAGE IN ELECTRONIC SURVEILLANCE',
  '50:1809C.F': '50:1809C.F           PENALTIES',
  '50:192.F': '50:192.F             FAIL, OBSTRUCT OR INTERFERE WITH RUL...',
  '50:210.F': '50:210.F             PENALTIES FOR UNAUTHORIZED TRADING',
  '50:217.F': '50:217.F             TRADING IN CAPTURED OR ABANDONED PRO...',
  '50:421A.F': '50:421A.F            PROTECTION OF NATIONAL SECURITY INFO...',
  '50:421B.F': '50:421B.F            PROTECTION OF NATIONAL SECURITY INFO...',
  '50:421C.F': '50:421C.F            PROTECTION OF NATIONAL SECURITY INFO...',
  '50:783A.F': '50:783A.F            COMMUNICATION OF CLASSIFIED INFORMAT...',
  '50:783B.F': '50:783B.F            COMMUNICATION OF CLASSIFIED INFORMAT...',
  '50:783C.F': '50:783C.F            RECEIPT OF, OR ATTEMPT TO RECEIVE BY...',
  '50:783D.F': '50:783D.F            INTERNAL SECURITY: PENALTIES FOR VIO...',
  '50:784.F': '50:784.F             FAILURE TO DISCLOSE MEMBERSHIP IN CO...',
  '50:789.F': '50:789.F             USE OF MAILS AND INSTRUMENT OF INTER...',
  '50:789.M': '50:789.M             USE OF MAILS AND INSTRUMENT OF INTER...',
  '50:794.F': '50:794.F             PENALTIES',
  '50:794.M': '50:794.M             PENALTIES',
  '50:797.M': '50:797.M             SECURITY REGULATIONS AND ORDERS: PEN...',
  '50:822.F': '50:822.F             RESISTING, DISREGARDING OR EVADING A...',
  '50:823.F': '50:823.F             AIDING EVASION OF APPREHENSION, OR E...',
  '50:824.M': '50:824.M             RESISTANCE OF,OR INTERFERENCE WITH B...',
  '50:851.F': '50:851.F             REGISTRATION OF CERTAIN PERSON: FILI...',
  '50:855.F': '50:855.F             VIOLATIONS: SUBCHAPTER V',
  '50A:1152.M': '50A:1152.M           PENALTIES FOR VIOLATIONS - NATIONAL ...',
  '50A:1193.F': '50A:1193.F           PENALTIES - FAILURE TO FURNISH INFO....',
  '50A:16.F': '50A:16.F             PENALTIES - TRADING WITH THE ENEMY',
  '50A:1985.M': '50A:1985.M           PENALTIES - OVERCHARGE ATTORNEY FEES',
  '50A:2.F': '50A:2.F              TRADING WITH THE ENEMY ACT',
  '50A:2061.M': '50A:2061.M           PENALTIES - CRIMINAL VIOLATIONS',
  '50A:2062.M': '50A:2062.M           PENALTIES - CRIMINAL VIOLATIONS',
  '50A:2071A.M': '50A:2071A.M          ALLOCATION OF MATERIAL AND FACILITIE...',
  '50A:2071B.M': '50A:2071B.M          CRITICAL AND STRATEGIC MATERIALS - N...',
  '50A:2072.M': '50A:2072.M           HOARDING DESIGNATED MATERIALS - NATI...',
  '50A:2073.M': '50A:2073.M           PENALTIES - VIOLATION OF EXPORT CONT...',
  '50A:2213.M': '50A:2213.M           FRAUD - ACCEPTANCE OF BENEFITS',
  '50A:2405A.F': '50A:2405A.F          VIOLATING EXPORT REGULATIONS - 2ND O...',
  '50A:2405A.M': '50A:2405A.M          VIOLATING EXPORT REGULATIONS - 1ST O...',
  '50A:2405B.F': '50A:2405B.F          EXPORT TO COMMUNIST DOMINATED NATIONS',
  '50A:2410A.F': '50A:2410A.F          PENALTIES - EXPORTATION OF WAR MATER...',
  '50A:2410B.F': '50A:2410B.F          PENALTIES - EXPORTATION OF WAR MATER...',
  '50A:2410B.M': '50A:2410B.M          PENALTIES - EXPORTATION OF WAR MATER...',
  '50A:321.F': '50A:321.F            PENALTIES - VIOLATION OF SELECTIVE S...',
  '50A:322.F': '50A:322.F            SELECTIVE SERVICE FUNCTIONS, DUTIES,...',
  '50A:323.F': '50A:323.F            SELECTIVE SERVICE TRANSFER OF FUNDS/...',
  '50A:324.F': '50A:324.F            SELECTIVE SERVICE TRANSFER OF PROPER...',
  '50A:325.F': '50A:325.F            SELECTIVE SERVICE TRANSFER OF FUNCTI...',
  '50A:326.F': '50A:326.F            SELECTIVE SERVICE POWERS AND DUTIES ...',
  '50A:327.F': '50A:327.F            SELECTIVE SERVICE UNLAWFUL USE OF CO...',
  '50A:328.F': '50A:328.F            SELECTIVE SERVICE SUSPENSION OF CONF...',
  '50A:329.F': '50A:329.F            SELECTIVE SERVICE EFFECTIVE DATE',
  '50A:3A.F': '50A:3A.F             TRADING WITH THE ENEMY ACT',
  '50A:3B.F': '50A:3B.F             TRANSPORTING AN ENEMY INTO OR OUT OF...',
  '50A:3C.F': '50A:3C.F             COMMUNICATE WITH THE ENEMY',
  '50A:462.F': '50A:462.F            EVADE THE SELECTIVE SERVICE',
  '50A:468A.F': '50A:468A.F           PLACEMENT OF ORDERS',
  '50A:468B.F': '50A:468B.F           SELECTIVE SERVICE PRECEDENCE OF GOVE...',
  '50A:468F.F': '50A:468F.F           SELECTIVE SERVICE PENALTIES',
  '50A:531.M': '50A:531.M            WAR AND NATIONAL DEFENSE, OTHER',
  '50A:532.M': '50A:532.M            FEDERAL STATUTES - MORTGAGES, TRUST ...',
  '50A:643A.F': '50A:643A.F           NATIONAL DEFENSE, OTHER',
  '50A:643B.M': '50A:643B.M           CONTEMPT - REFUSAL TO GIVE EVIDENCE',
  '50A:781.M': '50A:781.M            ILLEGAL KNOWLEDGE OF MILITARY INSTAL...',
  '50A:783.M': '50A:783.M            NATIONAL DEFENSE, OTHER',
  '5:552.F': '5:552.F              PUBLIC INFORMATION',
  '5:552.M': '5:552.M              OBTAINS/REQUESTS INDIVIDUAL RECORDS ...',
  '7:12.M': '7:12.M               TRADING BAN VIOLATIONS',
  '7:136.F': '7:136.F              UNLAWFUL USE OF INSECTICIDES, PENALTIES',
  '7:136.M': '7:136.M              UNLAWFUL USE OF INSECTICIDES, PENALTIES',
  '7:136.P': '7:136.P              UNLAWFUL USE OF INSECTICIDES, PENALTIES',
  '7:1373.P': '7:1373.P             REPORTS AND RECORDS',
  '7:1379B.P': '7:1379B.P            WHEAT MARKET ALLOCATIONS',
  '7:1379C.P': '7:1379C.P            MARKETING CERTIFICATES',
  '7:1379D.P': '7:1379D.P            TRANSFER OF CERTIFICATES, RESTRICTIONS',
  '7:1379E.P': '7:1379E.P            PURCHASE/SALE OF MARKET CERTIFICATES',
  '7:1379F.P': '7:1379F.P            CONVERSION FACTORS',
  '7:1379G.P': '7:1379G.P            AUTHORITY TO FACILITATE TRANSITION',
  '7:1379H.P': '7:1379H.P            APPLICABILITY OF PROVISIONS',
  '7:1379I.F': '7:1379I.F            AGRICULTURE, PENALTIES',
  '7:1379I.P': '7:1379I.P            AGRICULTURE, PENALTIES',
  '7:1379J.P': '7:1379J.P            REGULATIONS',
  '7:1380.P': '7:1380.P             REPORTS AND RECORDS, RICE CERTIFICATES',
  '7:13A.F': '7:13A.F              EMBEZZLEMENT OR LARCENY, EMPLOYEES O...',
  '7:13B.F': '7:13B.F              PRICE MANIPULATION CONCERNING COMMUN...',
  '7:13C.F': '7:13C.F              FALSE CLAIMS AND STATEMENTS',
  '7:1433.M': '7:1433.M             MISUSE OF DESIGNATED FOOD',
  '7:150B.M': '7:150B.M             PLANT QUARANTINE - PERMITS FOR MOVEM...',
  '7:150C.M': '7:150C.M             PLANT QUARANTINE - UNLAWFUL MAILING ...',
  '7:150D.M': '7:150D.M             PLANT QUARANTINE - DISPOSAL',
  '7:150E.M': '7:150E.M             PLANT QUARANTINE - REGULATIONS AND C...',
  '7:150G.M': '7:150G.M             PLANT QUARANTINE - PLANT PESTS',
  '7:154.M': '7:154.M              PLANT QUARANTINE - RESTRICT PLANT IM...',
  '7:156.M': '7:156.M              PLANT QUARANTINE - SHIPPING WITHOUT ...',
  '7:157.M': '7:157.M              PLANT QUARANTINE - INCORRECT MARKING...',
  '7:158.M': '7:158.M              PLANT QUARANTINE - INCORRECT MARKING...',
  '7:1596.P': '7:1596.P             FOREIGN COMMERCE REGULATIONS',
  '7:161.M': '7:161.M              INTERSTATE QUARANTINE',
  '7:162.M': '7:162.M              PLANT QUARANTINE - RULES AND REGULAT...',
  '7:1622.M': '7:1622.M             INSPECTION OF AGRICULTURAL PRODUCTS',
  '7:163.M': '7:163.M              FORGERY, ALTERATION OF CERTIFICATES',
  '7:1642A.P': '7:1642A.P            RULES AND REGULATIONS',
  '7:1642B.P': '7:1642B.P            REPORTS AND EXAMINATIONS OF BOOKS',
  '7:1642C.P': '7:1642C.P            PENALTIES FOR VIOLATIONS',
  '7:166.P': '7:166.P              STATE INSPECTION',
  '7:195.F': '7:195.F              VIOLATIONS OF ORDERS',
  '7:2023B.F': '7:2023B.F            FOOD STAMPS, UNAUTHORIZED USE BY RET...',
  '7:2023B.M': '7:2023B.M            FOOD STAMPS, UNAUTHORIZED USE BY RET...',
  '7:2024B.F': '7:2024B.F            TRANSFER OR UNAUTHORIZED USE OF FOOD...',
  '7:2024B.M': '7:2024B.M            TRANSFER OR UNAUTHORIZED USE OF FOOD...',
  '7:2024C.F': '7:2024C.F            REDEMPTION OF ILLEGALLY RECEIVED FOO...',
  '7:2024C.M': '7:2024C.M            REDEMPTION OF ILLEGALLY RECEIVED FOO...',
  '7:2024H.F': '7:2024H.F            CRIMINAL FORFEITURE',
  '7:203.P': '7:203.P              FAILURE TO REGISTER',
  '7:207A.M': '7:207A.M             SCHEDULE OF RATES, FILING: PUBLIC IN...',
  '7:207B.M': '7:207B.M             DETAILS REQUIREMENTS: FORMS',
  '7:207C.M': '7:207C.M             CHANGES TO REQUIREMENTS',
  '7:207D.M': '7:207D.M             REJECTION OF PERMITS BY SECRETARY',
  '7:207E.M': '7:207E.M             DETERMINATION OF LAWFULNESS',
  '7:207F.M': '7:207F.M             SUSPENSION OF OPERATIONS',
  '7:207G.P': '7:207G.P             PENALTIES',
  '7:207H.M': '7:207H.M             INTENTIONAL VIOLATIONS, PENALTIES',
  '7:2105.M': '7:2105.M             COTTON RESEARCH AND PROMOTION',
  '7:211.P': '7:211.P              CHARGES OR PRACTICES, RATES',
  '7:212.P': '7:212.P              RATES AND PRACTICES TO PREVENT DISCR...',
  '7:213.P': '7:213.P              PREVENT UNFAIR DISCRIMINATION PRACTICES',
  '7:2133.M': '7:2133.M             DEALERS AND EXHIBITORS LICENSING',
  '7:2134.M': '7:2134.M             DEALERS AND EXHIBITORS VALID LICENSE',
  '7:2135.M': '7:2135.M             TIME PERIOD, DISPOSAL OF PETS BY DEA...',
  '7:2136.M': '7:2136.M             REGISTRATION OF RESEARCH FACILITY AN...',
  '7:2137.M': '7:2137.M             PROHIBITED PURCHASE OF PETS BY RESEA...',
  '7:2138.M': '7:2138.M             PROHIBITED PURCHASE OF PETS BY GOVER...',
  '7:2141.M': '7:2141.M             MARKING AND IDENTIFICATION OF ANIMALS',
  '7:2142.M': '7:2142.M             HUMANE STANDARDS, RECORDKEEPING REQU...',
  '7:2143.M': '7:2143.M             HUMANE STANDARDS FOR ANIMALS, DEALER...',
  '7:2144.M': '7:2144.M             HUMANE STANDARDS FOR ANIMALS U.S. GO...',
  '7:2146.F': '7:2146.F             ADMINISTRATION AND ENFORCEMENT BY SE...',
  '7:2149C.M': '7:2149C.M            VIOLATIONS, AUCTION SALES OF ANIMALS',
  '7:215.P': '7:215.P              FAILURE TO OBEY ORDERS, PUNISHMENT',
  '7:2151.M': '7:2151.M             RULES AND REGULATIONS',
  '7:2156.F': '7:2156.F             ANIMAL FIGHTING VENTURE PROHIBITION',
  '7:2156.M': '7:2156.M             TRANSPORTING ANIMALS FOR FIGHTING VE...',
  '7:221.F': '7:221.F              PUNISHMENT FOR, FAILURE TO KEEP ACCO...',
  '7:2621.P': '7:2621.P             POTATO RESEARCH AND PROMOTION, PENAL...',
  '7:270.F': '7:270.F              FRAUD, WAREHOUSES, PUNISHMENT FOR VI...',
  '7:270.P': '7:270.P              FRAUD, WAREHOUSES, PUNISHMENT FOR VI...',
  '7:2803.M': '7:2803.M             MOVING NOXIOUS WEEDS INTO/THROUGH U.S.',
  '7:2804.M': '7:2804.M             PLANT QUARANTINE',
  '7:2807.M': '7:2807.M             PENALTIES - NOXIOUS WEEDS',
  '7:2809.M': '7:2809.M             REGULATIONS',
  '7:281.M': '7:281.M              IMPORT PROHIBITED HONEYBEES',
  '7:282.M': '7:282.M              PENALTIES - UNLAWFUL IMPORTING HONEY...',
  '7:3410.M': '7:3410.M             ENFORCEMENT OF ORDERS AND REGULATIONS',
  '7:3803.M': '7:3803.M             HEALTH, FEEDING SWINE GARBAGE',
  '7:3806.M': '7:3806.M             PENALTIES',
  '7:472.M': '7:472.M              PENALTIES FOR DIVULGING INFORMATION',
  '7:472.P': '7:472.P              PENALTIES FOR DIVULGING INFORMATION',
  '7:473.M': '7:473.M              COTTON WAREHOUSES, FAILURE TO FURNIS...',
  '7:473.P': '7:473.P              COTTON WAREHOUSES, FAILURE TO FURNIS...',
  '7:491.M': '7:491.M              FRAUD - DESTROY INTERSTATE PRODUCE',
  '7:491.P': '7:491.P              FRAUD - DESTROY INTERSTATE PRODUCE',
  '7:499C.P': '7:499C.P             INSPECT PERISHABLE COMMODITIES, LICE...',
  '7:499N.M': '7:499N.M             INSPECT PERISHABLE COMMODITIES, EMPL...',
  '7:503.M': '7:503.M              TOBACCO STATISTICS, QUALITY REPORTS',
  '7:503.P': '7:503.P              TOBACCO STATISTICS, QUALITY REPORTS',
  '7:511D.M': '7:511D.M             DESIGNATION OF MARKETS',
  '7:511I.M': '7:511I.M             TOBACCO OFFENSES',
  '7:511K.M': '7:511K.M             TOBACCO, PENALTY FOR VIOLATIONS',
  '7:52.P': '7:52.P               PROHIBITED USE OF STANDARDS, NON-OFF...',
  '7:586.M': '7:586.M              VIOLATIONS AND PENALTIES, APPLES AND...',
  '7:586.P': '7:586.P              VIOLATIONS AND PENALTIES, APPLES AND...',
  '7:59.P': '7:59.P               COTTON STANDARDS, OFFENSES',
  '7:596.M': '7:596.M              VIOLATIONS AND PENALTIES, GRAPES AND...',
  '7:596.P': '7:596.P              VIOLATIONS AND PENALTIES, GRAPES AND...',
  '7:6.F': '7:6.F                RESTRICTION OF FUTURES TRADING TO CO...',
  '7:6.M': '7:6.M                PROHIBITIONS IN COMMODITIES, FUTURES',
  '7:60.P': '7:60.P               PENALTIES FOR VIOLATIONS',
  '7:608A.P': '7:608A.P             SUGAR QUOTAS',
  '7:608C.P': '7:608C.P             COMMODITY HANDLING REGULATIONS',
  '7:612C.F': '7:612C.F             EXPORT AND DOMESTIC USE OF AGRICULTU...',
  '7:612C.M': '7:612C.M             EXPORT AND DOMESTIC USE OF AGRICULTU...',
  '7:615B.M': '7:615B.M             AGRICULTURAL ADJUSTMENT - REFUND OF TAX',
  '7:620A.P': '7:620A.P             FALSE DEDUCTIONS, CHARGES TO TAXES',
  '7:620B.P': '7:620B.P             FALSE DEDUCTIONS, CHARGES TO TAXES',
  '7:620C.P': '7:620C.P             FALSE DEDUCTIONS, CHARGES TO TAXES',
  '7:6E.M': '7:6E.M               FLOOR BROKERS, PROHIBITIONS',
  '7:6H.M': '7:6H.M               MARKET DEALINGS, PROHIBITIONS',
  '7:6I.M': '7:6I.M               REPORTS OF DEALS, TRADING LIMITS',
  '7:7711.F': '7:7711.F             PLANT PROTECTION',
  '7:7734.F': '7:7734.F             PLANT PROTECTION-VIOLATIONS',
  '7:87B.F': '7:87B.F              GRAIN SHIPMENTS, PROHIBITED ACTS',
  '7:87B.M': '7:87B.M              GRAIN SHIPMENTS, PROHIBITED ACTS',
  '7:87C.F': '7:87C.F              GRAIN STANDARDS - 2ND OFFENSE',
  '7:87C.M': '7:87C.M              GRAIN STANDARDS - 1ST OFFENSE',
  '7:95.M': '7:95.M               INJURIOUS ACTS',
  '7:953.M': '7:953.M              PENALTIES - REPORTS',
  '7:96.M': '7:96.M               PUNISHMENT FOR PROHIBITION VIOLATIONS',
  8764455: '8764455              second test citation for ~COUNT',
  882233: '882233               first test citation for ~COUNT',
  '8:1160.F': '8:1160.F             FALSIFY DOCUMENTS FOR AGRICULTURE WO...',
  '8:1185.F': '8:1185.F             TRAVEL CONTROL OF CITIZENS AND ALIENS',
  '8:1252D.M': '8:1252D.M            SUPERVISION OF DEPORTABLE ALIEN - VI...',
  '8:1252E.F': '8:1252E.F            WILLFUL FAILURE TO DEPART',
  '8:1253.F': '8:1253.F             FAILURE TO DEPART',
  '8:1253.M': '8:1253.M             FAILURE TO DEPART',
  '8:1255.F': '8:1255.F             ADJUSTMENT OF CITIZENSHIP STATUS',
  '8:1282.P': '8:1282.P             CONDITIONAL PERMITS TO LAND TEMPORARILY',
  '8:1282A.P': '8:1282A.P            PERIOD OF TIME FOR CONDITIONAL PERMITS',
  '8:1282C.P': '8:1282C.P            CONDITIONAL PERMITS, PENALTIES',
  '8:1286.P': '8:1286.P             DISCHARGING ALIEN CREWMEN',
  '8:1287.P': '8:1287.P             ALIEN CREWMEN IN U.S. TO EVADE IMMIG...',
  '8:1304.P': '8:1304.P             CERTIFICATE OF ALIEN REGISTRATION',
  '8:1304D.P': '8:1304D.P            CERTIFICATE OF REGISTRATION FOR ALIENS',
  '8:1304E.P': '8:1304E.P            PERSONAL POSSESSION OF REGISTRATION ...',
  '8:1306A.P': '8:1306A.P            WILLFUL FAILURE TO REGISTER',
  '8:1306B.P': '8:1306B.P            FAILURE TO NOTIFY OF CHANGE OF ADDRESS',
  '8:1306C.P': '8:1306C.P            FRAUDULENT STATEMENTS',
  '8:1306D.F': '8:1306D.F            COUNTERFEITING',
  '8:1321.P': '8:1321.P             UNAUTHORIZED LANDING OF ALIENS, PREV...',
  '8:1324.F': '8:1324.F             BRINGING IN AND HARBORING ALIENS',
  '8:1324.M': '8:1324.M             BRINGING IN AND HARBORING ALIENS',
  '8:1325.F': '8:1325.F             ILLEGAL ENTRY, CONCEALMENT OF FACTS',
  '8:1325.P': '8:1325.P             CONCEALMENT OF FACTS ABOUT REENTRY',
  '8:1326A.F': '8:1326A.F            REENTRY OF DEPORTED ALIENS',
  '8:1326B.F': '8:1326B.F            REENTRY OF DEPORTED ALIEN - FELONY',
  '8:1327.F': '8:1327.F             AIDING OR ASSISTING CERTAIN ALIENS T...',
  '8:1328.F': '8:1328.F             IMPORTATION OF ALIEN FOR IMMORAL PUR...',
  '8:1357.F': '8:1357.F             POWERS OF IMMIGRATION OF OFFICERS AN...',
  '99:42.M': '99:42.M              Contempt',
  A1: 'A1                   7',
  REPEAL1: 'REPEAL1              2:242.F - FEDERAL STATUTES - POLITIC...',
  REPEAL10: 'REPEAL10             2:247.F - FEDERAL STATUTES - STATEME...',
  REPEAL100: 'REPEAL100            16:991.M NORTHWEST ATLANTIC FISHERIES',
  REPEAL101: 'REPEAL101            16:1029.M NORTH PACIFIC FISHERIES',
  REPEAL102: 'REPEAL102            16:1029A.M NORTH PACIFIC FISHERIES',
  REPEAL103: 'REPEAL103            16:1029B.M NORTH PACIFIC FISHERIES',
  REPEAL104: 'REPEAL104            16:1029C.M NORTH PACIFIC FISHERIES',
  REPEAL105: 'REPEAL105            16:1029D.M NORTH PACIFIC FISHERIES',
  REPEAL106: 'REPEAL106            16:1029E.M NORTH PACIFIC FISHERIES',
  REPEAL107: 'REPEAL107            16:1029F.M NORTH PACIFIC FISHERIES',
  REPEAL108: 'REPEAL108            16:1030A.M NORTH PACIFIC FISHERIES',
  REPEAL109: 'REPEAL109            16:1030B.M NORTH PACIFIC FISHERIES',
  REPEAL11: 'REPEAL11             2:247.M - FEDERAL STATUTES - STATEME...',
  REPEAL110: 'REPEAL110            16:1030C.M NORTH PACIFIC FISHERIES',
  REPEAL111: 'REPEAL111            16:1081.M FOREIGN FISHING VESSELS',
  REPEAL112: 'REPEAL112            16:1082.M FOREIGN FISHING VESSELS',
  REPEAL113: 'REPEAL113            16:1183.M REGULATIONS',
  REPEAL114: 'REPEAL114            16:1184.M PROHIBITIONS: EVIDENCE',
  REPEAL115: 'REPEAL115            18:44.P MARKING PACKAGE OR CONTAINERS',
  REPEAL116: 'REPEAL116            18:45.P CAPTURING OR KILLING CARRIER...',
  REPEAL117: 'REPEAL117            18:608.F LIMIT ON CONTRIBUTIONS AND ...',
  REPEAL118: 'REPEAL118            18:608.M LIMIT ON CONTRIBUTIONS AND ...',
  REPEAL119: 'REPEAL119            18:610.F CONTRIBUTIONS BY NATIONAL B...',
  REPEAL12: 'REPEAL12             2:248.F - FEDERAL STATUTES - EXPENDI...',
  REPEAL120: 'REPEAL120            18:610.M CONTRIBUTIONS BY NATIONAL B...',
  REPEAL121: 'REPEAL121            18:611.F ELECTION LAW VIOLATORS',
  REPEAL122: 'REPEAL122            18:611.M DEPRIVE EMPLOYMENT/OTHER BE...',
  REPEAL123: 'REPEAL123            18:612.M PUBLISH OR DISTRIBUTE POLIT...',
  REPEAL124: 'REPEAL124            18:613.F CONTRIBUTION BY AGENT OF FO...',
  REPEAL125: 'REPEAL125            18:613.M CONTRIBUTION BY AGENT OF FO...',
  REPEAL126: 'REPEAL126            18:614.M PROHIBIT CONTRIBUTIONS IN N...',
  REPEAL127: 'REPEAL127            18:615.M LIMIT ON CONTRIBUTIONS OF C...',
  REPEAL128: 'REPEAL128            18:616.M ACCEPTANCE OF EXCESSIVE HON...',
  REPEAL129: 'REPEAL129            18:617.M FRAUD/MISREPRESENTATION OF ...',
  REPEAL13: 'REPEAL13             2:248.M - FEDERAL STATUTES - EXPENDI...',
  REPEAL130: 'REPEAL130            18:714.P JOHNNY HORIZON CHARACTER OR...',
  REPEAL131: 'REPEAL131            18:832.F TRANSPORT OF EXPLOSIVES, RA...',
  REPEAL132: 'REPEAL132            18:832.M TRANSPORT OF EXPLOSIVES, RA...',
  REPEAL133: 'REPEAL133            18:833.F MARKING PACKAGES CONTAINING...',
  REPEAL134: 'REPEAL134            18:833.M MARKING PACKAGES CONTAINING...',
  REPEAL135: 'REPEAL135            18:834.F EXPLOSIVES  (T)',
  REPEAL136: 'REPEAL136            18:834.M REGULATIONS BY ICC',
  REPEAL137: 'REPEAL137            18:969.P EXPORT ARMS, LIQUORS AND NA...',
  REPEAL138: 'REPEAL138            18:1008.F FEDERAL SAVINGS AND LOAN I...',
  REPEAL139: 'REPEAL139            18:1009.M RUMORS REGARDING FED. SAVI...',
  REPEAL14: 'REPEAL14             2:252.F - FEDERAL STATUTES - PENALTIES',
  REPEAL141: 'REPEAL141            18:1383.M RESTRICTIONS IN MILITARY A...',
  REPEAL142: 'REPEAL142            18:1714.M FOREIGN DIVORCE INFO AS NO...',
  REPEAL143: 'REPEAL143            18:1718.M LIBELOUS MATTER ON WRAPPER...',
  REPEAL144: 'REPEAL144            18:1844A.F MAIL FRAUD',
  REPEAL145: 'REPEAL145            18:1862.P TRESPASS ON BULL RUN NATIO...',
  REPEAL146: 'REPEAL146            18:1964.F NATIONAL PARK/RECREATION V...',
  REPEAL147: 'REPEAL147            18:2198.M SEDUCTION OF FEMALE PASSENGER',
  REPEAL148: 'REPEAL148            18:3150.F PENALTIES FOR FAILURE TO A...',
  REPEAL149: 'REPEAL149            18:3150.M PENALTIES FOR FAILURE TO A...',
  REPEAL15: 'REPEAL15             2:252.M - FEDERAL STATUTES - PENALTIES',
  REPEAL150: 'REPEAL150            18A:1202A.F ARMED CAREER CRIMINAL  (T)',
  REPEAL151: 'REPEAL151            18A:1202B.F RECEIVE/POSSESS/TRANSPOR...',
  REPEAL152: 'REPEAL152            21 :171.F IMPORTATION AND EXPORT - 2...',
  REPEAL153: 'REPEAL153            21 :172.F IMPORTATION AND EXPORT - 2...',
  REPEAL154: 'REPEAL154            21 :173.F IMPORTATION AND EXPORT - 2...',
  REPEAL155: 'REPEAL155            21 :174.F IMPORTATION AND EXPORT - 2...',
  REPEAL156: 'REPEAL156            21 :175.F IMPORTATION AND EXPORT - 2...',
  REPEAL157: 'REPEAL157            21 :176.F IMPORTATION AND EXPORT - 2...',
  REPEAL158: 'REPEAL158            21 :176A.F IMPORTATION AND EXPORT - ...',
  REPEAL159: 'REPEAL159            21:845 MOVED TO 21:859',
  REPEAL16: 'REPEAL16             2:434D.M CONGRESSIONAL REPORTING EXE...',
  REPEAL160: 'REPEAL160            21:845 MOVED TO 21:859',
  REPEAL161: 'REPEAL161            21:845 MOVED TO 21:859',
  REPEAL162: 'REPEAL162            21:845 MOVED TO 21:859',
  REPEAL163: 'REPEAL163            21:845 MOVED TO 21:859',
  REPEAL164: 'REPEAL164            21:845 MOVED TO 21:859',
  REPEAL165: 'REPEAL165            21:845 MOVED TO 21:859',
  REPEAL166: 'REPEAL166            21:845 MOVED TO 21:859',
  REPEAL167: 'REPEAL167            21:845 MOVED TO 21:859',
  REPEAL168: 'REPEAL168            21:845 MOVED TO 21:859',
  REPEAL169: 'REPEAL169            21:845 MOVED TO 21:859',
  REPEAL17: 'REPEAL17             2:434E.M REPORTS, OTHER THAN POLITIC...',
  REPEAL170: 'REPEAL170            21:845 MOVED TO 21:859',
  REPEAL171: 'REPEAL171            21:845 MOVED TO 21:859',
  REPEAL172: 'REPEAL172            21:845 MOVED TO 21:859',
  REPEAL173: 'REPEAL173            21:845 MOVED TO 21:859',
  REPEAL174: 'REPEAL174            21:845 MOVED TO 21:859',
  REPEAL175: 'REPEAL175            21:845 MOVED TO 21:859',
  REPEAL176: 'REPEAL176            21:845 MOVED TO 21:859',
  REPEAL177: 'REPEAL177            21:845 MOVED TO 21:859',
  REPEAL178: 'REPEAL178            21:859=CO.F CONTROLLED SUBSTANCE - P...',
  REPEAL179: 'REPEAL179            21:955=MP.F TRANSFERRED TO 46 APPEND...',
  REPEAL18: 'REPEAL18             2:435A.M EL -  CHARGES FOR ADVERTISING',
  REPEAL180: 'REPEAL180            21:955=NP.F TRANSFERRED TO 46 APPEND...',
  REPEAL181: 'REPEAL181            21:955A=CD.F TRANSFERRED TO 46 APPEN...',
  REPEAL182: 'REPEAL182            21:955A=CI.F TRANSFERRED TO 46 APPEN...',
  REPEAL183: 'REPEAL183            21:955A=CM.F TRANSFERRED TO 46 APPEN...',
  REPEAL184: 'REPEAL184            21:955A=MD.F TRANSFERRED TO 46 APPEN...',
  REPEAL185: 'REPEAL185            21:955A=MI.F TRANSFERRED TO 46 APPEN...',
  REPEAL186: 'REPEAL186            21:955A=MM.F TRANSFERRED TO 46 APPEN...',
  REPEAL187: 'REPEAL187            21:955A=ND.F TRANSFERRED TO 46 APPEN...',
  REPEAL188: 'REPEAL188            21:955A=NI.F TRANSFERRED TO 46 APPEN...',
  REPEAL189: 'REPEAL189            21:955A=NM.F TRANSFERRED TO 46 APPEN...',
  REPEAL19: 'REPEAL19             2:435B.M EL -  FUND SOLICITATION',
  REPEAL190: 'REPEAL190            21:955C=CD.F TRANSFERRED TO 46 APPEN...',
  REPEAL191: 'REPEAL191            21:955C=CI.F TRANSFERRED TO 46 APPEN...',
  REPEAL192: 'REPEAL192            21:955C=CM.F TRANSFERRED TO 46 APPEN...',
  REPEAL193: 'REPEAL193            21:955C=MD.F TRANSFERRED TO 46 APPEN...',
  REPEAL194: 'REPEAL194            21:955C=MI.F TRANSFERRED TO 46 APPEN...',
  REPEAL195: 'REPEAL195            21:955C=MM.F TRANSFERRED TO 46 APPEN...',
  REPEAL196: 'REPEAL196            21:955C=ND.F TRANSFERRED TO 46 APPEN...',
  REPEAL197: 'REPEAL197            21:955C=NI.F TRANSFERRED TO 46 APPEN...',
  REPEAL198: 'REPEAL198            21:955C=NM.F TRANSFERRED TO 46 APPEN...',
  REPEAL199: 'REPEAL199            22:286.P DEFACING CEMETERIES',
  REPEAL2: 'REPEAL2              2:243.F - FEDERAL STATUTES - CONTRIB...',
  REPEAL20: 'REPEAL20             2:436A.M EL -  PRESERVING COPIES',
  REPEAL200: 'REPEAL200            22:1934.F REGISTRATION OF EXPORT AND...',
  REPEAL201: 'REPEAL201            22:1934B.F REGISTRATION OF EXPORT AN...',
  REPEAL202: 'REPEAL202            22:1934C.F REGISTRATION OF EXPORT AN...',
  REPEAL203: 'REPEAL203            22:2778.F REGISTRATION AND LICENSING',
  REPEAL204: 'REPEAL204            22D:103-4993.M ATTEMPTS TO COMMIT CRIME',
  REPEAL205: 'REPEAL205            22D:701.F OBSTRUCTING JUSTICE - BRIB...',
  REPEAL206: 'REPEAL206            22D:703.F OBSTRUCTING JUSTICE - BRIB...',
  REPEAL207: 'REPEAL207            22D:704.F OBSTRUCTING JUSTICE - BRIB...',
  REPEAL208: 'REPEAL208            22D:713A.F BRIBERY OF WITNESS',
  REPEAL209: 'REPEAL209            22D:901.F MISC. GENERAL OFFENSES, OTHER',
  REPEAL21: 'REPEAL21             2:436B.M EL -  WAIVER OF REPORTING',
  REPEAL210: 'REPEAL210            22D:1202.F EMBEZZLEMENT',
  REPEAL211: 'REPEAL211            22D:1202.M EMBEZZLEMENT',
  REPEAL212: 'REPEAL212            22D:1211.P TAKING PROPERTY W/O RIGHT',
  REPEAL213: 'REPEAL213            22D:1301.F FRAUD',
  REPEAL214: 'REPEAL214            22D:1301.M FRAUD',
  REPEAL215: 'REPEAL215            22D:1301.P FRAUD',
  REPEAL216: 'REPEAL216            22D:1401.F FORGERY, OTHER',
  REPEAL217: 'REPEAL217            22D:2201.F GRAND LARCENY',
  REPEAL218: 'REPEAL218            22D:2202.M PETIT LARCENY',
  REPEAL219: 'REPEAL219            22D:2203.F EMBEZZLEMENT',
  REPEAL22: 'REPEAL22             2:436C.M EL -  DEBTS, PLEDGES, ETC.',
  REPEAL220: 'REPEAL220            22D:2203.M EMBEZZLEMENT',
  REPEAL221: 'REPEAL221            22D:2204.F AUTO THEFT',
  REPEAL222: 'REPEAL222            22D:2205.F AUTO THEFT',
  REPEAL223: 'REPEAL223            22D:2205.M AUTO THEFT',
  REPEAL224: 'REPEAL224            22D:2206.F STEALING D.C. PROPERTY',
  REPEAL225: 'REPEAL225            22D:2207.F STEALING D.C. PROPERTY',
  REPEAL226: 'REPEAL226            22D:2208.F STEALING D.C. PROPERTY',
  REPEAL227: 'REPEAL227            22D:2305.F EXTORTION',
  REPEAL228: 'REPEAL228            22D:2306.F EXTORTION',
  REPEAL229: 'REPEAL229            22D:2501.F PERJURY',
  REPEAL23: 'REPEAL23             2:436D.M EL -  MAILING DATES',
  REPEAL230: 'REPEAL230            22D:2602.M MISPRISION BY OFFICERS/EM...',
  REPEAL231: 'REPEAL231            26:4591.F IMPOSITION OF TAX',
  REPEAL232: 'REPEAL232            26:4591.M IMPOSITION OF TAX',
  REPEAL233: 'REPEAL233            26:4594.F PACKAGES FOR OLEOMARGARINE',
  REPEAL234: 'REPEAL234            26:4594A.F PACKAGES FOR OLEOMARGARINE',
  REPEAL235: 'REPEAL235            26:4594B.F PACKAGES FOR OLEOMARGARINE',
  REPEAL236: 'REPEAL236            26:4594C.F PACKAGES FOR OLEOMARGARINE',
  REPEAL237: 'REPEAL237            26:4597.P WHOLESALE DEALERS IN OLEOM...',
  REPEAL238: 'REPEAL238            26:4704.F NARCOTICS',
  REPEAL239: 'REPEAL239            26:4804.F REQUIREMENTS OF MANUFACTURERS',
  REPEAL24: 'REPEAL24             2:437A.M EL -  CONVENTION FINANCING',
  REPEAL240: 'REPEAL240            26:4804.P REQUIREMENTS OF MANUFACTURERS',
  REPEAL241: 'REPEAL241            26:4804A.F REQUIREMENTS OF MANUFACTU...',
  REPEAL242: 'REPEAL242            26:4804A.P REQUIREMENTS OF MANUFACTU...',
  REPEAL243: 'REPEAL243            26:4804B.P REQUIREMENTS OF MANUFACTU...',
  REPEAL244: 'REPEAL244            26:4805.M REQUIREMENTS OF MANUFACTURERS',
  REPEAL245: 'REPEAL245            26:4814.P SELL ADULTERATED BUTTER',
  REPEAL246: 'REPEAL246            26:4815A.F SELLING REQUIREMENTS',
  REPEAL247: 'REPEAL247            26:4815B.P DEALERS IN ADULTERATED BU...',
  REPEAL248: 'REPEAL248            26:4817.M INSPECTION OF BUTTER',
  REPEAL249: 'REPEAL249            26:4833.M MANUFACTURES LABEL-FILLED ...',
  REPEAL25: 'REPEAL25             2:437B.M EL -  CAMPAIGN DEPOSITORIES',
  REPEAL250: 'REPEAL250            26:4833A.M MANUFACTURES LABEL-FILLED...',
  REPEAL251: 'REPEAL251            26:4833B.M MANUFACTURES LABEL-FILLED...',
  REPEAL252: 'REPEAL252            26:4833C.M MANUFACTURES LABEL-FILLED...',
  REPEAL253: 'REPEAL253            26:4834.P SIGNS FOR DEALERS IN FILLE...',
  REPEAL254: 'REPEAL254            26:4841.P IMPOSITION OF TAX',
  REPEAL255: 'REPEAL255            26:4862.P DETERMINATION OF SPOT MARKETS',
  REPEAL256: 'REPEAL256            26:4918.M SALES MADE BY FIRMS',
  REPEAL257: 'REPEAL257            26:4918E.M SALES MADE BY FIRMS',
  REPEAL258: 'REPEAL258            26:4918H.M SALES MADE BY FIRMS',
  REPEAL259: 'REPEAL259            26:4919.M SALES MADE BY FIRMS',
  REPEAL26: 'REPEAL26             2:437G.M ELECT. LAWS -',
  REPEAL260: 'REPEAL260            26:5205.F DISTILLED SPIRITS',
  REPEAL261: 'REPEAL261            26:5676.F DEVICES AND TRAFFICKING',
  REPEAL262: 'REPEAL262            26:5676.M DEVICES AND TRAFFICKING',
  REPEAL263: 'REPEAL263            26:5676.P DEVICES AND TRAFFICKING',
  REPEAL264: 'REPEAL264            26:5689.F DEVICES AND TRAFFICKING',
  REPEAL265: 'REPEAL265            26:6056.M  REPORT OF PRIVATE FOUNDAT...',
  REPEAL266: 'REPEAL266            26:6420F.M EXAMINATION OF BOOKS',
  REPEAL267: 'REPEAL267            26:6424.M EXAMINATION OF BOOKS',
  REPEAL268: 'REPEAL268            26:7203.M WILLFUL FAILURE TO FILE RE...',
  REPEAL269: 'REPEAL269            26:7206.F DECLARE UNDER PENALTY',
  REPEAL27: 'REPEAL27             2:439B.M  FRANKED SOLICITATIONS',
  REPEAL270: 'REPEAL270            26:7208.F OFFENSES RELATING TO STAMPS',
  REPEAL271: 'REPEAL271            26:7233.F FAILURE TO PAY, ATTEMPT TO...',
  REPEAL272: 'REPEAL272            26:7233.M FAILURE TO PAY, ATTEMPT TO...',
  REPEAL273: 'REPEAL273            26:7233.P FAILURE TO PAY, ATTEMPT TO...',
  REPEAL274: 'REPEAL274            26:7234.F FALSE BRANDING, SELLING, O...',
  REPEAL275: 'REPEAL275            26:7234.M FALSE BRANDING, SELLING, O...',
  REPEAL276: 'REPEAL276            26:7234.P FALSE BRANDING, SELLING, O...',
  REPEAL277: 'REPEAL277            26:7234A.F FALSE BRANDING, SELLING, ...',
  REPEAL278: 'REPEAL278            26:7234B.M FALSE BRANDING, SELLING, ...',
  REPEAL279: 'REPEAL279            26:7234C.P FALSE BRANDING, SELLING, ...',
  REPEAL28: 'REPEAL28             2:441A.M PENALTIES FOR VIOLATIONS',
  REPEAL280: 'REPEAL280            26:7234D.F FALSE BRANDING, SELLING, ...',
  REPEAL281: 'REPEAL281            26:7234D.M FALSE BRANDING, SELLING, ...',
  REPEAL282: 'REPEAL282            26:7234D.P FALSE BRANDING, SELLING, ...',
  REPEAL283: 'REPEAL283            26:7235.F FRAUD BY MANUFACTURER',
  REPEAL284: 'REPEAL284            26:7235.M FRAUD BY MANUFACTURER',
  REPEAL285: 'REPEAL285            26:7235.P FRAUD BY MANUFACTURER',
  REPEAL286: 'REPEAL286            26:7235A.F FRAUD BY MANUFACTURER',
  REPEAL287: 'REPEAL287            26:7235B.P FRAUD BY MANUFACTURER',
  REPEAL288: 'REPEAL288            26:7235C.M FRAUD BY MANUFACTURER',
  REPEAL289: 'REPEAL289            26:7235D.P FRAUD BY MANUFACTURER',
  REPEAL29: 'REPEAL29             2:441B.M SOLICITING EMPLOYEE FOR POL...',
  REPEAL290: 'REPEAL290            26:7235E.F FRAUD BY MANUFACTURER',
  REPEAL291: 'REPEAL291            26:7236.M FALSE BRANDING, SALE',
  REPEAL292: 'REPEAL292            26:7239.F SELLING UN-STAMPED MATCHES',
  REPEAL293: 'REPEAL293            26:7239A.F SELLING UN-STAMPED MATCHES',
  REPEAL294: 'REPEAL294            26:7239B.F SELLING UN-STAMPED MATCHES',
  REPEAL295: 'REPEAL295            26:7240.F OFFICIALS INVESTING/SPECUL...',
  REPEAL296: 'REPEAL296            26:7241.M PENALTY FOR FRAUD',
  REPEAL297: 'REPEAL297            26:7263.P PENALTIES: COTTON FUTURES',
  REPEAL298: 'REPEAL298            26:7264.M ADULTERATED BUTTER',
  REPEAL299: 'REPEAL299            26:7265.P ADULTERATED BUTTER',
  REPEAL3: 'REPEAL3              2:243.M - FEDERAL STATUTES - CONTRIB...',
  REPEAL30: 'REPEAL30             7:1153.P SUGAR EXCISE TAX',
  REPEAL300: 'REPEAL300            26:7265A.P ADULTERATED BUTTER',
  REPEAL301: 'REPEAL301            26:7265B.P ADULTERATED BUTTER',
  REPEAL302: 'REPEAL302            26:7266.M FAILURE TO PAY SPECIAL TAX',
  REPEAL303: 'REPEAL303            26:7266.P FAILURE TO PAY SPECIAL TAX',
  REPEAL304: 'REPEAL304            26:7266A.M FAILURE TO PAY SPECIAL TAX',
  REPEAL305: 'REPEAL305            26:7266A.P FAILURE TO PAY SPECIAL TAX',
  REPEAL306: 'REPEAL306            26:7266B.M FAILURE TO PAY SPECIAL TAX',
  REPEAL307: 'REPEAL307            26:7266C.P FAILURE TO PAY SPECIAL TAX',
  REPEAL308: 'REPEAL308            26:7266D.P FAILURE TO PAY SPECIAL TAX',
  REPEAL309: 'REPEAL309            26:7267.M WHITE PHOSPHOROUS MATCHES/...',
  REPEAL31: 'REPEAL31             7:1156.M DUTY TO FURNISH INFORMATION',
  REPEAL310: 'REPEAL310            26:7267.P WHITE PHOSPHOROUS MATCHES/...',
  REPEAL311: 'REPEAL311            26:7267A.M WHITE PHOSPHOROUS MATCHES...',
  REPEAL312: 'REPEAL312            26:7267B.M WHITE PHOSPHOROUS MATCHES...',
  REPEAL313: 'REPEAL313            26:7267C.P WHITE PHOSPHOROUS MATCHES...',
  REPEAL314: 'REPEAL314            26:7267D.P WHITE PHOSPHOROUS MATCHES...',
  REPEAL315: 'REPEAL315            33:1002.M DISCHARGE OF OIL PROHIBITED',
  REPEAL316: 'REPEAL316            33:1005.M DISCHARGE OF OIL PROHIBITED',
  REPEAL317: 'REPEAL317            33:1005A.M DISCHARGE OF OIL PROHIBITED',
  REPEAL318: 'REPEAL318            33:1008.M DISCHARGE OF OIL PROHIBITED',
  REPEAL319: 'REPEAL319            33:1008C.M DISCHARGE OF OIL PROHIBITED',
  REPEAL32: 'REPEAL32             7:135A.M INSECTICIDE ACT - UNREGISTE...',
  REPEAL320: 'REPEAL320            33:1008D.M DISCHARGE OF OIL PROHIBITED',
  REPEAL321: 'REPEAL321            33:1008E.M DISCHARGE OF OIL PROHIBITED',
  REPEAL322: 'REPEAL322            33:1008F.M DISCHARGE OF OIL PROHIBITED',
  REPEAL323: 'REPEAL323            33D:702.F NARCOTICS, OTHER',
  REPEAL324: 'REPEAL324            33D:702.M NARCOTICS, OTHER',
  REPEAL325: 'REPEAL325            42:2703.F EMBEZZLES PUBLIC MONEYS',
  REPEAL326: 'REPEAL326            42:2703.M EMBEZZLES PUBLIC MONEYS',
  REPEAL327: 'REPEAL327            42:2703A.F EMBEZZLES PUBLIC MONEYS',
  REPEAL328: 'REPEAL328            42:2703A.M EMBEZZLES PUBLIC MONEYS',
  REPEAL329: 'REPEAL329            42:2703B.M EMBEZZLES PUBLIC MONEYS',
  REPEAL33: 'REPEAL33             7:135A.P UNREGISTERED POISONS 2ND OF...',
  REPEAL330: 'REPEAL330            43:1096.M FRAUDULENT SETTLEMENT',
  REPEAL331: 'REPEAL331            43:1191.F FRAUDULENT SETTLEMENT',
  REPEAL332: 'REPEAL332            43:1192.F FRAUDULENT SETTLEMENT',
  REPEAL333: 'REPEAL333            43:1193.F FRAUDULENT SETTLEMENT',
  REPEAL334: 'REPEAL334            45:228.M FALSE OR FRAUDULENT STATEMENTS',
  REPEAL335: 'REPEAL335            46:1277.F OFFENSES AND PENALTIES',
  REPEAL336: 'REPEAL336            46:17010.F TENDERING EXPLOSIVES',
  REPEAL337: 'REPEAL337            46:17011.F TENDERING EXPLOSIVES',
  REPEAL338: 'REPEAL338            46:17013.F TENDERING EXPLOSIVES',
  REPEAL339: 'REPEAL339            46:17014.F TENDERING EXPLOSIVES',
  REPEAL34: 'REPEAL34             7:135B.M REGISTRATION OF ECONOMIC PO...',
  REPEAL340: 'REPEAL340            46:17015.F TENDERING EXPLOSIVES',
  REPEAL341: 'REPEAL341            46:1703.F TRANSPORT OF CERTAIN EXPLO...',
  REPEAL342: 'REPEAL342            46:1704.F TRANSPORT OF CERTAIN EXPLO...',
  REPEAL343: 'REPEAL343            46:1705.F TRANSPORT OF CERTAIN EXPLO...',
  REPEAL344: 'REPEAL344            46:1706.F TRANSPORT OF CERTAIN EXPLO...',
  REPEAL345: 'REPEAL345            46:1707.F TRANSPORT OF CERTAIN EXPLO...',
  REPEAL346: 'REPEAL346            46:1708.F TRANSPORT OF CERTAIN EXPLO...',
  REPEAL347: 'REPEAL347            46:1709.F TRANSPORT OF CERTAIN EXPLO...',
  REPEAL348: 'REPEAL348            46:2302.M OPERATING IN NEGLIGENT MANNER',
  REPEAL349: 'REPEAL349            46:526.M RECKLESS/NEGLIGENT OPERATIO...',
  REPEAL35: 'REPEAL35             7:135B.P REGISTRATION OF ECONOMIC PO...',
  REPEAL350: 'REPEAL350            46:7014.P WILLFUL DISOBEDIENCE',
  REPEAL351: 'REPEAL351            46:7015.P WILLFUL DISOBEDIENCE',
  REPEAL352: 'REPEAL352            46:7016.P WILLFUL DISOBEDIENCE',
  REPEAL353: 'REPEAL353            46:7017.M WILLFUL DISOBEDIENCE',
  REPEAL354: 'REPEAL354            46:7018.M WILLFUL DISOBEDIENCE',
  REPEAL355: 'REPEAL355            46:8151.P UNDUE OR UNREASONABLE PREF...',
  REPEAL356: 'REPEAL356            46:8153.P UNDUE OR UNREASONABLE PREF...',
  REPEAL357: 'REPEAL357            49A:1472E.M FAILURE TO FILE REPORTS',
  REPEAL358: 'REPEAL358            49A:1472F.M FAILURE TO FILE REPORTS',
  REPEAL359: 'REPEAL359            49A:1472H.M FAILURE TO FILE REPORTS',
  REPEAL36: 'REPEAL36             7:135C.M BOOKS AND RECORDS, ACCESS A...',
  REPEAL360: 'REPEAL360            49A:1472I.M FAILURE TO FILE REPORTS',
  REPEAL361: 'REPEAL361            49A:1472J.M FAILURE TO FILE REPORTS',
  REPEAL362: 'REPEAL362            49A:1472L.M FAILURE TO FILE REPORTS',
  REPEAL363: 'REPEAL363            49A:1472M.F FAILURE TO FILE REPORTS',
  REPEAL364: 'REPEAL364            49A:1472N.F FAILURE TO FILE REPORTS',
  REPEAL365: 'REPEAL365            49A:1472N.P FAILURE TO FILE REPORTS',
  REPEAL366: 'REPEAL366            49A:1472O.F FAILURE TO FILE REPORTS',
  REPEAL367: 'REPEAL367            49A:1472P.F FAILURE TO FILE REPORTS',
  REPEAL368: 'REPEAL368            49A:1472P.P FAILURE TO FILE REPORTS',
  REPEAL369: 'REPEAL369            49A:1472R.P FAILURE TO FILE REPORTS',
  REPEAL37: 'REPEAL37             7:135C.P BOOKS AND RECORDS, ACCESS A...',
  REPEAL370: 'REPEAL370            38:3301.P IMPROPER USE OF NAMES AND ...',
  REPEAL371: 'REPEAL371            38:33019.M IMPROPER USE OF NAMES AND...',
  REPEAL372: 'REPEAL372            38:33019.P IMPROPER USE OF NAMES AND...',
  REPEAL38: 'REPEAL38             7:135D.M RULES AND REGULATIONS, EXAM...',
  REPEAL39: 'REPEAL39             7:135D.P RULES AND REGULATIONS, EXAM...',
  REPEAL4: 'REPEAL4              2:244.F - FEDERAL STATUTES - TREASUR...',
  REPEAL40: 'REPEAL40             7:135F.F INSECTICIDES',
  REPEAL41: 'REPEAL41             7:135F.M INSECTICIDES',
  REPEAL42: 'REPEAL42             7:135F.P INSECTICIDES',
  REPEAL43: 'REPEAL43             7:135G.M INSECTICIDES',
  REPEAL44: 'REPEAL44             7:135G.P INSECTICIDES',
  REPEAL45: 'REPEAL45             7:2023C.F PRESENT, REDEEM COUPONS',
  REPEAL46: 'REPEAL46             7:2023C.M PRESENT, REDEEM COUPONS',
  REPEAL47: 'REPEAL47             7:2043.F FARM WORKER CERTIFICATES',
  REPEAL48: 'REPEAL48             7:2043.M FARM WORKER CERTIFICATES',
  REPEAL49: 'REPEAL49             7:2044.F CERTIFICATE OF REGISTRATION...',
  REPEAL5: 'REPEAL5              2:244.M - FEDERAL] STATUTES - TREASU...',
  REPEAL50: 'REPEAL50             7:2044.M CERTIFICATE OF REGISTRATION...',
  REPEAL51: 'REPEAL51             7:2045.F OBLIGATIONS AND PROHIBITION...',
  REPEAL52: 'REPEAL52             7:2045.M OBLIGATIONS AND PROHIBITION...',
  REPEAL53: 'REPEAL53             7:2046.F AUTHORITY TO OBTAIN INFORMA...',
  REPEAL54: 'REPEAL54             7:2046.M AUTHORITY TO OBTAIN INFORMA...',
  REPEAL55: 'REPEAL55             7:2048A.F FARM LABOR CONTRACTOR REGI...',
  REPEAL56: 'REPEAL56             7:2048A.M FARM LABOR CONTRACTOR REGI...',
  REPEAL57: 'REPEAL57             7:2048C.F FARM LABOR CONTRACTOR REGI...',
  REPEAL58: 'REPEAL58             7:2050C.F RECORDKEEPING - 2ND OFFENSE',
  REPEAL59: 'REPEAL59             7:2053.F RULES AND REGULATIONS - 2ND...',
  REPEAL6: 'REPEAL6              2:245.F - FEDERAL STATUTES - STATEME...',
  REPEAL60: 'REPEAL60             7:2053.M RULES AND REGULATIONS',
  REPEAL61: 'REPEAL61             7:2054.F WAIVER OF RIGHTS - 2ND OFF',
  REPEAL62: 'REPEAL62             7:2054.M WAIVER OF RIGHTS',
  REPEAL63: 'REPEAL63             7:218.P STOCKYARDS, LIVE POULTRY DEA...',
  REPEAL64: 'REPEAL64             7:516.M EXPORTATION OF SEEDS OR PLAN...',
  REPEAL65: 'REPEAL65             7:517.M EXPORT TOBACCO SEEDS OR PLAN...',
  REPEAL66: 'REPEAL66             8:331.M PROHIBITED COOLIE TRADE',
  REPEAL67: 'REPEAL67             8:333.M BUILDING BOATS FOR COOLIE TRADE',
  REPEAL68: 'REPEAL68             8:334.M PENALTIES - COOLIE TRADE',
  REPEAL69: 'REPEAL69             8:338.M TRANSPORTING ORIENTALS FOR S...',
  REPEAL7: 'REPEAL7              2:245.M - FEDERAL STATUTES - STATEME...',
  REPEAL70: 'REPEAL70             8:339.M CONTRACTING TO SUPPLY COOLIE...',
  REPEAL71: 'REPEAL71             12:1713.P RENTAL HOUSING INSURANCE',
  REPEAL72: 'REPEAL72             12:1846.M- HOLDING COMPANIES',
  REPEAL73: 'REPEAL73             16:85.P   TRANSPORTING ILLEGAL GAME',
  REPEAL74: 'REPEAL74             16.471.M LIMITATION IN CERTAIN STATES',
  REPEAL75: 'REPEAL75             16:476.M SALE OF TIMBER',
  REPEAL76: 'REPEAL76             16:709.F TAKING/KILLING TO BARTER OR...',
  REPEAL77: 'REPEAL77             16:709.F TAKING/KILLING TO BARTER OR...',
  REPEAL78: 'REPEAL78             16:772B/E HALIBUT ACT 1937',
  REPEAL79: 'REPEAL79             16:772B/E HALIBUT ACT 1937',
  REPEAL8: 'REPEAL8              2:246.F - FEDERAL STATUTES - STATEME...',
  REPEAL80: 'REPEAL80             16:772B/E HALIBUT ACT 1937',
  REPEAL81: 'REPEAL81             16:772B/E HALIBUT ACT 1937',
  REPEAL82: 'REPEAL82             16:776A/F SALMON FISHING',
  REPEAL83: 'REPEAL83             16:776A/F SALMON FISHING',
  REPEAL84: 'REPEAL84             16:776A/F SALMON FISHING',
  REPEAL85: 'REPEAL85             16:852.P  TRANSPORTING ILLEGAL GAME',
  REPEAL86: 'REPEAL86             16:852A.P  TRANSPORTING ILLEGAL GAME',
  REPEAL87: 'REPEAL87             16:852C.P  TRANSPORTING ILLEGAL GAME',
  REPEAL88: 'REPEAL88             16:981.M NORTHWEST ATLANTIC FISHERIES',
  REPEAL89: 'REPEAL89             16:982.M NORTHWEST ATLANTIC FISHERIES',
  REPEAL9: 'REPEAL9              2:246.M - FEDERAL STATUTES - STATEME...',
  REPEAL90: 'REPEAL90             16:983.M NORTHWEST ATLANTIC FISHERIES',
  REPEAL91: 'REPEAL91             16:984.M NORTHWEST ATLANTIC FISHERIES',
  REPEAL92: 'REPEAL92             16:985.M NORTHWEST ATLANTIC FISHERIES',
  REPEAL93: 'REPEAL93             16:986.M NORTHWEST ATLANTIC FISHERIES',
  REPEAL94: 'REPEAL94             16:987.M NORTHWEST ATLANTIC FISHERIES',
  REPEAL95: 'REPEAL95             16:988.M NORTHWEST ATLANTIC FISHERIES',
  REPEAL96: 'REPEAL96             16:988.P NORTHWEST ATLANTIC FISHERIES',
  REPEAL97: 'REPEAL97             16:989.M NORTHWEST ATLANTIC FISHERIES',
  REPEAL98: 'REPEAL98             16:989.P NORTHWEST ATLANTIC FISHERIES',
  REPEAL99: 'REPEAL99             16:990.M NORTHWEST ATLANTIC FISHERIES',
  SD1: 'SD1                  5:552.M NO DEFINITION',
  SD10: 'SD10                 7:1986B.F STABILIZE PROVISIONS',
  SD100: 'SD100                18:1406.F NARCOTICS, OTHER',
  SD101: 'SD101                18:1406.M NARCOTICS, OTHER',
  SD102: 'SD102                18:1407.F NARCOTICS, BORDER REGISTRA...',
  SD103: 'SD103                18:1407.M NARCOTICS, BORDER REGISTRA...',
  SD104: 'SD104                18:1956-7420.F RACKETEERING, BRIBERY',
  SD105: 'SD105                18:1956-7430.F RACKETEERING, EXTORTION',
  SD106: 'SD106                18:1956-7440.F RACKETEERING, GAMBLING',
  SD107: 'SD107                18:1956-7450.F RACKETEERING, LIQUOR',
  SD108: 'SD108                18:1956-7460.F RACKETEERING, NARCOTICS',
  SD109: 'SD109                18:1956-7470.F RACKETEERING, PROSTIT...',
  SD11: 'SD11                 7:1986C.F CONFLICTS OF INTEREST',
  SD110: 'SD110                18:2113D.M BANK LARCENY - RECEIVED S...',
  SD111: 'SD111                18:2113E.M BANK ROBBERY',
  SD112: 'SD112                18:2241.F COMMIT RAPE W/IN SPECIAL M...',
  SD113: 'SD113                18:2242.F FORCED SEX THREATS/FEAR OF...',
  SD114: 'SD114                18:2244B.P SEXUAL CONTACT W/O PERMIS...',
  SD115: 'SD115                18:3056.M OBSTRUCTION AND INTERFEREN...',
  SD116: 'SD116                18:3146.M FAILURE TO APPEAR',
  SD117: 'SD117                21:853.P OTHER DAPCA OFFENSES',
  SD118: 'SD118                21:854=CI.F INVEST ILLICIT DRUG PROFITS',
  SD12: 'SD12                 7:2024E.M - FOOD STAMP FRAUD - UNAUT...',
  SD122: 'SD122                21:858=CM.F CONTROLLED SUBSTANCE - M...',
  SD123: 'SD123                21:959=MI.M MARIJUANA - IMPORT/EXPORT',
  SD124: 'SD124                21:9612=CI.M PRINCIPALS',
  SD125: 'SD125                26:5752A.F RESTRICTIONS TO MARKS, LA...',
  SD126: 'SD126                26:5752B.F RESTRICTIONS TO MARKS, LA...',
  SD127: 'SD127                26:5752C.F RESTRICTIONS TO MARKS, LA...',
  SD128: 'SD128                26:5752D.F RESTRICTIONS TO MARKS, LA...',
  SD129: 'SD129                26:6047.M  INSURANCE COMPANIES - REQ...',
  SD13: 'SD13                 7:211.M - AGRICULTURE ACTS - PRACTICES',
  SD130: 'SD130                26:7272.P FAILURE TO REGISTER',
  SD131: 'SD131                27:208.P INTERLOCKING DIRECTORATES',
  SD132: 'SD132                28:1866.P SELECTION AND SUMMONING OF...',
  SD133: 'SD133                29:1111.F HOLDING CERTAIN POSITIONS',
  SD134: 'SD134                29:1112.M UNLAWFUL TO CONTROL FUNDS',
  SD135: 'SD135                29:461D.M FALSE STATEMENTS',
  SD136: 'SD136                29:503.M LOANS TO OFFICERS AND EMPLO...',
  SD137: 'SD137                29:522.F EXTORTIONATE PICKETING',
  SD138: 'SD138                30:727.P WITHDRAWAL FROM DANGER AREA',
  SD139: 'SD139                30:733.P PENALTY: CIVIL AND CRIMINAL',
  SD14: 'SD14                 7:212.M - AGRICULTURE ACTS - DISCRIM...',
  SD140: 'SD140                30:820E.M DISTRIBUTION OR SALE',
  SD141: 'SD141                30:1267.M INSPECTIONS AND MONITORING...',
  SD142: 'SD142                31:1101.M PERSONS REQUIRED TO FILE',
  SD143: 'SD143                31:699.M CITIZENSHIP REQUIREMENTS, F...',
  SD144: 'SD144                33:941.P SAFE PLACE OF EMPLOYMENT',
  SD145: 'SD145                33:1321P.M FINANCIAL RESPONSIBILITY ...',
  SD146: 'SD146                33D:401.M REMOVED AT REQUEST OF DC C...',
  SD147: 'SD147                33D:402.F REMOVED AT REQUEST OF DC C...',
  SD148: 'SD148                33D:402.M REMOVED AT REQUEST OF DC C...',
  SD149: 'SD149                33D:403.F REMOVED AT REQUEST OF DC C...',
  SD15: 'SD15                 7:213.M - AGRICULTURE ACTS - UNFAIR ...',
  SD150: 'SD150                33D:403.M REMOVED AT REQUEST OF DC C...',
  SD151: 'SD151                33D:404.F REMOVED AT REQUEST OF DC C...',
  SD152: 'SD152                33D:404.M REMOVED AT REQUEST OF DC C...',
  SD153: 'SD153                33D:405.F REMOVED AT REQUEST OF DC C...',
  SD154: 'SD154                33D:405.M REMOVED AT REQUEST OF DC C...',
  SD155: 'SD155                33D:406.F REMOVED AT REQUEST OF DC C...',
  SD156: 'SD156                33D:406.M REMOVED AT REQUEST OF DC C...',
  SD157: 'SD157                33D:407.F REMOVED AT REQUEST OF DC C...',
  SD158: 'SD158                33D:407.M REMOVED AT REQUEST OF DC C...',
  SD159: 'SD159                33D:408.F REMOVED AT REQUEST OF DC C...',
  SD16: 'SD16                 7:2149D.M AGRICULTURE ACTS - ANIMAL ...',
  SD160: 'SD160                33D:408.M REMOVED AT REQUEST OF DC C...',
  SD161: 'SD161                33D:409.F REMOVED AT REQUEST OF DC C...',
  SD162: 'SD162                33D:409.M REMOVED AT REQUEST OF DC C...',
  SD163: 'SD163                33D:410.F REMOVED AT REQUEST OF DC C...',
  SD164: 'SD164                33D:410.M REMOVED AT REQUEST OF DC C...',
  SD165: 'SD165                33D:411.F REMOVED AT REQUEST OF DC C...',
  SD166: 'SD166                33D:411.M REMOVED AT REQUEST OF DC C...',
  SD167: 'SD167                33D:412.F REMOVED AT REQUEST OF DC C...',
  SD168: 'SD168                33D:412.M REMOVED AT REQUEST OF DC C...',
  SD169: 'SD169                33D:413.F REMOVED AT REQUEST OF DC C...',
  SD17: 'SD17                 7:3404.M PENALTIES - REPORTS',
  SD170: 'SD170                33D:413.M REMOVED AT REQUEST OF DC C...',
  SD171: 'SD171                33D:414.M REMOVED AT REQUEST OF DC C...',
  SD172: 'SD172                33D:415.F REMOVED AT REQUEST OF DC C...',
  SD173: 'SD173                33D:415.M REMOVED AT REQUEST OF DC C...',
  SD174: 'SD174                33D:416.F REMOVED AT REQUEST OF DC C...',
  SD175: 'SD175                33D:416.M REMOVED AT REQUEST OF DC C...',
  SD176: 'SD176                33D:417.F REMOVED AT REQUEST OF DC C...',
  SD178: 'SD178                33D:417.M REMOVED AT REQUEST OF DC C...',
  SD179: 'SD179                33D:418.F REMOVED AT REQUEST OF DC C...',
  SD18: 'SD18                 7:620.P AGRICULTURE ACTS - FALSE DED...',
  SD180: 'SD180                33D:418.M REMOVED AT REQUEST OF DC C...',
  SD181: 'SD181                33D:419.F REMOVED AT REQUEST OF DC C...',
  SD182: 'SD182                33D:419.M REMOVED AT REQUEST OF DC C...',
  SD183: 'SD183                33D:420.F REMOVED AT REQUEST OF DC C...',
  SD184: 'SD184                33D:420.M REMOVED AT REQUEST OF DC C...',
  SD185: 'SD185                33D:421.F REMOVED AT REQUEST OF DC C...',
  SD186: 'SD186                33D:421.M REMOVED AT REQUEST OF DC C...',
  SD187: 'SD187                33D:422.F REMOVED AT REQUEST OF DC C...',
  SD188: 'SD188                33D:422.M REMOVED AT REQUEST OF DC C...',
  SD189: 'SD189                33D:423.F REMOVED AT REQUEST OF DC C...',
  SD19: 'SD19                 8:1326.F ILLEGAL REENTRY OF ALIENS',
  SD190: 'SD190                33D:423.M REMOVED AT REQUEST OF DC C...',
  SD191: 'SD191                42:1973.F ELECTION LAW VIOLATIONS',
  SD192: 'SD192                42:2278A.M VIOLATION OF COMMISSION R...',
  SD193: 'SD193                42:2278A.P TRESPASS UPON INSTALLATION',
  SD194: 'SD194                42:9603C.F NOTIFICATION REQUIREMENTS',
  SD195: 'SD195                42:9603C.M FAILURE TO NOTIFY EPA',
  SD196: 'SD196                47:605A.P SATELLITE PIRACY',
  SD197: 'SD197                47:605E.F SATELLITE PIRACY',
  SD198: 'SD198                47:605E.P SATELLITE PIRACY',
  SD199: 'SD199                49A:1472D.F INTERFERENCE WITH AIR NA...',
  SD2: 'SD2                  7.:13.P POSTAL, INTERSTATE WIRE, RAD...',
  SD20: 'SD20                 12:378A.F - VIOLATIONS IN THE BANKIN...',
  SD200: 'SD200                49A:1472D.M INTERFERENCE WITH AIR NA...',
  SD201: 'SD201                99:42.M CONTEMPT',
  SD202: 'SD202                18:13-4600.P LENDING CREDIT INSTITUT...',
  SD21: 'SD21                 12:378B.F - VIOLATIONS IN THE BANKIN...',
  SD22: 'SD22                 12:1730D.F RETENTION OF RECORDS',
  SD23: 'SD23                 12:1730D.F RETENTION OF RECORDS',
  SD24: 'SD24                 12:1730D.F RETENTION OF RECORDS',
  SD25: 'SD25                 12:1730D.F RETENTION OF RECORDS',
  SD26: 'SD26                 12:1818.M ILLEGAL PARTICIPATION BY B...',
  SD27: 'SD27                 15:1.M ANTITRUST VIOLATIONS',
  SD28: 'SD28                 15:2.M MONOPOLIZING TRADE',
  SD29: 'SD29                 15:3.M TRUSTS IN TERRITORIES AND DIS...',
  SD3: 'SD3                  7:13.F EMBEZZLEMENT: OFFICER OR EMPL...',
  SD30: 'SD30                 16:710.F - PARTIAL VALIDITY',
  SD31: 'SD31                 16:710.F - PARTIAL VALIDITY',
  SD32: 'SD32                 18:13-0100.M MURDER FIRST DEGREE',
  SD33: 'SD33                 18:13-0200.M MURDER, SECOND DEGREE',
  SD34: 'SD34                 18:13-0300.M MANSLAUGHTER',
  SD35: 'SD35                 18:13-0310.M NEGLIGENT',
  SD36: 'SD36                 18:13-3200.P LARCENY AND THEFT, POSTAL',
  SD37: 'SD37                 18:13-3300.P INTERSTATE COMMERCE',
  SD38: 'SD38                 18:13-3400.P THEFT OF U.S. PROPERTY',
  SD39: 'SD39                 18:13-3700.M LARCENY AND THEFT, FELO...',
  SD4: 'SD4                  7:13.M AGRICULTURE ACTS - PRICE CORN...',
  SD40: 'SD40                 18:13-4100.P BANK EMBEZZLEMENT',
  SD41: 'SD41                 18:13-4200.P POSTAL EMBEZZLEMENT',
  SD42: 'SD42                 18:13-4320.P LENDING, CREDIT, INSURA...',
  SD43: 'SD43                 18:13-4350.P EMBEZZLEMENT: OFFICER O...',
  SD44: 'SD44                 18:13-4390.P EMBEZZLEMENT, OTHER',
  SD45: 'SD45                 18:13-4920.P SECURITIES AND EXCHANGE',
  SD46: 'SD46                 18:13-4931.P FRAUD, EXCISE TAX, OTHER',
  SD47: 'SD47                 18:13-4932.P FRAUD, WAGERING TAX, OTHER',
  SD48: 'SD48                 18:13-4941.P FRAUD FOOD STAMP PROGRAM',
  SD49: 'SD49                 18:13-4950.F SOCIAL SECURITY',
  SD5: 'SD5                  7:131.P MANIPULATIONS OR OTHER VIOLA...',
  SD50: 'SD50                 18:13-4992.M FRAUD, CONSPIRE TO DEFR...',
  SD51: 'SD51                 18:13-6511.F MARIJUANA -  DISTRIBUTE...',
  SD52: 'SD52                 18:13-6511.M MARIJUANA -  DISTRIBUTE...',
  SD53: 'SD53                 18:13-6512.F MARIJUANA - IMPORTATION...',
  SD54: 'SD54                 18:13-6513-F MARIJUANA - MANUFACTURE',
  SD55: 'SD55                 18:13-6514.F MARIJUANA - POSSESSION',
  SD56: 'SD56                 18:13-6514.M MARIJUANA - POSSESSION',
  SD57: 'SD57                 18:13-6515.F MARIJUANA - RECORDS, RX...',
  SD58: 'SD58                 18:13-6711.F NARCOTICS - DISTRIBUTE,...',
  SD59: 'SD59                 18:13-6712.F NARCOTICS - IMPORTATION...',
  SD6: 'SD6                  7:13B.P AGRICULTURE ACTS - USE OF CO...',
  SD60: 'SD60                 18:13-6713.F NARCOTICS - MANUFACTURE',
  SD61: 'SD61                 18:13-6714.F NARCOTICS - POSSESSION',
  SD62: 'SD62                 18:13-6714.M NARCOTICS - POSSESSION',
  SD63: 'SD63                 18:13-6715.F NARCOTICS - RECORDS, RX...',
  SD64: 'SD64                 18:13-6811.F CONTROLLED SUBSTANCE - ...',
  SD65: 'SD65                 18:13-6812.F CONTROLLED SUBSTANCE - ...',
  SD66: 'SD66                 18:13-6813.F CONTROLLED SUBSTANCE - ...',
  SD67: 'SD67                 18:13-6814.F CONTROLLED SUBSTANCE - ...',
  SD68: 'SD68                 18:13-6814.M CONTROLLED SUBSTANCE - ...',
  SD69: 'SD69                 18:13-6815.F CONTROLLED SUBSTANCE - ...',
  SD7: 'SD7                  7:13C.M  AGRICULTURE ACTS - PROHIBIT...',
  SD70: 'SD70                 18:13-6825.M CONTROLLED SUBSTANCE - ...',
  SD71: 'SD71                 18:13-6834.F CONTROLLED  SUBSTANCE -...',
  SD72: 'SD72                 18:13-6844.F CONTROLLED  SUBSTANCE -...',
  SD73: 'SD73                 18:13-6854.F CONTROLLED SUBSTANCE - ...',
  SD74: 'SD74                 18:13-7320.P ESCAPE, AIDING OR HARBO...',
  SD75: 'SD75                 18:13-7500.P GAMBLING AND LOTTERY',
  SD76: 'SD76                 18:13-7910.P ARSON',
  SD77: 'SD77                 18:13-7920.F ABORTION',
  SD78: 'SD78                 18:13-8720.M IMMIGRATION LAWS, ILLEG...',
  SD79: 'SD79                 18:13-8740.M IMMIGRATION LAWS, ILLEG...',
  SD8: 'SD8                  7:1986.F - AGRICULTURE ACTS - CONFLI...',
  SD80: 'SD80                 18:13-8900.P LIQUOR, INTERNAL REVENUE',
  SD81: 'SD81                 18:13-9001.M HAZARDOUS WASTE - TREAT...',
  SD82: 'SD82                 18:13-9200.P ANTITRUST VIOLATIONS',
  SD83: 'SD83                 18:13-9300.P FAIR LABOR STANDARDS ACT',
  SD84: 'SD84                 18:13-9500.M MIGRATORY BIRD LAWS',
  SD85: 'SD85                 18:13-9752.P ESPIONAGE',
  SD86: 'SD86                 18:42.P IMPORT OR SHIP INJURIOUS MAM...',
  SD87: 'SD87                 18:112-7420.M TAMPERING W/WITNESS',
  SD88: 'SD88                 18:201C.F BRIBERY OF PUBLIC OFFICIAL...',
  SD89: 'SD89                 18:201D.F BRIBERY OF PUBLIC OFFICIAL...',
  SD9: 'SD9                  7:1986A.F STABILIZE PROVISIONS',
  SD90: 'SD90                 18:201E.F BRIBERY OF PUBLIC OFFICIAL...',
  SD91: 'SD91                 18:201F.F BRIBERY OF PUBLIC OFFICIAL...',
  SD92: 'SD92                 18:201G.F BRIBERY OF PUBLIC OFFICIAL...',
  SD93: 'SD93                 18:201H.F BRIBERY OF PUBLIC OFFICIAL...',
  SD94: 'SD94                 18:201I.F BRIBERY OF PUBLIC OFFICIAL...',
  SD95: 'SD95                 18:203.F CONTEMPT, MEMBERS OF CONGRE...',
  SD96: 'SD96                 18:373-0100.P SOLICIT/COMMIT CRIME O...',
  SD97: 'SD97                 18:982.P CRIMINAL FORFEITURE',
  SD98: 'SD98                 18:1403.F NARCOTICS, OTHER',
  SD99: 'SD99                 18:1403.M NARCOTICS, OTHER',
  cmp: 'cmp                  complaint filed',
};
const caseFlagOptions = {
  APPEAL: 'APPEAL',
  ARBITRATION: 'ARBITRATION',
  CASREF: 'CASREF',
  CLOSED: 'CLOSED',
  CONSENT: 'CONSENT',
  ENE: 'ENE',
  HABEAS: 'HABEAS',
  HBS: 'HBS',
  HKS: 'HKS',
  INTERPRETER: 'INTERPRETER',
  JJM: 'JJM',
  JWF: 'JWF',
  LEAD: 'LEAD',
  LGF: 'LGF',
  MEDIATION: 'MEDIATION',
  MEMBER: 'MEMBER',
  MERGED: 'MERGED',
  MOTREF: 'MOTREF',
  MWP: 'MWP',
  PRIOR: 'PRIOR',
  ProSe: 'ProSe',
  SEALED: 'SEALED',
  SETTLE: 'SETTLE',
  SM: 'SM',
  STAT_CLOSE: 'STAT_CLOSE',
  STAYED: 'STAYED',
  VEB: 'VEB',
  VictimNotify: 'VictimNotify',
};
const countStatusOptions = {
  pending_citations: 'Pending',
  terminated_citations: 'Disposed',
};
const includeCVBCasesOptions = {
  '': '',
  Yes: 'Yes',
  No: 'No',
};
const casePropertiesOptions = {
  pending_defendants: 'Pending defendants',
  terminated_defendants: 'Terminated defendants',
};



/** WEBPACK FOOTER **
 ** ./src/pages/filings/SearchCourtRecords/ReportsTab/ReportsTabForms/Criminal/Criminal.js
 **/